export const newCentersData = [
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KRISHNAVENI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR RTC BUSTAND,BESIDE DWARAKA PETROL BUNK,KHAJA NAGAR,ANANTAPUR "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 8-74A, BESIDE HEAD POST OFFICE, NEAR ANDHRA BANK, ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR PAVAN GAS AGENCY, RTO OFFICE ROAD, HOUSING BOARD, ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,OPP.TATA SHOWROOM,KAKKALAPALLI,RUDRAMPETA BY PASS,ANANTHAPUR 515672"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KAMMA BHAVAN, OLD NIRMALA NURSING COLLEGE LAKSHMI SRINIVASA NAGAR ANANTAPUR-515004, "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OLD DPS SCHOOL ,OPPOSITE TATA SHOWROOM,HYDERABAD HIGH WAY PAMURAI VILLAGE ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SAKSHI OFFICE,OPP: TATA MOTORS,RUDRAMPETA BY-PASS,ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEW REVENUE OFFICE BACKSIDE,RUDRAMPETA,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL, SURVEY NO.:149\/4, WARD NO.: 13, SHIRDI NAGAR, NEAR RTC BUS STAND,OPP. ANAND HOSPITAL ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.315-1B,WARD NO.28,L.P.NO.518\/85, SINGARAYANI COLONY,NEW REVENUE COLONY, ANANTAPURAMU 515001."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 10\/413,ADIMURTHY NAGAR,OPPOSITE DEVI NURSING HOME,NEAR SRI CHAITANYA JR COLLEGE ,ANANTHAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "GORANTLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/277 OPPSITE MARKET YARD KADIRI - HINDUPUR MAIN ROAD,BESIDE SPVM DEGREE COLLEGE GORANTLA (M&amp;V) ANANTAPUR DIST A.P - 515231"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KALYANADURG",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO:-359\/1A, OPP GOVT HOSPITAL BELLARY ROAD, KALYANADURG, ANANTAPUR (DT) 515761"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:17\/1111, RAJENDRA NAGAR,NEAR VENKATESWARA SWAMY TEMPLE, POST OFFICE LINE, GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 4\/369, DMM GATE ROAD,NEAR PANDURANGA SWAMY TEMPLE,P&amp;T COLONY,GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. MAHENDRA FUNCTION HALL,TILAK NAGAR, GUNTAKAL515801"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 12-1-76\/G2, PALANI NAGAR, BESIDE RAJADHANI FUNCTION HALL, HINDUPUR,ANANTHAPUR - 515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 26, SATYANARAYANA PETA MF ROAD, HINDUPUR, ANANTHAPUR-515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kadiri",
     "Center": "KADIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO : 13\/13\/1\/C ,MADANAPALLI ROAD,OPPO.CHOWDESWARI TEMPLE,KADIRI,SATYA SAI DIST 515591"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kothacheruvu",
     "Center": "KOTHACHERUVU",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 7\/196, PENUGONDA ROAD KOTHACHERUVU ANANTAPUR 515133"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Tadipatri",
     "Center": "TADIPATRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NETHAJI SCHOOL COMPOUND, BEHIND RICE MILL, KALAVAKATTA STREET, TADIPATRI, ANANTAPUR 515411 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Bangarupalyam",
     "Center": "BANGARUPALYAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL THAGGUVARIPALLI, BANGARUPALYAM,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chandragiri",
     "Center": "CHANDRAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VIJAY NAGAR COLONY,CANARA BANK ROAD,CHANDRAGIRI 517101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOR CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-10-199, TMR TOWER , GANDHI ROAD,OPPT LIC OFFICE, CHITTOOR,517001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.THAPOVANAM SCHOOL,TEACHERS COLONY,GREAMSPET,VELLORE ROAD,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27-515\/B,TELEPHONE COLONY ROAD,RAMNAGAR COLONY,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 28-1428, RAM NAGAR COLONY,CHITTOR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "MURUGANI PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO.22-978\/BB, KAMESHWAR NAGAR, MURUGANIPALLI, CHITTOOR,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalle",
     "Center": "SRI GANGA SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 3\/153-4-4-1, HOSPITAL BRANCH , BESIDE RTC BUS STAND,MADHANAPALLI-517325,ANNAMAIAH (D)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MALLIKARJUNA CIRCLE, COLLEGE ROAD, MADANAPALLI,CHITTOOR 517325 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.NO. III-145-6-12-4, PRASANTH NAGAR, BESIDE. SRI SIDDHARTHA JR. COLLEGE, MADANAPALLI,TIRUPATHI - 517325"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Palamaneru",
     "Center": "PALAMANERU",
     "CenterAddress": "SRI CHAITANYA SCHOOL GUDIYATHAM ROAD,SRI NAGAR COLONY,NEAR YSRCP PARTY OFFICE,PALAMANERU,TIRUPATHI 517408"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Piler",
     "Center": "PILER",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-421, LAKSHMI PURAM,PILER, CHITTOOR (DIST),TIRUPATHI 517214."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Punganur",
     "Center": "PUNGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MPDO OFFICE, R.R KALYANA MANDAPAM,MBT ROAD,PUNGANUR-517247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #12\/64\/1A,SWAMY STREET,PUTTUR,517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARAMESWARA MANGALAM,K.PALEM,PUTTUR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYANAPURAM,OPP.FIRE STATION, SWAMI STREET KN ROAD,PUTTUR 517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Renigunta",
     "Center": "RENIGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL VINAYAKA NAGAR, RENIGUNTA, TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-1-1988,JAYRAM RAO STREET,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 16\/550\/3,SRI RAM NAGAR COLONY,PANAGAL ROAD,OPP: SBI (ADB) BRANCH,SRIKALAHASTI. AP 517640"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI LAKSHMI KAMAKSHI KALYANA MANDAPAM, OPP DARMARAJ TEMPLE,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "ANJANADRI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 2-16,TELECOM COLONY OTERU ROAD ,SRINIVASAPURAM ,TIRUPATHI-517503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "CURE CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:6-2-83, KT ROAD,NEAR AXIS BANK MAIN BRANCH TIRUPATI - 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN CAMPUS DAYS ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  DO; NO 25, GANDHI ROAD   MUNICIPAL COMPLEX  PIN NO; 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN II CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 37 AGK BUILDING  GANDHI ROAD  TIRUPATHI PIN: 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  RC ROAD  EBSR COMPLEX NEAR  ANNAMAYYA CIRCLE TIRUPATI PIN CODE 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VEDAVYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DR NO:411\/2P    150 BY PASS ROAD, TIRUCHANOOR (V)  TIRUPATHI ( R)517503        "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VENKATADRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 8-171-1, NEW BALAJI COLONY, MR PALLI, TIRUPATHI PIN-517502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "AIR BY-PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL JAYA LAKSHMI COLONY, STV NAGAR, AIR BY PASS ROAD, NEAR PASSPORT OFFICE, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TARAKARAMA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP:A.G.STAFF QUARTERS,TARAKARAMANAGAR,PERUR,TIRUPATI(RURAL)571505"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "GS MADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 15-2-126\/A2 , BESIDE LAKSHMI NARAYANA SWAMY TEMPLE GSMADA STREET TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "KORALAGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 20-2--478\/A2,MARUTHINAGAR,KORLAGUNTA,TIRUPATI-517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MR PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT:26 NEW MARUTHI NAGAR, AIR BY PASS ROAD,MR PALLI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "SRINIVASAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL TELECOM COLONY, SRINIVASAPURAM, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUMALA BY PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:18-1-7\/10, BESIDE PAI VICROY HOTEL, RAMA CHANDRA NAGAR, TIRUMALA BY PASS,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI GIRLS RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL #10-128\/6-9 NETHAJI NAGAR P G N TOWER TIRUCHANUR TIRUPATI PIN:517507"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI IPL",
     "CenterAddress": "SRI CHAITANYA SCHOOL IPL BRANCH,BAIRAGIPATTEDA, NEAR RIMS,TIRUPATHI 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TSN PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR. NO. 20-3-131\/1A, SIVA JYOTHI NAGAR, SATHYANARAYANAPURAM, OPPOSITE SRIVARI SANNIDHI, BACK SIDE STREET SBI EXECUTIVE GUEST HOUSE, TIRUPATHI, CHITTOOR DISTRICT, AP 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VIKAS CAMPUS",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANA PALLY ROAD, THIRUCHNOR, THIRUPATHI "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Venkatagirikota",
     "Center": "V KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHOWDEPALLE ROAD, VKOTA,TIRUPATHI 517424"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "SRI SHIRDI SAI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SHIRDI SAI CAMPUS #1-5-58\/2A ONGC BYPASS ROAD, SAVARAM AMALAPURAM- 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MSN COMPLEX, MAIN ROAD, AMALAPURAM, EAST GODAVARI DIST, 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :I 1-72 ,BACKSIDE OF VL HEIGHTS,ABBIREDDY CANAL BRIDGE,KONKAPALLI,AMALAPURAM,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Anaparthi",
     "Center": "ANAPARTHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 13-37, CANAL ROAD,AYYAPPA TEMPLE ,KOTHURU TURNING,ANAPARTHI,ANAPARTHI (MD), RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimadole",
     "Center": "BHIMADOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:10-116,OPP. FIRE STATION,ELURU, RAJAHMUNDRY ROAD,BHIMADOLE,WEST GODAVARI 534425"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL,PLOT NO:6-126,SRI RAMA KUSUMA PLAZA,NEAR NATARAJ THEATER,CHINNAMIRAM,JP ROAD, PALAKODERU (M), W.G(DT)534210"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE DUPLEX COLONY CHINNAMIRAM,BHIMAVARAM,RAJAHMUNDRY 534204"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Chintalapudi",
     "Center": "CHINTALAPUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL ABOVE UNION BANK,SRINIDI COMPLEX,ELURU ROAD,CHINTALAPUDI,RAJAHMUNDRY 534460"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Devarapalli",
     "Center": "DEVARAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP:VEGETABLE MARKET, ELURU ROAD, DEVARAPALLI RAJAHMUNDRY 534313"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "SCHOOL - ELURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHALAPATHI TOWERS,4TH LINE ,SANTHI NAGAR ,ELURU,PIN CODE:534007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARVATHA VARDHINI COMPLEX , NEAR MAHATHMA GANDHI STATUE, VIDYANAGAR , ELURU. W.G.(DT) 534003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 7-179\/2,NEAR GANGANAMMA TEMPLE,BALAJI NAGAR, CHATAPARRU ROAD, ELURU-534001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ganapavaram",
     "Center": "GANAPAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NIDAMARRU MANDEL,BHAVIPALEM POST, GANAPAVARAM,RAJAHMUNDRY 534198"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Hanuman Junction",
     "Center": "HANUMAN JUNCTION",
     "CenterAddress": "SRI CHAITANYA SCHOOL KEPINIDI TOWERS, NUZVID ROAD,NEAR FLYOVER, HANUMANJUNCTION WEST GODAVARI 521105"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jaggampeta",
     "Center": "JAGGAMPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRISHNAVENI THEATOR , BALAJI CENTER , JAGGAMPETA, EAST GODAVARI 533435"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jangareddygudem",
     "Center": "JANGAREDDYGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :16-1-120, BESIDE M.R.OOFFICE,MANDAVALLI ESTATE, ASWARAOPETA ROAD, JANGAREDDYGUDEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kaikalur",
     "Center": "KAIKALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: FCI GODOWNS, BESIDE RELIANCE PETROL, ATAPAKA, KAIKALUR-521333"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "RAMAN BHAVAN 1 SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOWDHAM, #3-16A-101, LAKSHMINARAYANA NAGAR,KAKINADA -533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL #3-16B-4, OLD RTO OFFICE ROAD, NEAR MOTHER TERESA STATUE,SANTHI NAGAR, KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPOSITE BMC CHURCH SANTHI NAGAR KAKINADA - 533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.9-16,SRINIVASA COLONY, RAMANAYYAPETA, KAKINADA RURAL-533005, EAST GODAVARI DISTRICT, ANDHRA PRADESH"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO1-1111, JANA CHAITANYA LAYOUT NEAR JEWEL MEDOWS,SARPAVARAM,KAKINADA RURAL 533005"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-5-43\/1,NAGESWARARAO STREET,RAMARAO PETA,KAKINADA-533003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kovvur",
     "Center": "KOVVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP PMMM GOVT HIGH SCHOOL,BESIDE YUVRAJ FUNCTION HALL, NANDAMURU ROAD, KOVVUR, WEST GODAVARI 534350"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Mandapet",
     "Center": "MANDAPETA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAIN ROAD ,NEAR HP BUNK ,TAPESWARAM,MANDAPETA,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Nagaram",
     "Center": "NAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD HAVENS CAMPUS, MAIN ROAD, NAGARAM 533247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Narsapur",
     "Center": "NARSAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KARTHIKEYA NAGAR,21ST WARD,PEECHUPALEM ROAD,NARSAPURAM ,WEST GODAVARI (DT),A.P 534275"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL BRODIPET 2ND STREET, BYPASS ROAD, RAJUGARI BUILDING, PALAKOL, W.G.DT 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR AXIS BANK ,OPP.AMBEDKAR STATUE POOLAPALLI , PALAKOL , WEST GDHAVARI DIST"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Payakaraopeta",
     "Center": "PAYAKARAOPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL Y JUNCTION,NEAR GOVT HOSPITAL,PAYAKARAOPETA,KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Penugonda",
     "Center": "PENUGONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:31-112, OPPOSITE PALACE THEATER, SIDDHANTHAM ROAD, PENUGONDA, AP 534320"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Pitapuram",
     "Center": "PITAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PADA GAYA TEMPLE, BYPASS ROAD, PITHAPURAM,RAJAJMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARASWATHI SOUDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 85-6-15\/1,ROUTHU PLAZA, VL PURAM,RAJAMAHENDRAVARAM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARVANI TOWERS",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, D.NO:75-1-4,PRAKASH NAGAR, RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 14-137\/A,OPP RTC COMPLEX,BEHIND UNION BANK, RAJAMAHENDRAVARAM - 533 103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SRI VYBHAVI",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:78-10-7,SYAMALA NAGAR , BESIDE GOVINDURAJULU HOSPITAL,RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "KOVVURU",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:4-177,VEMULURU ROAD,KOVVURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL H. NO : 89-17 21\/1,MORAMPUDI ROAD, MORAMPUDI - KESAVARAM ROAD, SRI SAI CHAITANYA NAGAR, RAJAHMUNDRY, ANDHRA PRADESH 533107"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO11-11-1,OPPOSITE FIRE STATION,ARYAPURAM,RAJAHMUNDRY,EAST GODAVARI (DT) 533103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO-74-6-54, NEAR T T D KALYANA MANDAPAM,OPP SWATANTRA KUMAR CHURCH,PRAKESH NAGAR,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:17-12\/8\/1,KRISHNA NAGAR,SEETAM PETA,NEAR SATYAM GARI RICE SHOP,RAJAHMUNDRY,EAST GODAVARI (DT)533104"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:4-699\/1, BESIDE BEEJAPURI TOWNSHIP, SRIRAMPURAM ROAD, DIWANCHERUVU, RAJANAGARAM MANDAM, EAST GODAVARI, ANDHRAPRADESH - 533296"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "THE PARK INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:89-17-1\/21 CHAITANYA NAGAR, MORAMPUDI ROAD ,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajole",
     "Center": "RAJOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL(PS) EM SCHOOL,OPP. ANNAPURNA THEATER, MOGALIKUDURU,RAJOLE,RAJAHUMUNDRY 533249"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ramachandrapuram",
     "Center": "RAMACHANDRAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:5-282\/1,SRI CHAITANYA SCHOOL-RAMACHANDRAPURAM, SRINAGAR, OPPOSITE VSM ENGINEERING COLLEGE RAMACHANDRAPURAM,PASALAPUDI BRANCH, ANDHRAPRADESH - 533255"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ravulapalem",
     "Center": "RAVULAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR ANKALAMMA TEMPLE,UBALANKA ROAD,RAVULAPALEM ,EAST GODAVARI DIST 533238"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Razole",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #9-60\/1,OPP.RTC COMPLEX, RAZOLE-533242"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Sakhinetipalli",
     "Center": "SAKHINETIPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, ANTARVEDI PALEM, BESIDE INDIAN OIL PETROL BUNK,SAKHINETIPALLI MANDAL,E G DIST-533252"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO.CWC GUDEM,NALLAGERLA ROAD,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM CBSE",
     "CenterAddress": "SRI CHAITANYA OLYMPIAD SCHOOL,VASAVI IDEAL PUBLIC SCHOOL BUILDING,CHINNATADEPALLI,KADIYADDA POST,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU",
     "CenterAddress": "SRI CHAITANYA SCHOOL,IKEA NAGAR,NH-16,TANUKU,WG.DIST,534211"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PETROL BUNK,VISHNU PRIYANAGAR ,TANUKU VELPURU 534222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #3-41-8\/4, SRIRAM NAGAR, MR PETA, TUNI- 533401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL DURGADAS STREET,OPPOSITE SURESH KUMAR HOSPITAL, KOTHA PETA, TUNI, RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:3-41-8\/4, SAI NAGAR, MR PETA,TUNI,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "SUNKARAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUEU,KV NAGAR, YANAM, 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "YANAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUE, DRAKSHARAMA ROAD, VIA YANAM, SUNKARAPALEM 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yeleswaram",
     "Center": "YELESWARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 3-377\/1, NEAR RAJULA BABU TEMPLE, LINGAMPATHY ROAD,YELESWARAM ,RAJAHMUNDRY,AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Amaravathi",
     "Center": "AMARAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEAR MUSEUM ROAD,AMARAVATHI ,GUNTUR 522020 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "SARASWATHI SOUDHAM BAPATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.94\/1, VIJAYALAKSHMI PURAM, BAPATLA - 522101."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 8-3-8, OPP OLD MAA CABLE, OFFICE, BHIMAVARIPALEM, BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO -4-10-139\/1SRINIVAS NAGAR COLONY,BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripet",
     "Center": "SIDDHARTHA CAMPUS CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.25-367 &amp; 25-367\/1, NEAR R.V.S. HIGH SCHOOL, CHILAKALURIPET - 522616."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GUNDABOLU RAMACHANDRA HOSPITAL, SUBBAIAH THOTA, CHILAKALURIPET GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD DRN SCVS JR.COLLEGE BUILDING,NSP OFFICE, NARSARAOPET ROAD, CHILAKALURIPET,GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chirala",
     "Center": "CHIRALA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NALLA PANENI TOWERS, OPP MARGADHARSI CHIT FUNDS PVT.LTD,MUNTHAVARICENTER,CHIRALA 523165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Dachepalli",
     "Center": "DACHEPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRANTHI NURSING HOME,NARAYANAPURAM,DACHEPALLI(MD)GUNTUR(DT)-522414"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "CHAITANYA LAKSHMI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.22-4-47, TITANIC SHOW ROOM UPSTAIRS, NEAR OLD BUS STAND, LALAPET, GUNTUR - 522003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "ICON CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.5-89-9, 3RD LINE, LAKSHMIPURAM, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "AVANTHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.589-11\/5, 1ST LINE, CHANDRAMOULI NAGAR, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR NAYAR HOTEL CENTER, OPP. CENTRO, LAKSHMIPURAM MAIN ROAD, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR PRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NAYAR HOTEL CENTER, LAKSHMIPURAM MAIN ROAD, BESIDE WOODLAND, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHATMA GANDHI 80FEET INNER RING ROAD, REDDYPALEM, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "INTERNATIONAL SCHOOL WHITEHOUSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NAVABHARAT NAGAR, 4TH LANE,MAHA LAKSHMI TOWERS OPP. CHALAPATHI GROUNDS GUNTUR 522006"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "NEHRU NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL BUCHAITHOTA 1ST LINE,OPP VIJAYAWADA RAILWAY TRACK, NEHRU NAGAR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "REDDYPALEM DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD REDYYPALEM ,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "SYAMALA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYAMALA NAGAR, ZERO LINE,NEAR ARMY CANTEEN,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Macherla",
     "Center": "MACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13TH WARD, R&amp;B BUNGLOW BACK SIDE, NEAR PALAMARA ,MACHERLA GUNTUR (D.T) 522426"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Mangalagiri",
     "Center": "COLLEGE - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  D.NO.7-426 &amp; 7-426\/A, TIPPARLA BAZAR, MANGALAGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Nagaralu",
     "Center": "NAGARALU",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,TELECOME NAGAR 2ND LINE,AMARAVATHI ROAD, NEAR TAGORE RICE MILL,NAGARALU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARASARAOPET RAMANUJAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.11-23-1, RAMIREDDY PET, NARASARAOPET - 522601."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:11-14-1\/1,RAMIREDDYPET,BANK COLONY,NARASARAOPET,GUNTUR."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA CENTER ,SATTENAPALLI ROAD, OPP MAHALAKSHMAMMA CHETTU,NARSARAOPET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 60 FEET ROAD , PRAKASH NAGAR NARASAOPET,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "GAUTAMA BUDDHA BHAVAN PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.416\/B, KOTAIAH SASTRY BAZAR, PIDUGURALLA - 522413."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 7-703\/A ABBUBAKAR MUSEED STREET OPP AXIS BANK PIDUGURALLA,GUNTUR - 522413"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Ponnur",
     "Center": "PONNUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GBC ROAD, PONNUR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Repalle",
     "Center": "PARAMESWARA SADAN REPALLE",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.9-35-210 &amp; 9-35-210\/1, UPPUDI ROAD, REPALLE - 522265."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHINA MAJID CENTER,SBI ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 5-8-8, NAGARJUNA NAGAR,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARK ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "VYAS BHAVAN TENALI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.2-1-74, GANDHI NAGAR, RATNA TALKIES CENTRE, TENALI - 522201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANGANAMMA PET, TENALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR-NO-21-1-60\/1, DEVI CHOWK, RAMALINGESWARAPET,TENALI,GUNTUR-522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR UMESH CHANDRA STATUE,CHENCHUPET,TENALI,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP: GOVERNMENT VETERINERY HOSPITAL ,BURRIPALEM ROAD,TENALI 522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Vinukonda",
     "Center": "VINUKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE CURRENT OFFICE, KARAMPUDI ROAD, VINUKONDA GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Badwel",
     "Center": "BADWEL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDLA STREET,PORUMAMILLA ROAD,BADWEL,KADAPA 516227"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI BALAJI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DONO:1-399 MARUTHI NAGAR, BESIDE KADAPA CAFÉ, KOTIREDDY CIRCLE KADAPA-516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI SAI SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:42\/609-28, NGOS COLONY, APASARA CIRCLE , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,KEERTHI PARK VIEW,OPP RAJIV PARK,MARUTHI NAGAR,KADAPA 516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMBHA BHAVANI TEMPLE,NEAR BUILTUP, KADAPA."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NEHRU PARK,CO-OPRATIVE COLONY,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL ARP COLONY, PRAKASH NAGAR , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL 101\/257-2 RIMS BYPASS ROAD KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUGGA VANKA PROJECT ROAD,NEAR SWAMY NAGAR,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL #97\/217-8,NEAR RTO OFFICE,YSR CIRCLE,C.K.DINNE,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:CHINNACHOWK POLICE STATION,NEHRUNAGAR,KADAPA 516002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAYACHOTI RING ROAD,VUTKUR CIRCLE,KADAPA 516003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Porumamilla",
     "Center": "PORUMAMILLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DESAI MAHAL BACK SIDE,NEAR APSRTC BUSSTAND,PORUMAMILLA(V)KADAPA(DT)AP-516193"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ARAVINDA ASHRAMAM, YMR COLONY , PRODDUTUR, Y.S.R KADAPA(DIST) 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL YERRAGUNTLA BY PASS ROAD, NEAR CINE HUB,PRODDATUR,KADAPA 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL BACKSIDE HONDA SHOWROOM,KVR COLONY,MYDUKUR ROAD,PRODDUTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BOLLAVARAM NEAR GOLDEN PARK JAMMALAMADUGU BYPASS ROAD PRODDATUR, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Pulivendula ",
     "Center": "PULIVENDULA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT 70, BESIDE RTO OFFICE, MUDDANURU ROAD ,PULIVENDULA,KADAPA 516390"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHUVANAGIRI PALLI,RAJAMPET,KADAPA 516115"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL R.S.ROAD, RAJAMPET, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO COLONY,KOTHAPETA,RAYACHOTI,KADAPA 516269"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 430 BESIDE PREETHAM RESIDENCY,RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 5\/283,NEAR BY ICDS OFFICE, BESIDE VINAYAKA TEMPLE, SUNDEPALLI ROAD, RAJULA COLONY RAYACHOTI 516269 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA REDDY NAGAR,MADANAPALLI ROAD RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Avaniggadda",
     "Center": "AVANIGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5TH WARD, NEAR SANTHA MARKET AVANIGADDA,VIJYAWADA KRISHNA (DT)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Challapalli",
     "Center": "CHALLAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CLUB ROAD, RAMANAGARAM(VILLAGE),CHALLAPALLI(MANDAL), KRISHNA (DIST),521126."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gannavaram",
     "Center": "GANNAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GNT ROAD ,KOTHAPETA,GANNAVARAM,VIJAYAWADA 521101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "COLLEGE - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 8\/191, SRI RAM PURAM COLONY, OLD CURRENT OFFICE, BESIDE FISH MARKET ROAD, SATYANARAYANA PURAM, GUDIVADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "SCHOOL - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:10\/153, RAJENDRA NAGAR 1ST LINE, GUDIVADA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Ibrahimpatnam",
     "Center": "IBRAHIMPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR STATE BANK OF INDIA,OPP-MANDALAM OFFICE ,V.T.P.S ROAD,IBRAHIMPATNAM,KRISHNA (DT)521456"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Jaggaiahpet",
     "Center": "JAGGAIAHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: YOGIRAMA HOSPITAL, UMA GOPAL COMPLEX,JAGGAIAHPET,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Kankipadu",
     "Center": "KANKIPADU DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE TVS SHOW ROOM,BANDAR ROAD,KANKIPADU,VIJAYAWADA 521151"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "COLLEGE - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMANAIDU PETA, SHAIK IMAM STREET, MACHILIPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "SCHOOL - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO : 21\/478, SRI CHAITANYA SCHOOL, SAI BABA TEMPLE ROAD, BHASKARAPURAM , MACHILIPATNAM , KRISHNA(DIST), AP 521001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "SCHOOL - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO 1-816, NEAR HEAD POST OFFICE, MANGALAGIRI VIJAYAWADA 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO 5-470,WARD NO.5,TENALI ROAD,NEAR MARKANDEYA KALYANA MANDAPAM,ABOVE ICICI BANK,MANGALAGIRI 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 14-271\/1, CHAIATANYA THOPAVANAM ASHRAMAM, KRISHNA NAGAR, TADEPALLI ,MANGALAGIRI - 522501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI-5",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAROFF BAZAR, VADLAPUDI CENTER,MANGALAGIRI,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mylavaram",
     "Center": "MYLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:-2-58,BESIDE NARAYANA THEATER , MYLAVARAM MYLAVARAM(M.D)KRISHNA (D.T)-521230 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nandigama",
     "Center": "NANDIGAMA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP VARUN BAJAJ , RAITHUPETA,NANDIGAMA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nuzvidu",
     "Center": "NUZVIDU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHERUKURI COMPLEX, BEHIND HERO HONDA SHOW ROOM, H.JUNCTION ROAD, NUZVIDU, KRISHNA (DT) 521201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Penuganchiprolu",
     "Center": "PENUGANCHIPROLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-1,MAKKAPET ROAD,PENUGANCHIPROLU,KRISHNA-521191.AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Repalle",
     "Center": "REPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RAJYA LAKSMI THEATRE,OLD STATE BANK COMPOUND,REPALLE 522265"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Tiruvuru",
     "Center": "TIRUVURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP NAGARJUNA COLLEGE, BOSU BOMMA CENTERE, TIRUVURU VIJAYAWADA 521235"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INDRA TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, USHA LAND MARK, OPP. M&amp;M SHOWROOM, MG ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MAHESWARA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAHESWARA BHAVAN, OPP. HDFC BANK, MG ROAD "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ESWARI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KRISHNAVENI CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SHEDS CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "RABINDRANATH TAGORE BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO. 32-27-9\/1, SARVODAYA VIDYA PEET ST CHUTTUGUNTA, MARUTHI NAGAR, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "VUYYURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OPP. DEEPAK MAHAL KATURU ROAD, BESIDE CARE HOSPITAL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHAVANI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SAI SARASWATHI NILAYAM,  SWATHI THEATER CROMBAAY ROAD, BHAVANI PURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ASHOKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:74-14-2, OLD CHECK POST CENTER, YANAMALAKUDURU LAKULA ROAD, KRISHNA NAGAR (ASHOK NAGAR), BESIDE COMMERCIAL TAX OFFICE, VIJAYAWADA-520007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "BHAVANIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:76-8\/6-5\/1,GUDIVADA RAMA RAO STREET,SWATHI THEATRE ROAD,BHAVANIPURAM,VIJAYAWADA-520012"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "CURRENCY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2ND LINE, OM NAMASHIVYA STREET, CURRENCY NAGAR,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "GOSALA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PUNADIPADU VILLAGE,KANKIPADU MANDAL,GOSALA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL GAYATHRI NAGAR,POLYCLINIC ROAD,NEAR BENZ CIRCLE,VIJAYAWADA 520008"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTL BEZAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:57-6-21\/2, ABC BUILDING, OLD POST OFFICE ROAD, BESIDE SONOVISION, PADAMATA, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KANCHIKACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.PRATAP TVS SHOW ROOM,KANCHIKACHERLA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KRISHNA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:-41-1\/8-42,GOWTHAMI NAGAR 3'RD LINE OPPOSITE AMERICAN HOSPITAL,KRISHNA LANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MARUTINAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:32-26-110\/124, SRI BHAVANI MANSION,MARUTINAGAR,ELURU ROAD,VIJAYAWADA 520004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MOGULRAJAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO36-12\/15\/2A,RAMARAO STREET,MADHU GARDEN,MOGULRAJAPURAM,VIJAYAWADA 520010"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "NUNNA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6-80, BESIDE BSNL TELEPHONE EXCHANGE, MAIN ROAD, NUNNA,VIJAYAWADA - 521212"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ONE TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:4-1-27, BANGARAIAH KOTTU CENTER,ONE TOWN,VIJAYAWADA KRISHNA (DT) 520009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PATAMATA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:40-12-3\/5, OPP:ASWINI ENCLAVE,SEETHARAMA NAGAR, PATAMATALANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PORANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-15-113,PRABHU NAGAR,PORANKI,VIJAYAWADA,KRISHNA 521137."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "S.N. PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR NO : 24-25-63,NEAR FOOD JUNCTION,OPP.RAILWAY QUARTERS,BRTS ROAD,DURGAPURAM,SATYANARAYANAPURAM,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SING NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO. 43-78-7 KRISHNA HOTEL CENTER, AJIT SING NAGAR, VIJAYAWADA-520015"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Visannapet",
     "Center": "VISANNAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, KUKKADAPU PRASAD COMPEX, BESIDE SURVEYNDICATE BANK, MAIN ROAD, VISANNAPETA 521215 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vuyyur",
     "Center": "VUYYUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :- 8-269, SRI CHAITANYA SCHOOL, ANU ARCADE BUILDING, BEHIND CARE HOSPITAL, KATURU ROAD, VUYYURU, KRISHNA (D.T) 521165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHEKURI GARDENS, NEAR NEW RTC BUS STAND,ADONI,KURNOOL 518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 21\/515\/9\/BCD\/1,AMBEDKAR NAGAR,REVENUE WARD-21,A.P.B.H COLONY,ADONI,518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Allagadda",
     "Center": "ALLAGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VISWARUPA NAGAR, ALLAGADDA,KURNOOL(DIST) 518543"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Alur",
     "Center": "ALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL LIC BACK SIDE,ALUR,KURNOOL 521329"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Atmakur",
     "Center": "ATMAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VENKATESWARA SWAMI TEMPLE,GAREEB NAGAR,ATMAKUR,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Banaganapalle",
     "Center": "BANAGANAPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL BANAGANAPALLI NEAR RTC BUS STOP ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Bethamcherla",
     "Center": "BETHAMCHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12TH WARD,DHONE ROAD, BETHAMCHERLA,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Dhone",
     "Center": "DHONE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VENKATANAINI PALLI ROAD,OPP ITI COLLEGE,DHONE,KURNOOL 518222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "SRI GURU RAGHAVENDRA BHAVAN BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,NH 40, OPPOSITE SAFA ENGINEERING COLLEGE, NEAR KRANTI GODOWN, B.THANDRAPADU, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,D.NO 40-304, BESIDE RR HOSPITAL, NEAR MOURYA INN, BHAGYA NAGAR, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL , D.NO:451 42\/13B-7 ,KAPPALA NAGAR,ROAD NO 4,VENKATA RAMANA COLONY LANE,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL VENKATADRI NAGAR, NERA RAILWAY GATE, KALLURU, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:40-321-1-F ,BESIDE OLD AYYAPPA SWAMY TEMPLE, BHASKAR NAGAR,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BESIDE OLD RAVI THEATER, CENTRAL PLAZA, NEAR VINAYAK GHAT, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE VIJAYA DURGA DEGREE COLLEGE, SRINAGA COLONY,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL KNL652,SRI CHAITANYASCHOOL, SANKHALBAGH,KURNOOL-518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO:46-156-D-1A,BUDHAWARAPET NEAR PADMA CHANDRA(OMNI) HOSPITAL, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VISWAK GARDEN, SOMISETTY FUNCTION HALL,SANKAL BAGH,KURNOOL 518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:6-68\/A,SC-COLONY, THANDRAPADU LAKE,OPP.SIVALAYAM,NANDYAL ROAD,KURNOOL518007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI RAMA NAGAR ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL CRR SECONDARY SCHOOL DINNEDEVARAPADU KURNOOL POST BOX NO :-8 ANANTHAPUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandikotkur",
     "Center": "NANDIKOTKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL MADDHUR NAGAR, BESIDE SRI RAMA THEATER, NANDIKOTKUR 518401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 25426-E BEHIND MUNCIPAL OFFICE NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRNIVASA NAGAR,TTD ROAD,OPP: RAITHUBAZAR,NANDYAL,KURNOOL 518502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO'S COLONY, NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SOWJANYA MOTORS,R.S ROAD,NANDYAL,KURNOOL(DIST),A.P"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 13\/71, RAMAKRISHNA NAGAR,KOILAKUNTLA ROAD, KANALA,NANDYAL. KURNOOL (DT)518493"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Pattikonda",
     "Center": "PATTIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 17\/177\/12\/1 YASHODA GARDEN SCHOOL YASHODA GARDEN NEAR RTC BUS STAND PATTIKONDA KURNOOL 518380"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Yemmiganur",
     "Center": "YEMMIGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GEETHA NAGAR, YEMMIGANUR, KURNOOL(DI),AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Buchireddypalem",
     "Center": "BUCHIREDDYPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP OLD RTC BUS STAND,BUCHIREDDYPALEM,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Gudur",
     "Center": "GUDUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANATH NAGAR,OPP Z.P GIRLS HIGH SCOOL,GUDUR,NELLORE 524101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PULLAREDDYNAGAR, BEHIND RSR KALYANA MANDAPAM, KAVALI,SPSR NELLORE DT 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALIKIVARI STREET , OLD TOWN , KAVALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANTHINAGAR KAVALI,SPSR NELLORE DT, 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kota",
     "Center": "KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SRINIVASA NAGAR,KOTA (MANDAL),NELLORE (DT) 524411"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kovvur",
     "Center": "KOVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE PANCHAYT OFFICE, KOTTUR RAMA MANDIRAM ROAD, MANDABAYALU CENTER, KOVUR,SPSR NELLORE (D.T) 524137"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Naidupet",
     "Center": "NAIDUPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL AGRAHARPETA, NEAR SAI BABA TEMPLE, NAIDUPET, SPSR NELLORE DIST 524126"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GAYATHRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VEDAYAPALEM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRI BHARATHI BOYS DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMALINGAPURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "UJWALA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, TIPPA RAJU VARI STREET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRIVANI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PAPPULA VEEDI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "ATMAKUR NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL TENKAYA THOPU,NEAR RAVITEJA KALYANAMANDAPAM ,ATMAKUR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GUPTA PARK",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12-4-294,BESIDE MODEL HIGH SCHOOL,NEAR GUPTHAPARK,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NAWABPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:SIVALAYAM, NARUKUR MAIN ROAD, NAWABPETA, NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ISKON CITY,KONDAYAPALEM,BACK SIDE BHARATH PERTROL PUMP, VANAMTHOPU, NELLORE 524004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SETTYGUNTA ROAD,LAKSHMI PURAM,VENGAMAMBA CENTRE,NAWABPETA,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SANTHAPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR SANTHAPET , NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "AC NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ADDALA SAI BABA TEMPLE,PULIMI PEDDA BUCHI REDDY NAGAR, AC NAGAR, NELLORE 524002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "BALAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAMJI NAGAR, 5TH LINE , BALAJI NAGAR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "MUTHUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO POST OFFICE,MUTHUKUR ,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP HDFC BANK ATM, DHANALAKSHMIPURAM, NELLORE524003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "PODALAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,CHAITANYA NAGAR,RAPUR ROAD,PODALAKUR (MANDAL),NELLORE (DT) 524345"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Sullurpet",
     "Center": "SULLURPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RR SUPER MARKET ,GNT ROAD , SULLURPET,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vedayapalem",
     "Center": "VEDAYAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANDHI NAGAR ,VEDAYAPALEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMMAVARIPETA, MUNICIPAL OFFICE ROAD, VENKATAGIRI,SPSR NELLORE DIST 524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DVS COMPLEX, RAJA STREET, VENKATAGIRI, SPSR NELLORE (DT)524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vinjamuru",
     "Center": "VINJAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE PRAJA VAIDHYASALA, NEAR RTC BUS STAND , VINJAMURU,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ANJANEYA SADAN ADDANKI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.31-419, 31-420, OIL MILL ROAD, ADDANKI - 523201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ADDANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUNGLOW ROAD,ADDANKI,PRAKASAM -523201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Chimakurthy",
     "Center": "CHIMAKURTHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDHI NAGAR 7TH LINE,CHIMAKURTHY ONGOLE 523226"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Darsi",
     "Center": "DARSI",
     "CenterAddress": "SRI CHAITANYA SCHOOL TEACHERSCOLONY,PODILI(ROAD),DARSI,PRAKASAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kandukur",
     "Center": "KANDUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA REDDY NAGER,KANDUKUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.JR COLLEGE,KANDUKUR ROAD,KANIGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUBHASH ROAD,KOTHA PET,KANIGIRI,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Markapuram",
     "Center": "MARKAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.8\/A-20 ,BODAPADU ROD ,OPPISITE RTC DEPO,MARKAPURAM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Martur",
     "Center": "MARTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. VIJAYALAKSHMI KALAYANA MADAPAM, NH-5 ROAD , MARTUR,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "SARASWATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MANGUMUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "CUMBUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.INDIAN PETROL BUNK,NEAR SBI BANK ,GIDDALUR ROAD,CUMBUM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHAGYA NAGAR 2ND LINE, BESIDE REGISTER OFFICE ,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP.HP GAS AGENCY,NEAR MARRI CHETTU,MANGAMUR DONKA ROAD,ONGOLE 523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL V.I.P. ROAD,MANGAMUR DONKA,ABOVE HDFC BANK,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MAHALAKSHMI TOWERS, 4TH LINE ,LAWYERPET,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Pamuru",
     "Center": "PAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.HP PETROL BUNK ,NELLORE ROAD,PAMURU,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Singarayakonda",
     "Center": "SINGARAYAKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE I.T.I COLLEGE,MULAGUNTAPADU(V),SINGARAYAKONDA(M) PRAKASAM DISTRICT 523101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-3,4&amp;5, BEHIND DEEPAMAHAL, SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "KAMAKSHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OLD NH-5 ROAD, OPP. HONDA SHOWROOM, PADMANABHAPURAM, KASIBUGGA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRIKAKULAM ROAD, NEAR AMRUTHA HOSPITAL, OPP. MAHENDRA SHOWROOM, RAJAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI NAGAR , NEAR DEO OFFICE,WOMENS COLLEGE ROAD,SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANGI SURYANARAYANA COLONY, NEAR AYYAPPA SWAMY TEMPLE, ADIVARAMPETA, CHAPURAM PANCHAYAT, PALAKONDA ROAD, SRIKAKULAM 532 001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "GOWRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 12-12-73, OLD BUS STAND ROAD, NEAR SHIRDI SAI THEATRE, ANAKAPALLI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "ANAKAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 80 FEET RING ROAD , OPP HEMA SEKHAR DEGREE COLLEGE, STATION ROAD, ANAKAPALLI,VISAKHAPATNAM -531001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Bobbili",
     "Center": "BOBBILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR CBM CHURCH , BALIJIPETA ROAD, BOBBILI,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Narsipatnam",
     "Center": "NARSIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2-101\/1, NEAR RTC COMPLEX , ANAKAPALLI ROAD, NARSIPATNAM-531116 VISAKHAPATNAM DIST."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Palasa",
     "Center": "PALASA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:14-1-279\/A,NEAR AYYAPPA SWAMY TEMPLE,OLD NH-5 ROAD,PADMANABHAPURAM,PALASA-KASIBUGGA,SRIKAKULAM DIST 532222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Parvathipuram",
     "Center": "PARVATHIPURAM",
     "CenterAddress": "SRI CHAITANAYA SCHOOL , OPP- SRI VENKATESWARA NURSHING HOME ,SUNDERNARAYANAPURAM COLONY , BELAGUM ,PARVATHIPURAM , VIZIANAGARAM ( DIST ) ."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Rajam",
     "Center": "RAJAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP ELECTRICAL SUB STATION, PONDURU ROAD, RAJAM, SRIKAKULAM (DIST) 532127"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN- II",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-48-6-16, SRI VIJAYA SAI TOWERS, OPP. RAMA TALKIES MAIN GATE, SRINAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRIPADA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-48-8-14, BEHIND KALANIKETHAN, NEAR BUDHIL PARK HOTEL, DWARAKANAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-58-22-50, NEAR NAD HOSPITAL, SUSARLA COLONY, BUTCHIRAJUPALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO 6-62-6\/1, NEAR GAJUWAKA POLICE STATION, SHRAMIK NAGAR, CHINAGANTYADA, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYSHNAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MIG 110, D.NO 24-3-1,BUDA COLONY,PEDAGANTYADA, GAJUWAKA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYDEHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, STEEL PLANT MAIN ROAD, UKKUNAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRISAI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 34\/2, PILAKAVANIPALEM, CARSHED JUNCTION, P.M PALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 10-12-8, OPP PYDAH DEGREE COLLEGE REDNAM GARDENS RAM NAGAR,ASILMETTA VISAKHAPATNAM -530002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 11-4-1\/1,UDAY SRI TOWERS, RAMNAGAR,ASILMETTA,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:26- 42-10\/2,BESIDE SRI CHAITANYA JUNIOR KALASALA,CHAITANYANAGAR,OLD GAJUWAKA,VISAKHAPATNAM-530026."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 27-1-65,SRINAGAR,GAJUWAKA,VISAKHAPATNAM,530026"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KOMMADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VIJAYA MOHAN LAYOUTS,NEAR CHAITANYA ENGG COLLEGE, KOMMADI VILLAGE,CHINAGADILI MD MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KURMANNAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 31\/6-3\/1 OPP. STEEL CITY APSRTC BUS DEPO SATHAVAHANANAGAR ROAD NO.6,MAINROAD KURMANNAPALEM, GAJUWAKA MANDAL VISAKHAPATNAM 530046"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: CMR GARDENS, MADHURAWADA , VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR FLY OVER BAKKANAPALEM ROAD, MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MVP COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-10-2\/4, USHA RESIDENCY, SECTOR-1,MVP COLONY, VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D.NO. 58-1-237, TEEGALA TOWERS, MARRIPALEM ROAD, NAD, VIZAG 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D-NO-58-15-116\/A, OPP GAJANANA FORT, SANTHI NAGAR, NAD ,VISAKHAPATNAM 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "PENDURTY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SBI, PULAGANIPALEM ROAD, PENDURTY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Yalamanchali",
     "Center": "YALAMANCHILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR FIRE STATION,RAMAKRISHNAPURAM, YELAMANCHILI,VISAKHAPATNAM-531055"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL, 100 FEET RING ROAD, DHARMAPUR, NEAR VENKATESWARA SWAMY TEMPLE, VIZIANAGARAM 535001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR NEAR BUS STOP,BOWDARA MAIN ROAD, VIZIANAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagarm",
     "Center": "VIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO-102,103,104, NAIDU COLONY, THOTA PALEM, VIZIANAGARM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Eluru",
     "Center": "COLLEGE - ELURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAIN CAMPUS- ELURU, MARGHADARSHI ROAD, NARASIMHA RAO PETA, ELURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Palakol",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS BRODIPET, BRODIPET BIPASS ROAD, PALAKOLLU, WEST GODAVARI - 534260"
    },
    {
     "State": "Bihar",
     "District": "Patna",
     "City": "Patna",
     "Center": "Knowledge Hub",
     "CenterAddress": "Abc tower, Main Boring road, Plot no - 134, Opp Harihar Chamber, Patna, 800001"
    },
    {
     "State": "Chandigarh",
     "District": "Chandigarh",
     "City": "Chandigarh",
     "Center": "Sri Chaitanya Centre",
     "CenterAddress": "SCO 369-70, Sector 34A, Chandigarh, India"
    },
    {
     "State": "DELHI",
     "District": "Delhi",
     "City": "Gurugram",
     "Center": "GURUGRAM 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUSHANT LOK, C BLOCK, GURUGRAM"
    },
    {
     "State": "DELHI",
     "District": "Delhi",
     "City": "Gurugram",
     "Center": "GURUGRAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SECTOR 56, BLOCK-C , SUSHANT LOK PHASE-II , VILLAGE-GHATTA TEHSIL-SOHNA NEAR HUDA MARKET, GURUGRAM, HARYANA 122002"
    },
    {
     "State": "DELHI",
     "District": "Delhi",
     "City": "Gurugram",
     "Center": "GURUGRAM 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BLOCK K#6, SECTOR 83, BEHIND VATIKA LIFE STYLE HOMES, GURUGRAM, HARYANA 122001"
    },
    {
     "State": "HARYANA",
     "District": "Palwal",
     "City": "Palwal",
     "Center": "PALWAL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL ALIGARH,PALWAL ROAD,NEAR KITHWARI VILLAGE,HARYANA-121102"
    },
    {
     "State": "Haryana",
     "District": "Panchkula",
     "City": "Panchkula",
     "Center": "Sri Chaitanya Centre",
     "CenterAddress": "SCO 219, 2nd Floor, Sector 14, Panchkula"
    },
    {
     "State": "HARYANA",
     "District": "Rewari",
     "City": "Rewari",
     "Center": "REWARI",
     "CenterAddress": "SRI CHAITANYA SCHOOL E-BLOCK,SUNCITY,SECTOR 6-7,REWARI,HARYANA-123401"
    },
    {
     "State": "HARYANA",
     "District": "Rohtak",
     "City": "Meham",
     "Center": "MEHAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 108TH MILESTONE,NH-10,HISAR ROAD,MEHAM,HARYANA-124112"
    },
    {
     "State": "Karnataka",
     "District": "Belgaum",
     "City": "Belgaum",
     "Center": "Sri Chaitanya Belgaum Knowledge Hub",
     "CenterAddress": "Krishnai Arcade Tanishq, Opp Tata Croma, khanapur road, Tilakwadi Belgaum - 590006, Contact :-+91 72079 14070. "
    },
    {
     "State": "KARNATAKA",
     "District": "Bellary",
     "City": "Ballari",
     "Center": "BALLARI",
     "CenterAddress": "SRI CHAITANYA SCHOOL N K B COMPOUND , BACK SIDE OF BHARAT PETROL BUNK , HAVAMBHAI, SIRIGUPPA ROAD, BALLARI, 583101"
    },
    {
     "State": "KARNATAKA",
     "District": "Bellary",
     "City": "Hospet",
     "Center": "HOSPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE HAMPI INTERNATIONAL HOTEL,RAILWAY STATION ROAD ,HOSPET KARNATAKA - 583201"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANASWADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 84\/1, GARDEN HOUSE, 5TH MAIN, OMBR LAYOUT, BANASWADI, BANGALORE-560033"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANNERGHATTA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL 75\/A, BANNERGHATTA ROAD, HULIMAVU, BANGALORE-560076"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BASAVANAGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #2, B.P WADIA ROAD, PANDU TOWERS, TAGORE CIRCLE, BASAVANAGUDI, BANGALORE-560004"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ELECTRONIC CITY INTERNATIONAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL LAKSHMINARAYANAPURA, BEHIND APMC FRUIT MARKET, NEAR HUSKURGATE, ELECTRONIC CITY, ANEKAL TALUK, KARNATAKA - 560099"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HEBBAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NO: 49\/4, KASABA HOBLI, VEERANNA PALYA MAIN ROAD,NAGAWARA VILLAGE,HEBBAL, ARABIC COLLEGE POST, BANGALORE 560045"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HSR LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL #55\/2, 19TH MAIN, 27TH CROSS, SECTOR 2, HSR LAYOUT, BANGALORE.PIN :560102"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "JP NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8TH PHASE,JAMBU SAVARI DINNE, JP NAGAR,BENGALURU "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KAGGADASAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 121\/4,VEMANNA ROAD,5TH MAIN, 7TH CROSS,MALLESHPALAYA, KAGGADASAPURA,BANGALORE -560075"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KANAKAPURA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 11, NEAR MANTRI TRANQUIL, GUBBALALA VILLAGE, KANAKAPURA ROAD, BANGALORE 560062"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KR PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAMMANNA GARDEN, DEVASANDRA MAIN ROAD, BEHIND&nbsp;KAVERI&nbsp; BAKERY, K.R.PURAM, BANGLORE-560036"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, #429, PRABHU LAYOUT, AECS LAYOUT, KUDLU, BANGALORE 560068"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUDLU2 #165,KUDLU VILLAGE,NEAR PARAPPANA AGRAHARA,MADIWALA (P),BENGULURU-560068."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "M S PALYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13\/1, NEAR AMBHABHAVANI TEMPLE, DODDABETTAHALLI, VIDYARANYAPURA POST MSPALYA - BANGALORE - 560097"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MAHALAKSHMI LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 227, 15TH C CROSS ROAD, 2ND PHASE, BOVIPALYA, NAGAPURA, MAHALAKSHMI LAYOUT,BENGALURU, 560086"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #86\/1C,NEAR S.G.R DENTAL COLLEGE,MUNNEKOLALA,MARATHAHALLI-1"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 93\/10, 93\/11, 93\/2A3, 93\/2A4, MUNNEKOLALA VILLAGE, BESIDE SHANMUKHA RESTAURANT, NEAR MARATHAHALLI BRIDGE, MARATHAHALLI, BANGALORE-560037"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "NAGARBHAVI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 42\/65, OPP BANGALORE UNIVERSITY STAFF QUARTERS, JNANAGANGA NAGAR, MYSORE-MAGADI RING ROAD, NAGARBHAVI,BANGALORE 560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "PEENYA DASARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYNO,65\/1,65\/2,NAGASANDRA VILAGE,YESHWANTHPUR HOBLI,BANGALORE 560073"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAJAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #21,(A-108)22, 5TH MAIN ROAD, TNDUSTRIAL AREA, 6TH BLOCK, RAJAJINAGAR, BANGALORE:-560010"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SEETHAPPA GARDEN, RAGHAVENDRA CIRCLE, T C PALAYA MAIN ROAD, RAMAMURTHY NAGAR, BANGALORE - 560016"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO. 131\/2, OPP. STATE BANK OF MYSORE, 1ST MAIN, 5 E CROSS, POOJA GARDEN, ASHIRWAD COLONY, HORAMAVU, BENGALURU 560043"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR HARIVILLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.91\/1,HOYSALA NAGAR, 8TH MAIN,5TH A CROSS,T C PALYA MAIN ROAD,RAMMURTHYNAGAR, BENGALURU 560016 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "SESHADRIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:79,SRINIVASA COMPLEX, 1ST MAIN ROAD, NEAR FORTIS HOSPITAL, SESHADRIPURAM, BENGALURU, KARNATAKA 560020"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ULLAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 161\/4,ULLAL VILLAGE,ULLAL,YESWANTHPUR HOBLI,BENGALURU-560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "UTTARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27, AREHALLI, AGS LAYOUT, ITTAMADU MAIN ROAD, UTTARAHALLI, BANGALORE-560061"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "VIDYARANYAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#21\/3, RAMCHANDRAPURA, VIDYARANYAPURA,JALAHALLI POST ,BANGALORE 560013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "WHITEFIELD",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#190, ANS SQUARE, NEXT TO SATHYA SAI COMPLEX, ITPL MAIN ROAD, NEAR HOODI CIRCLE, HOODI, WHITEFIELD, BENGALURU 560048"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YELLAHANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 30\/2A, THIRUMALA NAGAR, ATTUR LAYOUT, NEAR THIRUMALA DABA, YELAHANKA, BANGALORE"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YESHWANTHPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #22\/2, HMR COMPUND, 6TH CROSS, 1ST MAIN, YESHWANTHPUR, BENGALURU-560022"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Jayanagar Knowledge Hub",
     "CenterAddress": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
     "CenterAddress": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068."
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
     "CenterAddress": "PID no 21\/97\/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Davanagere",
     "Center": "DAVANAGERE",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE DCM RAILWAY BRIDGE, P B ROAD, DAVANAGERE,BENGALORE 577003 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Mangalore",
     "Center": "MANGALORE",
     "CenterAddress": "SRI CHAITANYA TENCHO SCHOOL BANGRA KULOOR ROAD , KOTTARA CHOWKI ,MANGALORE 576013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KYATHSANDRA FLYOVER, NH-4, KYATHSANDRA, TUMKUR 572104"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TUDA OFFICE ADARSHANAGAR, SRI SAI BABA TEMPAL ROAD, TUMKUR 572103"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI SAI BABA TEMPLE, OPP TUDA OFFICE, ADHARSHA NAGAR,TUMKUR,KARNATAKA "
    },
    {
     "State": "KARNATAKA",
     "District": "Dharwad",
     "City": "Hubli",
     "Center": "HUBLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUSUGAL ROAD,NEAR VRL RESIDENCY,SARASWATHIPURAM,KESHAWPUR,HUBLI 580023"
    },
    {
     "State": "KARNATAKA",
     "District": "Koppal",
     "City": "Gangavathi",
     "Center": "GANGAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL C\/O SAPTHAGIRI PUBLIC SCHOOL NEAR SAMARTH KOPPAL ROAD WADDARHATTI GANGAVATHI-583227 "
    },
    {
     "State": "KARNATAKA",
     "District": "Mandya",
     "City": "Mandya",
     "Center": "MANDYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP SANJO HOSPITAL,SRINIVASAPURA, BM HIGHWAY, MANDYA,KARNATAKA"
    },
    {
     "State": "KARNATAKA",
     "District": "Raichur",
     "City": "Raichur",
     "Center": "RAICHUR-3",
     "CenterAddress": "SRI CHAITANYA SCHOOL ASHAPUR ROAD, NEAR RAJMATHA TEMPLE, KRISHNAGIRI HILLS,RAICHUR"
    },
    {
     "State": "KARNATAKA",
     "District": "Raichur",
     "City": "Sindhanur",
     "Center": "SINDHANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TO KANNIKA PARAMESHWARI TEMPLE, PWD CAMP, SINDHANUR 584128"
    },
    {
     "State": "MADHYA PRADESH",
     "District": "Bhopal",
     "City": "Bhopal",
     "Center": "BHOPAL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. TO PRIDE CITY,NEAR KATARA HILLS,RAPADIA VILLAGE,BHOPAL,MADYAPRADESH-462043"
    },
    {
     "State": "MADHYA PRADESH",
     "District": "Indore",
     "City": "Indore",
     "Center": "INDORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA AVENUE,NEAR SMALL POWER HOUSE,RANI BAGH MAIN,KHANDWA ROAD,INDORE 452001"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Aurangabad",
     "City": "Aurangabad",
     "Center": "AURANGABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.Y.S.KHEEDKHAR INTERNATIONAL SCHOOL,PSPM CAMPUS,NEAR PHISTIYA CHOWK N-6,CIDCO COLONY ,AURANGABAD,MAHARASTRA-431003"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Andheri Sri Chaitanya Centre",
     "CenterAddress": "Sri Chaitanya, 301,B wing. Business point. Paliram road. Andheri west. Near by BMC office Mumbai 400058"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Borivali Sri Chaitanya Centre",
     "CenterAddress": "Brio e-Tech Jr. College &amp; V K Krishna Menon Academy, Plot no. 462, New MHB Colony, Off Gorai Road, Borivali West, Mumbai -400091"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Thane Sri Chaitanya Centre",
     "CenterAddress": "M. H. High School and Junior College, Shivaji Path near Thane station &amp; Talaopali Thane (W)"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Mumbai",
     "City": "Ulhasnagar",
     "Center": "ULHASNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYAN-MURBAD ROAD,NEAR RIVER WIND RESORT,OPPOSITE TO HP PETROL BUNK, KAMBA, KALYAN, ULHASNAGAR – 421103."
    },
    {
     "State": "Maharashtra",
     "District": "Nanded",
     "City": "Nanded",
     "Center": "Sri Chaitanya Knowledge Hub",
     "CenterAddress": "2nd Floor, Lotia Building, Reliance Digital Upstairs,Beside Shivaji Police Station, Shivaji Nagar, Nanded - 431620, Contact :-6301871851."
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "AUNDH JAIHINDH BLDG",
     "CenterAddress": "SRI CHAITANYA IIT ACADAMY, 4TH FLOOR   JAIHINDH BUILDING PARIHAR CHOWK AREA AUNDH PUNE 411007"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "BAVDHAN CAMPUS PUNE",
     "CenterAddress": "SRI CHAITANYA TECHNO SCHOOL NEAR CRYSTAL HONDA SHOWROOM MUMBAI-PUNE HIGHWAY BAVDHAN(BK) PUNE 411021"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "WAGHOLI CAMPUS PUNE",
     "CenterAddress": "SRI CHAITANYA TECHNO SCHOOL, KONARK ORCHID, GATE NO . 905,906,926,1085 OPP. SATAV ENTERPRISES, BESIDES SEEMA WAREHOUSE, KESNAND ROAD, WAGHOLI,PUNE-412207"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "SHIVAJI BHAVAN PUN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, SURVEY NO 134,NEAR XRBIA CHOWK MARUNJI TO KASARSAI ROAD, NERE DATTAWADI , POST : JAMBE,TAL - MULSHI PUNE,MAHARASHTRA-411057"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE,  NANDHE SYMBOYSIS UNIVERSITY(NAWALE)  NEAR LOPIN COMPANI GURUKUL HOSTAL  MULSHI TALUKA  NANDHE  PUNE-411042"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "BAVADHAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:267\/3, OLD MUMBAI - PUNE HWY, NEAR CRYSTAL HONDA SHOWROOM, BAVDHAN, PUNE"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "WAGHOLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL KONARK ORCHID, OPPOSITE SATAV ENTERPRISES, KESNAND ROAD, BESIDE SEEMA WAREHOUSE, WAGHOLI, MAHARASHTRA 412207"
    },
    {
     "State": "PUNJAB",
     "District": "Jalandhar",
     "City": "Jalandhar",
     "Center": "JALANDHAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL ELDECO GREENS, NAKODAR ROAD, JALANDHAR CITY, JALANDHAR - 144026"
    },
    {
     "State": "PUNJAB",
     "District": "Moga",
     "City": "Moga",
     "Center": "MOGA",
     "CenterAddress": "SRI CHAITANYA SCHOOL LUDHIANA ROAD, PURANEWALA VILLAGE ROAD, MOGA 142001"
    },
    {
     "State": "RAJASTHAN",
     "District": "Jaipur",
     "City": "Jaipur",
     "Center": "JAIPUR 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMLA NEHRU NAGAR, KESHU PURA, NEAR DOUNGRI HOUSE, AJMER ROAD, JAIPUR, RAJASTHAN, 303006"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "IYYAPANTHANGAL",
     "CenterAddress": "SRI CHAITHANYA SCHOOL 16\/2,EVP PARK AVENUE 2ND STREET IYYAPANTHANGAL CHENNAI 600056"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KEELKATTALAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/1234,THIRU NAGAR,VIDUTHALAI NAGAR EXTN,KOVILAMBAKKAM,KEELKATTALAI,CHENNAI-600129"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KK NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 132 PILLAIYAR KOIL STREET KASI ESTATE JAFFERKHANPET,KK NAGAR CHENNAI -600083"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MADHAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD ,HOUSING SECTOR MADHAVRAM,CHENNAI-600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MANAPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 472\/1, BALARAMAN STREET, THIRUVALLUVAR NAGAR, MANAPAKKAM CHENNAI 600125"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MOOLAKADAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:1065\/1A1,TS NO.11, BLOCK 58,KKR NAGAR, MADAHAVARAM ,CHENNAI 600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MYLAPORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO: 4, NORTON ROAD,MANDAVELI,MYLAPORE,CHENNAI 600028"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "NOLAMBUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 314\/4, VGN NAGAR PHASE 1 3RD CROSS STREET, NOLAMBUR, CHENNAI-600095"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALAVAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:10\/6, MGR ROAD, ECR PALAVAKKAM, CHENNAI 600041"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 110 GST ROAD, ADJECENT PALLAVARAM FLYOVER ROAD, PALLAVARAM, CHENNAI 600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 200 FEET RADIAL ROAD, ARUL MURUGAN NAGAR,ZAMIN PALLAVARAM ,CHENNAI-600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUMBAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 139, INDIRA PRIYADHARSHINI NAGAR LAYOUT, NEAR GLOBAL HOSPITAL, PERUMBAKKAM, CHENNAI 600100"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUNGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 1,44A,CORPORATION ROAD,PERUNGUDI,CHENNAI 600096"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "POONAMALLEE INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO :184 POONAMALLEE TO PATTABIRAM MAINROAD,SOKKANALLUR,KOLAPPANCHERI,CHENNAI 600072"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "RAMAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12\/2,12\/3 ANANI SATHYA NAGAR MAIN ROAD THIRUVALLUVAR SALAI RAMAPURAM CHENNAI-600089 TAMILNADU"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "ROYAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8\/89, PUDUMANI KUPPAM,WEST MADHA CHURCH STREET,OPP GOVERNMENT UNANI HOSPITAL,ROYAPURAM,CHENNAI - 600013."
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "TAMBARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.276,GANDHI NAGAR.MUDICHUR MAIN ROAD,WEST TAMBARAM,CHENNAI 600063"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "THORAIPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL #104\/8C3, FOUNDRY ROAD, OKKIYAM THORAIPAKKAM, CHENNAI - 600097"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "VELACHERY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #169 VAIGAISTREET DEVIKARUMARIAMMAN NAGAR EXTN VELACHERY -600042"
    },
    {
     "State": "Tamil Nadu",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "Sri Chaitanya Knowledge Hub",
     "CenterAddress": "No.19, 1st Main Road, Gandhi Nagar, Above Pantaloons, Adyar, Chennai -600020, Contact :-7207931589 \/ 7207931590. "
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,DOOR NO:79, ATHIPALAYAM RD, NEAR JAS COLLEGE OF EDUCATION, CHINNAVEDAMPATTI, COIMBATORE 641049"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 806,WISDOM TREE, KATHIR CAMPUS,NEELAMBUR,COIMBATORE-641062"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.11,DR.NANJAPPA ROAD, NEAR PARK GATE ,BESIDE NEHRU STADIUM,GANDHIPURAM, COIMBATORE 641018"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL S.F.NO 22, LAKSHMI NAGAR, SENAMANICKENPALAYAM ROAD, IDIKARAI, COIMBATORE,TAMIL NADU 641022"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Tiruppur",
     "Center": "TIRUPPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 537 VIVEKANANDA NAGAR, COLLEGE ROAD, TIRUPPUR 641603"
    },
    {
     "State": "TAMIL NADU",
     "District": "Erode",
     "City": "Erode",
     "Center": "ERODE",
     "CenterAddress": "SRI CHAITANYA SCHOOL 111\/3,BEHIND FORD SHOWROOM,NANJANAPURAM,THINDAL,ERODE-638012"
    },
    {
     "State": "TAMIL NADU",
     "District": "Karur",
     "City": "Karur",
     "Center": "KARUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:113&amp;114, LNS VILLAGE, KARUR 639002"
    },
    {
     "State": "TAMIL NADU",
     "District": "Krishnagiri",
     "City": "Hosur",
     "Center": "HOSUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY. NO:116\/2, DINNUR BUS STOP, OPP. TO RK AVENUE, BEHIND FAIR MART, HOSUR 635109"
    },
    {
     "State": "TAMIL NADU",
     "District": "Krishnagiri",
     "City": "Hosur",
     "Center": "HOSUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL F.NO:36\/6 &amp; 36\/7, BEHIND TREND CITY LAYOUT, SANTHAPURAM AGRAHARAM VILLAGE,VIA BAGALUR ROAD, HOSUR MUNICIPALITY, KRISHNAGIRI- 635109"
    },
    {
     "State": "TAMIL NADU",
     "District": "Namakkal",
     "City": "Namakkal",
     "Center": "NAMAKKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 3\/19A,THURAIUR ROAD, KOOLITATTI NAMAKAAL , OLD SREE MAHABHARATHI SECONDARY HIGHER SCHOOL 637002"
    },
    {
     "State": "TAMIL NADU",
     "District": "Salem",
     "City": "Salem",
     "Center": "SALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.3\/6, N K N NAGAR, PERUMAL MALAI ROAD, NARASOTHIPATTY, KURANGUCHAVADI, SALEM 636004"
    },
    {
     "State": "TAMIL NADU",
     "District": "Tiruchirappalli",
     "City": "Trichy",
     "Center": "TRICHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.1,KUMARAN ROAD,SENTHANEERPURAM,NEAR APOLLO HOSPITAL,TRICHY-620004 "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARNAKA (HARI HARA HEIGHTS)",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-13-1210\/1, STREET NO 10, TARNAKA, SECUNDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 6-10-8\/1\/1, NAGENDRA NAGAR, HABSIGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANTHAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-9-29, SHARADA NAGAR, ADRM HOSPITAL LANE, RAMANTHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,1-7-158\/2&amp;1-7-159\/1,KAMALA NAGAR,ECIL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SECENDRABAD",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,OLD LICBUILDING,BEHIND HDFC BANK,NEAR PARADISE CIRCLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ALWAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ALWAL,PNO 27&amp;28,H.NO-1-12-115,MADHAVI NAGAR COLONY,"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "WEST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, R.C NO 23010\/62206\/C23-1\/2002-03,WEST MAREDPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SATYASAI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:18-98,KAMALA NAGAR,CHAITANYAPURI,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI BHAVAN ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO: 5-4-59\/2\/1 SARASWATHI BHAVAN, NEAR GENESIS HIGH SCHOOL, SANGEETH NAGAR, KUKATPALLY, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRIVIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 5-4-58\/9\/1 &amp; 5-5-7\/10\/1, PLOT NO 7 &amp; 8, KUKATPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI VIKRAM TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAI VIKRAM TOWERS, 3RD FLOOR, BESIDE METRO STATION, KUKATPALLY,HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI BHASKAR BHAVAN, ABOVE NEXA CAR SHOWROOM, A S RAJU NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAGDEVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VAGDEVI BHAVAN, PHASE I, BESIDE MRO OFFICE, KPHB COLONY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, APIIC COLONY, OPP IDPL COLONY, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SPRING FIELD COLONY, NEAR GOOD SHEPHERD SCHOOL, SUCHITRA, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHARATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHARATHI BHAVAN, PLOT NO: 5,6 &amp; 7, BEHIND MAX SHOPPING MALL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHARADHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 1-58\/A\/8\/1, RAMA KRISHNA COLONY, BESIDE NAIDU EYE HOSPITAL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASUDA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BACK SIDE KAJANA JEWELERS, MADINAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "JAI HIND COMPLEX",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO 53 TO 63 H NO: 5-88\/2 NEAR ZPH SCHOOL MANIKONDA, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SOUDAMINI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 4-94, CHANDA NAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MAIN CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-5-947 &amp;948, OPP.TAJMAHAL HOTEL, SUDARSHAN BUILDING, NARAYANAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAYS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-4-703,VAYS BHAVAN,NEAR NARAYANAGUDA FLYOVER,HYDERABD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AKSHARA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/279, 256\/M6, BESIDE AXIS BANK, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMRUTHA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/550, 516\/3RT, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ARYABHATTA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 7-1-414\/35(B), AMEERPET,HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "YOUSUFGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8-3-318\/6\/6, BANDARU BHAVAN, 2ND FLOOR, YOUSUFGUDA, HYDERABAD-500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8229382\/J111\/573 G, RAJIV BHAVAN, JUBILEE HILLS, OPP: KBR PARK, GATE NO 6, ROAD NO -1, JUBILEE HILLS, HYDERABAD-500096"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PILLAR NO: 143, H.NO: 3-4-183\/1, ATTAPUR, RAJENDRA NAGAR, RANGA REDDY DISTRICT-500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R K PURAM-2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ROAD NO-1,GREENHILLS COLONY,KOTHAPET"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BALAJI ARCADE ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR CHIKKADPALLY METRO, ABOVE RAMRAJ COTTON, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LBNAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 3-1-33, BAHADURGUDA, LBNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYDEHI BHAVAN AUTONAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 284 (WESTERN PART), NAKKA VENKATA SWAMY YADAV NAGAR, BAGH HAYATHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "UPPAL RES BODUPPAL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-165\/9, PEERZADIGUDA, UPPAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NAGOLE ENCLAVE,BAHADURGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VIVIN TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MADHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VEDAVYAS 1",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO. 319, 320  BESIDE. H.P. PETROL PUMP, NARSINGI,  GANDIPET MD RANGA REDDY DT"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANUJAM BHAVAN BONGULOR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D:NO 5-105, SY.NO:109(PART), OLD JNIT ENGG COLLEGE, BONGULUR X ROADS, MANGALPALLI-PATELGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYASA BHAVAN ADIBATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SURVEY NO 163\/AA, OF BONGULURU VILLAGE, IBRAHIMPATNAM MANDAL, RANGAREDDY DIST"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANDLAGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO 196, ARUNODHAYA COLONY, BANDLAGUDA ROAD NAGOLE, HYD-35"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUSHRUTHA BHAVAN MEDIPALLY CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MEDIPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO-265  AUSHAPUR,ANKUSHAPUR POST  "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PANANIYA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO 103,BLOCK 2B,VVNAGAR,GADDINNARAM"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERNAGAR BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SYNO . 1598169\/2 SRI CHAITANYA JR COLLEGE, HYDERNAGAR BOY CAMPUS, MANJEERA WATER WORK ROAD, NEAR CALAVERY TEMPLE, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MIYAPUR GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE FOR GIRLS,HOUSE NO 1-62 &amp;1-62\/1,SRI VIDYA BHAVAN"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KPHB RES PRATIBHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KPHB RES PRATIBHA BHAVAN,SRI CHAITANYA JUNIOR KALASALA, DHARMA REDDY COLONY,KPHB PHASE -3,NEAR LOTUS HOSPITAL BESIDE STREET ,NEAR TO OPPOSITE PRATIBHA SCHOOL,JNTU, "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PRATHIBHA SAI NAGAR HYD",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, FLOT NO \/ PLOT NO \/ SURVEY NO -16-2-132\/135\/231 STREET NAME -K V R COMPLEX,NIZAMPET CROSS ROAD AREA NAME -SAINAGAR COLONY NEAR BY LAND MARK -LUCID DIAGNASTICS CITY - HYDERABAD PINCIDE -500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI SAI DARBHAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO.1-62\/SD\/5TO 8\/1,PLOT NO.5678,SY NO:198\/2\/A, SRI AUROBINDO COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-217\/A, BALKAMPET, B K GUDA, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DSNR ZONAL DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAIBABA TEMPLE LINE,P &amp; T COLONY,BESIDE SANJAY STEEL,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L B NAGAR ZONAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:3-6-260,L B NAGAR,SBI BANK COLONY,VENTURE -1"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R.K.PURAM SEMI RESI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:11-13-1106&amp;1107,NEAR VICTORIA,MEMORIAL METRO STATION,GREEN HILLS COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHASKAR BHAVAN, OMNI HOSPITAL BACK SIDE, BALAJI NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMAN BHAVAN, BHAGYA NAGAR CO-OPERATIVE SOCIETY , SHIVA PARVATHI THEATER RAOD, OPP KPHB, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 8-3-319\/8\/2 TO 6&amp;319\/2\/7,NEAR SARADHI STUDIOS YOUSUFGUDA,MAIN ROAD AMEERPET HYD 500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO-8-3-222 \/ A\/1,2,3 PLOT NO-C 57-C 59 BESIDE ALLAHABAD BANK ( INDIAN BANK ), MADHURA NAGAR YOUSUFGUDA MAIN ROAD ,AMEERPET HYDERABAD 500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-4-183\/1, SATTI REDDY COMPLEX, ATTAPUR,RAJENDRA NAGAR, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO - 367&amp;368 , KAKATEEYA HILLS (KAVURI HILLS), ROAD NO -8, MADHAPUR , JUBILEE HILLS , GUTALA BEGUMPET , SHERILINGAMPALLY MANDAL, RANGA REDDY DISTRIT - 500081"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:143,145,149,JAYA ABODE,OPP:ANDHRA BANK,SECRETARIAT COLONY,MANIKONDA 500089"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHAMSHABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 578\/A582\/A,ADARSH NAGAR,SHAMSHABAD, RANGAREDDY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SR NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR.NO.7-1-621\/280 &amp; 281,254 &amp; 255-3RT, SR NAGAR MAIN RD, ABOVE SBH BANK, SANJEEVA REDDY NAGAR, HYDERABAD, TELANGANA,500038."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUN CITY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 1-2\/1, SHANTHI NAGAR COLONY, HYDERSHAKOTE, SUNCITY, RR. DT- 500091"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TOLICHOWKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8-1-22\/1\/M, 7 TOMBS ROAD,OPPOSITE GOLDEN PALACE,FUNCTION HALL,TOLICHOWKI, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHAITANYAPURI CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PANANIYA MAHAVIDYALAYA PUBLIC SCHOOL,OPP THANKUR HARI PRASAD INSTITUTE,CHAITANYAPURI,DILSUKNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DILSUKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:3-10\/A,HANUMANNAGAR,BESIDE PAKALA PLAZA,OPP.SAPTAGIRI HOSPITAL,CHAITANYAPURI,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GADDI ANNARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.16-2-752\/123\/1\/123\/A&amp;4A, SHIVA GANGA THEATRES ROAD, BESIDE: SBH BANK, GADDIANNARAM, HYD-500060"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GAYATHRI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 2&amp;131, NEAR GAYATHRINAGAR X ROADS, BESIDE SBI BANK, GAYATHRINAGAR, JILLALAGUDA,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:60,64 &amp; 67,71 KHALSA, HAYATHNAGAR RR(DT) 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT. NO. 5,6,7,8,9 &amp; 10,KHALSA,HAYATHNAGAR,RANGAREDDY 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KESHAVAPURI",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 8-7-92\/K, KESHAVAPURI COLONY, SAGAR ROAD, HASTINAPURAM,HYDERABAD TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHALSA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR HIWAY BAWACHI HOTEL LINE,SUGUNA ENCLAVE,KHALSA,HAYATNAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHARMANGHAT",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:7,SRINIVASA NAGAR COLONY,OPP:UCO BANK,KHARMANGHAT,HYDERABAD 500035"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOTHAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.23-38\/2&amp;3,KRISHNAVENI NAGAR,OPP:FRUITMARKET LANE,NEAR GHMC EAST ZONAL OFFICE,KOTHAPET,DILSUKNAGAR,HYDERABAD,R.R.DIST-60."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-11-282,SHIVA GANGA COLONY,OPP. BIG BAZAR,LBNAGAR,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 3-11-461\/A PART, ROAD NO: 2, SHIVA GANGA COLONY ,MANSOORABAD, L.B NAGAR, HYDERABAD, TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANSOORABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SAI BABA TEMPLE,KAMINENI HOSPITAL BYPASS ROAD,LAXMI NAGAR COLONY,MANSOORABAD,HYDERABAD-500074"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:1234.OPP:Y JR FUNCTION HALL,TMR ENCLAVE ,NEAR MEERPET CROSS ROAD,BADANGPET HYDERABAD 500097"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MOOSARAMBAGH",
     "CenterAddress": "SRI CHAITANYA SCHOOL H NO:16-11-469\/A\/1 TO 12,OPP SBI OFFICERS COLONY PARK, SBI OFFICERS COLONY,MOOSARAMBAGH DILSUKHNAGAR,500036"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO 46&amp;47, ROAD NO.5, SAI NAGAR COLONY, OPP. ALKAPURI SIGNAL, NAGOLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI NAGAR COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SURVEY NO:13,23 &amp; PART OF-25,OPP:RADIO STATION TOWER,VIJAYAWADA HIGHWAY,KALASA,SAI NAGAR COLONY,HAYATH NAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VANASTHALIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.288, DOOR NO.5-5-285, NEAR SRI KANAKADURGA TEMPLE, PRASHANTH NAGAR, VANASTHALIPURAM, HYDERABAD 500070"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HMT COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL FLOT NO :59&amp;60,HT LINE,HMT COLONY,ALWAL,500010"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GUNDLAPOCHAMPALLY,BESIDE GVK EMRI,NEAR PRESTIGE PARK,MEDCHAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MLR COMPLEX,BESIDE BHARATH PETROL BUNK,KOMPALLY,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHANDRAREDDY GARDENS SURVEY NO: 87, MAHALAKSHMI ENCLAVE ROAD,NEAR DHOLA-RI- DHANI, KOMPALLY, HYDERABAD,TELANGANA- 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO.85 BESIDE S.N.R GARDEN, KOMPALLY 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI ENCLAVE, BESIDE NAVATHA TRANSPORT, NEAR DOLA RI DANI, KOMPALLY, MEDCHAL - 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDCHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 36,37,64,OPP SEVEN TEMPLES,UMA NAGAR, MEDCHAL,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BEERAMGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GREEN MEADOWS MAIN ROAD, ESUKA BAVI, BEERAMGUDA, AMEENPUR (MDL), SANGAREDDY (DST) 502032"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHINTAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 145\/P OPP HP GAS AGENCY PATWARI ENCLAVE IDPL CHINTAL 500054"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 6 ,BALAJI NAGAR, NEAR METRO STATION KUKATAPALLY,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5-3-114, PLOT NO 1 &amp; 14, BEHIND RELIANCE SMART, SHANTI NAGAR,NEAR RAMALAYAM, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAGANDLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP APARNA CYBER LIFE,NALLAGANDLA(VILL), RANGAREDDY(DIST) 500019"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SERILINGAMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.20 &amp; 21, HUDA LAY OUT, NEAR AJAY FUNCTION HALL &amp; LINGAMPALLY RYTHU BAZAR, SERILINGAMPALLY RANGA REDDY "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SEVEN HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-2-46\/348,ANJANADRI BLOCK,SEVENHILLS APARTMENTS,NIZAMPET X ROAD,BESID SRI SRI HOLISTIC HOSPITAL,HYD,500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO:3&amp;4,SARDARPATEL NAGAR,NIZAMPET X RAOD,HYDERNAGAR,HYDERBAD 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 175,NEAR JNTU METRO STATION ,SARDAR PATEL NAGAR, KUKATPALLY 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO. 157,158 &amp;159, BESIDE RAMALAYAM, SAPTHAGIRI COLONY, VIVEKANANDANAGAR, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR RES(BOYS)",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO.28,29, SAPTHAGIRI COLONY,VIVEKANANDANAGAR,KUKATPALLY 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANJARAHILLS STARKIDSPREMIUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 8-2-310-B-10, ROAD NO 14, NAVODAYA COLONY, NANDI NAGAR, BANJARA HILLS,HYDERABAD 500034"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BOWENPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO. 1-4, CHINNATHOKATTA, NEW BOWENPALLY, SECUNDERABAD 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "EAST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-3-18\/4,OPP: BANK OF BARODA(FORMERLY DENA BANK),,EAST MAREDPALLY,HYDERBAD-5000026"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL A8, TULASI HOSPITAL LINE,ELECTRONIC COMPLEX, ECIL,KUSHAIGUDA, HYDERABAD - 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:A\/10, ELECTRONIC COMPLEX, PHASE 2,KUSHAIGUDA, ECIL 'X' ROADS MEHDIPATNAM 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GOSHA MAHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO.5-3-825,MALLAKUNTA ROAD, OPP. NEW IOC PETROL PUMP,GOSHAMAHAL,HYDERABAD,500012"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HASMATHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 1, SEETHA RAMAPURAM, MALLAREDDY GARDEN LANE,BESIDE KALYANI THEATRE, OLD BOWENPALLY HASMATHPET 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PILLAR NO -118 ,HANUMAN TEMPLE LANE , SRI LAKSMI NAGAR COLONY, STREET NO -03 ,NEAR INDIAN BANK BACK SIDE &amp; CLOSE TO JANAPRIYA UTOPIYA APARTMENTS, HYDERGUDA ATTAPUR - 500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KARKHANA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 144\/149, TEXT BOOK COLONY ,TRANSPORT ROAD,KARKHANA,SECUNDERABAD. TELANGANA-500009"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LAL DARWAJ",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.18-4-42\/3\/2, ANDHRA BANK LANE,LAL DARWAJ ,HYDERABAD 500065"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "M G ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 2 - 4- 73\/74 , BESIDE KFC, MG ROAD, NALLAGUTTA, SECUNDERABAD -500003"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEHDIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 3 , SANTOSH NAGAR COLONY, ST.ANN'S WOMEN'S COLLEGE ROAD, MEHDIPATNAM, HYDERABAD - 500028"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BARKATPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO: 3-4-760, BESIDE ANDHRA YUVATHI MANDAL, BARKATPURA, HYDERABAD, TELANGANA 500027"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-9-165,OPP IOC PETROL BUNK,NEAR ELECTRICITY SUB STATION,MAIN ROAD, GHATKESAR-501301"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-7-34\/7 &amp; 4\/NR, OPP CHRIST THE KING CHURCH, BESIDE BADRAS GRAND HOTEL, RAMANTHAPUR,HABSIGUDA, UPPAL(M), MEDCHAL (D)"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HIMAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-6-655ROAD9,ASHOKNAGAR.HIMAYATNAGAR,NARAYANGUDA,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDIPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 13-238, OPP.HANUMAN TEMPLE,MAIN ROAD MEDIPALLY VILLEGE,MEDCHAL DIST-500098"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NACHARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 17\/4 , SURVEY NO: 45 &amp; 46 , NACHARAM ,UPPAL MANDAL,MEDCHAL 500076"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAKUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:1-9-1104 TO 1112,OPP LANE TO DURGABAI DESHMUKH HOSPITAL,VIDYANAGAR,ADIKMET,NALLAKUNTA, HYDERABAD-500044"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARANAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-12-5-28\/29\/2,TARNAKA,SECUNDERABAD-500017."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DAMMAIGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL ANJANADRI&nbsp;NAGAR,&nbsp;EXTENSION&nbsp;OPP LAKE VIEW WATER TANK, DAMMAIGUDA MEDCHAL 500083"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Sangareddy",
     "Center": "SANGAREDDY",
     "CenterAddress": "SRI CHAITANYA SCHOOL APHB COLONY OPP NEW COLLECTORATE, SANGAREDDY 502001"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Toopran",
     "Center": "TOOPRAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO-455, ALLAPUR ROAD, TOOPRAN,KOMPALLY 502334"
    },
    {
     "State": "TELANGANA",
     "District": "Karim Nagar",
     "City": "Ramagundam",
     "Center": "RAMAGUNDAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL-FERTILIZER CITY,RFCL TOWNSHIP, RFCL, RAMAGUNDAM-PEDDAPALLY(DIST) 505210"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "STARKIDS KODAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, STAR KIDS CAMPUS, GANESH NAGAR,CURRENT OFFICE BACK,KODAD, SURYAPET (DIST) 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-237\/3, SRINAGAR COLONY,KODAD POST &amp; MDL, SURYAPETA DT 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT RS",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANA ENGINEERING COLLEGE KODAD POST &amp; MDL, KODAD SURYAPETA 508206 "
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Agra",
     "City": "Agra",
     "Center": "AGRA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BODLA-BICHPURI ROAD, NEAR SHASTRI PURAM, AGRA - 283 105"
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Firozabad",
     "City": "Firozabad",
     "Center": "FIROZABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL NH 2 , BEHIND BISHAN DHABA AND PETROL PUMP, NEAR USAINI, TUNDLA ,FIROZABAD 283103"
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Lucknow",
     "City": "Lucknow",
     "Center": "LUCKNOW 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL ADJACENT TO FLYOVER, AMETHIYA, HARDOI ROAD, STATE HIGHWAY 25,LUCKNOW UTTAR PRADESH 2260101 "
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Meerut",
     "City": "Meerut",
     "Center": "MEERUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6TH MILE STONE, MAWANA ROAD,MEERUT,UTTAR PRADESH 250001"
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Muzaffarnagar",
     "City": "Muzaffarnagar",
     "Center": "MUZAFFARNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NH-58, BIBIPUR, BLOCK SADAR,MUZAFFARNAGAR,UTTAR PRADESH 251001 "
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "BADA BAZAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2A,NANDA MULLICK LANE, NEAR GANESH TALKIES , BURRA BAZAR, KOLKATA-700006"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "DUNLOP",
     "CenterAddress": "SRI CHAITANYA SCHOOL 51, S.M.BOSE ROAD (LAHABAGAN), NEAR DUCK BACK MORE , PANIHATI,KOLKATA-700114"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "NEW TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL 06-360, STREET NO: 360, BESIDE RISHI TECH PARK, NEWTOWN, KOLKATA-700160"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Serampore",
     "Center": "SERAMPORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL JANNAGAR RD, MAHESH COLONY, NEAR TENNIS CLUB, SERAMPORE, HOOGHLY-712202"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KRISHNAVENI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR RTC BUSTAND,BESIDE DWARAKA PETROL BUNK,KHAJA NAGAR,ANANTAPUR "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 8-74A, BESIDE HEAD POST OFFICE, NEAR ANDHRA BANK, ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR PAVAN GAS AGENCY, RTO OFFICE ROAD, HOUSING BOARD, ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,OPP.TATA SHOWROOM,KAKKALAPALLI,RUDRAMPETA BY PASS,ANANTHAPUR 515672"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KAMMA BHAVAN, OLD NIRMALA NURSING COLLEGE LAKSHMI SRINIVASA NAGAR ANANTAPUR-515004, "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OLD DPS SCHOOL ,OPPOSITE TATA SHOWROOM,HYDERABAD HIGH WAY PAMURAI VILLAGE ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SAKSHI OFFICE,OPP: TATA MOTORS,RUDRAMPETA BY-PASS,ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEW REVENUE OFFICE BACKSIDE,RUDRAMPETA,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL, SURVEY NO.:149\/4, WARD NO.: 13, SHIRDI NAGAR, NEAR RTC BUS STAND,OPP. ANAND HOSPITAL ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.315-1B,WARD NO.28,L.P.NO.518\/85, SINGARAYANI COLONY,NEW REVENUE COLONY, ANANTAPURAMU 515001."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 10\/413,ADIMURTHY NAGAR,OPPOSITE DEVI NURSING HOME,NEAR SRI CHAITANYA JR COLLEGE ,ANANTHAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "GORANTLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/277 OPPSITE MARKET YARD KADIRI - HINDUPUR MAIN ROAD,BESIDE SPVM DEGREE COLLEGE GORANTLA (M&amp;V) ANANTAPUR DIST A.P - 515231"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KALYANADURG",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO:-359\/1A, OPP GOVT HOSPITAL BELLARY ROAD, KALYANADURG, ANANTAPUR (DT) 515761"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:17\/1111, RAJENDRA NAGAR,NEAR VENKATESWARA SWAMY TEMPLE, POST OFFICE LINE, GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 4\/369, DMM GATE ROAD,NEAR PANDURANGA SWAMY TEMPLE,P&amp;T COLONY,GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. MAHENDRA FUNCTION HALL,TILAK NAGAR, GUNTAKAL515801"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 12-1-76\/G2, PALANI NAGAR, BESIDE RAJADHANI FUNCTION HALL, HINDUPUR,ANANTHAPUR - 515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 26, SATYANARAYANA PETA MF ROAD, HINDUPUR, ANANTHAPUR-515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kadiri",
     "Center": "KADIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO : 13\/13\/1\/C ,MADANAPALLI ROAD,OPPO.CHOWDESWARI TEMPLE,KADIRI,SATYA SAI DIST 515591"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kothacheruvu",
     "Center": "KOTHACHERUVU",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 7\/196, PENUGONDA ROAD KOTHACHERUVU ANANTAPUR 515133"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Tadipatri",
     "Center": "TADIPATRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NETHAJI SCHOOL COMPOUND, BEHIND RICE MILL, KALAVAKATTA STREET, TADIPATRI, ANANTAPUR 515411 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Bangarupalyam",
     "Center": "BANGARUPALYAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL THAGGUVARIPALLI, BANGARUPALYAM,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chandragiri",
     "Center": "CHANDRAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VIJAY NAGAR COLONY,CANARA BANK ROAD,CHANDRAGIRI 517101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOR CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-10-199, TMR TOWER , GANDHI ROAD,OPPT LIC OFFICE, CHITTOOR,517001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.THAPOVANAM SCHOOL,TEACHERS COLONY,GREAMSPET,VELLORE ROAD,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27-515\/B,TELEPHONE COLONY ROAD,RAMNAGAR COLONY,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 28-1428, RAM NAGAR COLONY,CHITTOR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "MURUGANI PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO.22-978\/BB, KAMESHWAR NAGAR, MURUGANIPALLI, CHITTOOR,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalle",
     "Center": "SRI GANGA SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 3\/153-4-4-1, HOSPITAL BRANCH , BESIDE RTC BUS STAND,MADHANAPALLI-517325,ANNAMAIAH (D)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MALLIKARJUNA CIRCLE, COLLEGE ROAD, MADANAPALLI,CHITTOOR 517325 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.NO. III-145-6-12-4, PRASANTH NAGAR, BESIDE. SRI SIDDHARTHA JR. COLLEGE, MADANAPALLI,TIRUPATHI - 517325"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Palamaneru",
     "Center": "PALAMANERU",
     "CenterAddress": "SRI CHAITANYA SCHOOL GUDIYATHAM ROAD,SRI NAGAR COLONY,NEAR YSRCP PARTY OFFICE,PALAMANERU,TIRUPATHI 517408"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Piler",
     "Center": "PILER",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-421, LAKSHMI PURAM,PILER, CHITTOOR (DIST),TIRUPATHI 517214."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Punganur",
     "Center": "PUNGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MPDO OFFICE, R.R KALYANA MANDAPAM,MBT ROAD,PUNGANUR-517247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #12\/64\/1A,SWAMY STREET,PUTTUR,517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARAMESWARA MANGALAM,K.PALEM,PUTTUR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYANAPURAM,OPP.FIRE STATION, SWAMI STREET KN ROAD,PUTTUR 517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Renigunta",
     "Center": "RENIGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL VINAYAKA NAGAR, RENIGUNTA, TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-1-1988,JAYRAM RAO STREET,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 16\/550\/3,SRI RAM NAGAR COLONY,PANAGAL ROAD,OPP: SBI (ADB) BRANCH,SRIKALAHASTI. AP 517640"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI LAKSHMI KAMAKSHI KALYANA MANDAPAM, OPP DARMARAJ TEMPLE,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "ANJANADRI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 2-16,TELECOM COLONY OTERU ROAD ,SRINIVASAPURAM ,TIRUPATHI-517503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "CURE CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:6-2-83, KT ROAD,NEAR AXIS BANK MAIN BRANCH TIRUPATI - 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN CAMPUS DAYS ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  DO; NO 25, GANDHI ROAD   MUNICIPAL COMPLEX  PIN NO; 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN II CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 37 AGK BUILDING  GANDHI ROAD  TIRUPATHI PIN: 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  RC ROAD  EBSR COMPLEX NEAR  ANNAMAYYA CIRCLE TIRUPATI PIN CODE 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VEDAVYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DR NO:411\/2P    150 BY PASS ROAD, TIRUCHANOOR (V)  TIRUPATHI ( R)517503        "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VENKATADRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 8-171-1, NEW BALAJI COLONY, MR PALLI, TIRUPATHI PIN-517502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "AIR BY-PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL JAYA LAKSHMI COLONY, STV NAGAR, AIR BY PASS ROAD, NEAR PASSPORT OFFICE, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TARAKARAMA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP:A.G.STAFF QUARTERS,TARAKARAMANAGAR,PERUR,TIRUPATI(RURAL)571505"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "GS MADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 15-2-126\/A2 , BESIDE LAKSHMI NARAYANA SWAMY TEMPLE GSMADA STREET TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "KORALAGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 20-2--478\/A2,MARUTHINAGAR,KORLAGUNTA,TIRUPATI-517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MR PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT:26 NEW MARUTHI NAGAR, AIR BY PASS ROAD,MR PALLI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "SRINIVASAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL TELECOM COLONY, SRINIVASAPURAM, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUMALA BY PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:18-1-7\/10, BESIDE PAI VICROY HOTEL, RAMA CHANDRA NAGAR, TIRUMALA BY PASS,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI GIRLS RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL #10-128\/6-9 NETHAJI NAGAR P G N TOWER TIRUCHANUR TIRUPATI PIN:517507"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI IPL",
     "CenterAddress": "SRI CHAITANYA SCHOOL IPL BRANCH,BAIRAGIPATTEDA, NEAR RIMS,TIRUPATHI 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TSN PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR. NO. 20-3-131\/1A, SIVA JYOTHI NAGAR, SATHYANARAYANAPURAM, OPPOSITE SRIVARI SANNIDHI, BACK SIDE STREET SBI EXECUTIVE GUEST HOUSE, TIRUPATHI, CHITTOOR DISTRICT, AP 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VIKAS CAMPUS",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANA PALLY ROAD, THIRUCHNOR, THIRUPATHI "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Venkatagirikota",
     "Center": "V KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHOWDEPALLE ROAD, VKOTA,TIRUPATHI 517424"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "SRI SHIRDI SAI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SHIRDI SAI CAMPUS #1-5-58\/2A ONGC BYPASS ROAD, SAVARAM AMALAPURAM- 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MSN COMPLEX, MAIN ROAD, AMALAPURAM, EAST GODAVARI DIST, 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :I 1-72 ,BACKSIDE OF VL HEIGHTS,ABBIREDDY CANAL BRIDGE,KONKAPALLI,AMALAPURAM,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Anaparthi",
     "Center": "ANAPARTHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 13-37, CANAL ROAD,AYYAPPA TEMPLE ,KOTHURU TURNING,ANAPARTHI,ANAPARTHI (MD), RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimadole",
     "Center": "BHIMADOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:10-116,OPP. FIRE STATION,ELURU, RAJAHMUNDRY ROAD,BHIMADOLE,WEST GODAVARI 534425"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL,PLOT NO:6-126,SRI RAMA KUSUMA PLAZA,NEAR NATARAJ THEATER,CHINNAMIRAM,JP ROAD, PALAKODERU (M), W.G(DT)534210"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE DUPLEX COLONY CHINNAMIRAM,BHIMAVARAM,RAJAHMUNDRY 534204"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Chintalapudi",
     "Center": "CHINTALAPUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL ABOVE UNION BANK,SRINIDI COMPLEX,ELURU ROAD,CHINTALAPUDI,RAJAHMUNDRY 534460"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Devarapalli",
     "Center": "DEVARAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP:VEGETABLE MARKET, ELURU ROAD, DEVARAPALLI RAJAHMUNDRY 534313"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "SCHOOL - ELURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHALAPATHI TOWERS,4TH LINE ,SANTHI NAGAR ,ELURU,PIN CODE:534007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARVATHA VARDHINI COMPLEX , NEAR MAHATHMA GANDHI STATUE, VIDYANAGAR , ELURU. W.G.(DT) 534003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 7-179\/2,NEAR GANGANAMMA TEMPLE,BALAJI NAGAR, CHATAPARRU ROAD, ELURU-534001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ganapavaram",
     "Center": "GANAPAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NIDAMARRU MANDEL,BHAVIPALEM POST, GANAPAVARAM,RAJAHMUNDRY 534198"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Hanuman Junction",
     "Center": "HANUMAN JUNCTION",
     "CenterAddress": "SRI CHAITANYA SCHOOL KEPINIDI TOWERS, NUZVID ROAD,NEAR FLYOVER, HANUMANJUNCTION WEST GODAVARI 521105"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jaggampeta",
     "Center": "JAGGAMPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRISHNAVENI THEATOR , BALAJI CENTER , JAGGAMPETA, EAST GODAVARI 533435"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jangareddygudem",
     "Center": "JANGAREDDYGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :16-1-120, BESIDE M.R.OOFFICE,MANDAVALLI ESTATE, ASWARAOPETA ROAD, JANGAREDDYGUDEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kaikalur",
     "Center": "KAIKALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: FCI GODOWNS, BESIDE RELIANCE PETROL, ATAPAKA, KAIKALUR-521333"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "RAMAN BHAVAN 1 SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOWDHAM, #3-16A-101, LAKSHMINARAYANA NAGAR,KAKINADA -533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL #3-16B-4, OLD RTO OFFICE ROAD, NEAR MOTHER TERESA STATUE,SANTHI NAGAR, KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPOSITE BMC CHURCH SANTHI NAGAR KAKINADA - 533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.9-16,SRINIVASA COLONY, RAMANAYYAPETA, KAKINADA RURAL-533005, EAST GODAVARI DISTRICT, ANDHRA PRADESH"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO1-1111, JANA CHAITANYA LAYOUT NEAR JEWEL MEDOWS,SARPAVARAM,KAKINADA RURAL 533005"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-5-43\/1,NAGESWARARAO STREET,RAMARAO PETA,KAKINADA-533003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kovvur",
     "Center": "KOVVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP PMMM GOVT HIGH SCHOOL,BESIDE YUVRAJ FUNCTION HALL, NANDAMURU ROAD, KOVVUR, WEST GODAVARI 534350"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Mandapet",
     "Center": "MANDAPETA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAIN ROAD ,NEAR HP BUNK ,TAPESWARAM,MANDAPETA,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Nagaram",
     "Center": "NAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD HAVENS CAMPUS, MAIN ROAD, NAGARAM 533247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Narsapur",
     "Center": "NARSAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KARTHIKEYA NAGAR,21ST WARD,PEECHUPALEM ROAD,NARSAPURAM ,WEST GODAVARI (DT),A.P 534275"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL BRODIPET 2ND STREET, BYPASS ROAD, RAJUGARI BUILDING, PALAKOL, W.G.DT 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR AXIS BANK ,OPP.AMBEDKAR STATUE POOLAPALLI , PALAKOL , WEST GDHAVARI DIST"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Payakaraopeta",
     "Center": "PAYAKARAOPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL Y JUNCTION,NEAR GOVT HOSPITAL,PAYAKARAOPETA,KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Penugonda",
     "Center": "PENUGONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:31-112, OPPOSITE PALACE THEATER, SIDDHANTHAM ROAD, PENUGONDA, AP 534320"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Pitapuram",
     "Center": "PITAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PADA GAYA TEMPLE, BYPASS ROAD, PITHAPURAM,RAJAJMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARASWATHI SOUDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 85-6-15\/1,ROUTHU PLAZA, VL PURAM,RAJAMAHENDRAVARAM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARVANI TOWERS",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, D.NO:75-1-4,PRAKASH NAGAR, RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 14-137\/A,OPP RTC COMPLEX,BEHIND UNION BANK, RAJAMAHENDRAVARAM - 533 103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SRI VYBHAVI",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:78-10-7,SYAMALA NAGAR , BESIDE GOVINDURAJULU HOSPITAL,RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "KOVVURU",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:4-177,VEMULURU ROAD,KOVVURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL H. NO : 89-17 21\/1,MORAMPUDI ROAD, MORAMPUDI - KESAVARAM ROAD, SRI SAI CHAITANYA NAGAR, RAJAHMUNDRY, ANDHRA PRADESH 533107"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO11-11-1,OPPOSITE FIRE STATION,ARYAPURAM,RAJAHMUNDRY,EAST GODAVARI (DT) 533103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO-74-6-54, NEAR T T D KALYANA MANDAPAM,OPP SWATANTRA KUMAR CHURCH,PRAKESH NAGAR,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:17-12\/8\/1,KRISHNA NAGAR,SEETAM PETA,NEAR SATYAM GARI RICE SHOP,RAJAHMUNDRY,EAST GODAVARI (DT)533104"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:4-699\/1, BESIDE BEEJAPURI TOWNSHIP, SRIRAMPURAM ROAD, DIWANCHERUVU, RAJANAGARAM MANDAM, EAST GODAVARI, ANDHRAPRADESH - 533296"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "THE PARK INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:89-17-1\/21 CHAITANYA NAGAR, MORAMPUDI ROAD ,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajole",
     "Center": "RAJOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL(PS) EM SCHOOL,OPP. ANNAPURNA THEATER, MOGALIKUDURU,RAJOLE,RAJAHUMUNDRY 533249"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ramachandrapuram",
     "Center": "RAMACHANDRAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:5-282\/1,SRI CHAITANYA SCHOOL-RAMACHANDRAPURAM, SRINAGAR, OPPOSITE VSM ENGINEERING COLLEGE RAMACHANDRAPURAM,PASALAPUDI BRANCH, ANDHRAPRADESH - 533255"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ravulapalem",
     "Center": "RAVULAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR ANKALAMMA TEMPLE,UBALANKA ROAD,RAVULAPALEM ,EAST GODAVARI DIST 533238"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Razole",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #9-60\/1,OPP.RTC COMPLEX, RAZOLE-533242"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Sakhinetipalli",
     "Center": "SAKHINETIPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, ANTARVEDI PALEM, BESIDE INDIAN OIL PETROL BUNK,SAKHINETIPALLI MANDAL,E G DIST-533252"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO.CWC GUDEM,NALLAGERLA ROAD,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM CBSE",
     "CenterAddress": "SRI CHAITANYA OLYMPIAD SCHOOL,VASAVI IDEAL PUBLIC SCHOOL BUILDING,CHINNATADEPALLI,KADIYADDA POST,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU",
     "CenterAddress": "SRI CHAITANYA SCHOOL,IKEA NAGAR,NH-16,TANUKU,WG.DIST,534211"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PETROL BUNK,VISHNU PRIYANAGAR ,TANUKU VELPURU 534222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #3-41-8\/4, SRIRAM NAGAR, MR PETA, TUNI- 533401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL DURGADAS STREET,OPPOSITE SURESH KUMAR HOSPITAL, KOTHA PETA, TUNI, RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:3-41-8\/4, SAI NAGAR, MR PETA,TUNI,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "SUNKARAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUEU,KV NAGAR, YANAM, 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "YANAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUE, DRAKSHARAMA ROAD, VIA YANAM, SUNKARAPALEM 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yeleswaram",
     "Center": "YELESWARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 3-377\/1, NEAR RAJULA BABU TEMPLE, LINGAMPATHY ROAD,YELESWARAM ,RAJAHMUNDRY,AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Amaravathi",
     "Center": "AMARAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEAR MUSEUM ROAD,AMARAVATHI ,GUNTUR 522020 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "SARASWATHI SOUDHAM BAPATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.94\/1, VIJAYALAKSHMI PURAM, BAPATLA - 522101."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 8-3-8, OPP OLD MAA CABLE, OFFICE, BHIMAVARIPALEM, BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO -4-10-139\/1SRINIVAS NAGAR COLONY,BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripet",
     "Center": "SIDDHARTHA CAMPUS CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.25-367 &amp; 25-367\/1, NEAR R.V.S. HIGH SCHOOL, CHILAKALURIPET - 522616."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GUNDABOLU RAMACHANDRA HOSPITAL, SUBBAIAH THOTA, CHILAKALURIPET GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD DRN SCVS JR.COLLEGE BUILDING,NSP OFFICE, NARSARAOPET ROAD, CHILAKALURIPET,GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chirala",
     "Center": "CHIRALA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NALLA PANENI TOWERS, OPP MARGADHARSI CHIT FUNDS PVT.LTD,MUNTHAVARICENTER,CHIRALA 523165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Dachepalli",
     "Center": "DACHEPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRANTHI NURSING HOME,NARAYANAPURAM,DACHEPALLI(MD)GUNTUR(DT)-522414"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "CHAITANYA LAKSHMI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.22-4-47, TITANIC SHOW ROOM UPSTAIRS, NEAR OLD BUS STAND, LALAPET, GUNTUR - 522003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "ICON CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.5-89-9, 3RD LINE, LAKSHMIPURAM, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "AVANTHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.589-11\/5, 1ST LINE, CHANDRAMOULI NAGAR, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR NAYAR HOTEL CENTER, OPP. CENTRO, LAKSHMIPURAM MAIN ROAD, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR PRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NAYAR HOTEL CENTER, LAKSHMIPURAM MAIN ROAD, BESIDE WOODLAND, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHATMA GANDHI 80FEET INNER RING ROAD, REDDYPALEM, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "INTERNATIONAL SCHOOL WHITEHOUSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NAVABHARAT NAGAR, 4TH LANE,MAHA LAKSHMI TOWERS OPP. CHALAPATHI GROUNDS GUNTUR 522006"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "NEHRU NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL BUCHAITHOTA 1ST LINE,OPP VIJAYAWADA RAILWAY TRACK, NEHRU NAGAR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "REDDYPALEM DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD REDYYPALEM ,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "SYAMALA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYAMALA NAGAR, ZERO LINE,NEAR ARMY CANTEEN,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Macherla",
     "Center": "MACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13TH WARD, R&amp;B BUNGLOW BACK SIDE, NEAR PALAMARA ,MACHERLA GUNTUR (D.T) 522426"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Mangalagiri",
     "Center": "COLLEGE - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  D.NO.7-426 &amp; 7-426\/A, TIPPARLA BAZAR, MANGALAGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Nagaralu",
     "Center": "NAGARALU",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,TELECOME NAGAR 2ND LINE,AMARAVATHI ROAD, NEAR TAGORE RICE MILL,NAGARALU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARASARAOPET RAMANUJAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.11-23-1, RAMIREDDY PET, NARASARAOPET - 522601."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:11-14-1\/1,RAMIREDDYPET,BANK COLONY,NARASARAOPET,GUNTUR."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA CENTER ,SATTENAPALLI ROAD, OPP MAHALAKSHMAMMA CHETTU,NARSARAOPET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 60 FEET ROAD , PRAKASH NAGAR NARASAOPET,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "GAUTAMA BUDDHA BHAVAN PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.416\/B, KOTAIAH SASTRY BAZAR, PIDUGURALLA - 522413."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 7-703\/A ABBUBAKAR MUSEED STREET OPP AXIS BANK PIDUGURALLA,GUNTUR - 522413"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Ponnur",
     "Center": "PONNUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GBC ROAD, PONNUR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Repalle",
     "Center": "PARAMESWARA SADAN REPALLE",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.9-35-210 &amp; 9-35-210\/1, UPPUDI ROAD, REPALLE - 522265."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHINA MAJID CENTER,SBI ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 5-8-8, NAGARJUNA NAGAR,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARK ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "VYAS BHAVAN TENALI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.2-1-74, GANDHI NAGAR, RATNA TALKIES CENTRE, TENALI - 522201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANGANAMMA PET, TENALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR-NO-21-1-60\/1, DEVI CHOWK, RAMALINGESWARAPET,TENALI,GUNTUR-522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR UMESH CHANDRA STATUE,CHENCHUPET,TENALI,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP: GOVERNMENT VETERINERY HOSPITAL ,BURRIPALEM ROAD,TENALI 522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Vinukonda",
     "Center": "VINUKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE CURRENT OFFICE, KARAMPUDI ROAD, VINUKONDA GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Badwel",
     "Center": "BADWEL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDLA STREET,PORUMAMILLA ROAD,BADWEL,KADAPA 516227"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI BALAJI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DONO:1-399 MARUTHI NAGAR, BESIDE KADAPA CAFÉ, KOTIREDDY CIRCLE KADAPA-516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI SAI SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:42\/609-28, NGOS COLONY, APASARA CIRCLE , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,KEERTHI PARK VIEW,OPP RAJIV PARK,MARUTHI NAGAR,KADAPA 516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMBHA BHAVANI TEMPLE,NEAR BUILTUP, KADAPA."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NEHRU PARK,CO-OPRATIVE COLONY,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL ARP COLONY, PRAKASH NAGAR , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL 101\/257-2 RIMS BYPASS ROAD KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUGGA VANKA PROJECT ROAD,NEAR SWAMY NAGAR,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL #97\/217-8,NEAR RTO OFFICE,YSR CIRCLE,C.K.DINNE,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:CHINNACHOWK POLICE STATION,NEHRUNAGAR,KADAPA 516002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAYACHOTI RING ROAD,VUTKUR CIRCLE,KADAPA 516003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Porumamilla",
     "Center": "PORUMAMILLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DESAI MAHAL BACK SIDE,NEAR APSRTC BUSSTAND,PORUMAMILLA(V)KADAPA(DT)AP-516193"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ARAVINDA ASHRAMAM, YMR COLONY , PRODDUTUR, Y.S.R KADAPA(DIST) 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL YERRAGUNTLA BY PASS ROAD, NEAR CINE HUB,PRODDATUR,KADAPA 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL BACKSIDE HONDA SHOWROOM,KVR COLONY,MYDUKUR ROAD,PRODDUTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BOLLAVARAM NEAR GOLDEN PARK JAMMALAMADUGU BYPASS ROAD PRODDATUR, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Pulivendula ",
     "Center": "PULIVENDULA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT 70, BESIDE RTO OFFICE, MUDDANURU ROAD ,PULIVENDULA,KADAPA 516390"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHUVANAGIRI PALLI,RAJAMPET,KADAPA 516115"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL R.S.ROAD, RAJAMPET, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO COLONY,KOTHAPETA,RAYACHOTI,KADAPA 516269"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 430 BESIDE PREETHAM RESIDENCY,RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 5\/283,NEAR BY ICDS OFFICE, BESIDE VINAYAKA TEMPLE, SUNDEPALLI ROAD, RAJULA COLONY RAYACHOTI 516269 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA REDDY NAGAR,MADANAPALLI ROAD RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Avaniggadda",
     "Center": "AVANIGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5TH WARD, NEAR SANTHA MARKET AVANIGADDA,VIJYAWADA KRISHNA (DT)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Challapalli",
     "Center": "CHALLAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CLUB ROAD, RAMANAGARAM(VILLAGE),CHALLAPALLI(MANDAL), KRISHNA (DIST),521126."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gannavaram",
     "Center": "GANNAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GNT ROAD ,KOTHAPETA,GANNAVARAM,VIJAYAWADA 521101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "COLLEGE - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 8\/191, SRI RAM PURAM COLONY, OLD CURRENT OFFICE, BESIDE FISH MARKET ROAD, SATYANARAYANA PURAM, GUDIVADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "SCHOOL - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:10\/153, RAJENDRA NAGAR 1ST LINE, GUDIVADA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Ibrahimpatnam",
     "Center": "IBRAHIMPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR STATE BANK OF INDIA,OPP-MANDALAM OFFICE ,V.T.P.S ROAD,IBRAHIMPATNAM,KRISHNA (DT)521456"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Jaggaiahpet",
     "Center": "JAGGAIAHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: YOGIRAMA HOSPITAL, UMA GOPAL COMPLEX,JAGGAIAHPET,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Kankipadu",
     "Center": "KANKIPADU DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE TVS SHOW ROOM,BANDAR ROAD,KANKIPADU,VIJAYAWADA 521151"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "COLLEGE - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMANAIDU PETA, SHAIK IMAM STREET, MACHILIPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "SCHOOL - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO : 21\/478, SRI CHAITANYA SCHOOL, SAI BABA TEMPLE ROAD, BHASKARAPURAM , MACHILIPATNAM , KRISHNA(DIST), AP 521001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "SCHOOL - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO 1-816, NEAR HEAD POST OFFICE, MANGALAGIRI VIJAYAWADA 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO 5-470,WARD NO.5,TENALI ROAD,NEAR MARKANDEYA KALYANA MANDAPAM,ABOVE ICICI BANK,MANGALAGIRI 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 14-271\/1, CHAIATANYA THOPAVANAM ASHRAMAM, KRISHNA NAGAR, TADEPALLI ,MANGALAGIRI - 522501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI-5",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAROFF BAZAR, VADLAPUDI CENTER,MANGALAGIRI,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mylavaram",
     "Center": "MYLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:-2-58,BESIDE NARAYANA THEATER , MYLAVARAM MYLAVARAM(M.D)KRISHNA (D.T)-521230 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nandigama",
     "Center": "NANDIGAMA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP VARUN BAJAJ , RAITHUPETA,NANDIGAMA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nuzvidu",
     "Center": "NUZVIDU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHERUKURI COMPLEX, BEHIND HERO HONDA SHOW ROOM, H.JUNCTION ROAD, NUZVIDU, KRISHNA (DT) 521201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Penuganchiprolu",
     "Center": "PENUGANCHIPROLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-1,MAKKAPET ROAD,PENUGANCHIPROLU,KRISHNA-521191.AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Repalle",
     "Center": "REPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RAJYA LAKSMI THEATRE,OLD STATE BANK COMPOUND,REPALLE 522265"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Tiruvuru",
     "Center": "TIRUVURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP NAGARJUNA COLLEGE, BOSU BOMMA CENTERE, TIRUVURU VIJAYAWADA 521235"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INDRA TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, USHA LAND MARK, OPP. M&amp;M SHOWROOM, MG ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MAHESWARA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAHESWARA BHAVAN, OPP. HDFC BANK, MG ROAD "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ESWARI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KRISHNAVENI CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SHEDS CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "RABINDRANATH TAGORE BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO. 32-27-9\/1, SARVODAYA VIDYA PEET ST CHUTTUGUNTA, MARUTHI NAGAR, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "VUYYURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OPP. DEEPAK MAHAL KATURU ROAD, BESIDE CARE HOSPITAL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHAVANI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SAI SARASWATHI NILAYAM,  SWATHI THEATER CROMBAAY ROAD, BHAVANI PURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ASHOKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:74-14-2, OLD CHECK POST CENTER, YANAMALAKUDURU LAKULA ROAD, KRISHNA NAGAR (ASHOK NAGAR), BESIDE COMMERCIAL TAX OFFICE, VIJAYAWADA-520007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "BHAVANIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:76-8\/6-5\/1,GUDIVADA RAMA RAO STREET,SWATHI THEATRE ROAD,BHAVANIPURAM,VIJAYAWADA-520012"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "CURRENCY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2ND LINE, OM NAMASHIVYA STREET, CURRENCY NAGAR,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "GOSALA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PUNADIPADU VILLAGE,KANKIPADU MANDAL,GOSALA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL GAYATHRI NAGAR,POLYCLINIC ROAD,NEAR BENZ CIRCLE,VIJAYAWADA 520008"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTL BEZAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:57-6-21\/2, ABC BUILDING, OLD POST OFFICE ROAD, BESIDE SONOVISION, PADAMATA, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KANCHIKACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.PRATAP TVS SHOW ROOM,KANCHIKACHERLA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KRISHNA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:-41-1\/8-42,GOWTHAMI NAGAR 3'RD LINE OPPOSITE AMERICAN HOSPITAL,KRISHNA LANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MARUTINAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:32-26-110\/124, SRI BHAVANI MANSION,MARUTINAGAR,ELURU ROAD,VIJAYAWADA 520004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MOGULRAJAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO36-12\/15\/2A,RAMARAO STREET,MADHU GARDEN,MOGULRAJAPURAM,VIJAYAWADA 520010"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "NUNNA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6-80, BESIDE BSNL TELEPHONE EXCHANGE, MAIN ROAD, NUNNA,VIJAYAWADA - 521212"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ONE TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:4-1-27, BANGARAIAH KOTTU CENTER,ONE TOWN,VIJAYAWADA KRISHNA (DT) 520009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PATAMATA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:40-12-3\/5, OPP:ASWINI ENCLAVE,SEETHARAMA NAGAR, PATAMATALANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PORANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-15-113,PRABHU NAGAR,PORANKI,VIJAYAWADA,KRISHNA 521137."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "S.N. PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR NO : 24-25-63,NEAR FOOD JUNCTION,OPP.RAILWAY QUARTERS,BRTS ROAD,DURGAPURAM,SATYANARAYANAPURAM,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SING NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO. 43-78-7 KRISHNA HOTEL CENTER, AJIT SING NAGAR, VIJAYAWADA-520015"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Visannapet",
     "Center": "VISANNAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, KUKKADAPU PRASAD COMPEX, BESIDE SURVEYNDICATE BANK, MAIN ROAD, VISANNAPETA 521215 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vuyyur",
     "Center": "VUYYUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :- 8-269, SRI CHAITANYA SCHOOL, ANU ARCADE BUILDING, BEHIND CARE HOSPITAL, KATURU ROAD, VUYYURU, KRISHNA (D.T) 521165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHEKURI GARDENS, NEAR NEW RTC BUS STAND,ADONI,KURNOOL 518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 21\/515\/9\/BCD\/1,AMBEDKAR NAGAR,REVENUE WARD-21,A.P.B.H COLONY,ADONI,518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Allagadda",
     "Center": "ALLAGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VISWARUPA NAGAR, ALLAGADDA,KURNOOL(DIST) 518543"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Alur",
     "Center": "ALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL LIC BACK SIDE,ALUR,KURNOOL 521329"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Atmakur",
     "Center": "ATMAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VENKATESWARA SWAMI TEMPLE,GAREEB NAGAR,ATMAKUR,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Banaganapalle",
     "Center": "BANAGANAPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL BANAGANAPALLI NEAR RTC BUS STOP ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Bethamcherla",
     "Center": "BETHAMCHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12TH WARD,DHONE ROAD, BETHAMCHERLA,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Dhone",
     "Center": "DHONE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VENKATANAINI PALLI ROAD,OPP ITI COLLEGE,DHONE,KURNOOL 518222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "SRI GURU RAGHAVENDRA BHAVAN BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,NH 40, OPPOSITE SAFA ENGINEERING COLLEGE, NEAR KRANTI GODOWN, B.THANDRAPADU, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,D.NO 40-304, BESIDE RR HOSPITAL, NEAR MOURYA INN, BHAGYA NAGAR, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL , D.NO:451 42\/13B-7 ,KAPPALA NAGAR,ROAD NO 4,VENKATA RAMANA COLONY LANE,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL VENKATADRI NAGAR, NERA RAILWAY GATE, KALLURU, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:40-321-1-F ,BESIDE OLD AYYAPPA SWAMY TEMPLE, BHASKAR NAGAR,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BESIDE OLD RAVI THEATER, CENTRAL PLAZA, NEAR VINAYAK GHAT, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE VIJAYA DURGA DEGREE COLLEGE, SRINAGA COLONY,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL KNL652,SRI CHAITANYASCHOOL, SANKHALBAGH,KURNOOL-518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO:46-156-D-1A,BUDHAWARAPET NEAR PADMA CHANDRA(OMNI) HOSPITAL, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VISWAK GARDEN, SOMISETTY FUNCTION HALL,SANKAL BAGH,KURNOOL 518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:6-68\/A,SC-COLONY, THANDRAPADU LAKE,OPP.SIVALAYAM,NANDYAL ROAD,KURNOOL518007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI RAMA NAGAR ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL CRR SECONDARY SCHOOL DINNEDEVARAPADU KURNOOL POST BOX NO :-8 ANANTHAPUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandikotkur",
     "Center": "NANDIKOTKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL MADDHUR NAGAR, BESIDE SRI RAMA THEATER, NANDIKOTKUR 518401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 25426-E BEHIND MUNCIPAL OFFICE NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRNIVASA NAGAR,TTD ROAD,OPP: RAITHUBAZAR,NANDYAL,KURNOOL 518502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO'S COLONY, NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SOWJANYA MOTORS,R.S ROAD,NANDYAL,KURNOOL(DIST),A.P"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 13\/71, RAMAKRISHNA NAGAR,KOILAKUNTLA ROAD, KANALA,NANDYAL. KURNOOL (DT)518493"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Pattikonda",
     "Center": "PATTIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 17\/177\/12\/1 YASHODA GARDEN SCHOOL YASHODA GARDEN NEAR RTC BUS STAND PATTIKONDA KURNOOL 518380"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Yemmiganur",
     "Center": "YEMMIGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GEETHA NAGAR, YEMMIGANUR, KURNOOL(DI),AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Buchireddypalem",
     "Center": "BUCHIREDDYPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP OLD RTC BUS STAND,BUCHIREDDYPALEM,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Gudur",
     "Center": "GUDUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANATH NAGAR,OPP Z.P GIRLS HIGH SCOOL,GUDUR,NELLORE 524101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PULLAREDDYNAGAR, BEHIND RSR KALYANA MANDAPAM, KAVALI,SPSR NELLORE DT 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALIKIVARI STREET , OLD TOWN , KAVALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANTHINAGAR KAVALI,SPSR NELLORE DT, 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kota",
     "Center": "KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SRINIVASA NAGAR,KOTA (MANDAL),NELLORE (DT) 524411"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kovvur",
     "Center": "KOVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE PANCHAYT OFFICE, KOTTUR RAMA MANDIRAM ROAD, MANDABAYALU CENTER, KOVUR,SPSR NELLORE (D.T) 524137"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Naidupet",
     "Center": "NAIDUPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL AGRAHARPETA, NEAR SAI BABA TEMPLE, NAIDUPET, SPSR NELLORE DIST 524126"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GAYATHRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VEDAYAPALEM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRI BHARATHI BOYS DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMALINGAPURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "UJWALA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, TIPPA RAJU VARI STREET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRIVANI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PAPPULA VEEDI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "ATMAKUR NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL TENKAYA THOPU,NEAR RAVITEJA KALYANAMANDAPAM ,ATMAKUR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GUPTA PARK",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12-4-294,BESIDE MODEL HIGH SCHOOL,NEAR GUPTHAPARK,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NAWABPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:SIVALAYAM, NARUKUR MAIN ROAD, NAWABPETA, NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ISKON CITY,KONDAYAPALEM,BACK SIDE BHARATH PERTROL PUMP, VANAMTHOPU, NELLORE 524004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SETTYGUNTA ROAD,LAKSHMI PURAM,VENGAMAMBA CENTRE,NAWABPETA,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SANTHAPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR SANTHAPET , NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "AC NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ADDALA SAI BABA TEMPLE,PULIMI PEDDA BUCHI REDDY NAGAR, AC NAGAR, NELLORE 524002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "BALAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAMJI NAGAR, 5TH LINE , BALAJI NAGAR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "MUTHUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO POST OFFICE,MUTHUKUR ,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP HDFC BANK ATM, DHANALAKSHMIPURAM, NELLORE524003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "PODALAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,CHAITANYA NAGAR,RAPUR ROAD,PODALAKUR (MANDAL),NELLORE (DT) 524345"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Sullurpet",
     "Center": "SULLURPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RR SUPER MARKET ,GNT ROAD , SULLURPET,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vedayapalem",
     "Center": "VEDAYAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANDHI NAGAR ,VEDAYAPALEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMMAVARIPETA, MUNICIPAL OFFICE ROAD, VENKATAGIRI,SPSR NELLORE DIST 524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DVS COMPLEX, RAJA STREET, VENKATAGIRI, SPSR NELLORE (DT)524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vinjamuru",
     "Center": "VINJAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE PRAJA VAIDHYASALA, NEAR RTC BUS STAND , VINJAMURU,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ANJANEYA SADAN ADDANKI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.31-419, 31-420, OIL MILL ROAD, ADDANKI - 523201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ADDANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUNGLOW ROAD,ADDANKI,PRAKASAM -523201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Chimakurthy",
     "Center": "CHIMAKURTHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDHI NAGAR 7TH LINE,CHIMAKURTHY ONGOLE 523226"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Darsi",
     "Center": "DARSI",
     "CenterAddress": "SRI CHAITANYA SCHOOL TEACHERSCOLONY,PODILI(ROAD),DARSI,PRAKASAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kandukur",
     "Center": "KANDUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA REDDY NAGER,KANDUKUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.JR COLLEGE,KANDUKUR ROAD,KANIGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUBHASH ROAD,KOTHA PET,KANIGIRI,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Markapuram",
     "Center": "MARKAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.8\/A-20 ,BODAPADU ROD ,OPPISITE RTC DEPO,MARKAPURAM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Martur",
     "Center": "MARTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. VIJAYALAKSHMI KALAYANA MADAPAM, NH-5 ROAD , MARTUR,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "SARASWATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MANGUMUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "CUMBUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.INDIAN PETROL BUNK,NEAR SBI BANK ,GIDDALUR ROAD,CUMBUM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHAGYA NAGAR 2ND LINE, BESIDE REGISTER OFFICE ,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP.HP GAS AGENCY,NEAR MARRI CHETTU,MANGAMUR DONKA ROAD,ONGOLE 523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL V.I.P. ROAD,MANGAMUR DONKA,ABOVE HDFC BANK,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MAHALAKSHMI TOWERS, 4TH LINE ,LAWYERPET,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Pamuru",
     "Center": "PAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.HP PETROL BUNK ,NELLORE ROAD,PAMURU,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Singarayakonda",
     "Center": "SINGARAYAKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE I.T.I COLLEGE,MULAGUNTAPADU(V),SINGARAYAKONDA(M) PRAKASAM DISTRICT 523101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-3,4&amp;5, BEHIND DEEPAMAHAL, SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "KAMAKSHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OLD NH-5 ROAD, OPP. HONDA SHOWROOM, PADMANABHAPURAM, KASIBUGGA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRIKAKULAM ROAD, NEAR AMRUTHA HOSPITAL, OPP. MAHENDRA SHOWROOM, RAJAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI NAGAR , NEAR DEO OFFICE,WOMENS COLLEGE ROAD,SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANGI SURYANARAYANA COLONY, NEAR AYYAPPA SWAMY TEMPLE, ADIVARAMPETA, CHAPURAM PANCHAYAT, PALAKONDA ROAD, SRIKAKULAM 532 001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "GOWRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 12-12-73, OLD BUS STAND ROAD, NEAR SHIRDI SAI THEATRE, ANAKAPALLI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "ANAKAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 80 FEET RING ROAD , OPP HEMA SEKHAR DEGREE COLLEGE, STATION ROAD, ANAKAPALLI,VISAKHAPATNAM -531001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Bobbili",
     "Center": "BOBBILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR CBM CHURCH , BALIJIPETA ROAD, BOBBILI,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Narsipatnam",
     "Center": "NARSIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2-101\/1, NEAR RTC COMPLEX , ANAKAPALLI ROAD, NARSIPATNAM-531116 VISAKHAPATNAM DIST."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Palasa",
     "Center": "PALASA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:14-1-279\/A,NEAR AYYAPPA SWAMY TEMPLE,OLD NH-5 ROAD,PADMANABHAPURAM,PALASA-KASIBUGGA,SRIKAKULAM DIST 532222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Parvathipuram",
     "Center": "PARVATHIPURAM",
     "CenterAddress": "SRI CHAITANAYA SCHOOL , OPP- SRI VENKATESWARA NURSHING HOME ,SUNDERNARAYANAPURAM COLONY , BELAGUM ,PARVATHIPURAM , VIZIANAGARAM ( DIST ) ."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Rajam",
     "Center": "RAJAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP ELECTRICAL SUB STATION, PONDURU ROAD, RAJAM, SRIKAKULAM (DIST) 532127"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN- II",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-48-6-16, SRI VIJAYA SAI TOWERS, OPP. RAMA TALKIES MAIN GATE, SRINAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRIPADA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-48-8-14, BEHIND KALANIKETHAN, NEAR BUDHIL PARK HOTEL, DWARAKANAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-58-22-50, NEAR NAD HOSPITAL, SUSARLA COLONY, BUTCHIRAJUPALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO 6-62-6\/1, NEAR GAJUWAKA POLICE STATION, SHRAMIK NAGAR, CHINAGANTYADA, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYSHNAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MIG 110, D.NO 24-3-1,BUDA COLONY,PEDAGANTYADA, GAJUWAKA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYDEHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, STEEL PLANT MAIN ROAD, UKKUNAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRISAI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 34\/2, PILAKAVANIPALEM, CARSHED JUNCTION, P.M PALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 10-12-8, OPP PYDAH DEGREE COLLEGE REDNAM GARDENS RAM NAGAR,ASILMETTA VISAKHAPATNAM -530002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 11-4-1\/1,UDAY SRI TOWERS, RAMNAGAR,ASILMETTA,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:26- 42-10\/2,BESIDE SRI CHAITANYA JUNIOR KALASALA,CHAITANYANAGAR,OLD GAJUWAKA,VISAKHAPATNAM-530026."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 27-1-65,SRINAGAR,GAJUWAKA,VISAKHAPATNAM,530026"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KOMMADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VIJAYA MOHAN LAYOUTS,NEAR CHAITANYA ENGG COLLEGE, KOMMADI VILLAGE,CHINAGADILI MD MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KURMANNAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 31\/6-3\/1 OPP. STEEL CITY APSRTC BUS DEPO SATHAVAHANANAGAR ROAD NO.6,MAINROAD KURMANNAPALEM, GAJUWAKA MANDAL VISAKHAPATNAM 530046"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: CMR GARDENS, MADHURAWADA , VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR FLY OVER BAKKANAPALEM ROAD, MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MVP COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-10-2\/4, USHA RESIDENCY, SECTOR-1,MVP COLONY, VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D.NO. 58-1-237, TEEGALA TOWERS, MARRIPALEM ROAD, NAD, VIZAG 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D-NO-58-15-116\/A, OPP GAJANANA FORT, SANTHI NAGAR, NAD ,VISAKHAPATNAM 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "PENDURTY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SBI, PULAGANIPALEM ROAD, PENDURTY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Yalamanchali",
     "Center": "YALAMANCHILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR FIRE STATION,RAMAKRISHNAPURAM, YELAMANCHILI,VISAKHAPATNAM-531055"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL, 100 FEET RING ROAD, DHARMAPUR, NEAR VENKATESWARA SWAMY TEMPLE, VIZIANAGARAM 535001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR NEAR BUS STOP,BOWDARA MAIN ROAD, VIZIANAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagarm",
     "Center": "VIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO-102,103,104, NAIDU COLONY, THOTA PALEM, VIZIANAGARM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Eluru",
     "Center": "COLLEGE - ELURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAIN CAMPUS- ELURU, MARGHADARSHI ROAD, NARASIMHA RAO PETA, ELURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Palakol",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS BRODIPET, BRODIPET BIPASS ROAD, PALAKOLLU, WEST GODAVARI - 534260"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARNAKA (HARI HARA HEIGHTS)",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-13-1210\/1, STREET NO 10, TARNAKA, SECUNDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 6-10-8\/1\/1, NAGENDRA NAGAR, HABSIGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANTHAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-9-29, SHARADA NAGAR, ADRM HOSPITAL LANE, RAMANTHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,1-7-158\/2&amp;1-7-159\/1,KAMALA NAGAR,ECIL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SECENDRABAD",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,OLD LICBUILDING,BEHIND HDFC BANK,NEAR PARADISE CIRCLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ALWAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ALWAL,PNO 27&amp;28,H.NO-1-12-115,MADHAVI NAGAR COLONY,"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "WEST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, R.C NO 23010\/62206\/C23-1\/2002-03,WEST MAREDPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SATYASAI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:18-98,KAMALA NAGAR,CHAITANYAPURI,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI BHAVAN ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO: 5-4-59\/2\/1 SARASWATHI BHAVAN, NEAR GENESIS HIGH SCHOOL, SANGEETH NAGAR, KUKATPALLY, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRIVIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 5-4-58\/9\/1 &amp; 5-5-7\/10\/1, PLOT NO 7 &amp; 8, KUKATPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI VIKRAM TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAI VIKRAM TOWERS, 3RD FLOOR, BESIDE METRO STATION, KUKATPALLY,HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI BHASKAR BHAVAN, ABOVE NEXA CAR SHOWROOM, A S RAJU NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAGDEVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VAGDEVI BHAVAN, PHASE I, BESIDE MRO OFFICE, KPHB COLONY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, APIIC COLONY, OPP IDPL COLONY, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SPRING FIELD COLONY, NEAR GOOD SHEPHERD SCHOOL, SUCHITRA, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHARATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHARATHI BHAVAN, PLOT NO: 5,6 &amp; 7, BEHIND MAX SHOPPING MALL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHARADHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 1-58\/A\/8\/1, RAMA KRISHNA COLONY, BESIDE NAIDU EYE HOSPITAL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASUDA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BACK SIDE KAJANA JEWELERS, MADINAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "JAI HIND COMPLEX",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO 53 TO 63 H NO: 5-88\/2 NEAR ZPH SCHOOL MANIKONDA, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SOUDAMINI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 4-94, CHANDA NAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MAIN CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-5-947 &amp;948, OPP.TAJMAHAL HOTEL, SUDARSHAN BUILDING, NARAYANAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAYS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-4-703,VAYS BHAVAN,NEAR NARAYANAGUDA FLYOVER,HYDERABD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AKSHARA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/279, 256\/M6, BESIDE AXIS BANK, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMRUTHA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/550, 516\/3RT, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ARYABHATTA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 7-1-414\/35(B), AMEERPET,HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "YOUSUFGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8-3-318\/6\/6, BANDARU BHAVAN, 2ND FLOOR, YOUSUFGUDA, HYDERABAD-500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8229382\/J111\/573 G, RAJIV BHAVAN, JUBILEE HILLS, OPP: KBR PARK, GATE NO 6, ROAD NO -1, JUBILEE HILLS, HYDERABAD-500096"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PILLAR NO: 143, H.NO: 3-4-183\/1, ATTAPUR, RAJENDRA NAGAR, RANGA REDDY DISTRICT-500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R K PURAM-2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ROAD NO-1,GREENHILLS COLONY,KOTHAPET"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BALAJI ARCADE ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR CHIKKADPALLY METRO, ABOVE RAMRAJ COTTON, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LBNAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 3-1-33, BAHADURGUDA, LBNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYDEHI BHAVAN AUTONAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 284 (WESTERN PART), NAKKA VENKATA SWAMY YADAV NAGAR, BAGH HAYATHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "UPPAL RES BODUPPAL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-165\/9, PEERZADIGUDA, UPPAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NAGOLE ENCLAVE,BAHADURGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VIVIN TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MADHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VEDAVYAS 1",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO. 319, 320  BESIDE. H.P. PETROL PUMP, NARSINGI,  GANDIPET MD RANGA REDDY DT"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANUJAM BHAVAN BONGULOR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D:NO 5-105, SY.NO:109(PART), OLD JNIT ENGG COLLEGE, BONGULUR X ROADS, MANGALPALLI-PATELGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYASA BHAVAN ADIBATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SURVEY NO 163\/AA, OF BONGULURU VILLAGE, IBRAHIMPATNAM MANDAL, RANGAREDDY DIST"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANDLAGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO 196, ARUNODHAYA COLONY, BANDLAGUDA ROAD NAGOLE, HYD-35"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUSHRUTHA BHAVAN MEDIPALLY CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MEDIPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO-265  AUSHAPUR,ANKUSHAPUR POST  "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PANANIYA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO 103,BLOCK 2B,VVNAGAR,GADDINNARAM"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERNAGAR BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SYNO . 1598169\/2 SRI CHAITANYA JR COLLEGE, HYDERNAGAR BOY CAMPUS, MANJEERA WATER WORK ROAD, NEAR CALAVERY TEMPLE, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MIYAPUR GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE FOR GIRLS,HOUSE NO 1-62 &amp;1-62\/1,SRI VIDYA BHAVAN"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KPHB RES PRATIBHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KPHB RES PRATIBHA BHAVAN,SRI CHAITANYA JUNIOR KALASALA, DHARMA REDDY COLONY,KPHB PHASE -3,NEAR LOTUS HOSPITAL BESIDE STREET ,NEAR TO OPPOSITE PRATIBHA SCHOOL,JNTU, "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PRATHIBHA SAI NAGAR HYD",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, FLOT NO \/ PLOT NO \/ SURVEY NO -16-2-132\/135\/231 STREET NAME -K V R COMPLEX,NIZAMPET CROSS ROAD AREA NAME -SAINAGAR COLONY NEAR BY LAND MARK -LUCID DIAGNASTICS CITY - HYDERABAD PINCIDE -500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI SAI DARBHAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO.1-62\/SD\/5TO 8\/1,PLOT NO.5678,SY NO:198\/2\/A, SRI AUROBINDO COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-217\/A, BALKAMPET, B K GUDA, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DSNR ZONAL DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAIBABA TEMPLE LINE,P &amp; T COLONY,BESIDE SANJAY STEEL,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L B NAGAR ZONAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:3-6-260,L B NAGAR,SBI BANK COLONY,VENTURE -1"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R.K.PURAM SEMI RESI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:11-13-1106&amp;1107,NEAR VICTORIA,MEMORIAL METRO STATION,GREEN HILLS COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHASKAR BHAVAN, OMNI HOSPITAL BACK SIDE, BALAJI NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMAN BHAVAN, BHAGYA NAGAR CO-OPERATIVE SOCIETY , SHIVA PARVATHI THEATER RAOD, OPP KPHB, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 8-3-319\/8\/2 TO 6&amp;319\/2\/7,NEAR SARADHI STUDIOS YOUSUFGUDA,MAIN ROAD AMEERPET HYD 500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO-8-3-222 \/ A\/1,2,3 PLOT NO-C 57-C 59 BESIDE ALLAHABAD BANK ( INDIAN BANK ), MADHURA NAGAR YOUSUFGUDA MAIN ROAD ,AMEERPET HYDERABAD 500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-4-183\/1, SATTI REDDY COMPLEX, ATTAPUR,RAJENDRA NAGAR, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO - 367&amp;368 , KAKATEEYA HILLS (KAVURI HILLS), ROAD NO -8, MADHAPUR , JUBILEE HILLS , GUTALA BEGUMPET , SHERILINGAMPALLY MANDAL, RANGA REDDY DISTRIT - 500081"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:143,145,149,JAYA ABODE,OPP:ANDHRA BANK,SECRETARIAT COLONY,MANIKONDA 500089"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHAMSHABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 578\/A582\/A,ADARSH NAGAR,SHAMSHABAD, RANGAREDDY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SR NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR.NO.7-1-621\/280 &amp; 281,254 &amp; 255-3RT, SR NAGAR MAIN RD, ABOVE SBH BANK, SANJEEVA REDDY NAGAR, HYDERABAD, TELANGANA,500038."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUN CITY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 1-2\/1, SHANTHI NAGAR COLONY, HYDERSHAKOTE, SUNCITY, RR. DT- 500091"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TOLICHOWKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8-1-22\/1\/M, 7 TOMBS ROAD,OPPOSITE GOLDEN PALACE,FUNCTION HALL,TOLICHOWKI, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHAITANYAPURI CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PANANIYA MAHAVIDYALAYA PUBLIC SCHOOL,OPP THANKUR HARI PRASAD INSTITUTE,CHAITANYAPURI,DILSUKNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DILSUKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:3-10\/A,HANUMANNAGAR,BESIDE PAKALA PLAZA,OPP.SAPTAGIRI HOSPITAL,CHAITANYAPURI,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GADDI ANNARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.16-2-752\/123\/1\/123\/A&amp;4A, SHIVA GANGA THEATRES ROAD, BESIDE: SBH BANK, GADDIANNARAM, HYD-500060"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GAYATHRI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 2&amp;131, NEAR GAYATHRINAGAR X ROADS, BESIDE SBI BANK, GAYATHRINAGAR, JILLALAGUDA,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:60,64 &amp; 67,71 KHALSA, HAYATHNAGAR RR(DT) 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT. NO. 5,6,7,8,9 &amp; 10,KHALSA,HAYATHNAGAR,RANGAREDDY 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KESHAVAPURI",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 8-7-92\/K, KESHAVAPURI COLONY, SAGAR ROAD, HASTINAPURAM,HYDERABAD TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHALSA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR HIWAY BAWACHI HOTEL LINE,SUGUNA ENCLAVE,KHALSA,HAYATNAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHARMANGHAT",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:7,SRINIVASA NAGAR COLONY,OPP:UCO BANK,KHARMANGHAT,HYDERABAD 500035"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOTHAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.23-38\/2&amp;3,KRISHNAVENI NAGAR,OPP:FRUITMARKET LANE,NEAR GHMC EAST ZONAL OFFICE,KOTHAPET,DILSUKNAGAR,HYDERABAD,R.R.DIST-60."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-11-282,SHIVA GANGA COLONY,OPP. BIG BAZAR,LBNAGAR,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 3-11-461\/A PART, ROAD NO: 2, SHIVA GANGA COLONY ,MANSOORABAD, L.B NAGAR, HYDERABAD, TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANSOORABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SAI BABA TEMPLE,KAMINENI HOSPITAL BYPASS ROAD,LAXMI NAGAR COLONY,MANSOORABAD,HYDERABAD-500074"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:1234.OPP:Y JR FUNCTION HALL,TMR ENCLAVE ,NEAR MEERPET CROSS ROAD,BADANGPET HYDERABAD 500097"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MOOSARAMBAGH",
     "CenterAddress": "SRI CHAITANYA SCHOOL H NO:16-11-469\/A\/1 TO 12,OPP SBI OFFICERS COLONY PARK, SBI OFFICERS COLONY,MOOSARAMBAGH DILSUKHNAGAR,500036"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO 46&amp;47, ROAD NO.5, SAI NAGAR COLONY, OPP. ALKAPURI SIGNAL, NAGOLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI NAGAR COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SURVEY NO:13,23 &amp; PART OF-25,OPP:RADIO STATION TOWER,VIJAYAWADA HIGHWAY,KALASA,SAI NAGAR COLONY,HAYATH NAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VANASTHALIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.288, DOOR NO.5-5-285, NEAR SRI KANAKADURGA TEMPLE, PRASHANTH NAGAR, VANASTHALIPURAM, HYDERABAD 500070"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HMT COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL FLOT NO :59&amp;60,HT LINE,HMT COLONY,ALWAL,500010"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GUNDLAPOCHAMPALLY,BESIDE GVK EMRI,NEAR PRESTIGE PARK,MEDCHAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MLR COMPLEX,BESIDE BHARATH PETROL BUNK,KOMPALLY,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHANDRAREDDY GARDENS SURVEY NO: 87, MAHALAKSHMI ENCLAVE ROAD,NEAR DHOLA-RI- DHANI, KOMPALLY, HYDERABAD,TELANGANA- 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO.85 BESIDE S.N.R GARDEN, KOMPALLY 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI ENCLAVE, BESIDE NAVATHA TRANSPORT, NEAR DOLA RI DANI, KOMPALLY, MEDCHAL - 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDCHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 36,37,64,OPP SEVEN TEMPLES,UMA NAGAR, MEDCHAL,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BEERAMGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GREEN MEADOWS MAIN ROAD, ESUKA BAVI, BEERAMGUDA, AMEENPUR (MDL), SANGAREDDY (DST) 502032"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHINTAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 145\/P OPP HP GAS AGENCY PATWARI ENCLAVE IDPL CHINTAL 500054"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 6 ,BALAJI NAGAR, NEAR METRO STATION KUKATAPALLY,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5-3-114, PLOT NO 1 &amp; 14, BEHIND RELIANCE SMART, SHANTI NAGAR,NEAR RAMALAYAM, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAGANDLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP APARNA CYBER LIFE,NALLAGANDLA(VILL), RANGAREDDY(DIST) 500019"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SERILINGAMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.20 &amp; 21, HUDA LAY OUT, NEAR AJAY FUNCTION HALL &amp; LINGAMPALLY RYTHU BAZAR, SERILINGAMPALLY RANGA REDDY "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SEVEN HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-2-46\/348,ANJANADRI BLOCK,SEVENHILLS APARTMENTS,NIZAMPET X ROAD,BESID SRI SRI HOLISTIC HOSPITAL,HYD,500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO:3&amp;4,SARDARPATEL NAGAR,NIZAMPET X RAOD,HYDERNAGAR,HYDERBAD 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 175,NEAR JNTU METRO STATION ,SARDAR PATEL NAGAR, KUKATPALLY 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO. 157,158 &amp;159, BESIDE RAMALAYAM, SAPTHAGIRI COLONY, VIVEKANANDANAGAR, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR RES(BOYS)",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO.28,29, SAPTHAGIRI COLONY,VIVEKANANDANAGAR,KUKATPALLY 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANJARAHILLS STARKIDSPREMIUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 8-2-310-B-10, ROAD NO 14, NAVODAYA COLONY, NANDI NAGAR, BANJARA HILLS,HYDERABAD 500034"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BOWENPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO. 1-4, CHINNATHOKATTA, NEW BOWENPALLY, SECUNDERABAD 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "EAST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-3-18\/4,OPP: BANK OF BARODA(FORMERLY DENA BANK),,EAST MAREDPALLY,HYDERBAD-5000026"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL A8, TULASI HOSPITAL LINE,ELECTRONIC COMPLEX, ECIL,KUSHAIGUDA, HYDERABAD - 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:A\/10, ELECTRONIC COMPLEX, PHASE 2,KUSHAIGUDA, ECIL 'X' ROADS MEHDIPATNAM 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GOSHA MAHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO.5-3-825,MALLAKUNTA ROAD, OPP. NEW IOC PETROL PUMP,GOSHAMAHAL,HYDERABAD,500012"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HASMATHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 1, SEETHA RAMAPURAM, MALLAREDDY GARDEN LANE,BESIDE KALYANI THEATRE, OLD BOWENPALLY HASMATHPET 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PILLAR NO -118 ,HANUMAN TEMPLE LANE , SRI LAKSMI NAGAR COLONY, STREET NO -03 ,NEAR INDIAN BANK BACK SIDE &amp; CLOSE TO JANAPRIYA UTOPIYA APARTMENTS, HYDERGUDA ATTAPUR - 500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KARKHANA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 144\/149, TEXT BOOK COLONY ,TRANSPORT ROAD,KARKHANA,SECUNDERABAD. TELANGANA-500009"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LAL DARWAJ",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.18-4-42\/3\/2, ANDHRA BANK LANE,LAL DARWAJ ,HYDERABAD 500065"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "M G ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 2 - 4- 73\/74 , BESIDE KFC, MG ROAD, NALLAGUTTA, SECUNDERABAD -500003"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEHDIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 3 , SANTOSH NAGAR COLONY, ST.ANN'S WOMEN'S COLLEGE ROAD, MEHDIPATNAM, HYDERABAD - 500028"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BARKATPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO: 3-4-760, BESIDE ANDHRA YUVATHI MANDAL, BARKATPURA, HYDERABAD, TELANGANA 500027"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-9-165,OPP IOC PETROL BUNK,NEAR ELECTRICITY SUB STATION,MAIN ROAD, GHATKESAR-501301"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-7-34\/7 &amp; 4\/NR, OPP CHRIST THE KING CHURCH, BESIDE BADRAS GRAND HOTEL, RAMANTHAPUR,HABSIGUDA, UPPAL(M), MEDCHAL (D)"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HIMAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-6-655ROAD9,ASHOKNAGAR.HIMAYATNAGAR,NARAYANGUDA,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDIPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 13-238, OPP.HANUMAN TEMPLE,MAIN ROAD MEDIPALLY VILLEGE,MEDCHAL DIST-500098"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NACHARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 17\/4 , SURVEY NO: 45 &amp; 46 , NACHARAM ,UPPAL MANDAL,MEDCHAL 500076"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAKUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:1-9-1104 TO 1112,OPP LANE TO DURGABAI DESHMUKH HOSPITAL,VIDYANAGAR,ADIKMET,NALLAKUNTA, HYDERABAD-500044"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARANAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-12-5-28\/29\/2,TARNAKA,SECUNDERABAD-500017."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DAMMAIGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL ANJANADRI&nbsp;NAGAR,&nbsp;EXTENSION&nbsp;OPP LAKE VIEW WATER TANK, DAMMAIGUDA MEDCHAL 500083"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Sangareddy",
     "Center": "SANGAREDDY",
     "CenterAddress": "SRI CHAITANYA SCHOOL APHB COLONY OPP NEW COLLECTORATE, SANGAREDDY 502001"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Toopran",
     "Center": "TOOPRAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO-455, ALLAPUR ROAD, TOOPRAN,KOMPALLY 502334"
    },
    {
     "State": "TELANGANA",
     "District": "Karim Nagar",
     "City": "Ramagundam",
     "Center": "RAMAGUNDAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL-FERTILIZER CITY,RFCL TOWNSHIP, RFCL, RAMAGUNDAM-PEDDAPALLY(DIST) 505210"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "STARKIDS KODAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, STAR KIDS CAMPUS, GANESH NAGAR,CURRENT OFFICE BACK,KODAD, SURYAPET (DIST) 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-237\/3, SRINAGAR COLONY,KODAD POST &amp; MDL, SURYAPETA DT 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT RS",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANA ENGINEERING COLLEGE KODAD POST &amp; MDL, KODAD SURYAPETA 508206 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANASWADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 84\/1, GARDEN HOUSE, 5TH MAIN, OMBR LAYOUT, BANASWADI, BANGALORE-560033"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANNERGHATTA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL 75\/A, BANNERGHATTA ROAD, HULIMAVU, BANGALORE-560076"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BASAVANAGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #2, B.P WADIA ROAD, PANDU TOWERS, TAGORE CIRCLE, BASAVANAGUDI, BANGALORE-560004"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ELECTRONIC CITY INTERNATIONAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL LAKSHMINARAYANAPURA, BEHIND APMC FRUIT MARKET, NEAR HUSKURGATE, ELECTRONIC CITY, ANEKAL TALUK, KARNATAKA - 560099"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HEBBAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NO: 49\/4, KASABA HOBLI, VEERANNA PALYA MAIN ROAD,NAGAWARA VILLAGE,HEBBAL, ARABIC COLLEGE POST, BANGALORE 560045"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HSR LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL #55\/2, 19TH MAIN, 27TH CROSS, SECTOR 2, HSR LAYOUT, BANGALORE.PIN :560102"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "JP NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8TH PHASE,JAMBU SAVARI DINNE, JP NAGAR,BENGALURU "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KAGGADASAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 121\/4,VEMANNA ROAD,5TH MAIN, 7TH CROSS,MALLESHPALAYA, KAGGADASAPURA,BANGALORE -560075"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KANAKAPURA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 11, NEAR MANTRI TRANQUIL, GUBBALALA VILLAGE, KANAKAPURA ROAD, BANGALORE 560062"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KR PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAMMANNA GARDEN, DEVASANDRA MAIN ROAD, BEHIND&nbsp;KAVERI&nbsp; BAKERY, K.R.PURAM, BANGLORE-560036"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, #429, PRABHU LAYOUT, AECS LAYOUT, KUDLU, BANGALORE 560068"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUDLU2 #165,KUDLU VILLAGE,NEAR PARAPPANA AGRAHARA,MADIWALA (P),BENGULURU-560068."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "M S PALYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13\/1, NEAR AMBHABHAVANI TEMPLE, DODDABETTAHALLI, VIDYARANYAPURA POST MSPALYA - BANGALORE - 560097"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MAHALAKSHMI LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 227, 15TH C CROSS ROAD, 2ND PHASE, BOVIPALYA, NAGAPURA, MAHALAKSHMI LAYOUT,BENGALURU, 560086"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #86\/1C,NEAR S.G.R DENTAL COLLEGE,MUNNEKOLALA,MARATHAHALLI-1"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 93\/10, 93\/11, 93\/2A3, 93\/2A4, MUNNEKOLALA VILLAGE, BESIDE SHANMUKHA RESTAURANT, NEAR MARATHAHALLI BRIDGE, MARATHAHALLI, BANGALORE-560037"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "NAGARBHAVI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 42\/65, OPP BANGALORE UNIVERSITY STAFF QUARTERS, JNANAGANGA NAGAR, MYSORE-MAGADI RING ROAD, NAGARBHAVI,BANGALORE 560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "PEENYA DASARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYNO,65\/1,65\/2,NAGASANDRA VILAGE,YESHWANTHPUR HOBLI,BANGALORE 560073"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAJAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #21,(A-108)22, 5TH MAIN ROAD, TNDUSTRIAL AREA, 6TH BLOCK, RAJAJINAGAR, BANGALORE:-560010"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SEETHAPPA GARDEN, RAGHAVENDRA CIRCLE, T C PALAYA MAIN ROAD, RAMAMURTHY NAGAR, BANGALORE - 560016"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO. 131\/2, OPP. STATE BANK OF MYSORE, 1ST MAIN, 5 E CROSS, POOJA GARDEN, ASHIRWAD COLONY, HORAMAVU, BENGALURU 560043"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR HARIVILLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.91\/1,HOYSALA NAGAR, 8TH MAIN,5TH A CROSS,T C PALYA MAIN ROAD,RAMMURTHYNAGAR, BENGALURU 560016 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "SESHADRIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:79,SRINIVASA COMPLEX, 1ST MAIN ROAD, NEAR FORTIS HOSPITAL, SESHADRIPURAM, BENGALURU, KARNATAKA 560020"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ULLAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 161\/4,ULLAL VILLAGE,ULLAL,YESWANTHPUR HOBLI,BENGALURU-560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "UTTARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27, AREHALLI, AGS LAYOUT, ITTAMADU MAIN ROAD, UTTARAHALLI, BANGALORE-560061"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "VIDYARANYAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#21\/3, RAMCHANDRAPURA, VIDYARANYAPURA,JALAHALLI POST ,BANGALORE 560013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "WHITEFIELD",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#190, ANS SQUARE, NEXT TO SATHYA SAI COMPLEX, ITPL MAIN ROAD, NEAR HOODI CIRCLE, HOODI, WHITEFIELD, BENGALURU 560048"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YELLAHANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 30\/2A, THIRUMALA NAGAR, ATTUR LAYOUT, NEAR THIRUMALA DABA, YELAHANKA, BANGALORE"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YESHWANTHPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #22\/2, HMR COMPUND, 6TH CROSS, 1ST MAIN, YESHWANTHPUR, BENGALURU-560022"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Jayanagar Knowledge Hub",
     "CenterAddress": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
     "CenterAddress": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068."
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
     "CenterAddress": "PID no 21\/97\/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Davanagere",
     "Center": "DAVANAGERE",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE DCM RAILWAY BRIDGE, P B ROAD, DAVANAGERE,BENGALORE 577003 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Mangalore",
     "Center": "MANGALORE",
     "CenterAddress": "SRI CHAITANYA TENCHO SCHOOL BANGRA KULOOR ROAD , KOTTARA CHOWKI ,MANGALORE 576013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KYATHSANDRA FLYOVER, NH-4, KYATHSANDRA, TUMKUR 572104"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TUDA OFFICE ADARSHANAGAR, SRI SAI BABA TEMPAL ROAD, TUMKUR 572103"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI SAI BABA TEMPLE, OPP TUDA OFFICE, ADHARSHA NAGAR,TUMKUR,KARNATAKA "
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "IYYAPANTHANGAL",
     "CenterAddress": "SRI CHAITHANYA SCHOOL 16\/2,EVP PARK AVENUE 2ND STREET IYYAPANTHANGAL CHENNAI 600056"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KEELKATTALAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/1234,THIRU NAGAR,VIDUTHALAI NAGAR EXTN,KOVILAMBAKKAM,KEELKATTALAI,CHENNAI-600129"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KK NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 132 PILLAIYAR KOIL STREET KASI ESTATE JAFFERKHANPET,KK NAGAR CHENNAI -600083"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MADHAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD ,HOUSING SECTOR MADHAVRAM,CHENNAI-600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MANAPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 472\/1, BALARAMAN STREET, THIRUVALLUVAR NAGAR, MANAPAKKAM CHENNAI 600125"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MOOLAKADAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:1065\/1A1,TS NO.11, BLOCK 58,KKR NAGAR, MADAHAVARAM ,CHENNAI 600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MYLAPORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO: 4, NORTON ROAD,MANDAVELI,MYLAPORE,CHENNAI 600028"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "NOLAMBUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 314\/4, VGN NAGAR PHASE 1 3RD CROSS STREET, NOLAMBUR, CHENNAI-600095"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALAVAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:10\/6, MGR ROAD, ECR PALAVAKKAM, CHENNAI 600041"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 110 GST ROAD, ADJECENT PALLAVARAM FLYOVER ROAD, PALLAVARAM, CHENNAI 600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 200 FEET RADIAL ROAD, ARUL MURUGAN NAGAR,ZAMIN PALLAVARAM ,CHENNAI-600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUMBAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 139, INDIRA PRIYADHARSHINI NAGAR LAYOUT, NEAR GLOBAL HOSPITAL, PERUMBAKKAM, CHENNAI 600100"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUNGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 1,44A,CORPORATION ROAD,PERUNGUDI,CHENNAI 600096"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "POONAMALLEE INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO :184 POONAMALLEE TO PATTABIRAM MAINROAD,SOKKANALLUR,KOLAPPANCHERI,CHENNAI 600072"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "RAMAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12\/2,12\/3 ANANI SATHYA NAGAR MAIN ROAD THIRUVALLUVAR SALAI RAMAPURAM CHENNAI-600089 TAMILNADU"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "ROYAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8\/89, PUDUMANI KUPPAM,WEST MADHA CHURCH STREET,OPP GOVERNMENT UNANI HOSPITAL,ROYAPURAM,CHENNAI - 600013."
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "TAMBARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.276,GANDHI NAGAR.MUDICHUR MAIN ROAD,WEST TAMBARAM,CHENNAI 600063"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "THORAIPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL #104\/8C3, FOUNDRY ROAD, OKKIYAM THORAIPAKKAM, CHENNAI - 600097"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "VELACHERY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #169 VAIGAISTREET DEVIKARUMARIAMMAN NAGAR EXTN VELACHERY -600042"
    },
    {
     "State": "Tamil Nadu",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "Sri Chaitanya Knowledge Hub",
     "CenterAddress": "No.19, 1st Main Road, Gandhi Nagar, Above Pantaloons, Adyar, Chennai -600020, Contact :-7207931589 \/ 7207931590. "
    },
    {
     "State": "Bihar",
     "District": "Patna",
     "City": "Patna",
     "Center": "Knowledge Hub",
     "CenterAddress": "Abc tower, Main Boring road, Plot no - 134, Opp Harihar Chamber, Patna, 800001"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANASWADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 84\/1, GARDEN HOUSE, 5TH MAIN, OMBR LAYOUT, BANASWADI, BANGALORE-560033"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANNERGHATTA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL 75\/A, BANNERGHATTA ROAD, HULIMAVU, BANGALORE-560076"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BASAVANAGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #2, B.P WADIA ROAD, PANDU TOWERS, TAGORE CIRCLE, BASAVANAGUDI, BANGALORE-560004"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ELECTRONIC CITY INTERNATIONAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL LAKSHMINARAYANAPURA, BEHIND APMC FRUIT MARKET, NEAR HUSKURGATE, ELECTRONIC CITY, ANEKAL TALUK, KARNATAKA - 560099"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HEBBAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NO: 49\/4, KASABA HOBLI, VEERANNA PALYA MAIN ROAD,NAGAWARA VILLAGE,HEBBAL, ARABIC COLLEGE POST, BANGALORE 560045"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HSR LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL #55\/2, 19TH MAIN, 27TH CROSS, SECTOR 2, HSR LAYOUT, BANGALORE.PIN :560102"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "JP NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8TH PHASE,JAMBU SAVARI DINNE, JP NAGAR,BENGALURU "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KAGGADASAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 121\/4,VEMANNA ROAD,5TH MAIN, 7TH CROSS,MALLESHPALAYA, KAGGADASAPURA,BANGALORE -560075"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KANAKAPURA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 11, NEAR MANTRI TRANQUIL, GUBBALALA VILLAGE, KANAKAPURA ROAD, BANGALORE 560062"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KR PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAMMANNA GARDEN, DEVASANDRA MAIN ROAD, BEHIND&nbsp;KAVERI&nbsp; BAKERY, K.R.PURAM, BANGLORE-560036"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, #429, PRABHU LAYOUT, AECS LAYOUT, KUDLU, BANGALORE 560068"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUDLU2 #165,KUDLU VILLAGE,NEAR PARAPPANA AGRAHARA,MADIWALA (P),BENGULURU-560068."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "M S PALYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13\/1, NEAR AMBHABHAVANI TEMPLE, DODDABETTAHALLI, VIDYARANYAPURA POST MSPALYA - BANGALORE - 560097"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MAHALAKSHMI LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 227, 15TH C CROSS ROAD, 2ND PHASE, BOVIPALYA, NAGAPURA, MAHALAKSHMI LAYOUT,BENGALURU, 560086"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #86\/1C,NEAR S.G.R DENTAL COLLEGE,MUNNEKOLALA,MARATHAHALLI-1"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 93\/10, 93\/11, 93\/2A3, 93\/2A4, MUNNEKOLALA VILLAGE, BESIDE SHANMUKHA RESTAURANT, NEAR MARATHAHALLI BRIDGE, MARATHAHALLI, BANGALORE-560037"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "NAGARBHAVI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 42\/65, OPP BANGALORE UNIVERSITY STAFF QUARTERS, JNANAGANGA NAGAR, MYSORE-MAGADI RING ROAD, NAGARBHAVI,BANGALORE 560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "PEENYA DASARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYNO,65\/1,65\/2,NAGASANDRA VILAGE,YESHWANTHPUR HOBLI,BANGALORE 560073"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAJAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #21,(A-108)22, 5TH MAIN ROAD, TNDUSTRIAL AREA, 6TH BLOCK, RAJAJINAGAR, BANGALORE:-560010"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SEETHAPPA GARDEN, RAGHAVENDRA CIRCLE, T C PALAYA MAIN ROAD, RAMAMURTHY NAGAR, BANGALORE - 560016"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO. 131\/2, OPP. STATE BANK OF MYSORE, 1ST MAIN, 5 E CROSS, POOJA GARDEN, ASHIRWAD COLONY, HORAMAVU, BENGALURU 560043"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR HARIVILLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.91\/1,HOYSALA NAGAR, 8TH MAIN,5TH A CROSS,T C PALYA MAIN ROAD,RAMMURTHYNAGAR, BENGALURU 560016 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "SESHADRIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:79,SRINIVASA COMPLEX, 1ST MAIN ROAD, NEAR FORTIS HOSPITAL, SESHADRIPURAM, BENGALURU, KARNATAKA 560020"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ULLAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 161\/4,ULLAL VILLAGE,ULLAL,YESWANTHPUR HOBLI,BENGALURU-560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "UTTARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27, AREHALLI, AGS LAYOUT, ITTAMADU MAIN ROAD, UTTARAHALLI, BANGALORE-560061"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "VIDYARANYAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#21\/3, RAMCHANDRAPURA, VIDYARANYAPURA,JALAHALLI POST ,BANGALORE 560013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "WHITEFIELD",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#190, ANS SQUARE, NEXT TO SATHYA SAI COMPLEX, ITPL MAIN ROAD, NEAR HOODI CIRCLE, HOODI, WHITEFIELD, BENGALURU 560048"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YELLAHANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 30\/2A, THIRUMALA NAGAR, ATTUR LAYOUT, NEAR THIRUMALA DABA, YELAHANKA, BANGALORE"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YESHWANTHPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #22\/2, HMR COMPUND, 6TH CROSS, 1ST MAIN, YESHWANTHPUR, BENGALURU-560022"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Jayanagar Knowledge Hub",
     "CenterAddress": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
     "CenterAddress": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068."
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
     "CenterAddress": "PID no 21\/97\/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Davanagere",
     "Center": "DAVANAGERE",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE DCM RAILWAY BRIDGE, P B ROAD, DAVANAGERE,BENGALORE 577003 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Mangalore",
     "Center": "MANGALORE",
     "CenterAddress": "SRI CHAITANYA TENCHO SCHOOL BANGRA KULOOR ROAD , KOTTARA CHOWKI ,MANGALORE 576013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KYATHSANDRA FLYOVER, NH-4, KYATHSANDRA, TUMKUR 572104"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TUDA OFFICE ADARSHANAGAR, SRI SAI BABA TEMPAL ROAD, TUMKUR 572103"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI SAI BABA TEMPLE, OPP TUDA OFFICE, ADHARSHA NAGAR,TUMKUR,KARNATAKA "
    },
    {
     "State": "MADHYA PRADESH",
     "District": "Bhopal",
     "City": "Bhopal",
     "Center": "BHOPAL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. TO PRIDE CITY,NEAR KATARA HILLS,RAPADIA VILLAGE,BHOPAL,MADYAPRADESH-462043"
    },
    {
     "State": "MADHYA PRADESH",
     "District": "Indore",
     "City": "Indore",
     "Center": "INDORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA AVENUE,NEAR SMALL POWER HOUSE,RANI BAGH MAIN,KHANDWA ROAD,INDORE 452001"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Andheri Sri Chaitanya Centre",
     "CenterAddress": "Sri Chaitanya, 301,B wing. Business point. Paliram road. Andheri west. Near by BMC office Mumbai 400058"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Borivali Sri Chaitanya Centre",
     "CenterAddress": "Brio e-Tech Jr. College &amp; V K Krishna Menon Academy, Plot no. 462, New MHB Colony, Off Gorai Road, Borivali West, Mumbai -400091"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Thane Sri Chaitanya Centre",
     "CenterAddress": "M. H. High School and Junior College, Shivaji Path near Thane station &amp; Talaopali Thane (W)"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Mumbai",
     "City": "Ulhasnagar",
     "Center": "ULHASNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYAN-MURBAD ROAD,NEAR RIVER WIND RESORT,OPPOSITE TO HP PETROL BUNK, KAMBA, KALYAN, ULHASNAGAR – 421103."
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "AUNDH JAIHINDH BLDG",
     "CenterAddress": "SRI CHAITANYA IIT ACADAMY, 4TH FLOOR   JAIHINDH BUILDING PARIHAR CHOWK AREA AUNDH PUNE 411007"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "BAVDHAN CAMPUS PUNE",
     "CenterAddress": "SRI CHAITANYA TECHNO SCHOOL NEAR CRYSTAL HONDA SHOWROOM MUMBAI-PUNE HIGHWAY BAVDHAN(BK) PUNE 411021"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "WAGHOLI CAMPUS PUNE",
     "CenterAddress": "SRI CHAITANYA TECHNO SCHOOL, KONARK ORCHID, GATE NO . 905,906,926,1085 OPP. SATAV ENTERPRISES, BESIDES SEEMA WAREHOUSE, KESNAND ROAD, WAGHOLI,PUNE-412207"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "SHIVAJI BHAVAN PUN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, SURVEY NO 134,NEAR XRBIA CHOWK MARUNJI TO KASARSAI ROAD, NERE DATTAWADI , POST : JAMBE,TAL - MULSHI PUNE,MAHARASHTRA-411057"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE,  NANDHE SYMBOYSIS UNIVERSITY(NAWALE)  NEAR LOPIN COMPANI GURUKUL HOSTAL  MULSHI TALUKA  NANDHE  PUNE-411042"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "BAVADHAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:267\/3, OLD MUMBAI - PUNE HWY, NEAR CRYSTAL HONDA SHOWROOM, BAVDHAN, PUNE"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Pune",
     "City": "Pune",
     "Center": "WAGHOLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL KONARK ORCHID, OPPOSITE SATAV ENTERPRISES, KESNAND ROAD, BESIDE SEEMA WAREHOUSE, WAGHOLI, MAHARASHTRA 412207"
    },
    {
     "State": "PUNJAB",
     "District": "Jalandhar",
     "City": "Jalandhar",
     "Center": "JALANDHAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL ELDECO GREENS, NAKODAR ROAD, JALANDHAR CITY, JALANDHAR - 144026"
    },
    {
     "State": "RAJASTHAN",
     "District": "Jaipur",
     "City": "Jaipur",
     "Center": "JAIPUR 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMLA NEHRU NAGAR, KESHU PURA, NEAR DOUNGRI HOUSE, AJMER ROAD, JAIPUR, RAJASTHAN, 303006"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "IYYAPANTHANGAL",
     "CenterAddress": "SRI CHAITHANYA SCHOOL 16\/2,EVP PARK AVENUE 2ND STREET IYYAPANTHANGAL CHENNAI 600056"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KEELKATTALAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/1234,THIRU NAGAR,VIDUTHALAI NAGAR EXTN,KOVILAMBAKKAM,KEELKATTALAI,CHENNAI-600129"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "KK NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 132 PILLAIYAR KOIL STREET KASI ESTATE JAFFERKHANPET,KK NAGAR CHENNAI -600083"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MADHAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD ,HOUSING SECTOR MADHAVRAM,CHENNAI-600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MANAPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 472\/1, BALARAMAN STREET, THIRUVALLUVAR NAGAR, MANAPAKKAM CHENNAI 600125"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MOOLAKADAI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:1065\/1A1,TS NO.11, BLOCK 58,KKR NAGAR, MADAHAVARAM ,CHENNAI 600060"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "MYLAPORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO: 4, NORTON ROAD,MANDAVELI,MYLAPORE,CHENNAI 600028"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "NOLAMBUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 314\/4, VGN NAGAR PHASE 1 3RD CROSS STREET, NOLAMBUR, CHENNAI-600095"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALAVAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:10\/6, MGR ROAD, ECR PALAVAKKAM, CHENNAI 600041"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 110 GST ROAD, ADJECENT PALLAVARAM FLYOVER ROAD, PALLAVARAM, CHENNAI 600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PALLAVARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 200 FEET RADIAL ROAD, ARUL MURUGAN NAGAR,ZAMIN PALLAVARAM ,CHENNAI-600043"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUMBAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 139, INDIRA PRIYADHARSHINI NAGAR LAYOUT, NEAR GLOBAL HOSPITAL, PERUMBAKKAM, CHENNAI 600100"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "PERUNGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 1,44A,CORPORATION ROAD,PERUNGUDI,CHENNAI 600096"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "POONAMALLEE INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO :184 POONAMALLEE TO PATTABIRAM MAINROAD,SOKKANALLUR,KOLAPPANCHERI,CHENNAI 600072"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "RAMAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12\/2,12\/3 ANANI SATHYA NAGAR MAIN ROAD THIRUVALLUVAR SALAI RAMAPURAM CHENNAI-600089 TAMILNADU"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "ROYAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8\/89, PUDUMANI KUPPAM,WEST MADHA CHURCH STREET,OPP GOVERNMENT UNANI HOSPITAL,ROYAPURAM,CHENNAI - 600013."
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "TAMBARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.276,GANDHI NAGAR.MUDICHUR MAIN ROAD,WEST TAMBARAM,CHENNAI 600063"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "THORAIPAKKAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL #104\/8C3, FOUNDRY ROAD, OKKIYAM THORAIPAKKAM, CHENNAI - 600097"
    },
    {
     "State": "TAMIL NADU",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "VELACHERY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #169 VAIGAISTREET DEVIKARUMARIAMMAN NAGAR EXTN VELACHERY -600042"
    },
    {
     "State": "Tamil Nadu",
     "District": "Chennai",
     "City": "Chennai",
     "Center": "Sri Chaitanya Knowledge Hub",
     "CenterAddress": "No.19, 1st Main Road, Gandhi Nagar, Above Pantaloons, Adyar, Chennai -600020, Contact :-7207931589 \/ 7207931590. "
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,DOOR NO:79, ATHIPALAYAM RD, NEAR JAS COLLEGE OF EDUCATION, CHINNAVEDAMPATTI, COIMBATORE 641049"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 806,WISDOM TREE, KATHIR CAMPUS,NEELAMBUR,COIMBATORE-641062"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.11,DR.NANJAPPA ROAD, NEAR PARK GATE ,BESIDE NEHRU STADIUM,GANDHIPURAM, COIMBATORE 641018"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Coimbatore",
     "Center": "COIMBATORE 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL S.F.NO 22, LAKSHMI NAGAR, SENAMANICKENPALAYAM ROAD, IDIKARAI, COIMBATORE,TAMIL NADU 641022"
    },
    {
     "State": "TAMIL NADU",
     "District": "Coimbatore",
     "City": "Tiruppur",
     "Center": "TIRUPPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO 537 VIVEKANANDA NAGAR, COLLEGE ROAD, TIRUPPUR 641603"
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Lucknow",
     "City": "Lucknow",
     "Center": "LUCKNOW 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL ADJACENT TO FLYOVER, AMETHIYA, HARDOI ROAD, STATE HIGHWAY 25,LUCKNOW UTTAR PRADESH 2260101 "
    },
    {
     "State": "UTTAR PRADESH",
     "District": "Meerut",
     "City": "Meerut",
     "Center": "MEERUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6TH MILE STONE, MAWANA ROAD,MEERUT,UTTAR PRADESH 250001"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "BADA BAZAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2A,NANDA MULLICK LANE, NEAR GANESH TALKIES , BURRA BAZAR, KOLKATA-700006"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "DUNLOP",
     "CenterAddress": "SRI CHAITANYA SCHOOL 51, S.M.BOSE ROAD (LAHABAGAN), NEAR DUCK BACK MORE , PANIHATI,KOLKATA-700114"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Kolkata",
     "Center": "NEW TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL 06-360, STREET NO: 360, BESIDE RISHI TECH PARK, NEWTOWN, KOLKATA-700160"
    },
    {
     "State": "WEST BENGAL",
     "District": "Kolkata",
     "City": "Serampore",
     "Center": "SERAMPORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL JANNAGAR RD, MAHESH COLONY, NEAR TENNIS CLUB, SERAMPORE, HOOGHLY-712202"
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-Olympiad",
     "CenterAddress": "Sri Chaitanya International Olympiad School,H.No.5-7-182\/3\/1, Near Mamata Hospital, Khammam - 507 002, Khammam Dist. Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-IOS",
     "CenterAddress": "Sri Chaitanya International School,H.No.5-7-182\/3\/1,  Near Mamata Hospital,Khammam - 507 002, Khammam Dist.Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-1",
     "CenterAddress": "Sri Chaitanya School,H.No.6-3-284, G.L.Towers, Near Ntr Statue,Bypass Road, Khammam - 507 001.Cell: 9666666720 &amp; 9666666718."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-2",
     "CenterAddress": "Sri Chaitanya School,H.No.10-4-31\/A, Beside Sai Baba Temple, Mamillagudem, Khammam - 500 702, Cell: 9666666721 &amp; 7680884537."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-3(Lotus)",
     "CenterAddress": "Near Petrol Bunk ,Musthfanagar Khammam"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-1",
     "CenterAddress": "Sri Chaitanya School,H.No.9-11, Laxmidevi Palli, Kothagudem - 507 101,Bhadradri Kothagudem Dist.Cell: 9666666722, 9666666723."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-2",
     "CenterAddress": "Sri Chaitanya School,G.R. Basthi, Bhajan Mandhir Road, Kothagudem  - 507 101,Bhadradri Kothagudem Dist.Cell: 8367317755 &amp;"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-3",
     "CenterAddress": "Sri Chaitanya School,H.No.3-1-6\/7, Vidhyanagar Colony (Panchayath), Chunchupally (Mndl), Kothagudem,Bhadradri Kothagudem (Dist), Pin: 507 101."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-1",
     "CenterAddress": "Sri Chaitanya School,H.No.20-5-32\/1, Contractor’S Colony,Palvancha - 507 115, Bhadradri Kothagudem (Dist).Cell: 7675837755, 7675847755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-2",
     "CenterAddress": "Sri Chaitanya School,Oddugudem, Near Bramana Kalayana Mandapam, Palvancha - 521 175, Bhadradri Kothagudem (Dist).Cell: 8367247755 &amp; 8367257755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Bhadrachalam",
     "Center": "Bhadrachalam",
     "CenterAddress": "Sri Chaitanya School,Opp: K.K.Function Hall, Charla Road, Bhadrachalam (Post &amp; Mdl).Bhadradri Kothagudem (Dist.) Pin: 507 111.Cell: 8340947755, 8340957755 &amp; 8340967755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Manugur",
     "Center": "Manugur",
     "CenterAddress": "Sri Chaitanya School,Guttamallaram, Manuguru - 507 117,Bhadradri Kothagudem (Dist).Cell: 8340977755, 8340987755 &amp; 8340997755."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Madhira",
     "Center": "Madhira",
     "CenterAddress": "Sri Chaitanya School,Ward No.121, Opp: Club Complex, Madhira (Post &amp; Mndl), Pin: 507 203, Khammam (Dist).Cell: 9666666724, 9666666725."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Mahabubabad",
     "Center": "Mahabubabad",
     "CenterAddress": "Sri Chaitanya School,H.No.6-2-44\/7\/1, Krishna Colony,Near Railwary Gate, Mahabubabad - 506 101 , Mahabubabad Dist.Cell: 9666666714 &amp; 9666666715."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Sathupally",
     "Center": "Sathupally",
     "CenterAddress": "Millennium School,Busstand Opp,Bonthu Aslesha Street, Sathupally.  9949609680"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-4"
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Warangal",
     "Center": "Warangal",
     "CenterAddress": "Sri Chaitanya School,H.No.11-27-16, Near Inner Wheel Club, Vasavi Colony, Kothawada, Warangal - 506 002, Warangal Dist.Cell: 9666666710 &amp; 9666666711."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda",
     "CenterAddress": "Sri Chaitanya School,H.N.5-9-210, Opp: Seven Hills Hospital, Kishanpura, Hanamkonda - 506 001, Warangal (Urban) Dist.Cell: 9666666712 &amp; 9666666708."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda-IPL",
     "CenterAddress": "Sri Chaitanya School,H.No.2-5-278\/280, Iob Lane, Beside G.R Hospital,Hanmakonda -506 001, Warangal (Dist). Cell: 8367407755, 8367417755, 8367427755 &amp; 8367397755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanmakonda",
     "Center": "Hanmakonda-CBSE",
     "CenterAddress": "Sri Chaitanya School,Lead India School, Hunter Road, Dwaraka Nagar, Shyampet,Hanmakonda - 506 001."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Kashibugga",
     "Center": "Kashibugga",
     "CenterAddress": "Sri Chaitanya School,H.No.11-23-662, L.B Nagar, Beside Decent Function Hall, Main Road, Kashibugga - 506 002, Warangal (Urban Dist).Cell: 7995555731 &amp; 7995555733."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Rangasaipet",
     "Center": "Rangasaipet",
     "CenterAddress": "Sri Chaitanya School,H.No.19-9-441, Beside Nagamaiah Temple Arch, Shambhunipet, Khammam Main Road, Warangal - 506 005."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Narsampet",
     "Center": "Narsampet",
     "CenterAddress": "Sri Chaitanya School,Sarojini Devi Road, Near Post Office,Narsampet - 506 132, Warangal (Rural) Dist.Cell: 9951377755 &amp; 9951277755."
    },
    {
     "State": "TELANGANA",
     "District": "Jayashankar Bhupalpally&nbsp;",
     "City": "Bhupalpally",
     "Center": "Bhupalpally",
     "CenterAddress": "Sri Chaitanya School,H.No-9-13\/1, Near Ramalayam Temple, Gandhinagar, Bhupalpally - 506 169,Bhupalpally Jayashankar (Dist).Cell: 9666666740 &amp; 9666666741."
    },
    {
     "State": "TELANGANA",
     "District": "Janagoan",
     "City": "Janagoan",
     "Center": "Janagoan",
     "CenterAddress": "Sri Chaitanya School,D.No.1-10-64\/20, Grain Market Road, A.V.Nagar, Janagoan - 506167, Janagoan (Dist).Cell: 7997837755 &amp; 7997847755"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubabad",
     "City": "Thorrur",
     "Center": "Thorrur",
     "CenterAddress": "Sri Chaitanya School,Bhatupaly, Kazipet -  506 003,Warangal Urban (Dist),Cell: 9705257755 &amp; 9705267755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Kazipet",
     "Center": "Kazipet CBSE",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755"
    },
    {
     "State": "TELANGANA",
     "District": "Medchal",
     "City": "Dammaiguda",
     "Center": "Dammaiguda",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 6-75\/8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755."
    },
    {
     "State": "TELANGANA",
     "District": "Medchal-Malkajgiri",
     "City": "Hyderabad",
     "Center": "Boduppal",
     "CenterAddress": "Sri Chaitanya School,H.No.3-105\/3\/3, Sairam Nagar Colony ,Boduppal, Medipally (M),Medchal Malkajgiri Disit, Pin: 500 039."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Tukkuguda",
     "Center": "Tukkuguda",
     "CenterAddress": "Sri Chaitanya School,Survey No.152\/A\/J, Beside Sri Swami Ayyappa Temple,Tukkuguda, Rangareddy Dist. Pin: 501 359."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Badangpet",
     "CenterAddress": "Sri Chaitanya School,D.No.4-74\/3, Raghavendra Colony,Badangpet Main Road, Opp: Sbi Bank,Badangpet Village, Balapur (Mandal),Ranga Reddy Dist, Pin: 500 058."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Ibrahimpatnam",
     "CenterAddress": "Sri Chaitanya School,Opp : Bharat Garden, Manchal Road,Siripuram Colony, Ibrahimpatnam, Ranga Reddy Dist. Pin: 501 506."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Sangareddy",
     "Center": "Sangareddy",
     "CenterAddress": "Sri Chaitanya School,H.No.9-93, Pothireddy Pally X Roads, Sangareddy, Sangareddy Dist, Pin: 502 295."
    },
    {
     "State": "TELANGANA",
     "District": "Medak",
     "City": "Sadasivpet",
     "Center": "Sadasivpet",
     "CenterAddress": "Sri Chaitanya School, H.No.3-9-12\/2 , Beside Bus Stop,Rahamath Nagar, Sadasivpet, Sangareddy Dist, Pin: 502 291."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Zaheerabad",
     "Center": "Zaheerabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.96\/A\/7, Opp. Sbi Bank, Pastapur X Roads,Zaheerabad - 502 220, Sangaredy Dist."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Vikarabad",
     "Center": "Vikarabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.72, Beside Indian Oil Petrol Pump,Hyderabad Road, Yenapally, Vikarabad,Vikarabad Dist, Pin: 501 101."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Annojiguda",
     "CenterAddress": "Sri Chaitanya School, H.No.6-52\/G\/1, Beside Sbi, Near Sbr Gardens, Annojiguda - 500 088, Ghatkesar (Mdl), Medchal-Malkajgiri (Dist),Cell: 9705737755 &amp; 9705747755."
    },
    {
     "State": "TELANGANA",
     "District": "Yadadri Bhuvanagiri ",
     "City": "Bhongir",
     "Center": "Bhongir",
     "CenterAddress": "Azad Road, 2-2-153 Bongiri"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Kandukur",
     "Center": "Kandukur",
     "CenterAddress": "Beside Mro Office,Kandukur"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Moinabad",
     "Center": "Moinabad",
     "CenterAddress": "Chilkur Village,Moinabad"
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-1",
     "CenterAddress": "Sri Chaitanya School,H.No.18-80, Haripriya Nagar, Vijaya Bank Back Side, Beside Konda Mallaiah Gardens, Hyd Road, Siddipet - 502 103, Siddipet Dist.Cell: 9666666744 &amp; 9666666745."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-2",
     "CenterAddress": "Sri Chaitanya School,H.No.18-19-28\/2 &amp; 2A, Prashanth Nagar, Above Tvs Show Room, Near Hotel Akshaya Grand, Siddipet - 502 103, Siddipet Dist.Cell: 8297827755 &amp; "
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mancheriyal",
     "Center": "Mancheriyal",
     "CenterAddress": "Sri Chaitanya School,Opp. Govt. Degree &amp; P.G College, Godavari Road, Mancherial - 504 208, Mancherial Dist. Cell: 9666666746 &amp; 9666666747."
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mandamarri",
     "Center": "Mandamarri",
     "CenterAddress": "Sri Chaitanya High School,H.No. 42-2\/B, Near Old Bus Stand, Besides Shivani Degree &amp; Pg Collage, Mandamarri - 504 231, Mancheriyal Dist.Cell 7680867755, 7680857755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Godavarikhani",
     "Center": "Godavarikhani",
     "CenterAddress": "Sri Chaitanya School,H.No.17-1-14\/2, F.C.I. Road, Sanjay Gandhi Nagar, Godavarikhani - 505 209, Ramagundam (Mdl), Peddapally (Dist). Cell: 9666666748 &amp; 9666666749."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Boiwada",
     "Center": "Boiwada",
     "CenterAddress": "Sri Chaitanya School,H.No.1-6-79, Near Hanuman Temple,  Boiwada, Karimnagar - 505 001, Karimnagar (Mdl &amp; Dist).Cell: 7995555623,7995555625."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Thimmapur",
     "Center": "Thimmapur",
     "CenterAddress": "Sri Chaitanya School,Opp. Saakshi Office, Hyderabad Road, Rajeev Rahadari, Thimmapur, Karimnagar (Mdl &amp; Dist), Pin: 505 527.Cell: 7995555622 &amp; 7995555624."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Vavilalapally",
     "Center": "Vavilalapally",
     "CenterAddress": "Sri Chaitanya School,H.No.3-7-142, Near Svjc Girls Jr.College, Vavilalpally (Vil),  Karimnagar (Mndl &amp; Dist), Pin:505 001.Cell: 8367637755, 8367647755 &amp; 8367657755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Karimnagar",
     "Center": "Karimnagar-IPL",
     "CenterAddress": "Sri Chaitanya SchoolH.No:4-65\/55-5D2\/4,Road No.2Opp:Apollo Reach Hospital, Vidhyaranyapuri,  Theegalaguttapally (Vill),Karimnagar (Mdl &amp; Dist), Pin: 505 001,Cell: 836743775, 8367457755 &amp; 8367467755."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Yellapur",
     "Center": "Yellapur",
     "CenterAddress": "Sri Chaitanya School,Yellapur (Vil), Hasnparthy (Mdl), Warangal (Urban Dist) Pin: 506 371.Cell: 9666 666 713, 8297427755 &amp; 8297437755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Sircilla",
     "Center": "Sircilla",
     "CenterAddress": "Sri Chaitanya School,H.No.473B\/1, Near Hanuman Temple, Vidyanagar, Siricilla - 505 301, Rajanna Sircilla Dist.Cell: 9912487755 &amp; 9912497755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Sultanabad",
     "Center": "Sultanabad",
     "CenterAddress": "Sri Chaitanya School,H.No.4-76, Opp: Library, Venugopala Swamy Street,  Sulthanabad - 505 185, Peddapalli Dist.Cell: 9505257755 &amp; 9505267755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Huzurabad",
     "Center": "Huzurabad",
     "CenterAddress": "Sri Chaitanya School,H.No.9-116\/1, Banda Ankoos Wada, Huzurabad - 505 468, Karimnagar Dist.Cell: 9603627755 &amp; 9603637755."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet CBSE",
     "CenterAddress": "Sri Chaitanya School,Rangadampally Chowrasta To Husnabad Road, Karimnagar To Hyderabad Highway, Siddipet - 502 103, Siddipet Dist.Cell: 7997807755 &amp; 7997817755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Yellareddypet",
     "Center": "Yellareddypet",
     "CenterAddress": "Siricilla Road, Yellareddy Pet-505301"
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Korutla",
     "Center": "Korutla",
     "CenterAddress": "Sri Chaitanya School,Near Sri Krishna Temple, Sai Ram Pura Colony,Korutla - 505 326, Karimnagar (Dist).Cell: 9666666717, 8374453341."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Jagtial",
     "Center": "Jagtial",
     "CenterAddress": "Sri Chaitanya School,Dr.No.1-3-129,Dr.Md.Shankar Hospital Road,Krishna Nagar, Jagtial, Pin: 505 327."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet ",
     "Center": "Siddipet IPL",
     "CenterAddress": "Near By New Busstand, Muralikrishna (Sushrutha) Hospital Lane, Back Side Of Bajaj Electronics, Siddipet"
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Bellampally",
     "Center": "Bellampally",
     "CenterAddress": "Chemical Area, Caltex, Bellampalli."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Vemulawada",
     "Center": "Vemulawada",
     "CenterAddress": "Chekkapally Road,Bhaghavanthrao Nagar ,Vemulawada."
    },
    {
     "State": "TELANGANA",
     "District": "Komaram Bheem",
     "City": "Sirpur Kagaz Nagar",
     "Center": "Sirpur Kagaz Nagar",
     "CenterAddress": "H.No.1-16-713\/8, Srinagar Colony, Kagaznagar, Komaram Bheem Asifabad Dist. - 504 296."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Husnabad",
     "Center": "Husnabad",
     "CenterAddress": "Siddipet Road,Husnabad"
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Armoor",
     "Center": "Armoor",
     "CenterAddress": "Sri Chaitanya School, H.No.1-18\/6\/E, Housing Board Colony, Perkit, Armoor (Post &amp; Mndl), Nizamabad (Dist), Pin: 503 224.Cell: 8367607755 &amp; 8367627755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-1",
     "CenterAddress": "Sri Chaitanya School,H.No.11-1-272, Gupanpally X Road, Armoor Road, Gangasthan, Nizamabad- 503 003, Nizamabad Dist.Cell: 8367357755 &amp; 8367367755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-2",
     "CenterAddress": "Sri Chaithanya School,H.No.1-12-126\/19,Srinidhi High School, Near Presidency School, Srinagar Colony, Vinayak Nagar,Nizamabad - 503 003."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-1",
     "CenterAddress": "Sri Chaitanya School,H.No.5-11-51\/8\/18, Priya Darshini Nagar,Behind Bus Stand, Nirmal - 504 106. Nirmal (Mdl &amp; Dist).Cell: 8367537755, 8367547755;8367567755."
    },
    {
     "State": "TELANGANA",
     "District": "Adilabad",
     "City": "Adilabad",
     "Center": "Adilabad",
     "CenterAddress": "Sri Chaitanya School,Beside L.V.Prasad Eye Hospital,Mavala Road, Adilabad.Adilabad Dist, Pin: 504 001."
    },
    {
     "State": "TELANGANA",
     "District": "Kamareddy",
     "City": "Kamareddy",
     "Center": "Kamareddy",
     "CenterAddress": "H.No.9-29,Kaliki Nagar,3Rd Street, Lingapur, Kamareddy."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-2",
     "CenterAddress": "Behind Nakshatra Water Plant,Adarsh Nagar, Nirmal"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-1",
     "CenterAddress": "Sri Chaitanya School,Ravindra Nagar, Hyderabad Road, Nalgonda - 508 001, Nalgonda Dist.Cell: 9666666730 &amp; 9666666731."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-2",
     "CenterAddress": "Sri Chaitanya School, H.No:4-10-741, Siddradha Colony,Dvk Road, Nalgonda, Nalgonda Dist, Pin: 508 001."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-1",
     "CenterAddress": "Sri Chaitanya School,Doctor’S Colony, Behind Gromore, Nakirekal - 508 211, Nalgonda Dist. Cell: 9666666732 &amp; 9666666733. "
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-2",
     "CenterAddress": "Sri Chaitanya School,Opp. Raghurama Theatre,Tipparthi Road, Nakirekal - 508 211, Nalgonda Dist.Cell: 9618522088, 9618522077."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Suryapet",
     "Center": "Suryapet",
     "CenterAddress": "Sri Chaitanya School,H.No:1-6-41-10A\/3, Near 60 Feet Road, Nh-65, Beside Gayatri Jr.College, Vidya Nagar, Suryapet - 508213, Suryapet Dist.Cell:9666666734 &amp; 9666666735."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Huzurnagar",
     "Center": "Huzurnagar",
     "CenterAddress": "Sri Chaitanya School,H.No.1-53\/14\/1, C\/O Siddu B.Ed. College, Near Srinivasa Theater, Huzurnagar (Post &amp; Mdl), Suryapet (Dist), Pin: 508 204. Cell:  8367227755 &amp; 8367217755."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-1",
     "CenterAddress": "Sri Chaitanya School,Krishna Manasa Colony, Miryalaguda - 508 207, Nalgonda Dist.  Cell: 9666666736 &amp; 9666666737."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-2",
     "CenterAddress": "Sri Chaitanya School,Reddy Colony, Above Tamilnadu Bank,Near Sbi Complex, Miryalaguda - 508207,  Nalgonda Dist. Cell: 7995555616."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-3",
     "CenterAddress": "Venkatadripalem, Miryalaguda."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Nagarkurnool",
     "Center": "Nagarkurnool",
     "CenterAddress": "Sri Chaitanya School,Eshwar Colony, Road No.1, Nagarkurnool (Post &amp; Dist), Pin: 509 209. Cell: 8340847755 &amp; 8340857755."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Achampet",
     "Center": "Achampet",
     "CenterAddress": "Sri Chaitanya School,Venkateswara Colony, Opp: T.V. Tower, Achampet - 509 375, Nagarkunool (Dist).Cell: 8340917755 &amp; 8340927755."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur",
     "CenterAddress": "Sri Chaitanya School,H.No.2-2-163, Shanthi Nagar,Tandur (Vil &amp; Mdl), Vikarabad Dist, Pin: 501 141.Cell:"
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Kalwakurthy",
     "Center": "Kalwakurthy",
     "CenterAddress": "Ho.No.7-3, Near Dr.Br.Ambedkar Paramedical Vocational College, Subhash Nagar, Nagarkurnool Road, Kalwakurthy."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Shadnagar",
     "Center": "Shadnagar",
     "CenterAddress": "H.No:17-1\/7,Rachappa Estates, Ayyappa Colony, Near Bharat Petrol Bunk, Shadnagar."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur-2",
     "CenterAddress": "Brundavan Colony, Tandur"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Mahabubnagar",
     "Center": "Mahabubnagar",
     "CenterAddress": "Sri Chaitanya School,Telangana Chowrastha, Opp: Dccb Head Office, Mahabubnagar - 509 001,Mahabubnagar (Dist).Cell: 8340817755, 8340827755 &amp;  8340837755."
    },
    {
     "State": "TELANGANA",
     "District": "Jogulamba-Gadwal",
     "City": "Gadwal",
     "Center": "Gadwal",
     "CenterAddress": "Sri Chaitanya School,Navodaya High School, Rajeev Marg, Gadwal, Jogulambha Gadwal Dist, Pin: 509 125."
    },
    {
     "State": "TELANGANA",
     "District": "Wanaparthy",
     "City": "Wanaparthy",
     "Center": "Wanaparthy",
     "CenterAddress": "Sri Chaitanya School,Genius High School,Chityala Road,Wanaparthy, Wanaparthy Dist, Pin: 509 103."
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Jadcherla",
     "Center": "Jadcherla",
     "CenterAddress": "Vikas Nagar, Near Laxminagar Colony, Jedcherla."
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Navi Mumbai",
     "Center": "Navi Mumbai",
     "CenterAddress": "Jaipuriar School, Plot No 12 , Sector : 18, off Palm Beach Road, Sanpada, Navi Mumbai, 400705"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Mumbai",
     "City": "Ulhasnagar",
     "Center": "ULHASNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYAN-MURBAD ROAD,NEAR RIVER WIND RESORT,OPPOSITE TO HP PETROL BUNK, KAMBA, KALYAN, ULHASNAGAR – 421103."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANASWADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 84\/1, GARDEN HOUSE, 5TH MAIN, OMBR LAYOUT, BANASWADI, BANGALORE-560033"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANNERGHATTA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL 75\/A, BANNERGHATTA ROAD, HULIMAVU, BANGALORE-560076"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BASAVANAGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #2, B.P WADIA ROAD, PANDU TOWERS, TAGORE CIRCLE, BASAVANAGUDI, BANGALORE-560004"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ELECTRONIC CITY INTERNATIONAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL LAKSHMINARAYANAPURA, BEHIND APMC FRUIT MARKET, NEAR HUSKURGATE, ELECTRONIC CITY, ANEKAL TALUK, KARNATAKA - 560099"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HEBBAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NO: 49\/4, KASABA HOBLI, VEERANNA PALYA MAIN ROAD,NAGAWARA VILLAGE,HEBBAL, ARABIC COLLEGE POST, BANGALORE 560045"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HSR LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL #55\/2, 19TH MAIN, 27TH CROSS, SECTOR 2, HSR LAYOUT, BANGALORE.PIN :560102"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "JP NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8TH PHASE,JAMBU SAVARI DINNE, JP NAGAR,BENGALURU "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KAGGADASAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 121\/4,VEMANNA ROAD,5TH MAIN, 7TH CROSS,MALLESHPALAYA, KAGGADASAPURA,BANGALORE -560075"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KANAKAPURA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 11, NEAR MANTRI TRANQUIL, GUBBALALA VILLAGE, KANAKAPURA ROAD, BANGALORE 560062"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KR PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAMMANNA GARDEN, DEVASANDRA MAIN ROAD, BEHIND&nbsp;KAVERI&nbsp; BAKERY, K.R.PURAM, BANGLORE-560036"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, #429, PRABHU LAYOUT, AECS LAYOUT, KUDLU, BANGALORE 560068"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUDLU2 #165,KUDLU VILLAGE,NEAR PARAPPANA AGRAHARA,MADIWALA (P),BENGULURU-560068."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "M S PALYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13\/1, NEAR AMBHABHAVANI TEMPLE, DODDABETTAHALLI, VIDYARANYAPURA POST MSPALYA - BANGALORE - 560097"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MAHALAKSHMI LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 227, 15TH C CROSS ROAD, 2ND PHASE, BOVIPALYA, NAGAPURA, MAHALAKSHMI LAYOUT,BENGALURU, 560086"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #86\/1C,NEAR S.G.R DENTAL COLLEGE,MUNNEKOLALA,MARATHAHALLI-1"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 93\/10, 93\/11, 93\/2A3, 93\/2A4, MUNNEKOLALA VILLAGE, BESIDE SHANMUKHA RESTAURANT, NEAR MARATHAHALLI BRIDGE, MARATHAHALLI, BANGALORE-560037"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "NAGARBHAVI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 42\/65, OPP BANGALORE UNIVERSITY STAFF QUARTERS, JNANAGANGA NAGAR, MYSORE-MAGADI RING ROAD, NAGARBHAVI,BANGALORE 560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "PEENYA DASARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYNO,65\/1,65\/2,NAGASANDRA VILAGE,YESHWANTHPUR HOBLI,BANGALORE 560073"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAJAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #21,(A-108)22, 5TH MAIN ROAD, TNDUSTRIAL AREA, 6TH BLOCK, RAJAJINAGAR, BANGALORE:-560010"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SEETHAPPA GARDEN, RAGHAVENDRA CIRCLE, T C PALAYA MAIN ROAD, RAMAMURTHY NAGAR, BANGALORE - 560016"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO. 131\/2, OPP. STATE BANK OF MYSORE, 1ST MAIN, 5 E CROSS, POOJA GARDEN, ASHIRWAD COLONY, HORAMAVU, BENGALURU 560043"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR HARIVILLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.91\/1,HOYSALA NAGAR, 8TH MAIN,5TH A CROSS,T C PALYA MAIN ROAD,RAMMURTHYNAGAR, BENGALURU 560016 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "SESHADRIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:79,SRINIVASA COMPLEX, 1ST MAIN ROAD, NEAR FORTIS HOSPITAL, SESHADRIPURAM, BENGALURU, KARNATAKA 560020"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ULLAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 161\/4,ULLAL VILLAGE,ULLAL,YESWANTHPUR HOBLI,BENGALURU-560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "UTTARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27, AREHALLI, AGS LAYOUT, ITTAMADU MAIN ROAD, UTTARAHALLI, BANGALORE-560061"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "VIDYARANYAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#21\/3, RAMCHANDRAPURA, VIDYARANYAPURA,JALAHALLI POST ,BANGALORE 560013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "WHITEFIELD",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#190, ANS SQUARE, NEXT TO SATHYA SAI COMPLEX, ITPL MAIN ROAD, NEAR HOODI CIRCLE, HOODI, WHITEFIELD, BENGALURU 560048"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YELLAHANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 30\/2A, THIRUMALA NAGAR, ATTUR LAYOUT, NEAR THIRUMALA DABA, YELAHANKA, BANGALORE"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YESHWANTHPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #22\/2, HMR COMPUND, 6TH CROSS, 1ST MAIN, YESHWANTHPUR, BENGALURU-560022"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Jayanagar Knowledge Hub",
     "CenterAddress": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
     "CenterAddress": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068."
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
     "CenterAddress": "PID no 21\/97\/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Davanagere",
     "Center": "DAVANAGERE",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE DCM RAILWAY BRIDGE, P B ROAD, DAVANAGERE,BENGALORE 577003 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Mangalore",
     "Center": "MANGALORE",
     "CenterAddress": "SRI CHAITANYA TENCHO SCHOOL BANGRA KULOOR ROAD , KOTTARA CHOWKI ,MANGALORE 576013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KYATHSANDRA FLYOVER, NH-4, KYATHSANDRA, TUMKUR 572104"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TUDA OFFICE ADARSHANAGAR, SRI SAI BABA TEMPAL ROAD, TUMKUR 572103"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI SAI BABA TEMPLE, OPP TUDA OFFICE, ADHARSHA NAGAR,TUMKUR,KARNATAKA "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANASWADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 84\/1, GARDEN HOUSE, 5TH MAIN, OMBR LAYOUT, BANASWADI, BANGALORE-560033"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BANNERGHATTA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL 75\/A, BANNERGHATTA ROAD, HULIMAVU, BANGALORE-560076"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "BASAVANAGUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #2, B.P WADIA ROAD, PANDU TOWERS, TAGORE CIRCLE, BASAVANAGUDI, BANGALORE-560004"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ELECTRONIC CITY INTERNATIONAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL LAKSHMINARAYANAPURA, BEHIND APMC FRUIT MARKET, NEAR HUSKURGATE, ELECTRONIC CITY, ANEKAL TALUK, KARNATAKA - 560099"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HEBBAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NO: 49\/4, KASABA HOBLI, VEERANNA PALYA MAIN ROAD,NAGAWARA VILLAGE,HEBBAL, ARABIC COLLEGE POST, BANGALORE 560045"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "HSR LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL #55\/2, 19TH MAIN, 27TH CROSS, SECTOR 2, HSR LAYOUT, BANGALORE.PIN :560102"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "JP NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8TH PHASE,JAMBU SAVARI DINNE, JP NAGAR,BENGALURU "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KAGGADASAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 121\/4,VEMANNA ROAD,5TH MAIN, 7TH CROSS,MALLESHPALAYA, KAGGADASAPURA,BANGALORE -560075"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KANAKAPURA ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 11, NEAR MANTRI TRANQUIL, GUBBALALA VILLAGE, KANAKAPURA ROAD, BANGALORE 560062"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KR PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAMMANNA GARDEN, DEVASANDRA MAIN ROAD, BEHIND&nbsp;KAVERI&nbsp; BAKERY, K.R.PURAM, BANGLORE-560036"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, #429, PRABHU LAYOUT, AECS LAYOUT, KUDLU, BANGALORE 560068"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "KUDLU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KUDLU2 #165,KUDLU VILLAGE,NEAR PARAPPANA AGRAHARA,MADIWALA (P),BENGULURU-560068."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "M S PALYA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13\/1, NEAR AMBHABHAVANI TEMPLE, DODDABETTAHALLI, VIDYARANYAPURA POST MSPALYA - BANGALORE - 560097"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MAHALAKSHMI LAYOUT",
     "CenterAddress": "SRI CHAITANYA SCHOOL 227, 15TH C CROSS ROAD, 2ND PHASE, BOVIPALYA, NAGAPURA, MAHALAKSHMI LAYOUT,BENGALURU, 560086"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL #86\/1C,NEAR S.G.R DENTAL COLLEGE,MUNNEKOLALA,MARATHAHALLI-1"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "MARTHAHALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 93\/10, 93\/11, 93\/2A3, 93\/2A4, MUNNEKOLALA VILLAGE, BESIDE SHANMUKHA RESTAURANT, NEAR MARATHAHALLI BRIDGE, MARATHAHALLI, BANGALORE-560037"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "NAGARBHAVI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 42\/65, OPP BANGALORE UNIVERSITY STAFF QUARTERS, JNANAGANGA NAGAR, MYSORE-MAGADI RING ROAD, NAGARBHAVI,BANGALORE 560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "PEENYA DASARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYNO,65\/1,65\/2,NAGASANDRA VILAGE,YESHWANTHPUR HOBLI,BANGALORE 560073"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAJAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #21,(A-108)22, 5TH MAIN ROAD, TNDUSTRIAL AREA, 6TH BLOCK, RAJAJINAGAR, BANGALORE:-560010"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SEETHAPPA GARDEN, RAGHAVENDRA CIRCLE, T C PALAYA MAIN ROAD, RAMAMURTHY NAGAR, BANGALORE - 560016"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO. 131\/2, OPP. STATE BANK OF MYSORE, 1ST MAIN, 5 E CROSS, POOJA GARDEN, ASHIRWAD COLONY, HORAMAVU, BENGALURU 560043"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "RAM MURTHY NAGAR HARIVILLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO.91\/1,HOYSALA NAGAR, 8TH MAIN,5TH A CROSS,T C PALYA MAIN ROAD,RAMMURTHYNAGAR, BENGALURU 560016 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "SESHADRIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:79,SRINIVASA COMPLEX, 1ST MAIN ROAD, NEAR FORTIS HOSPITAL, SESHADRIPURAM, BENGALURU, KARNATAKA 560020"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "ULLAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 161\/4,ULLAL VILLAGE,ULLAL,YESWANTHPUR HOBLI,BENGALURU-560056"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "UTTARAHALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27, AREHALLI, AGS LAYOUT, ITTAMADU MAIN ROAD, UTTARAHALLI, BANGALORE-560061"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "VIDYARANYAPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#21\/3, RAMCHANDRAPURA, VIDYARANYAPURA,JALAHALLI POST ,BANGALORE 560013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "WHITEFIELD",
     "CenterAddress": "SRI CHAITANYA SCHOOL,#190, ANS SQUARE, NEXT TO SATHYA SAI COMPLEX, ITPL MAIN ROAD, NEAR HOODI CIRCLE, HOODI, WHITEFIELD, BENGALURU 560048"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YELLAHANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 30\/2A, THIRUMALA NAGAR, ATTUR LAYOUT, NEAR THIRUMALA DABA, YELAHANKA, BANGALORE"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "YESHWANTHPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #22\/2, HMR COMPUND, 6TH CROSS, 1ST MAIN, YESHWANTHPUR, BENGALURU-560022"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Jayanagar Knowledge Hub",
     "CenterAddress": "No.123, 24th Main, 30th Cross, 4th Block, Jayanagar, Bangalore - 560011, Karnataka,"
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Kalyan Nagar Knowledge Hub",
     "CenterAddress": "Next to Organic Mandya Farmers Market, 80 feet Road, HRBR Layout, Kalyan Nagar, Bangalore - 560043, Contact :-+91 72079 14068."
    },
    {
     "State": "Karnataka",
     "District": "Bengaluru",
     "City": "Bengaluru",
     "Center": "Sri Chaitanya Basaveshwara Nagar Knowledge Hub",
     "CenterAddress": "PID no 21\/97\/2, 80 feet Road, KHB 2nd Stage, Basaveshwara Nagar (Near Pavitra Paradise), Bangalore - 560079, Contact :-+91 72079 14069."
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Davanagere",
     "Center": "DAVANAGERE",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE DCM RAILWAY BRIDGE, P B ROAD, DAVANAGERE,BENGALORE 577003 "
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Mangalore",
     "Center": "MANGALORE",
     "CenterAddress": "SRI CHAITANYA TENCHO SCHOOL BANGRA KULOOR ROAD , KOTTARA CHOWKI ,MANGALORE 576013"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KYATHSANDRA FLYOVER, NH-4, KYATHSANDRA, TUMKUR 572104"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. TUDA OFFICE ADARSHANAGAR, SRI SAI BABA TEMPAL ROAD, TUMKUR 572103"
    },
    {
     "State": "KARNATAKA",
     "District": "Bengaluru",
     "City": "Tumkur",
     "Center": "TUMKUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI SAI BABA TEMPLE, OPP TUDA OFFICE, ADHARSHA NAGAR,TUMKUR,KARNATAKA "
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Andheri Sri Chaitanya Centre",
     "CenterAddress": "Sri Chaitanya, 301,B wing. Business point. Paliram road. Andheri west. Near by BMC office Mumbai 400058"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Borivali Sri Chaitanya Centre",
     "CenterAddress": "Brio e-Tech Jr. College &amp; V K Krishna Menon Academy, Plot no. 462, New MHB Colony, Off Gorai Road, Borivali West, Mumbai -400091"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Thane Sri Chaitanya Centre",
     "CenterAddress": "M. H. High School and Junior College, Shivaji Path near Thane station &amp; Talaopali Thane (W)"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Mumbai",
     "City": "Ulhasnagar",
     "Center": "ULHASNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYAN-MURBAD ROAD,NEAR RIVER WIND RESORT,OPPOSITE TO HP PETROL BUNK, KAMBA, KALYAN, ULHASNAGAR – 421103."
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Andheri Sri Chaitanya Centre",
     "CenterAddress": "Sri Chaitanya, 301,B wing. Business point. Paliram road. Andheri west. Near by BMC office Mumbai 400058"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Borivali Sri Chaitanya Centre",
     "CenterAddress": "Brio e-Tech Jr. College &amp; V K Krishna Menon Academy, Plot no. 462, New MHB Colony, Off Gorai Road, Borivali West, Mumbai -400091"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Mumbai",
     "Center": "Thane Sri Chaitanya Centre",
     "CenterAddress": "M. H. High School and Junior College, Shivaji Path near Thane station &amp; Talaopali Thane (W)"
    },
    {
     "State": "MAHARASHTRA",
     "District": "Mumbai",
     "City": "Ulhasnagar",
     "Center": "ULHASNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYAN-MURBAD ROAD,NEAR RIVER WIND RESORT,OPPOSITE TO HP PETROL BUNK, KAMBA, KALYAN, ULHASNAGAR – 421103."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KRISHNAVENI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR RTC BUSTAND,BESIDE DWARAKA PETROL BUNK,KHAJA NAGAR,ANANTAPUR "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 8-74A, BESIDE HEAD POST OFFICE, NEAR ANDHRA BANK, ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR PAVAN GAS AGENCY, RTO OFFICE ROAD, HOUSING BOARD, ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,OPP.TATA SHOWROOM,KAKKALAPALLI,RUDRAMPETA BY PASS,ANANTHAPUR 515672"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KAMMA BHAVAN, OLD NIRMALA NURSING COLLEGE LAKSHMI SRINIVASA NAGAR ANANTAPUR-515004, "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OLD DPS SCHOOL ,OPPOSITE TATA SHOWROOM,HYDERABAD HIGH WAY PAMURAI VILLAGE ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SAKSHI OFFICE,OPP: TATA MOTORS,RUDRAMPETA BY-PASS,ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEW REVENUE OFFICE BACKSIDE,RUDRAMPETA,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL, SURVEY NO.:149\/4, WARD NO.: 13, SHIRDI NAGAR, NEAR RTC BUS STAND,OPP. ANAND HOSPITAL ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.315-1B,WARD NO.28,L.P.NO.518\/85, SINGARAYANI COLONY,NEW REVENUE COLONY, ANANTAPURAMU 515001."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 10\/413,ADIMURTHY NAGAR,OPPOSITE DEVI NURSING HOME,NEAR SRI CHAITANYA JR COLLEGE ,ANANTHAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "GORANTLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/277 OPPSITE MARKET YARD KADIRI - HINDUPUR MAIN ROAD,BESIDE SPVM DEGREE COLLEGE GORANTLA (M&amp;V) ANANTAPUR DIST A.P - 515231"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KALYANADURG",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO:-359\/1A, OPP GOVT HOSPITAL BELLARY ROAD, KALYANADURG, ANANTAPUR (DT) 515761"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:17\/1111, RAJENDRA NAGAR,NEAR VENKATESWARA SWAMY TEMPLE, POST OFFICE LINE, GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 4\/369, DMM GATE ROAD,NEAR PANDURANGA SWAMY TEMPLE,P&amp;T COLONY,GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. MAHENDRA FUNCTION HALL,TILAK NAGAR, GUNTAKAL515801"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 12-1-76\/G2, PALANI NAGAR, BESIDE RAJADHANI FUNCTION HALL, HINDUPUR,ANANTHAPUR - 515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 26, SATYANARAYANA PETA MF ROAD, HINDUPUR, ANANTHAPUR-515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kadiri",
     "Center": "KADIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO : 13\/13\/1\/C ,MADANAPALLI ROAD,OPPO.CHOWDESWARI TEMPLE,KADIRI,SATYA SAI DIST 515591"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kothacheruvu",
     "Center": "KOTHACHERUVU",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 7\/196, PENUGONDA ROAD KOTHACHERUVU ANANTAPUR 515133"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Tadipatri",
     "Center": "TADIPATRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NETHAJI SCHOOL COMPOUND, BEHIND RICE MILL, KALAVAKATTA STREET, TADIPATRI, ANANTAPUR 515411 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Bangarupalyam",
     "Center": "BANGARUPALYAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL THAGGUVARIPALLI, BANGARUPALYAM,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chandragiri",
     "Center": "CHANDRAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VIJAY NAGAR COLONY,CANARA BANK ROAD,CHANDRAGIRI 517101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOR CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-10-199, TMR TOWER , GANDHI ROAD,OPPT LIC OFFICE, CHITTOOR,517001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.THAPOVANAM SCHOOL,TEACHERS COLONY,GREAMSPET,VELLORE ROAD,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27-515\/B,TELEPHONE COLONY ROAD,RAMNAGAR COLONY,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 28-1428, RAM NAGAR COLONY,CHITTOR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "MURUGANI PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO.22-978\/BB, KAMESHWAR NAGAR, MURUGANIPALLI, CHITTOOR,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalle",
     "Center": "SRI GANGA SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 3\/153-4-4-1, HOSPITAL BRANCH , BESIDE RTC BUS STAND,MADHANAPALLI-517325,ANNAMAIAH (D)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MALLIKARJUNA CIRCLE, COLLEGE ROAD, MADANAPALLI,CHITTOOR 517325 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.NO. III-145-6-12-4, PRASANTH NAGAR, BESIDE. SRI SIDDHARTHA JR. COLLEGE, MADANAPALLI,TIRUPATHI - 517325"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Palamaneru",
     "Center": "PALAMANERU",
     "CenterAddress": "SRI CHAITANYA SCHOOL GUDIYATHAM ROAD,SRI NAGAR COLONY,NEAR YSRCP PARTY OFFICE,PALAMANERU,TIRUPATHI 517408"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Piler",
     "Center": "PILER",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-421, LAKSHMI PURAM,PILER, CHITTOOR (DIST),TIRUPATHI 517214."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Punganur",
     "Center": "PUNGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MPDO OFFICE, R.R KALYANA MANDAPAM,MBT ROAD,PUNGANUR-517247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #12\/64\/1A,SWAMY STREET,PUTTUR,517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARAMESWARA MANGALAM,K.PALEM,PUTTUR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYANAPURAM,OPP.FIRE STATION, SWAMI STREET KN ROAD,PUTTUR 517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Renigunta",
     "Center": "RENIGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL VINAYAKA NAGAR, RENIGUNTA, TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-1-1988,JAYRAM RAO STREET,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 16\/550\/3,SRI RAM NAGAR COLONY,PANAGAL ROAD,OPP: SBI (ADB) BRANCH,SRIKALAHASTI. AP 517640"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI LAKSHMI KAMAKSHI KALYANA MANDAPAM, OPP DARMARAJ TEMPLE,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "ANJANADRI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 2-16,TELECOM COLONY OTERU ROAD ,SRINIVASAPURAM ,TIRUPATHI-517503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "CURE CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:6-2-83, KT ROAD,NEAR AXIS BANK MAIN BRANCH TIRUPATI - 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN CAMPUS DAYS ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  DO; NO 25, GANDHI ROAD   MUNICIPAL COMPLEX  PIN NO; 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN II CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 37 AGK BUILDING  GANDHI ROAD  TIRUPATHI PIN: 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  RC ROAD  EBSR COMPLEX NEAR  ANNAMAYYA CIRCLE TIRUPATI PIN CODE 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VEDAVYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DR NO:411\/2P    150 BY PASS ROAD, TIRUCHANOOR (V)  TIRUPATHI ( R)517503        "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VENKATADRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 8-171-1, NEW BALAJI COLONY, MR PALLI, TIRUPATHI PIN-517502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "AIR BY-PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL JAYA LAKSHMI COLONY, STV NAGAR, AIR BY PASS ROAD, NEAR PASSPORT OFFICE, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TARAKARAMA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP:A.G.STAFF QUARTERS,TARAKARAMANAGAR,PERUR,TIRUPATI(RURAL)571505"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "GS MADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 15-2-126\/A2 , BESIDE LAKSHMI NARAYANA SWAMY TEMPLE GSMADA STREET TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "KORALAGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 20-2--478\/A2,MARUTHINAGAR,KORLAGUNTA,TIRUPATI-517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MR PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT:26 NEW MARUTHI NAGAR, AIR BY PASS ROAD,MR PALLI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "SRINIVASAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL TELECOM COLONY, SRINIVASAPURAM, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUMALA BY PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:18-1-7\/10, BESIDE PAI VICROY HOTEL, RAMA CHANDRA NAGAR, TIRUMALA BY PASS,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI GIRLS RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL #10-128\/6-9 NETHAJI NAGAR P G N TOWER TIRUCHANUR TIRUPATI PIN:517507"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI IPL",
     "CenterAddress": "SRI CHAITANYA SCHOOL IPL BRANCH,BAIRAGIPATTEDA, NEAR RIMS,TIRUPATHI 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TSN PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR. NO. 20-3-131\/1A, SIVA JYOTHI NAGAR, SATHYANARAYANAPURAM, OPPOSITE SRIVARI SANNIDHI, BACK SIDE STREET SBI EXECUTIVE GUEST HOUSE, TIRUPATHI, CHITTOOR DISTRICT, AP 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VIKAS CAMPUS",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANA PALLY ROAD, THIRUCHNOR, THIRUPATHI "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Venkatagirikota",
     "Center": "V KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHOWDEPALLE ROAD, VKOTA,TIRUPATHI 517424"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "SRI SHIRDI SAI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SHIRDI SAI CAMPUS #1-5-58\/2A ONGC BYPASS ROAD, SAVARAM AMALAPURAM- 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MSN COMPLEX, MAIN ROAD, AMALAPURAM, EAST GODAVARI DIST, 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :I 1-72 ,BACKSIDE OF VL HEIGHTS,ABBIREDDY CANAL BRIDGE,KONKAPALLI,AMALAPURAM,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Anaparthi",
     "Center": "ANAPARTHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 13-37, CANAL ROAD,AYYAPPA TEMPLE ,KOTHURU TURNING,ANAPARTHI,ANAPARTHI (MD), RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimadole",
     "Center": "BHIMADOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:10-116,OPP. FIRE STATION,ELURU, RAJAHMUNDRY ROAD,BHIMADOLE,WEST GODAVARI 534425"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL,PLOT NO:6-126,SRI RAMA KUSUMA PLAZA,NEAR NATARAJ THEATER,CHINNAMIRAM,JP ROAD, PALAKODERU (M), W.G(DT)534210"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE DUPLEX COLONY CHINNAMIRAM,BHIMAVARAM,RAJAHMUNDRY 534204"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Chintalapudi",
     "Center": "CHINTALAPUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL ABOVE UNION BANK,SRINIDI COMPLEX,ELURU ROAD,CHINTALAPUDI,RAJAHMUNDRY 534460"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Devarapalli",
     "Center": "DEVARAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP:VEGETABLE MARKET, ELURU ROAD, DEVARAPALLI RAJAHMUNDRY 534313"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "SCHOOL - ELURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHALAPATHI TOWERS,4TH LINE ,SANTHI NAGAR ,ELURU,PIN CODE:534007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARVATHA VARDHINI COMPLEX , NEAR MAHATHMA GANDHI STATUE, VIDYANAGAR , ELURU. W.G.(DT) 534003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 7-179\/2,NEAR GANGANAMMA TEMPLE,BALAJI NAGAR, CHATAPARRU ROAD, ELURU-534001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ganapavaram",
     "Center": "GANAPAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NIDAMARRU MANDEL,BHAVIPALEM POST, GANAPAVARAM,RAJAHMUNDRY 534198"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Hanuman Junction",
     "Center": "HANUMAN JUNCTION",
     "CenterAddress": "SRI CHAITANYA SCHOOL KEPINIDI TOWERS, NUZVID ROAD,NEAR FLYOVER, HANUMANJUNCTION WEST GODAVARI 521105"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jaggampeta",
     "Center": "JAGGAMPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRISHNAVENI THEATOR , BALAJI CENTER , JAGGAMPETA, EAST GODAVARI 533435"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jangareddygudem",
     "Center": "JANGAREDDYGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :16-1-120, BESIDE M.R.OOFFICE,MANDAVALLI ESTATE, ASWARAOPETA ROAD, JANGAREDDYGUDEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kaikalur",
     "Center": "KAIKALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: FCI GODOWNS, BESIDE RELIANCE PETROL, ATAPAKA, KAIKALUR-521333"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "RAMAN BHAVAN 1 SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOWDHAM, #3-16A-101, LAKSHMINARAYANA NAGAR,KAKINADA -533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL #3-16B-4, OLD RTO OFFICE ROAD, NEAR MOTHER TERESA STATUE,SANTHI NAGAR, KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPOSITE BMC CHURCH SANTHI NAGAR KAKINADA - 533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.9-16,SRINIVASA COLONY, RAMANAYYAPETA, KAKINADA RURAL-533005, EAST GODAVARI DISTRICT, ANDHRA PRADESH"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO1-1111, JANA CHAITANYA LAYOUT NEAR JEWEL MEDOWS,SARPAVARAM,KAKINADA RURAL 533005"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-5-43\/1,NAGESWARARAO STREET,RAMARAO PETA,KAKINADA-533003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kovvur",
     "Center": "KOVVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP PMMM GOVT HIGH SCHOOL,BESIDE YUVRAJ FUNCTION HALL, NANDAMURU ROAD, KOVVUR, WEST GODAVARI 534350"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Mandapet",
     "Center": "MANDAPETA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAIN ROAD ,NEAR HP BUNK ,TAPESWARAM,MANDAPETA,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Nagaram",
     "Center": "NAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD HAVENS CAMPUS, MAIN ROAD, NAGARAM 533247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Narsapur",
     "Center": "NARSAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KARTHIKEYA NAGAR,21ST WARD,PEECHUPALEM ROAD,NARSAPURAM ,WEST GODAVARI (DT),A.P 534275"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL BRODIPET 2ND STREET, BYPASS ROAD, RAJUGARI BUILDING, PALAKOL, W.G.DT 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR AXIS BANK ,OPP.AMBEDKAR STATUE POOLAPALLI , PALAKOL , WEST GDHAVARI DIST"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Payakaraopeta",
     "Center": "PAYAKARAOPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL Y JUNCTION,NEAR GOVT HOSPITAL,PAYAKARAOPETA,KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Penugonda",
     "Center": "PENUGONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:31-112, OPPOSITE PALACE THEATER, SIDDHANTHAM ROAD, PENUGONDA, AP 534320"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Pitapuram",
     "Center": "PITAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PADA GAYA TEMPLE, BYPASS ROAD, PITHAPURAM,RAJAJMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARASWATHI SOUDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 85-6-15\/1,ROUTHU PLAZA, VL PURAM,RAJAMAHENDRAVARAM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARVANI TOWERS",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, D.NO:75-1-4,PRAKASH NAGAR, RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 14-137\/A,OPP RTC COMPLEX,BEHIND UNION BANK, RAJAMAHENDRAVARAM - 533 103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SRI VYBHAVI",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:78-10-7,SYAMALA NAGAR , BESIDE GOVINDURAJULU HOSPITAL,RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "KOVVURU",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:4-177,VEMULURU ROAD,KOVVURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL H. NO : 89-17 21\/1,MORAMPUDI ROAD, MORAMPUDI - KESAVARAM ROAD, SRI SAI CHAITANYA NAGAR, RAJAHMUNDRY, ANDHRA PRADESH 533107"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO11-11-1,OPPOSITE FIRE STATION,ARYAPURAM,RAJAHMUNDRY,EAST GODAVARI (DT) 533103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO-74-6-54, NEAR T T D KALYANA MANDAPAM,OPP SWATANTRA KUMAR CHURCH,PRAKESH NAGAR,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:17-12\/8\/1,KRISHNA NAGAR,SEETAM PETA,NEAR SATYAM GARI RICE SHOP,RAJAHMUNDRY,EAST GODAVARI (DT)533104"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:4-699\/1, BESIDE BEEJAPURI TOWNSHIP, SRIRAMPURAM ROAD, DIWANCHERUVU, RAJANAGARAM MANDAM, EAST GODAVARI, ANDHRAPRADESH - 533296"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "THE PARK INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:89-17-1\/21 CHAITANYA NAGAR, MORAMPUDI ROAD ,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajole",
     "Center": "RAJOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL(PS) EM SCHOOL,OPP. ANNAPURNA THEATER, MOGALIKUDURU,RAJOLE,RAJAHUMUNDRY 533249"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ramachandrapuram",
     "Center": "RAMACHANDRAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:5-282\/1,SRI CHAITANYA SCHOOL-RAMACHANDRAPURAM, SRINAGAR, OPPOSITE VSM ENGINEERING COLLEGE RAMACHANDRAPURAM,PASALAPUDI BRANCH, ANDHRAPRADESH - 533255"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ravulapalem",
     "Center": "RAVULAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR ANKALAMMA TEMPLE,UBALANKA ROAD,RAVULAPALEM ,EAST GODAVARI DIST 533238"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Razole",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #9-60\/1,OPP.RTC COMPLEX, RAZOLE-533242"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Sakhinetipalli",
     "Center": "SAKHINETIPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, ANTARVEDI PALEM, BESIDE INDIAN OIL PETROL BUNK,SAKHINETIPALLI MANDAL,E G DIST-533252"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO.CWC GUDEM,NALLAGERLA ROAD,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM CBSE",
     "CenterAddress": "SRI CHAITANYA OLYMPIAD SCHOOL,VASAVI IDEAL PUBLIC SCHOOL BUILDING,CHINNATADEPALLI,KADIYADDA POST,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU",
     "CenterAddress": "SRI CHAITANYA SCHOOL,IKEA NAGAR,NH-16,TANUKU,WG.DIST,534211"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PETROL BUNK,VISHNU PRIYANAGAR ,TANUKU VELPURU 534222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #3-41-8\/4, SRIRAM NAGAR, MR PETA, TUNI- 533401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL DURGADAS STREET,OPPOSITE SURESH KUMAR HOSPITAL, KOTHA PETA, TUNI, RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:3-41-8\/4, SAI NAGAR, MR PETA,TUNI,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "SUNKARAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUEU,KV NAGAR, YANAM, 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "YANAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUE, DRAKSHARAMA ROAD, VIA YANAM, SUNKARAPALEM 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yeleswaram",
     "Center": "YELESWARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 3-377\/1, NEAR RAJULA BABU TEMPLE, LINGAMPATHY ROAD,YELESWARAM ,RAJAHMUNDRY,AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Amaravathi",
     "Center": "AMARAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEAR MUSEUM ROAD,AMARAVATHI ,GUNTUR 522020 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "SARASWATHI SOUDHAM BAPATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.94\/1, VIJAYALAKSHMI PURAM, BAPATLA - 522101."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 8-3-8, OPP OLD MAA CABLE, OFFICE, BHIMAVARIPALEM, BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO -4-10-139\/1SRINIVAS NAGAR COLONY,BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripet",
     "Center": "SIDDHARTHA CAMPUS CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.25-367 &amp; 25-367\/1, NEAR R.V.S. HIGH SCHOOL, CHILAKALURIPET - 522616."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GUNDABOLU RAMACHANDRA HOSPITAL, SUBBAIAH THOTA, CHILAKALURIPET GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD DRN SCVS JR.COLLEGE BUILDING,NSP OFFICE, NARSARAOPET ROAD, CHILAKALURIPET,GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chirala",
     "Center": "CHIRALA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NALLA PANENI TOWERS, OPP MARGADHARSI CHIT FUNDS PVT.LTD,MUNTHAVARICENTER,CHIRALA 523165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Dachepalli",
     "Center": "DACHEPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRANTHI NURSING HOME,NARAYANAPURAM,DACHEPALLI(MD)GUNTUR(DT)-522414"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "CHAITANYA LAKSHMI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.22-4-47, TITANIC SHOW ROOM UPSTAIRS, NEAR OLD BUS STAND, LALAPET, GUNTUR - 522003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "ICON CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.5-89-9, 3RD LINE, LAKSHMIPURAM, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "AVANTHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.589-11\/5, 1ST LINE, CHANDRAMOULI NAGAR, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR NAYAR HOTEL CENTER, OPP. CENTRO, LAKSHMIPURAM MAIN ROAD, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR PRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NAYAR HOTEL CENTER, LAKSHMIPURAM MAIN ROAD, BESIDE WOODLAND, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHATMA GANDHI 80FEET INNER RING ROAD, REDDYPALEM, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "INTERNATIONAL SCHOOL WHITEHOUSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NAVABHARAT NAGAR, 4TH LANE,MAHA LAKSHMI TOWERS OPP. CHALAPATHI GROUNDS GUNTUR 522006"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "NEHRU NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL BUCHAITHOTA 1ST LINE,OPP VIJAYAWADA RAILWAY TRACK, NEHRU NAGAR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "REDDYPALEM DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD REDYYPALEM ,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "SYAMALA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYAMALA NAGAR, ZERO LINE,NEAR ARMY CANTEEN,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Macherla",
     "Center": "MACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13TH WARD, R&amp;B BUNGLOW BACK SIDE, NEAR PALAMARA ,MACHERLA GUNTUR (D.T) 522426"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Mangalagiri",
     "Center": "COLLEGE - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  D.NO.7-426 &amp; 7-426\/A, TIPPARLA BAZAR, MANGALAGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Nagaralu",
     "Center": "NAGARALU",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,TELECOME NAGAR 2ND LINE,AMARAVATHI ROAD, NEAR TAGORE RICE MILL,NAGARALU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARASARAOPET RAMANUJAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.11-23-1, RAMIREDDY PET, NARASARAOPET - 522601."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:11-14-1\/1,RAMIREDDYPET,BANK COLONY,NARASARAOPET,GUNTUR."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA CENTER ,SATTENAPALLI ROAD, OPP MAHALAKSHMAMMA CHETTU,NARSARAOPET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 60 FEET ROAD , PRAKASH NAGAR NARASAOPET,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "GAUTAMA BUDDHA BHAVAN PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.416\/B, KOTAIAH SASTRY BAZAR, PIDUGURALLA - 522413."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 7-703\/A ABBUBAKAR MUSEED STREET OPP AXIS BANK PIDUGURALLA,GUNTUR - 522413"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Ponnur",
     "Center": "PONNUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GBC ROAD, PONNUR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Repalle",
     "Center": "PARAMESWARA SADAN REPALLE",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.9-35-210 &amp; 9-35-210\/1, UPPUDI ROAD, REPALLE - 522265."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHINA MAJID CENTER,SBI ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 5-8-8, NAGARJUNA NAGAR,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARK ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "VYAS BHAVAN TENALI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.2-1-74, GANDHI NAGAR, RATNA TALKIES CENTRE, TENALI - 522201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANGANAMMA PET, TENALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR-NO-21-1-60\/1, DEVI CHOWK, RAMALINGESWARAPET,TENALI,GUNTUR-522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR UMESH CHANDRA STATUE,CHENCHUPET,TENALI,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP: GOVERNMENT VETERINERY HOSPITAL ,BURRIPALEM ROAD,TENALI 522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Vinukonda",
     "Center": "VINUKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE CURRENT OFFICE, KARAMPUDI ROAD, VINUKONDA GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Badwel",
     "Center": "BADWEL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDLA STREET,PORUMAMILLA ROAD,BADWEL,KADAPA 516227"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI BALAJI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DONO:1-399 MARUTHI NAGAR, BESIDE KADAPA CAFÉ, KOTIREDDY CIRCLE KADAPA-516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI SAI SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:42\/609-28, NGOS COLONY, APASARA CIRCLE , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,KEERTHI PARK VIEW,OPP RAJIV PARK,MARUTHI NAGAR,KADAPA 516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMBHA BHAVANI TEMPLE,NEAR BUILTUP, KADAPA."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NEHRU PARK,CO-OPRATIVE COLONY,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL ARP COLONY, PRAKASH NAGAR , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL 101\/257-2 RIMS BYPASS ROAD KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUGGA VANKA PROJECT ROAD,NEAR SWAMY NAGAR,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL #97\/217-8,NEAR RTO OFFICE,YSR CIRCLE,C.K.DINNE,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:CHINNACHOWK POLICE STATION,NEHRUNAGAR,KADAPA 516002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAYACHOTI RING ROAD,VUTKUR CIRCLE,KADAPA 516003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Porumamilla",
     "Center": "PORUMAMILLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DESAI MAHAL BACK SIDE,NEAR APSRTC BUSSTAND,PORUMAMILLA(V)KADAPA(DT)AP-516193"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ARAVINDA ASHRAMAM, YMR COLONY , PRODDUTUR, Y.S.R KADAPA(DIST) 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL YERRAGUNTLA BY PASS ROAD, NEAR CINE HUB,PRODDATUR,KADAPA 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL BACKSIDE HONDA SHOWROOM,KVR COLONY,MYDUKUR ROAD,PRODDUTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BOLLAVARAM NEAR GOLDEN PARK JAMMALAMADUGU BYPASS ROAD PRODDATUR, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Pulivendula ",
     "Center": "PULIVENDULA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT 70, BESIDE RTO OFFICE, MUDDANURU ROAD ,PULIVENDULA,KADAPA 516390"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHUVANAGIRI PALLI,RAJAMPET,KADAPA 516115"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL R.S.ROAD, RAJAMPET, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO COLONY,KOTHAPETA,RAYACHOTI,KADAPA 516269"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 430 BESIDE PREETHAM RESIDENCY,RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 5\/283,NEAR BY ICDS OFFICE, BESIDE VINAYAKA TEMPLE, SUNDEPALLI ROAD, RAJULA COLONY RAYACHOTI 516269 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA REDDY NAGAR,MADANAPALLI ROAD RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Avaniggadda",
     "Center": "AVANIGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5TH WARD, NEAR SANTHA MARKET AVANIGADDA,VIJYAWADA KRISHNA (DT)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Challapalli",
     "Center": "CHALLAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CLUB ROAD, RAMANAGARAM(VILLAGE),CHALLAPALLI(MANDAL), KRISHNA (DIST),521126."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gannavaram",
     "Center": "GANNAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GNT ROAD ,KOTHAPETA,GANNAVARAM,VIJAYAWADA 521101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "COLLEGE - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 8\/191, SRI RAM PURAM COLONY, OLD CURRENT OFFICE, BESIDE FISH MARKET ROAD, SATYANARAYANA PURAM, GUDIVADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "SCHOOL - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:10\/153, RAJENDRA NAGAR 1ST LINE, GUDIVADA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Ibrahimpatnam",
     "Center": "IBRAHIMPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR STATE BANK OF INDIA,OPP-MANDALAM OFFICE ,V.T.P.S ROAD,IBRAHIMPATNAM,KRISHNA (DT)521456"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Jaggaiahpet",
     "Center": "JAGGAIAHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: YOGIRAMA HOSPITAL, UMA GOPAL COMPLEX,JAGGAIAHPET,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Kankipadu",
     "Center": "KANKIPADU DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE TVS SHOW ROOM,BANDAR ROAD,KANKIPADU,VIJAYAWADA 521151"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "COLLEGE - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMANAIDU PETA, SHAIK IMAM STREET, MACHILIPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "SCHOOL - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO : 21\/478, SRI CHAITANYA SCHOOL, SAI BABA TEMPLE ROAD, BHASKARAPURAM , MACHILIPATNAM , KRISHNA(DIST), AP 521001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "SCHOOL - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO 1-816, NEAR HEAD POST OFFICE, MANGALAGIRI VIJAYAWADA 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO 5-470,WARD NO.5,TENALI ROAD,NEAR MARKANDEYA KALYANA MANDAPAM,ABOVE ICICI BANK,MANGALAGIRI 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 14-271\/1, CHAIATANYA THOPAVANAM ASHRAMAM, KRISHNA NAGAR, TADEPALLI ,MANGALAGIRI - 522501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI-5",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAROFF BAZAR, VADLAPUDI CENTER,MANGALAGIRI,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mylavaram",
     "Center": "MYLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:-2-58,BESIDE NARAYANA THEATER , MYLAVARAM MYLAVARAM(M.D)KRISHNA (D.T)-521230 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nandigama",
     "Center": "NANDIGAMA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP VARUN BAJAJ , RAITHUPETA,NANDIGAMA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nuzvidu",
     "Center": "NUZVIDU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHERUKURI COMPLEX, BEHIND HERO HONDA SHOW ROOM, H.JUNCTION ROAD, NUZVIDU, KRISHNA (DT) 521201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Penuganchiprolu",
     "Center": "PENUGANCHIPROLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-1,MAKKAPET ROAD,PENUGANCHIPROLU,KRISHNA-521191.AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Repalle",
     "Center": "REPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RAJYA LAKSMI THEATRE,OLD STATE BANK COMPOUND,REPALLE 522265"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Tiruvuru",
     "Center": "TIRUVURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP NAGARJUNA COLLEGE, BOSU BOMMA CENTERE, TIRUVURU VIJAYAWADA 521235"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INDRA TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, USHA LAND MARK, OPP. M&amp;M SHOWROOM, MG ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MAHESWARA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAHESWARA BHAVAN, OPP. HDFC BANK, MG ROAD "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ESWARI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KRISHNAVENI CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SHEDS CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "RABINDRANATH TAGORE BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO. 32-27-9\/1, SARVODAYA VIDYA PEET ST CHUTTUGUNTA, MARUTHI NAGAR, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "VUYYURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OPP. DEEPAK MAHAL KATURU ROAD, BESIDE CARE HOSPITAL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHAVANI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SAI SARASWATHI NILAYAM,  SWATHI THEATER CROMBAAY ROAD, BHAVANI PURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ASHOKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:74-14-2, OLD CHECK POST CENTER, YANAMALAKUDURU LAKULA ROAD, KRISHNA NAGAR (ASHOK NAGAR), BESIDE COMMERCIAL TAX OFFICE, VIJAYAWADA-520007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "BHAVANIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:76-8\/6-5\/1,GUDIVADA RAMA RAO STREET,SWATHI THEATRE ROAD,BHAVANIPURAM,VIJAYAWADA-520012"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "CURRENCY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2ND LINE, OM NAMASHIVYA STREET, CURRENCY NAGAR,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "GOSALA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PUNADIPADU VILLAGE,KANKIPADU MANDAL,GOSALA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL GAYATHRI NAGAR,POLYCLINIC ROAD,NEAR BENZ CIRCLE,VIJAYAWADA 520008"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTL BEZAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:57-6-21\/2, ABC BUILDING, OLD POST OFFICE ROAD, BESIDE SONOVISION, PADAMATA, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KANCHIKACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.PRATAP TVS SHOW ROOM,KANCHIKACHERLA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KRISHNA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:-41-1\/8-42,GOWTHAMI NAGAR 3'RD LINE OPPOSITE AMERICAN HOSPITAL,KRISHNA LANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MARUTINAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:32-26-110\/124, SRI BHAVANI MANSION,MARUTINAGAR,ELURU ROAD,VIJAYAWADA 520004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MOGULRAJAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO36-12\/15\/2A,RAMARAO STREET,MADHU GARDEN,MOGULRAJAPURAM,VIJAYAWADA 520010"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "NUNNA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6-80, BESIDE BSNL TELEPHONE EXCHANGE, MAIN ROAD, NUNNA,VIJAYAWADA - 521212"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ONE TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:4-1-27, BANGARAIAH KOTTU CENTER,ONE TOWN,VIJAYAWADA KRISHNA (DT) 520009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PATAMATA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:40-12-3\/5, OPP:ASWINI ENCLAVE,SEETHARAMA NAGAR, PATAMATALANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PORANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-15-113,PRABHU NAGAR,PORANKI,VIJAYAWADA,KRISHNA 521137."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "S.N. PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR NO : 24-25-63,NEAR FOOD JUNCTION,OPP.RAILWAY QUARTERS,BRTS ROAD,DURGAPURAM,SATYANARAYANAPURAM,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SING NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO. 43-78-7 KRISHNA HOTEL CENTER, AJIT SING NAGAR, VIJAYAWADA-520015"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Visannapet",
     "Center": "VISANNAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, KUKKADAPU PRASAD COMPEX, BESIDE SURVEYNDICATE BANK, MAIN ROAD, VISANNAPETA 521215 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vuyyur",
     "Center": "VUYYUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :- 8-269, SRI CHAITANYA SCHOOL, ANU ARCADE BUILDING, BEHIND CARE HOSPITAL, KATURU ROAD, VUYYURU, KRISHNA (D.T) 521165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHEKURI GARDENS, NEAR NEW RTC BUS STAND,ADONI,KURNOOL 518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 21\/515\/9\/BCD\/1,AMBEDKAR NAGAR,REVENUE WARD-21,A.P.B.H COLONY,ADONI,518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Allagadda",
     "Center": "ALLAGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VISWARUPA NAGAR, ALLAGADDA,KURNOOL(DIST) 518543"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Alur",
     "Center": "ALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL LIC BACK SIDE,ALUR,KURNOOL 521329"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Atmakur",
     "Center": "ATMAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VENKATESWARA SWAMI TEMPLE,GAREEB NAGAR,ATMAKUR,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Banaganapalle",
     "Center": "BANAGANAPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL BANAGANAPALLI NEAR RTC BUS STOP ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Bethamcherla",
     "Center": "BETHAMCHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12TH WARD,DHONE ROAD, BETHAMCHERLA,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Dhone",
     "Center": "DHONE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VENKATANAINI PALLI ROAD,OPP ITI COLLEGE,DHONE,KURNOOL 518222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "SRI GURU RAGHAVENDRA BHAVAN BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,NH 40, OPPOSITE SAFA ENGINEERING COLLEGE, NEAR KRANTI GODOWN, B.THANDRAPADU, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,D.NO 40-304, BESIDE RR HOSPITAL, NEAR MOURYA INN, BHAGYA NAGAR, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL , D.NO:451 42\/13B-7 ,KAPPALA NAGAR,ROAD NO 4,VENKATA RAMANA COLONY LANE,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL VENKATADRI NAGAR, NERA RAILWAY GATE, KALLURU, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:40-321-1-F ,BESIDE OLD AYYAPPA SWAMY TEMPLE, BHASKAR NAGAR,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BESIDE OLD RAVI THEATER, CENTRAL PLAZA, NEAR VINAYAK GHAT, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE VIJAYA DURGA DEGREE COLLEGE, SRINAGA COLONY,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL KNL652,SRI CHAITANYASCHOOL, SANKHALBAGH,KURNOOL-518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO:46-156-D-1A,BUDHAWARAPET NEAR PADMA CHANDRA(OMNI) HOSPITAL, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VISWAK GARDEN, SOMISETTY FUNCTION HALL,SANKAL BAGH,KURNOOL 518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:6-68\/A,SC-COLONY, THANDRAPADU LAKE,OPP.SIVALAYAM,NANDYAL ROAD,KURNOOL518007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI RAMA NAGAR ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL CRR SECONDARY SCHOOL DINNEDEVARAPADU KURNOOL POST BOX NO :-8 ANANTHAPUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandikotkur",
     "Center": "NANDIKOTKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL MADDHUR NAGAR, BESIDE SRI RAMA THEATER, NANDIKOTKUR 518401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 25426-E BEHIND MUNCIPAL OFFICE NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRNIVASA NAGAR,TTD ROAD,OPP: RAITHUBAZAR,NANDYAL,KURNOOL 518502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO'S COLONY, NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SOWJANYA MOTORS,R.S ROAD,NANDYAL,KURNOOL(DIST),A.P"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 13\/71, RAMAKRISHNA NAGAR,KOILAKUNTLA ROAD, KANALA,NANDYAL. KURNOOL (DT)518493"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Pattikonda",
     "Center": "PATTIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 17\/177\/12\/1 YASHODA GARDEN SCHOOL YASHODA GARDEN NEAR RTC BUS STAND PATTIKONDA KURNOOL 518380"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Yemmiganur",
     "Center": "YEMMIGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GEETHA NAGAR, YEMMIGANUR, KURNOOL(DI),AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Buchireddypalem",
     "Center": "BUCHIREDDYPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP OLD RTC BUS STAND,BUCHIREDDYPALEM,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Gudur",
     "Center": "GUDUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANATH NAGAR,OPP Z.P GIRLS HIGH SCOOL,GUDUR,NELLORE 524101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PULLAREDDYNAGAR, BEHIND RSR KALYANA MANDAPAM, KAVALI,SPSR NELLORE DT 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALIKIVARI STREET , OLD TOWN , KAVALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANTHINAGAR KAVALI,SPSR NELLORE DT, 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kota",
     "Center": "KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SRINIVASA NAGAR,KOTA (MANDAL),NELLORE (DT) 524411"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kovvur",
     "Center": "KOVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE PANCHAYT OFFICE, KOTTUR RAMA MANDIRAM ROAD, MANDABAYALU CENTER, KOVUR,SPSR NELLORE (D.T) 524137"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Naidupet",
     "Center": "NAIDUPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL AGRAHARPETA, NEAR SAI BABA TEMPLE, NAIDUPET, SPSR NELLORE DIST 524126"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GAYATHRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VEDAYAPALEM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRI BHARATHI BOYS DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMALINGAPURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "UJWALA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, TIPPA RAJU VARI STREET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRIVANI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PAPPULA VEEDI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "ATMAKUR NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL TENKAYA THOPU,NEAR RAVITEJA KALYANAMANDAPAM ,ATMAKUR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GUPTA PARK",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12-4-294,BESIDE MODEL HIGH SCHOOL,NEAR GUPTHAPARK,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NAWABPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:SIVALAYAM, NARUKUR MAIN ROAD, NAWABPETA, NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ISKON CITY,KONDAYAPALEM,BACK SIDE BHARATH PERTROL PUMP, VANAMTHOPU, NELLORE 524004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SETTYGUNTA ROAD,LAKSHMI PURAM,VENGAMAMBA CENTRE,NAWABPETA,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SANTHAPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR SANTHAPET , NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "AC NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ADDALA SAI BABA TEMPLE,PULIMI PEDDA BUCHI REDDY NAGAR, AC NAGAR, NELLORE 524002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "BALAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAMJI NAGAR, 5TH LINE , BALAJI NAGAR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "MUTHUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO POST OFFICE,MUTHUKUR ,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP HDFC BANK ATM, DHANALAKSHMIPURAM, NELLORE524003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "PODALAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,CHAITANYA NAGAR,RAPUR ROAD,PODALAKUR (MANDAL),NELLORE (DT) 524345"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Sullurpet",
     "Center": "SULLURPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RR SUPER MARKET ,GNT ROAD , SULLURPET,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vedayapalem",
     "Center": "VEDAYAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANDHI NAGAR ,VEDAYAPALEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMMAVARIPETA, MUNICIPAL OFFICE ROAD, VENKATAGIRI,SPSR NELLORE DIST 524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DVS COMPLEX, RAJA STREET, VENKATAGIRI, SPSR NELLORE (DT)524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vinjamuru",
     "Center": "VINJAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE PRAJA VAIDHYASALA, NEAR RTC BUS STAND , VINJAMURU,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ANJANEYA SADAN ADDANKI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.31-419, 31-420, OIL MILL ROAD, ADDANKI - 523201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ADDANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUNGLOW ROAD,ADDANKI,PRAKASAM -523201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Chimakurthy",
     "Center": "CHIMAKURTHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDHI NAGAR 7TH LINE,CHIMAKURTHY ONGOLE 523226"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Darsi",
     "Center": "DARSI",
     "CenterAddress": "SRI CHAITANYA SCHOOL TEACHERSCOLONY,PODILI(ROAD),DARSI,PRAKASAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kandukur",
     "Center": "KANDUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA REDDY NAGER,KANDUKUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.JR COLLEGE,KANDUKUR ROAD,KANIGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUBHASH ROAD,KOTHA PET,KANIGIRI,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Markapuram",
     "Center": "MARKAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.8\/A-20 ,BODAPADU ROD ,OPPISITE RTC DEPO,MARKAPURAM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Martur",
     "Center": "MARTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. VIJAYALAKSHMI KALAYANA MADAPAM, NH-5 ROAD , MARTUR,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "SARASWATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MANGUMUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "CUMBUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.INDIAN PETROL BUNK,NEAR SBI BANK ,GIDDALUR ROAD,CUMBUM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHAGYA NAGAR 2ND LINE, BESIDE REGISTER OFFICE ,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP.HP GAS AGENCY,NEAR MARRI CHETTU,MANGAMUR DONKA ROAD,ONGOLE 523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL V.I.P. ROAD,MANGAMUR DONKA,ABOVE HDFC BANK,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MAHALAKSHMI TOWERS, 4TH LINE ,LAWYERPET,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Pamuru",
     "Center": "PAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.HP PETROL BUNK ,NELLORE ROAD,PAMURU,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Singarayakonda",
     "Center": "SINGARAYAKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE I.T.I COLLEGE,MULAGUNTAPADU(V),SINGARAYAKONDA(M) PRAKASAM DISTRICT 523101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-3,4&amp;5, BEHIND DEEPAMAHAL, SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "KAMAKSHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OLD NH-5 ROAD, OPP. HONDA SHOWROOM, PADMANABHAPURAM, KASIBUGGA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRIKAKULAM ROAD, NEAR AMRUTHA HOSPITAL, OPP. MAHENDRA SHOWROOM, RAJAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI NAGAR , NEAR DEO OFFICE,WOMENS COLLEGE ROAD,SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANGI SURYANARAYANA COLONY, NEAR AYYAPPA SWAMY TEMPLE, ADIVARAMPETA, CHAPURAM PANCHAYAT, PALAKONDA ROAD, SRIKAKULAM 532 001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "GOWRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 12-12-73, OLD BUS STAND ROAD, NEAR SHIRDI SAI THEATRE, ANAKAPALLI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "ANAKAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 80 FEET RING ROAD , OPP HEMA SEKHAR DEGREE COLLEGE, STATION ROAD, ANAKAPALLI,VISAKHAPATNAM -531001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Bobbili",
     "Center": "BOBBILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR CBM CHURCH , BALIJIPETA ROAD, BOBBILI,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Narsipatnam",
     "Center": "NARSIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2-101\/1, NEAR RTC COMPLEX , ANAKAPALLI ROAD, NARSIPATNAM-531116 VISAKHAPATNAM DIST."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Palasa",
     "Center": "PALASA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:14-1-279\/A,NEAR AYYAPPA SWAMY TEMPLE,OLD NH-5 ROAD,PADMANABHAPURAM,PALASA-KASIBUGGA,SRIKAKULAM DIST 532222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Parvathipuram",
     "Center": "PARVATHIPURAM",
     "CenterAddress": "SRI CHAITANAYA SCHOOL , OPP- SRI VENKATESWARA NURSHING HOME ,SUNDERNARAYANAPURAM COLONY , BELAGUM ,PARVATHIPURAM , VIZIANAGARAM ( DIST ) ."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Rajam",
     "Center": "RAJAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP ELECTRICAL SUB STATION, PONDURU ROAD, RAJAM, SRIKAKULAM (DIST) 532127"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN- II",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-48-6-16, SRI VIJAYA SAI TOWERS, OPP. RAMA TALKIES MAIN GATE, SRINAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRIPADA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-48-8-14, BEHIND KALANIKETHAN, NEAR BUDHIL PARK HOTEL, DWARAKANAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-58-22-50, NEAR NAD HOSPITAL, SUSARLA COLONY, BUTCHIRAJUPALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO 6-62-6\/1, NEAR GAJUWAKA POLICE STATION, SHRAMIK NAGAR, CHINAGANTYADA, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYSHNAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MIG 110, D.NO 24-3-1,BUDA COLONY,PEDAGANTYADA, GAJUWAKA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYDEHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, STEEL PLANT MAIN ROAD, UKKUNAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRISAI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 34\/2, PILAKAVANIPALEM, CARSHED JUNCTION, P.M PALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 10-12-8, OPP PYDAH DEGREE COLLEGE REDNAM GARDENS RAM NAGAR,ASILMETTA VISAKHAPATNAM -530002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 11-4-1\/1,UDAY SRI TOWERS, RAMNAGAR,ASILMETTA,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:26- 42-10\/2,BESIDE SRI CHAITANYA JUNIOR KALASALA,CHAITANYANAGAR,OLD GAJUWAKA,VISAKHAPATNAM-530026."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 27-1-65,SRINAGAR,GAJUWAKA,VISAKHAPATNAM,530026"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KOMMADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VIJAYA MOHAN LAYOUTS,NEAR CHAITANYA ENGG COLLEGE, KOMMADI VILLAGE,CHINAGADILI MD MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KURMANNAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 31\/6-3\/1 OPP. STEEL CITY APSRTC BUS DEPO SATHAVAHANANAGAR ROAD NO.6,MAINROAD KURMANNAPALEM, GAJUWAKA MANDAL VISAKHAPATNAM 530046"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: CMR GARDENS, MADHURAWADA , VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR FLY OVER BAKKANAPALEM ROAD, MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MVP COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-10-2\/4, USHA RESIDENCY, SECTOR-1,MVP COLONY, VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D.NO. 58-1-237, TEEGALA TOWERS, MARRIPALEM ROAD, NAD, VIZAG 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D-NO-58-15-116\/A, OPP GAJANANA FORT, SANTHI NAGAR, NAD ,VISAKHAPATNAM 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "PENDURTY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SBI, PULAGANIPALEM ROAD, PENDURTY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Yalamanchali",
     "Center": "YALAMANCHILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR FIRE STATION,RAMAKRISHNAPURAM, YELAMANCHILI,VISAKHAPATNAM-531055"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL, 100 FEET RING ROAD, DHARMAPUR, NEAR VENKATESWARA SWAMY TEMPLE, VIZIANAGARAM 535001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR NEAR BUS STOP,BOWDARA MAIN ROAD, VIZIANAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagarm",
     "Center": "VIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO-102,103,104, NAIDU COLONY, THOTA PALEM, VIZIANAGARM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Eluru",
     "Center": "COLLEGE - ELURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAIN CAMPUS- ELURU, MARGHADARSHI ROAD, NARASIMHA RAO PETA, ELURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Palakol",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS BRODIPET, BRODIPET BIPASS ROAD, PALAKOLLU, WEST GODAVARI - 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KRISHNAVENI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR RTC BUSTAND,BESIDE DWARAKA PETROL BUNK,KHAJA NAGAR,ANANTAPUR "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 8-74A, BESIDE HEAD POST OFFICE, NEAR ANDHRA BANK, ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR PAVAN GAS AGENCY, RTO OFFICE ROAD, HOUSING BOARD, ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,OPP.TATA SHOWROOM,KAKKALAPALLI,RUDRAMPETA BY PASS,ANANTHAPUR 515672"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KAMMA BHAVAN, OLD NIRMALA NURSING COLLEGE LAKSHMI SRINIVASA NAGAR ANANTAPUR-515004, "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OLD DPS SCHOOL ,OPPOSITE TATA SHOWROOM,HYDERABAD HIGH WAY PAMURAI VILLAGE ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SAKSHI OFFICE,OPP: TATA MOTORS,RUDRAMPETA BY-PASS,ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEW REVENUE OFFICE BACKSIDE,RUDRAMPETA,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL, SURVEY NO.:149\/4, WARD NO.: 13, SHIRDI NAGAR, NEAR RTC BUS STAND,OPP. ANAND HOSPITAL ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.315-1B,WARD NO.28,L.P.NO.518\/85, SINGARAYANI COLONY,NEW REVENUE COLONY, ANANTAPURAMU 515001."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 10\/413,ADIMURTHY NAGAR,OPPOSITE DEVI NURSING HOME,NEAR SRI CHAITANYA JR COLLEGE ,ANANTHAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "GORANTLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/277 OPPSITE MARKET YARD KADIRI - HINDUPUR MAIN ROAD,BESIDE SPVM DEGREE COLLEGE GORANTLA (M&amp;V) ANANTAPUR DIST A.P - 515231"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KALYANADURG",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO:-359\/1A, OPP GOVT HOSPITAL BELLARY ROAD, KALYANADURG, ANANTAPUR (DT) 515761"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:17\/1111, RAJENDRA NAGAR,NEAR VENKATESWARA SWAMY TEMPLE, POST OFFICE LINE, GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 4\/369, DMM GATE ROAD,NEAR PANDURANGA SWAMY TEMPLE,P&amp;T COLONY,GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. MAHENDRA FUNCTION HALL,TILAK NAGAR, GUNTAKAL515801"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 12-1-76\/G2, PALANI NAGAR, BESIDE RAJADHANI FUNCTION HALL, HINDUPUR,ANANTHAPUR - 515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 26, SATYANARAYANA PETA MF ROAD, HINDUPUR, ANANTHAPUR-515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kadiri",
     "Center": "KADIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO : 13\/13\/1\/C ,MADANAPALLI ROAD,OPPO.CHOWDESWARI TEMPLE,KADIRI,SATYA SAI DIST 515591"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kothacheruvu",
     "Center": "KOTHACHERUVU",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 7\/196, PENUGONDA ROAD KOTHACHERUVU ANANTAPUR 515133"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Tadipatri",
     "Center": "TADIPATRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NETHAJI SCHOOL COMPOUND, BEHIND RICE MILL, KALAVAKATTA STREET, TADIPATRI, ANANTAPUR 515411 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Bangarupalyam",
     "Center": "BANGARUPALYAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL THAGGUVARIPALLI, BANGARUPALYAM,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chandragiri",
     "Center": "CHANDRAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VIJAY NAGAR COLONY,CANARA BANK ROAD,CHANDRAGIRI 517101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOR CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-10-199, TMR TOWER , GANDHI ROAD,OPPT LIC OFFICE, CHITTOOR,517001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.THAPOVANAM SCHOOL,TEACHERS COLONY,GREAMSPET,VELLORE ROAD,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27-515\/B,TELEPHONE COLONY ROAD,RAMNAGAR COLONY,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 28-1428, RAM NAGAR COLONY,CHITTOR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "MURUGANI PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO.22-978\/BB, KAMESHWAR NAGAR, MURUGANIPALLI, CHITTOOR,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalle",
     "Center": "SRI GANGA SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 3\/153-4-4-1, HOSPITAL BRANCH , BESIDE RTC BUS STAND,MADHANAPALLI-517325,ANNAMAIAH (D)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MALLIKARJUNA CIRCLE, COLLEGE ROAD, MADANAPALLI,CHITTOOR 517325 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.NO. III-145-6-12-4, PRASANTH NAGAR, BESIDE. SRI SIDDHARTHA JR. COLLEGE, MADANAPALLI,TIRUPATHI - 517325"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Palamaneru",
     "Center": "PALAMANERU",
     "CenterAddress": "SRI CHAITANYA SCHOOL GUDIYATHAM ROAD,SRI NAGAR COLONY,NEAR YSRCP PARTY OFFICE,PALAMANERU,TIRUPATHI 517408"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Piler",
     "Center": "PILER",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-421, LAKSHMI PURAM,PILER, CHITTOOR (DIST),TIRUPATHI 517214."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Punganur",
     "Center": "PUNGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MPDO OFFICE, R.R KALYANA MANDAPAM,MBT ROAD,PUNGANUR-517247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #12\/64\/1A,SWAMY STREET,PUTTUR,517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARAMESWARA MANGALAM,K.PALEM,PUTTUR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYANAPURAM,OPP.FIRE STATION, SWAMI STREET KN ROAD,PUTTUR 517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Renigunta",
     "Center": "RENIGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL VINAYAKA NAGAR, RENIGUNTA, TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-1-1988,JAYRAM RAO STREET,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 16\/550\/3,SRI RAM NAGAR COLONY,PANAGAL ROAD,OPP: SBI (ADB) BRANCH,SRIKALAHASTI. AP 517640"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI LAKSHMI KAMAKSHI KALYANA MANDAPAM, OPP DARMARAJ TEMPLE,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "ANJANADRI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 2-16,TELECOM COLONY OTERU ROAD ,SRINIVASAPURAM ,TIRUPATHI-517503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "CURE CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:6-2-83, KT ROAD,NEAR AXIS BANK MAIN BRANCH TIRUPATI - 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN CAMPUS DAYS ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  DO; NO 25, GANDHI ROAD   MUNICIPAL COMPLEX  PIN NO; 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN II CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 37 AGK BUILDING  GANDHI ROAD  TIRUPATHI PIN: 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  RC ROAD  EBSR COMPLEX NEAR  ANNAMAYYA CIRCLE TIRUPATI PIN CODE 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VEDAVYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DR NO:411\/2P    150 BY PASS ROAD, TIRUCHANOOR (V)  TIRUPATHI ( R)517503        "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VENKATADRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 8-171-1, NEW BALAJI COLONY, MR PALLI, TIRUPATHI PIN-517502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "AIR BY-PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL JAYA LAKSHMI COLONY, STV NAGAR, AIR BY PASS ROAD, NEAR PASSPORT OFFICE, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TARAKARAMA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP:A.G.STAFF QUARTERS,TARAKARAMANAGAR,PERUR,TIRUPATI(RURAL)571505"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "GS MADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 15-2-126\/A2 , BESIDE LAKSHMI NARAYANA SWAMY TEMPLE GSMADA STREET TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "KORALAGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 20-2--478\/A2,MARUTHINAGAR,KORLAGUNTA,TIRUPATI-517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MR PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT:26 NEW MARUTHI NAGAR, AIR BY PASS ROAD,MR PALLI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "SRINIVASAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL TELECOM COLONY, SRINIVASAPURAM, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUMALA BY PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:18-1-7\/10, BESIDE PAI VICROY HOTEL, RAMA CHANDRA NAGAR, TIRUMALA BY PASS,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI GIRLS RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL #10-128\/6-9 NETHAJI NAGAR P G N TOWER TIRUCHANUR TIRUPATI PIN:517507"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI IPL",
     "CenterAddress": "SRI CHAITANYA SCHOOL IPL BRANCH,BAIRAGIPATTEDA, NEAR RIMS,TIRUPATHI 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TSN PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR. NO. 20-3-131\/1A, SIVA JYOTHI NAGAR, SATHYANARAYANAPURAM, OPPOSITE SRIVARI SANNIDHI, BACK SIDE STREET SBI EXECUTIVE GUEST HOUSE, TIRUPATHI, CHITTOOR DISTRICT, AP 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VIKAS CAMPUS",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANA PALLY ROAD, THIRUCHNOR, THIRUPATHI "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Venkatagirikota",
     "Center": "V KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHOWDEPALLE ROAD, VKOTA,TIRUPATHI 517424"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "SRI SHIRDI SAI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SHIRDI SAI CAMPUS #1-5-58\/2A ONGC BYPASS ROAD, SAVARAM AMALAPURAM- 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MSN COMPLEX, MAIN ROAD, AMALAPURAM, EAST GODAVARI DIST, 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :I 1-72 ,BACKSIDE OF VL HEIGHTS,ABBIREDDY CANAL BRIDGE,KONKAPALLI,AMALAPURAM,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Anaparthi",
     "Center": "ANAPARTHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 13-37, CANAL ROAD,AYYAPPA TEMPLE ,KOTHURU TURNING,ANAPARTHI,ANAPARTHI (MD), RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimadole",
     "Center": "BHIMADOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:10-116,OPP. FIRE STATION,ELURU, RAJAHMUNDRY ROAD,BHIMADOLE,WEST GODAVARI 534425"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL,PLOT NO:6-126,SRI RAMA KUSUMA PLAZA,NEAR NATARAJ THEATER,CHINNAMIRAM,JP ROAD, PALAKODERU (M), W.G(DT)534210"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE DUPLEX COLONY CHINNAMIRAM,BHIMAVARAM,RAJAHMUNDRY 534204"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Chintalapudi",
     "Center": "CHINTALAPUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL ABOVE UNION BANK,SRINIDI COMPLEX,ELURU ROAD,CHINTALAPUDI,RAJAHMUNDRY 534460"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Devarapalli",
     "Center": "DEVARAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP:VEGETABLE MARKET, ELURU ROAD, DEVARAPALLI RAJAHMUNDRY 534313"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "SCHOOL - ELURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHALAPATHI TOWERS,4TH LINE ,SANTHI NAGAR ,ELURU,PIN CODE:534007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARVATHA VARDHINI COMPLEX , NEAR MAHATHMA GANDHI STATUE, VIDYANAGAR , ELURU. W.G.(DT) 534003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 7-179\/2,NEAR GANGANAMMA TEMPLE,BALAJI NAGAR, CHATAPARRU ROAD, ELURU-534001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ganapavaram",
     "Center": "GANAPAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NIDAMARRU MANDEL,BHAVIPALEM POST, GANAPAVARAM,RAJAHMUNDRY 534198"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Hanuman Junction",
     "Center": "HANUMAN JUNCTION",
     "CenterAddress": "SRI CHAITANYA SCHOOL KEPINIDI TOWERS, NUZVID ROAD,NEAR FLYOVER, HANUMANJUNCTION WEST GODAVARI 521105"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jaggampeta",
     "Center": "JAGGAMPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRISHNAVENI THEATOR , BALAJI CENTER , JAGGAMPETA, EAST GODAVARI 533435"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jangareddygudem",
     "Center": "JANGAREDDYGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :16-1-120, BESIDE M.R.OOFFICE,MANDAVALLI ESTATE, ASWARAOPETA ROAD, JANGAREDDYGUDEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kaikalur",
     "Center": "KAIKALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: FCI GODOWNS, BESIDE RELIANCE PETROL, ATAPAKA, KAIKALUR-521333"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "RAMAN BHAVAN 1 SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOWDHAM, #3-16A-101, LAKSHMINARAYANA NAGAR,KAKINADA -533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL #3-16B-4, OLD RTO OFFICE ROAD, NEAR MOTHER TERESA STATUE,SANTHI NAGAR, KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPOSITE BMC CHURCH SANTHI NAGAR KAKINADA - 533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.9-16,SRINIVASA COLONY, RAMANAYYAPETA, KAKINADA RURAL-533005, EAST GODAVARI DISTRICT, ANDHRA PRADESH"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO1-1111, JANA CHAITANYA LAYOUT NEAR JEWEL MEDOWS,SARPAVARAM,KAKINADA RURAL 533005"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-5-43\/1,NAGESWARARAO STREET,RAMARAO PETA,KAKINADA-533003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kovvur",
     "Center": "KOVVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP PMMM GOVT HIGH SCHOOL,BESIDE YUVRAJ FUNCTION HALL, NANDAMURU ROAD, KOVVUR, WEST GODAVARI 534350"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Mandapet",
     "Center": "MANDAPETA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAIN ROAD ,NEAR HP BUNK ,TAPESWARAM,MANDAPETA,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Nagaram",
     "Center": "NAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD HAVENS CAMPUS, MAIN ROAD, NAGARAM 533247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Narsapur",
     "Center": "NARSAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KARTHIKEYA NAGAR,21ST WARD,PEECHUPALEM ROAD,NARSAPURAM ,WEST GODAVARI (DT),A.P 534275"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL BRODIPET 2ND STREET, BYPASS ROAD, RAJUGARI BUILDING, PALAKOL, W.G.DT 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR AXIS BANK ,OPP.AMBEDKAR STATUE POOLAPALLI , PALAKOL , WEST GDHAVARI DIST"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Payakaraopeta",
     "Center": "PAYAKARAOPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL Y JUNCTION,NEAR GOVT HOSPITAL,PAYAKARAOPETA,KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Penugonda",
     "Center": "PENUGONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:31-112, OPPOSITE PALACE THEATER, SIDDHANTHAM ROAD, PENUGONDA, AP 534320"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Pitapuram",
     "Center": "PITAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PADA GAYA TEMPLE, BYPASS ROAD, PITHAPURAM,RAJAJMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARASWATHI SOUDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 85-6-15\/1,ROUTHU PLAZA, VL PURAM,RAJAMAHENDRAVARAM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARVANI TOWERS",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, D.NO:75-1-4,PRAKASH NAGAR, RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 14-137\/A,OPP RTC COMPLEX,BEHIND UNION BANK, RAJAMAHENDRAVARAM - 533 103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SRI VYBHAVI",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:78-10-7,SYAMALA NAGAR , BESIDE GOVINDURAJULU HOSPITAL,RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "KOVVURU",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:4-177,VEMULURU ROAD,KOVVURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL H. NO : 89-17 21\/1,MORAMPUDI ROAD, MORAMPUDI - KESAVARAM ROAD, SRI SAI CHAITANYA NAGAR, RAJAHMUNDRY, ANDHRA PRADESH 533107"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO11-11-1,OPPOSITE FIRE STATION,ARYAPURAM,RAJAHMUNDRY,EAST GODAVARI (DT) 533103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO-74-6-54, NEAR T T D KALYANA MANDAPAM,OPP SWATANTRA KUMAR CHURCH,PRAKESH NAGAR,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:17-12\/8\/1,KRISHNA NAGAR,SEETAM PETA,NEAR SATYAM GARI RICE SHOP,RAJAHMUNDRY,EAST GODAVARI (DT)533104"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:4-699\/1, BESIDE BEEJAPURI TOWNSHIP, SRIRAMPURAM ROAD, DIWANCHERUVU, RAJANAGARAM MANDAM, EAST GODAVARI, ANDHRAPRADESH - 533296"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "THE PARK INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:89-17-1\/21 CHAITANYA NAGAR, MORAMPUDI ROAD ,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajole",
     "Center": "RAJOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL(PS) EM SCHOOL,OPP. ANNAPURNA THEATER, MOGALIKUDURU,RAJOLE,RAJAHUMUNDRY 533249"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ramachandrapuram",
     "Center": "RAMACHANDRAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:5-282\/1,SRI CHAITANYA SCHOOL-RAMACHANDRAPURAM, SRINAGAR, OPPOSITE VSM ENGINEERING COLLEGE RAMACHANDRAPURAM,PASALAPUDI BRANCH, ANDHRAPRADESH - 533255"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ravulapalem",
     "Center": "RAVULAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR ANKALAMMA TEMPLE,UBALANKA ROAD,RAVULAPALEM ,EAST GODAVARI DIST 533238"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Razole",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #9-60\/1,OPP.RTC COMPLEX, RAZOLE-533242"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Sakhinetipalli",
     "Center": "SAKHINETIPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, ANTARVEDI PALEM, BESIDE INDIAN OIL PETROL BUNK,SAKHINETIPALLI MANDAL,E G DIST-533252"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO.CWC GUDEM,NALLAGERLA ROAD,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM CBSE",
     "CenterAddress": "SRI CHAITANYA OLYMPIAD SCHOOL,VASAVI IDEAL PUBLIC SCHOOL BUILDING,CHINNATADEPALLI,KADIYADDA POST,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU",
     "CenterAddress": "SRI CHAITANYA SCHOOL,IKEA NAGAR,NH-16,TANUKU,WG.DIST,534211"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PETROL BUNK,VISHNU PRIYANAGAR ,TANUKU VELPURU 534222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #3-41-8\/4, SRIRAM NAGAR, MR PETA, TUNI- 533401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL DURGADAS STREET,OPPOSITE SURESH KUMAR HOSPITAL, KOTHA PETA, TUNI, RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:3-41-8\/4, SAI NAGAR, MR PETA,TUNI,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "SUNKARAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUEU,KV NAGAR, YANAM, 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "YANAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUE, DRAKSHARAMA ROAD, VIA YANAM, SUNKARAPALEM 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yeleswaram",
     "Center": "YELESWARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 3-377\/1, NEAR RAJULA BABU TEMPLE, LINGAMPATHY ROAD,YELESWARAM ,RAJAHMUNDRY,AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Amaravathi",
     "Center": "AMARAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEAR MUSEUM ROAD,AMARAVATHI ,GUNTUR 522020 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "SARASWATHI SOUDHAM BAPATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.94\/1, VIJAYALAKSHMI PURAM, BAPATLA - 522101."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 8-3-8, OPP OLD MAA CABLE, OFFICE, BHIMAVARIPALEM, BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO -4-10-139\/1SRINIVAS NAGAR COLONY,BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripet",
     "Center": "SIDDHARTHA CAMPUS CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.25-367 &amp; 25-367\/1, NEAR R.V.S. HIGH SCHOOL, CHILAKALURIPET - 522616."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GUNDABOLU RAMACHANDRA HOSPITAL, SUBBAIAH THOTA, CHILAKALURIPET GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD DRN SCVS JR.COLLEGE BUILDING,NSP OFFICE, NARSARAOPET ROAD, CHILAKALURIPET,GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chirala",
     "Center": "CHIRALA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NALLA PANENI TOWERS, OPP MARGADHARSI CHIT FUNDS PVT.LTD,MUNTHAVARICENTER,CHIRALA 523165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Dachepalli",
     "Center": "DACHEPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRANTHI NURSING HOME,NARAYANAPURAM,DACHEPALLI(MD)GUNTUR(DT)-522414"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "CHAITANYA LAKSHMI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.22-4-47, TITANIC SHOW ROOM UPSTAIRS, NEAR OLD BUS STAND, LALAPET, GUNTUR - 522003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "ICON CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.5-89-9, 3RD LINE, LAKSHMIPURAM, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "AVANTHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.589-11\/5, 1ST LINE, CHANDRAMOULI NAGAR, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR NAYAR HOTEL CENTER, OPP. CENTRO, LAKSHMIPURAM MAIN ROAD, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR PRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NAYAR HOTEL CENTER, LAKSHMIPURAM MAIN ROAD, BESIDE WOODLAND, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHATMA GANDHI 80FEET INNER RING ROAD, REDDYPALEM, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "INTERNATIONAL SCHOOL WHITEHOUSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NAVABHARAT NAGAR, 4TH LANE,MAHA LAKSHMI TOWERS OPP. CHALAPATHI GROUNDS GUNTUR 522006"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "NEHRU NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL BUCHAITHOTA 1ST LINE,OPP VIJAYAWADA RAILWAY TRACK, NEHRU NAGAR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "REDDYPALEM DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD REDYYPALEM ,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "SYAMALA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYAMALA NAGAR, ZERO LINE,NEAR ARMY CANTEEN,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Macherla",
     "Center": "MACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13TH WARD, R&amp;B BUNGLOW BACK SIDE, NEAR PALAMARA ,MACHERLA GUNTUR (D.T) 522426"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Mangalagiri",
     "Center": "COLLEGE - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  D.NO.7-426 &amp; 7-426\/A, TIPPARLA BAZAR, MANGALAGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Nagaralu",
     "Center": "NAGARALU",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,TELECOME NAGAR 2ND LINE,AMARAVATHI ROAD, NEAR TAGORE RICE MILL,NAGARALU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARASARAOPET RAMANUJAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.11-23-1, RAMIREDDY PET, NARASARAOPET - 522601."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:11-14-1\/1,RAMIREDDYPET,BANK COLONY,NARASARAOPET,GUNTUR."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA CENTER ,SATTENAPALLI ROAD, OPP MAHALAKSHMAMMA CHETTU,NARSARAOPET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 60 FEET ROAD , PRAKASH NAGAR NARASAOPET,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "GAUTAMA BUDDHA BHAVAN PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.416\/B, KOTAIAH SASTRY BAZAR, PIDUGURALLA - 522413."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 7-703\/A ABBUBAKAR MUSEED STREET OPP AXIS BANK PIDUGURALLA,GUNTUR - 522413"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Ponnur",
     "Center": "PONNUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GBC ROAD, PONNUR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Repalle",
     "Center": "PARAMESWARA SADAN REPALLE",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.9-35-210 &amp; 9-35-210\/1, UPPUDI ROAD, REPALLE - 522265."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHINA MAJID CENTER,SBI ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 5-8-8, NAGARJUNA NAGAR,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARK ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "VYAS BHAVAN TENALI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.2-1-74, GANDHI NAGAR, RATNA TALKIES CENTRE, TENALI - 522201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANGANAMMA PET, TENALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR-NO-21-1-60\/1, DEVI CHOWK, RAMALINGESWARAPET,TENALI,GUNTUR-522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR UMESH CHANDRA STATUE,CHENCHUPET,TENALI,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP: GOVERNMENT VETERINERY HOSPITAL ,BURRIPALEM ROAD,TENALI 522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Vinukonda",
     "Center": "VINUKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE CURRENT OFFICE, KARAMPUDI ROAD, VINUKONDA GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Badwel",
     "Center": "BADWEL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDLA STREET,PORUMAMILLA ROAD,BADWEL,KADAPA 516227"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI BALAJI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DONO:1-399 MARUTHI NAGAR, BESIDE KADAPA CAFÉ, KOTIREDDY CIRCLE KADAPA-516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI SAI SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:42\/609-28, NGOS COLONY, APASARA CIRCLE , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,KEERTHI PARK VIEW,OPP RAJIV PARK,MARUTHI NAGAR,KADAPA 516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMBHA BHAVANI TEMPLE,NEAR BUILTUP, KADAPA."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NEHRU PARK,CO-OPRATIVE COLONY,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL ARP COLONY, PRAKASH NAGAR , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL 101\/257-2 RIMS BYPASS ROAD KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUGGA VANKA PROJECT ROAD,NEAR SWAMY NAGAR,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL #97\/217-8,NEAR RTO OFFICE,YSR CIRCLE,C.K.DINNE,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:CHINNACHOWK POLICE STATION,NEHRUNAGAR,KADAPA 516002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAYACHOTI RING ROAD,VUTKUR CIRCLE,KADAPA 516003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Porumamilla",
     "Center": "PORUMAMILLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DESAI MAHAL BACK SIDE,NEAR APSRTC BUSSTAND,PORUMAMILLA(V)KADAPA(DT)AP-516193"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ARAVINDA ASHRAMAM, YMR COLONY , PRODDUTUR, Y.S.R KADAPA(DIST) 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL YERRAGUNTLA BY PASS ROAD, NEAR CINE HUB,PRODDATUR,KADAPA 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL BACKSIDE HONDA SHOWROOM,KVR COLONY,MYDUKUR ROAD,PRODDUTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BOLLAVARAM NEAR GOLDEN PARK JAMMALAMADUGU BYPASS ROAD PRODDATUR, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Pulivendula ",
     "Center": "PULIVENDULA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT 70, BESIDE RTO OFFICE, MUDDANURU ROAD ,PULIVENDULA,KADAPA 516390"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHUVANAGIRI PALLI,RAJAMPET,KADAPA 516115"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL R.S.ROAD, RAJAMPET, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO COLONY,KOTHAPETA,RAYACHOTI,KADAPA 516269"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 430 BESIDE PREETHAM RESIDENCY,RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 5\/283,NEAR BY ICDS OFFICE, BESIDE VINAYAKA TEMPLE, SUNDEPALLI ROAD, RAJULA COLONY RAYACHOTI 516269 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA REDDY NAGAR,MADANAPALLI ROAD RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Avaniggadda",
     "Center": "AVANIGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5TH WARD, NEAR SANTHA MARKET AVANIGADDA,VIJYAWADA KRISHNA (DT)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Challapalli",
     "Center": "CHALLAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CLUB ROAD, RAMANAGARAM(VILLAGE),CHALLAPALLI(MANDAL), KRISHNA (DIST),521126."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gannavaram",
     "Center": "GANNAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GNT ROAD ,KOTHAPETA,GANNAVARAM,VIJAYAWADA 521101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "COLLEGE - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 8\/191, SRI RAM PURAM COLONY, OLD CURRENT OFFICE, BESIDE FISH MARKET ROAD, SATYANARAYANA PURAM, GUDIVADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "SCHOOL - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:10\/153, RAJENDRA NAGAR 1ST LINE, GUDIVADA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Ibrahimpatnam",
     "Center": "IBRAHIMPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR STATE BANK OF INDIA,OPP-MANDALAM OFFICE ,V.T.P.S ROAD,IBRAHIMPATNAM,KRISHNA (DT)521456"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Jaggaiahpet",
     "Center": "JAGGAIAHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: YOGIRAMA HOSPITAL, UMA GOPAL COMPLEX,JAGGAIAHPET,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Kankipadu",
     "Center": "KANKIPADU DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE TVS SHOW ROOM,BANDAR ROAD,KANKIPADU,VIJAYAWADA 521151"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "COLLEGE - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMANAIDU PETA, SHAIK IMAM STREET, MACHILIPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "SCHOOL - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO : 21\/478, SRI CHAITANYA SCHOOL, SAI BABA TEMPLE ROAD, BHASKARAPURAM , MACHILIPATNAM , KRISHNA(DIST), AP 521001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "SCHOOL - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO 1-816, NEAR HEAD POST OFFICE, MANGALAGIRI VIJAYAWADA 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO 5-470,WARD NO.5,TENALI ROAD,NEAR MARKANDEYA KALYANA MANDAPAM,ABOVE ICICI BANK,MANGALAGIRI 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 14-271\/1, CHAIATANYA THOPAVANAM ASHRAMAM, KRISHNA NAGAR, TADEPALLI ,MANGALAGIRI - 522501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI-5",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAROFF BAZAR, VADLAPUDI CENTER,MANGALAGIRI,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mylavaram",
     "Center": "MYLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:-2-58,BESIDE NARAYANA THEATER , MYLAVARAM MYLAVARAM(M.D)KRISHNA (D.T)-521230 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nandigama",
     "Center": "NANDIGAMA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP VARUN BAJAJ , RAITHUPETA,NANDIGAMA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nuzvidu",
     "Center": "NUZVIDU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHERUKURI COMPLEX, BEHIND HERO HONDA SHOW ROOM, H.JUNCTION ROAD, NUZVIDU, KRISHNA (DT) 521201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Penuganchiprolu",
     "Center": "PENUGANCHIPROLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-1,MAKKAPET ROAD,PENUGANCHIPROLU,KRISHNA-521191.AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Repalle",
     "Center": "REPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RAJYA LAKSMI THEATRE,OLD STATE BANK COMPOUND,REPALLE 522265"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Tiruvuru",
     "Center": "TIRUVURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP NAGARJUNA COLLEGE, BOSU BOMMA CENTERE, TIRUVURU VIJAYAWADA 521235"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INDRA TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, USHA LAND MARK, OPP. M&amp;M SHOWROOM, MG ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MAHESWARA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAHESWARA BHAVAN, OPP. HDFC BANK, MG ROAD "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ESWARI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KRISHNAVENI CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SHEDS CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "RABINDRANATH TAGORE BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO. 32-27-9\/1, SARVODAYA VIDYA PEET ST CHUTTUGUNTA, MARUTHI NAGAR, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "VUYYURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OPP. DEEPAK MAHAL KATURU ROAD, BESIDE CARE HOSPITAL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHAVANI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SAI SARASWATHI NILAYAM,  SWATHI THEATER CROMBAAY ROAD, BHAVANI PURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ASHOKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:74-14-2, OLD CHECK POST CENTER, YANAMALAKUDURU LAKULA ROAD, KRISHNA NAGAR (ASHOK NAGAR), BESIDE COMMERCIAL TAX OFFICE, VIJAYAWADA-520007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "BHAVANIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:76-8\/6-5\/1,GUDIVADA RAMA RAO STREET,SWATHI THEATRE ROAD,BHAVANIPURAM,VIJAYAWADA-520012"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "CURRENCY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2ND LINE, OM NAMASHIVYA STREET, CURRENCY NAGAR,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "GOSALA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PUNADIPADU VILLAGE,KANKIPADU MANDAL,GOSALA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL GAYATHRI NAGAR,POLYCLINIC ROAD,NEAR BENZ CIRCLE,VIJAYAWADA 520008"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTL BEZAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:57-6-21\/2, ABC BUILDING, OLD POST OFFICE ROAD, BESIDE SONOVISION, PADAMATA, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KANCHIKACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.PRATAP TVS SHOW ROOM,KANCHIKACHERLA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KRISHNA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:-41-1\/8-42,GOWTHAMI NAGAR 3'RD LINE OPPOSITE AMERICAN HOSPITAL,KRISHNA LANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MARUTINAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:32-26-110\/124, SRI BHAVANI MANSION,MARUTINAGAR,ELURU ROAD,VIJAYAWADA 520004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MOGULRAJAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO36-12\/15\/2A,RAMARAO STREET,MADHU GARDEN,MOGULRAJAPURAM,VIJAYAWADA 520010"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "NUNNA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6-80, BESIDE BSNL TELEPHONE EXCHANGE, MAIN ROAD, NUNNA,VIJAYAWADA - 521212"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ONE TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:4-1-27, BANGARAIAH KOTTU CENTER,ONE TOWN,VIJAYAWADA KRISHNA (DT) 520009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PATAMATA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:40-12-3\/5, OPP:ASWINI ENCLAVE,SEETHARAMA NAGAR, PATAMATALANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PORANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-15-113,PRABHU NAGAR,PORANKI,VIJAYAWADA,KRISHNA 521137."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "S.N. PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR NO : 24-25-63,NEAR FOOD JUNCTION,OPP.RAILWAY QUARTERS,BRTS ROAD,DURGAPURAM,SATYANARAYANAPURAM,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SING NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO. 43-78-7 KRISHNA HOTEL CENTER, AJIT SING NAGAR, VIJAYAWADA-520015"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Visannapet",
     "Center": "VISANNAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, KUKKADAPU PRASAD COMPEX, BESIDE SURVEYNDICATE BANK, MAIN ROAD, VISANNAPETA 521215 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vuyyur",
     "Center": "VUYYUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :- 8-269, SRI CHAITANYA SCHOOL, ANU ARCADE BUILDING, BEHIND CARE HOSPITAL, KATURU ROAD, VUYYURU, KRISHNA (D.T) 521165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHEKURI GARDENS, NEAR NEW RTC BUS STAND,ADONI,KURNOOL 518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 21\/515\/9\/BCD\/1,AMBEDKAR NAGAR,REVENUE WARD-21,A.P.B.H COLONY,ADONI,518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Allagadda",
     "Center": "ALLAGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VISWARUPA NAGAR, ALLAGADDA,KURNOOL(DIST) 518543"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Alur",
     "Center": "ALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL LIC BACK SIDE,ALUR,KURNOOL 521329"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Atmakur",
     "Center": "ATMAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VENKATESWARA SWAMI TEMPLE,GAREEB NAGAR,ATMAKUR,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Banaganapalle",
     "Center": "BANAGANAPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL BANAGANAPALLI NEAR RTC BUS STOP ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Bethamcherla",
     "Center": "BETHAMCHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12TH WARD,DHONE ROAD, BETHAMCHERLA,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Dhone",
     "Center": "DHONE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VENKATANAINI PALLI ROAD,OPP ITI COLLEGE,DHONE,KURNOOL 518222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "SRI GURU RAGHAVENDRA BHAVAN BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,NH 40, OPPOSITE SAFA ENGINEERING COLLEGE, NEAR KRANTI GODOWN, B.THANDRAPADU, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,D.NO 40-304, BESIDE RR HOSPITAL, NEAR MOURYA INN, BHAGYA NAGAR, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL , D.NO:451 42\/13B-7 ,KAPPALA NAGAR,ROAD NO 4,VENKATA RAMANA COLONY LANE,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL VENKATADRI NAGAR, NERA RAILWAY GATE, KALLURU, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:40-321-1-F ,BESIDE OLD AYYAPPA SWAMY TEMPLE, BHASKAR NAGAR,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BESIDE OLD RAVI THEATER, CENTRAL PLAZA, NEAR VINAYAK GHAT, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE VIJAYA DURGA DEGREE COLLEGE, SRINAGA COLONY,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL KNL652,SRI CHAITANYASCHOOL, SANKHALBAGH,KURNOOL-518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO:46-156-D-1A,BUDHAWARAPET NEAR PADMA CHANDRA(OMNI) HOSPITAL, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VISWAK GARDEN, SOMISETTY FUNCTION HALL,SANKAL BAGH,KURNOOL 518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:6-68\/A,SC-COLONY, THANDRAPADU LAKE,OPP.SIVALAYAM,NANDYAL ROAD,KURNOOL518007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI RAMA NAGAR ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL CRR SECONDARY SCHOOL DINNEDEVARAPADU KURNOOL POST BOX NO :-8 ANANTHAPUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandikotkur",
     "Center": "NANDIKOTKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL MADDHUR NAGAR, BESIDE SRI RAMA THEATER, NANDIKOTKUR 518401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 25426-E BEHIND MUNCIPAL OFFICE NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRNIVASA NAGAR,TTD ROAD,OPP: RAITHUBAZAR,NANDYAL,KURNOOL 518502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO'S COLONY, NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SOWJANYA MOTORS,R.S ROAD,NANDYAL,KURNOOL(DIST),A.P"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 13\/71, RAMAKRISHNA NAGAR,KOILAKUNTLA ROAD, KANALA,NANDYAL. KURNOOL (DT)518493"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Pattikonda",
     "Center": "PATTIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 17\/177\/12\/1 YASHODA GARDEN SCHOOL YASHODA GARDEN NEAR RTC BUS STAND PATTIKONDA KURNOOL 518380"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Yemmiganur",
     "Center": "YEMMIGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GEETHA NAGAR, YEMMIGANUR, KURNOOL(DI),AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Buchireddypalem",
     "Center": "BUCHIREDDYPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP OLD RTC BUS STAND,BUCHIREDDYPALEM,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Gudur",
     "Center": "GUDUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANATH NAGAR,OPP Z.P GIRLS HIGH SCOOL,GUDUR,NELLORE 524101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PULLAREDDYNAGAR, BEHIND RSR KALYANA MANDAPAM, KAVALI,SPSR NELLORE DT 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALIKIVARI STREET , OLD TOWN , KAVALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANTHINAGAR KAVALI,SPSR NELLORE DT, 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kota",
     "Center": "KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SRINIVASA NAGAR,KOTA (MANDAL),NELLORE (DT) 524411"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kovvur",
     "Center": "KOVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE PANCHAYT OFFICE, KOTTUR RAMA MANDIRAM ROAD, MANDABAYALU CENTER, KOVUR,SPSR NELLORE (D.T) 524137"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Naidupet",
     "Center": "NAIDUPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL AGRAHARPETA, NEAR SAI BABA TEMPLE, NAIDUPET, SPSR NELLORE DIST 524126"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GAYATHRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VEDAYAPALEM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRI BHARATHI BOYS DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMALINGAPURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "UJWALA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, TIPPA RAJU VARI STREET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRIVANI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PAPPULA VEEDI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "ATMAKUR NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL TENKAYA THOPU,NEAR RAVITEJA KALYANAMANDAPAM ,ATMAKUR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GUPTA PARK",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12-4-294,BESIDE MODEL HIGH SCHOOL,NEAR GUPTHAPARK,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NAWABPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:SIVALAYAM, NARUKUR MAIN ROAD, NAWABPETA, NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ISKON CITY,KONDAYAPALEM,BACK SIDE BHARATH PERTROL PUMP, VANAMTHOPU, NELLORE 524004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SETTYGUNTA ROAD,LAKSHMI PURAM,VENGAMAMBA CENTRE,NAWABPETA,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SANTHAPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR SANTHAPET , NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "AC NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ADDALA SAI BABA TEMPLE,PULIMI PEDDA BUCHI REDDY NAGAR, AC NAGAR, NELLORE 524002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "BALAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAMJI NAGAR, 5TH LINE , BALAJI NAGAR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "MUTHUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO POST OFFICE,MUTHUKUR ,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP HDFC BANK ATM, DHANALAKSHMIPURAM, NELLORE524003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "PODALAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,CHAITANYA NAGAR,RAPUR ROAD,PODALAKUR (MANDAL),NELLORE (DT) 524345"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Sullurpet",
     "Center": "SULLURPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RR SUPER MARKET ,GNT ROAD , SULLURPET,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vedayapalem",
     "Center": "VEDAYAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANDHI NAGAR ,VEDAYAPALEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMMAVARIPETA, MUNICIPAL OFFICE ROAD, VENKATAGIRI,SPSR NELLORE DIST 524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DVS COMPLEX, RAJA STREET, VENKATAGIRI, SPSR NELLORE (DT)524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vinjamuru",
     "Center": "VINJAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE PRAJA VAIDHYASALA, NEAR RTC BUS STAND , VINJAMURU,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ANJANEYA SADAN ADDANKI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.31-419, 31-420, OIL MILL ROAD, ADDANKI - 523201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ADDANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUNGLOW ROAD,ADDANKI,PRAKASAM -523201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Chimakurthy",
     "Center": "CHIMAKURTHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDHI NAGAR 7TH LINE,CHIMAKURTHY ONGOLE 523226"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Darsi",
     "Center": "DARSI",
     "CenterAddress": "SRI CHAITANYA SCHOOL TEACHERSCOLONY,PODILI(ROAD),DARSI,PRAKASAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kandukur",
     "Center": "KANDUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA REDDY NAGER,KANDUKUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.JR COLLEGE,KANDUKUR ROAD,KANIGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUBHASH ROAD,KOTHA PET,KANIGIRI,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Markapuram",
     "Center": "MARKAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.8\/A-20 ,BODAPADU ROD ,OPPISITE RTC DEPO,MARKAPURAM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Martur",
     "Center": "MARTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. VIJAYALAKSHMI KALAYANA MADAPAM, NH-5 ROAD , MARTUR,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "SARASWATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MANGUMUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "CUMBUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.INDIAN PETROL BUNK,NEAR SBI BANK ,GIDDALUR ROAD,CUMBUM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHAGYA NAGAR 2ND LINE, BESIDE REGISTER OFFICE ,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP.HP GAS AGENCY,NEAR MARRI CHETTU,MANGAMUR DONKA ROAD,ONGOLE 523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL V.I.P. ROAD,MANGAMUR DONKA,ABOVE HDFC BANK,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MAHALAKSHMI TOWERS, 4TH LINE ,LAWYERPET,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Pamuru",
     "Center": "PAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.HP PETROL BUNK ,NELLORE ROAD,PAMURU,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Singarayakonda",
     "Center": "SINGARAYAKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE I.T.I COLLEGE,MULAGUNTAPADU(V),SINGARAYAKONDA(M) PRAKASAM DISTRICT 523101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-3,4&amp;5, BEHIND DEEPAMAHAL, SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "KAMAKSHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OLD NH-5 ROAD, OPP. HONDA SHOWROOM, PADMANABHAPURAM, KASIBUGGA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRIKAKULAM ROAD, NEAR AMRUTHA HOSPITAL, OPP. MAHENDRA SHOWROOM, RAJAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI NAGAR , NEAR DEO OFFICE,WOMENS COLLEGE ROAD,SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANGI SURYANARAYANA COLONY, NEAR AYYAPPA SWAMY TEMPLE, ADIVARAMPETA, CHAPURAM PANCHAYAT, PALAKONDA ROAD, SRIKAKULAM 532 001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "GOWRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 12-12-73, OLD BUS STAND ROAD, NEAR SHIRDI SAI THEATRE, ANAKAPALLI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "ANAKAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 80 FEET RING ROAD , OPP HEMA SEKHAR DEGREE COLLEGE, STATION ROAD, ANAKAPALLI,VISAKHAPATNAM -531001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Bobbili",
     "Center": "BOBBILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR CBM CHURCH , BALIJIPETA ROAD, BOBBILI,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Narsipatnam",
     "Center": "NARSIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2-101\/1, NEAR RTC COMPLEX , ANAKAPALLI ROAD, NARSIPATNAM-531116 VISAKHAPATNAM DIST."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Palasa",
     "Center": "PALASA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:14-1-279\/A,NEAR AYYAPPA SWAMY TEMPLE,OLD NH-5 ROAD,PADMANABHAPURAM,PALASA-KASIBUGGA,SRIKAKULAM DIST 532222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Parvathipuram",
     "Center": "PARVATHIPURAM",
     "CenterAddress": "SRI CHAITANAYA SCHOOL , OPP- SRI VENKATESWARA NURSHING HOME ,SUNDERNARAYANAPURAM COLONY , BELAGUM ,PARVATHIPURAM , VIZIANAGARAM ( DIST ) ."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Rajam",
     "Center": "RAJAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP ELECTRICAL SUB STATION, PONDURU ROAD, RAJAM, SRIKAKULAM (DIST) 532127"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN- II",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-48-6-16, SRI VIJAYA SAI TOWERS, OPP. RAMA TALKIES MAIN GATE, SRINAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRIPADA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-48-8-14, BEHIND KALANIKETHAN, NEAR BUDHIL PARK HOTEL, DWARAKANAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-58-22-50, NEAR NAD HOSPITAL, SUSARLA COLONY, BUTCHIRAJUPALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO 6-62-6\/1, NEAR GAJUWAKA POLICE STATION, SHRAMIK NAGAR, CHINAGANTYADA, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYSHNAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MIG 110, D.NO 24-3-1,BUDA COLONY,PEDAGANTYADA, GAJUWAKA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYDEHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, STEEL PLANT MAIN ROAD, UKKUNAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRISAI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 34\/2, PILAKAVANIPALEM, CARSHED JUNCTION, P.M PALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 10-12-8, OPP PYDAH DEGREE COLLEGE REDNAM GARDENS RAM NAGAR,ASILMETTA VISAKHAPATNAM -530002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 11-4-1\/1,UDAY SRI TOWERS, RAMNAGAR,ASILMETTA,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:26- 42-10\/2,BESIDE SRI CHAITANYA JUNIOR KALASALA,CHAITANYANAGAR,OLD GAJUWAKA,VISAKHAPATNAM-530026."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 27-1-65,SRINAGAR,GAJUWAKA,VISAKHAPATNAM,530026"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KOMMADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VIJAYA MOHAN LAYOUTS,NEAR CHAITANYA ENGG COLLEGE, KOMMADI VILLAGE,CHINAGADILI MD MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KURMANNAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 31\/6-3\/1 OPP. STEEL CITY APSRTC BUS DEPO SATHAVAHANANAGAR ROAD NO.6,MAINROAD KURMANNAPALEM, GAJUWAKA MANDAL VISAKHAPATNAM 530046"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: CMR GARDENS, MADHURAWADA , VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR FLY OVER BAKKANAPALEM ROAD, MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MVP COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-10-2\/4, USHA RESIDENCY, SECTOR-1,MVP COLONY, VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D.NO. 58-1-237, TEEGALA TOWERS, MARRIPALEM ROAD, NAD, VIZAG 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D-NO-58-15-116\/A, OPP GAJANANA FORT, SANTHI NAGAR, NAD ,VISAKHAPATNAM 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "PENDURTY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SBI, PULAGANIPALEM ROAD, PENDURTY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Yalamanchali",
     "Center": "YALAMANCHILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR FIRE STATION,RAMAKRISHNAPURAM, YELAMANCHILI,VISAKHAPATNAM-531055"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL, 100 FEET RING ROAD, DHARMAPUR, NEAR VENKATESWARA SWAMY TEMPLE, VIZIANAGARAM 535001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR NEAR BUS STOP,BOWDARA MAIN ROAD, VIZIANAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagarm",
     "Center": "VIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO-102,103,104, NAIDU COLONY, THOTA PALEM, VIZIANAGARM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Eluru",
     "Center": "COLLEGE - ELURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAIN CAMPUS- ELURU, MARGHADARSHI ROAD, NARASIMHA RAO PETA, ELURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Palakol",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS BRODIPET, BRODIPET BIPASS ROAD, PALAKOLLU, WEST GODAVARI - 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KRISHNAVENI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR RTC BUSTAND,BESIDE DWARAKA PETROL BUNK,KHAJA NAGAR,ANANTAPUR "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 8-74A, BESIDE HEAD POST OFFICE, NEAR ANDHRA BANK, ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR PAVAN GAS AGENCY, RTO OFFICE ROAD, HOUSING BOARD, ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,OPP.TATA SHOWROOM,KAKKALAPALLI,RUDRAMPETA BY PASS,ANANTHAPUR 515672"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KAMMA BHAVAN, OLD NIRMALA NURSING COLLEGE LAKSHMI SRINIVASA NAGAR ANANTAPUR-515004, "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OLD DPS SCHOOL ,OPPOSITE TATA SHOWROOM,HYDERABAD HIGH WAY PAMURAI VILLAGE ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTAPUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SAKSHI OFFICE,OPP: TATA MOTORS,RUDRAMPETA BY-PASS,ANANTAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEW REVENUE OFFICE BACKSIDE,RUDRAMPETA,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL, SURVEY NO.:149\/4, WARD NO.: 13, SHIRDI NAGAR, NEAR RTC BUS STAND,OPP. ANAND HOSPITAL ANANTAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.315-1B,WARD NO.28,L.P.NO.518\/85, SINGARAYANI COLONY,NEW REVENUE COLONY, ANANTAPURAMU 515001."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "ANANTHAPUR 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 10\/413,ADIMURTHY NAGAR,OPPOSITE DEVI NURSING HOME,NEAR SRI CHAITANYA JR COLLEGE ,ANANTHAPUR 515001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "GORANTLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2\/277 OPPSITE MARKET YARD KADIRI - HINDUPUR MAIN ROAD,BESIDE SPVM DEGREE COLLEGE GORANTLA (M&amp;V) ANANTAPUR DIST A.P - 515231"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Anantapur",
     "Center": "KALYANADURG",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO:-359\/1A, OPP GOVT HOSPITAL BELLARY ROAD, KALYANADURG, ANANTAPUR (DT) 515761"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:17\/1111, RAJENDRA NAGAR,NEAR VENKATESWARA SWAMY TEMPLE, POST OFFICE LINE, GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 4\/369, DMM GATE ROAD,NEAR PANDURANGA SWAMY TEMPLE,P&amp;T COLONY,GUNTAKAL,ANANTHAPUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Guntakal",
     "Center": "GUNTAKAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO. MAHENDRA FUNCTION HALL,TILAK NAGAR, GUNTAKAL515801"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 12-1-76\/G2, PALANI NAGAR, BESIDE RAJADHANI FUNCTION HALL, HINDUPUR,ANANTHAPUR - 515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Hindupur",
     "Center": "HINDUPUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO 26, SATYANARAYANA PETA MF ROAD, HINDUPUR, ANANTHAPUR-515201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kadiri",
     "Center": "KADIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO : 13\/13\/1\/C ,MADANAPALLI ROAD,OPPO.CHOWDESWARI TEMPLE,KADIRI,SATYA SAI DIST 515591"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Kothacheruvu",
     "Center": "KOTHACHERUVU",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 7\/196, PENUGONDA ROAD KOTHACHERUVU ANANTAPUR 515133"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Anantapur",
     "City": "Tadipatri",
     "Center": "TADIPATRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NETHAJI SCHOOL COMPOUND, BEHIND RICE MILL, KALAVAKATTA STREET, TADIPATRI, ANANTAPUR 515411 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Bangarupalyam",
     "Center": "BANGARUPALYAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL THAGGUVARIPALLI, BANGARUPALYAM,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chandragiri",
     "Center": "CHANDRAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VIJAY NAGAR COLONY,CANARA BANK ROAD,CHANDRAGIRI 517101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOR CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-10-199, TMR TOWER , GANDHI ROAD,OPPT LIC OFFICE, CHITTOOR,517001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.THAPOVANAM SCHOOL,TEACHERS COLONY,GREAMSPET,VELLORE ROAD,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL #27-515\/B,TELEPHONE COLONY ROAD,RAMNAGAR COLONY,CHITTOOR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "CHITTOOR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 28-1428, RAM NAGAR COLONY,CHITTOR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Chittoor",
     "Center": "MURUGANI PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO.22-978\/BB, KAMESHWAR NAGAR, MURUGANIPALLI, CHITTOOR,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalle",
     "Center": "SRI GANGA SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 3\/153-4-4-1, HOSPITAL BRANCH , BESIDE RTC BUS STAND,MADHANAPALLI-517325,ANNAMAIAH (D)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MALLIKARJUNA CIRCLE, COLLEGE ROAD, MADANAPALLI,CHITTOOR 517325 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Madanapalli",
     "Center": "MADANAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR.NO. III-145-6-12-4, PRASANTH NAGAR, BESIDE. SRI SIDDHARTHA JR. COLLEGE, MADANAPALLI,TIRUPATHI - 517325"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Palamaneru",
     "Center": "PALAMANERU",
     "CenterAddress": "SRI CHAITANYA SCHOOL GUDIYATHAM ROAD,SRI NAGAR COLONY,NEAR YSRCP PARTY OFFICE,PALAMANERU,TIRUPATHI 517408"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Piler",
     "Center": "PILER",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-421, LAKSHMI PURAM,PILER, CHITTOOR (DIST),TIRUPATHI 517214."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Punganur",
     "Center": "PUNGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR MPDO OFFICE, R.R KALYANA MANDAPAM,MBT ROAD,PUNGANUR-517247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL #12\/64\/1A,SWAMY STREET,PUTTUR,517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARAMESWARA MANGALAM,K.PALEM,PUTTUR ,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Puttur",
     "Center": "PUTTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALYANAPURAM,OPP.FIRE STATION, SWAMI STREET KN ROAD,PUTTUR 517583"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Renigunta",
     "Center": "RENIGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL VINAYAKA NAGAR, RENIGUNTA, TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-1-1988,JAYRAM RAO STREET,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 16\/550\/3,SRI RAM NAGAR COLONY,PANAGAL ROAD,OPP: SBI (ADB) BRANCH,SRIKALAHASTI. AP 517640"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Srikalahasti",
     "Center": "SRIKALAHASTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI LAKSHMI KAMAKSHI KALYANA MANDAPAM, OPP DARMARAJ TEMPLE,SRIKALAHASTI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "ANJANADRI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO: 2-16,TELECOM COLONY OTERU ROAD ,SRINIVASAPURAM ,TIRUPATHI-517503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "CURE CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:6-2-83, KT ROAD,NEAR AXIS BANK MAIN BRANCH TIRUPATI - 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN CAMPUS DAYS ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  DO; NO 25, GANDHI ROAD   MUNICIPAL COMPLEX  PIN NO; 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MAIN II CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 37 AGK BUILDING  GANDHI ROAD  TIRUPATHI PIN: 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  RC ROAD  EBSR COMPLEX NEAR  ANNAMAYYA CIRCLE TIRUPATI PIN CODE 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VEDAVYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DR NO:411\/2P    150 BY PASS ROAD, TIRUCHANOOR (V)  TIRUPATHI ( R)517503        "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VENKATADRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO: 8-171-1, NEW BALAJI COLONY, MR PALLI, TIRUPATHI PIN-517502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "AIR BY-PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL JAYA LAKSHMI COLONY, STV NAGAR, AIR BY PASS ROAD, NEAR PASSPORT OFFICE, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TARAKARAMA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP:A.G.STAFF QUARTERS,TARAKARAMANAGAR,PERUR,TIRUPATI(RURAL)571505"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "GS MADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 15-2-126\/A2 , BESIDE LAKSHMI NARAYANA SWAMY TEMPLE GSMADA STREET TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "KORALAGUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 20-2--478\/A2,MARUTHINAGAR,KORLAGUNTA,TIRUPATI-517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "MR PALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT:26 NEW MARUTHI NAGAR, AIR BY PASS ROAD,MR PALLI,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "SRINIVASAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL TELECOM COLONY, SRINIVASAPURAM, TIRUPATI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUMALA BY PASS",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO:18-1-7\/10, BESIDE PAI VICROY HOTEL, RAMA CHANDRA NAGAR, TIRUMALA BY PASS,TIRUPATHI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI GIRLS RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL #10-128\/6-9 NETHAJI NAGAR P G N TOWER TIRUCHANUR TIRUPATI PIN:517507"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TIRUPATHI IPL",
     "CenterAddress": "SRI CHAITANYA SCHOOL IPL BRANCH,BAIRAGIPATTEDA, NEAR RIMS,TIRUPATHI 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "TSN PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR. NO. 20-3-131\/1A, SIVA JYOTHI NAGAR, SATHYANARAYANAPURAM, OPPOSITE SRIVARI SANNIDHI, BACK SIDE STREET SBI EXECUTIVE GUEST HOUSE, TIRUPATHI, CHITTOOR DISTRICT, AP 517501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Tirupathi",
     "Center": "VIKAS CAMPUS",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANA PALLY ROAD, THIRUCHNOR, THIRUPATHI "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Chittoor",
     "City": "Venkatagirikota",
     "Center": "V KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHOWDEPALLE ROAD, VKOTA,TIRUPATHI 517424"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "SRI SHIRDI SAI CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SHIRDI SAI CAMPUS #1-5-58\/2A ONGC BYPASS ROAD, SAVARAM AMALAPURAM- 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MSN COMPLEX, MAIN ROAD, AMALAPURAM, EAST GODAVARI DIST, 533201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Amalapuram",
     "Center": "AMALAPURAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :I 1-72 ,BACKSIDE OF VL HEIGHTS,ABBIREDDY CANAL BRIDGE,KONKAPALLI,AMALAPURAM,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Anaparthi",
     "Center": "ANAPARTHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 13-37, CANAL ROAD,AYYAPPA TEMPLE ,KOTHURU TURNING,ANAPARTHI,ANAPARTHI (MD), RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimadole",
     "Center": "BHIMADOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:10-116,OPP. FIRE STATION,ELURU, RAJAHMUNDRY ROAD,BHIMADOLE,WEST GODAVARI 534425"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL,PLOT NO:6-126,SRI RAMA KUSUMA PLAZA,NEAR NATARAJ THEATER,CHINNAMIRAM,JP ROAD, PALAKODERU (M), W.G(DT)534210"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Bhimavaram",
     "Center": "BHIMAVARAM-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE DUPLEX COLONY CHINNAMIRAM,BHIMAVARAM,RAJAHMUNDRY 534204"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Chintalapudi",
     "Center": "CHINTALAPUDI",
     "CenterAddress": "SRI CHAITANYA SCHOOL ABOVE UNION BANK,SRINIDI COMPLEX,ELURU ROAD,CHINTALAPUDI,RAJAHMUNDRY 534460"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Devarapalli",
     "Center": "DEVARAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP:VEGETABLE MARKET, ELURU ROAD, DEVARAPALLI RAJAHMUNDRY 534313"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "SCHOOL - ELURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHALAPATHI TOWERS,4TH LINE ,SANTHI NAGAR ,ELURU,PIN CODE:534007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARVATHA VARDHINI COMPLEX , NEAR MAHATHMA GANDHI STATUE, VIDYANAGAR , ELURU. W.G.(DT) 534003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Eluru",
     "Center": "ELURU-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 7-179\/2,NEAR GANGANAMMA TEMPLE,BALAJI NAGAR, CHATAPARRU ROAD, ELURU-534001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ganapavaram",
     "Center": "GANAPAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NIDAMARRU MANDEL,BHAVIPALEM POST, GANAPAVARAM,RAJAHMUNDRY 534198"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Hanuman Junction",
     "Center": "HANUMAN JUNCTION",
     "CenterAddress": "SRI CHAITANYA SCHOOL KEPINIDI TOWERS, NUZVID ROAD,NEAR FLYOVER, HANUMANJUNCTION WEST GODAVARI 521105"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jaggampeta",
     "Center": "JAGGAMPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRISHNAVENI THEATOR , BALAJI CENTER , JAGGAMPETA, EAST GODAVARI 533435"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Jangareddygudem",
     "Center": "JANGAREDDYGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :16-1-120, BESIDE M.R.OOFFICE,MANDAVALLI ESTATE, ASWARAOPETA ROAD, JANGAREDDYGUDEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kaikalur",
     "Center": "KAIKALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: FCI GODOWNS, BESIDE RELIANCE PETROL, ATAPAKA, KAIKALUR-521333"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "RAMAN BHAVAN 1 SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOWDHAM, #3-16A-101, LAKSHMINARAYANA NAGAR,KAKINADA -533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL #3-16B-4, OLD RTO OFFICE ROAD, NEAR MOTHER TERESA STATUE,SANTHI NAGAR, KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPOSITE BMC CHURCH SANTHI NAGAR KAKINADA - 533003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.9-16,SRINIVASA COLONY, RAMANAYYAPETA, KAKINADA RURAL-533005, EAST GODAVARI DISTRICT, ANDHRA PRADESH"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO1-1111, JANA CHAITANYA LAYOUT NEAR JEWEL MEDOWS,SARPAVARAM,KAKINADA RURAL 533005"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kakinada",
     "Center": "KAKINADA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-5-43\/1,NAGESWARARAO STREET,RAMARAO PETA,KAKINADA-533003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Kovvur",
     "Center": "KOVVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP PMMM GOVT HIGH SCHOOL,BESIDE YUVRAJ FUNCTION HALL, NANDAMURU ROAD, KOVVUR, WEST GODAVARI 534350"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Mandapet",
     "Center": "MANDAPETA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAIN ROAD ,NEAR HP BUNK ,TAPESWARAM,MANDAPETA,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Nagaram",
     "Center": "NAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD HAVENS CAMPUS, MAIN ROAD, NAGARAM 533247"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Narsapur",
     "Center": "NARSAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KARTHIKEYA NAGAR,21ST WARD,PEECHUPALEM ROAD,NARSAPURAM ,WEST GODAVARI (DT),A.P 534275"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL BRODIPET 2ND STREET, BYPASS ROAD, RAJUGARI BUILDING, PALAKOL, W.G.DT 534260"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Palakol",
     "Center": "PALAKOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR AXIS BANK ,OPP.AMBEDKAR STATUE POOLAPALLI , PALAKOL , WEST GDHAVARI DIST"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Payakaraopeta",
     "Center": "PAYAKARAOPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL Y JUNCTION,NEAR GOVT HOSPITAL,PAYAKARAOPETA,KAKINADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Penugonda",
     "Center": "PENUGONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:31-112, OPPOSITE PALACE THEATER, SIDDHANTHAM ROAD, PENUGONDA, AP 534320"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Pitapuram",
     "Center": "PITAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PADA GAYA TEMPLE, BYPASS ROAD, PITHAPURAM,RAJAJMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARASWATHI SOUDHAM",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 85-6-15\/1,ROUTHU PLAZA, VL PURAM,RAJAMAHENDRAVARAM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SARVANI TOWERS",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE, D.NO:75-1-4,PRAKASH NAGAR, RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO: 14-137\/A,OPP RTC COMPLEX,BEHIND UNION BANK, RAJAMAHENDRAVARAM - 533 103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "SRI VYBHAVI",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:78-10-7,SYAMALA NAGAR , BESIDE GOVINDURAJULU HOSPITAL,RAJAMAHENDRAVARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "KOVVURU",
     "CenterAddress": "SRI CHAITANYA JUNIOR COLLEGE D.NO:4-177,VEMULURU ROAD,KOVVURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL H. NO : 89-17 21\/1,MORAMPUDI ROAD, MORAMPUDI - KESAVARAM ROAD, SRI SAI CHAITANYA NAGAR, RAJAHMUNDRY, ANDHRA PRADESH 533107"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO11-11-1,OPPOSITE FIRE STATION,ARYAPURAM,RAJAHMUNDRY,EAST GODAVARI (DT) 533103"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO-74-6-54, NEAR T T D KALYANA MANDAPAM,OPP SWATANTRA KUMAR CHURCH,PRAKESH NAGAR,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:17-12\/8\/1,KRISHNA NAGAR,SEETAM PETA,NEAR SATYAM GARI RICE SHOP,RAJAHMUNDRY,EAST GODAVARI (DT)533104"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "RAJAHMUNDRY 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:4-699\/1, BESIDE BEEJAPURI TOWNSHIP, SRIRAMPURAM ROAD, DIWANCHERUVU, RAJANAGARAM MANDAM, EAST GODAVARI, ANDHRAPRADESH - 533296"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajahmundry",
     "Center": "THE PARK INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:89-17-1\/21 CHAITANYA NAGAR, MORAMPUDI ROAD ,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Rajole",
     "Center": "RAJOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL(PS) EM SCHOOL,OPP. ANNAPURNA THEATER, MOGALIKUDURU,RAJOLE,RAJAHUMUNDRY 533249"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ramachandrapuram",
     "Center": "RAMACHANDRAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:5-282\/1,SRI CHAITANYA SCHOOL-RAMACHANDRAPURAM, SRINAGAR, OPPOSITE VSM ENGINEERING COLLEGE RAMACHANDRAPURAM,PASALAPUDI BRANCH, ANDHRAPRADESH - 533255"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Ravulapalem",
     "Center": "RAVULAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR ANKALAMMA TEMPLE,UBALANKA ROAD,RAVULAPALEM ,EAST GODAVARI DIST 533238"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Razole",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #9-60\/1,OPP.RTC COMPLEX, RAZOLE-533242"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Sakhinetipalli",
     "Center": "SAKHINETIPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, ANTARVEDI PALEM, BESIDE INDIAN OIL PETROL BUNK,SAKHINETIPALLI MANDAL,E G DIST-533252"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO.CWC GUDEM,NALLAGERLA ROAD,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tadepalligudem",
     "Center": "TADEPALLIGUDEM CBSE",
     "CenterAddress": "SRI CHAITANYA OLYMPIAD SCHOOL,VASAVI IDEAL PUBLIC SCHOOL BUILDING,CHINNATADEPALLI,KADIYADDA POST,TADEPALLIGUDEM 534101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU",
     "CenterAddress": "SRI CHAITANYA SCHOOL,IKEA NAGAR,NH-16,TANUKU,WG.DIST,534211"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tanuku",
     "Center": "TANUKU 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR PETROL BUNK,VISHNU PRIYANAGAR ,TANUKU VELPURU 534222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS #3-41-8\/4, SRIRAM NAGAR, MR PETA, TUNI- 533401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL DURGADAS STREET,OPPOSITE SURESH KUMAR HOSPITAL, KOTHA PETA, TUNI, RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Tuni",
     "Center": "TUNI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:3-41-8\/4, SAI NAGAR, MR PETA,TUNI,RAJAHMUNDRY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "SUNKARAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUEU,KV NAGAR, YANAM, 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yanam",
     "Center": "YANAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR YSR STATUE, DRAKSHARAMA ROAD, VIA YANAM, SUNKARAPALEM 533464"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "East Godavari",
     "City": "Yeleswaram",
     "Center": "YELESWARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 3-377\/1, NEAR RAJULA BABU TEMPLE, LINGAMPATHY ROAD,YELESWARAM ,RAJAHMUNDRY,AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Amaravathi",
     "Center": "AMARAVATHI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NEAR MUSEUM ROAD,AMARAVATHI ,GUNTUR 522020 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "SARASWATHI SOUDHAM BAPATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.94\/1, VIJAYALAKSHMI PURAM, BAPATLA - 522101."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO: 8-3-8, OPP OLD MAA CABLE, OFFICE, BHIMAVARIPALEM, BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Bapatla",
     "Center": "BAPATLA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO -4-10-139\/1SRINIVAS NAGAR COLONY,BAPATLA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripet",
     "Center": "SIDDHARTHA CAMPUS CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.25-367 &amp; 25-367\/1, NEAR R.V.S. HIGH SCHOOL, CHILAKALURIPET - 522616."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GUNDABOLU RAMACHANDRA HOSPITAL, SUBBAIAH THOTA, CHILAKALURIPET GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chilakaluripeta",
     "Center": "CHILAKALURIPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL OLD DRN SCVS JR.COLLEGE BUILDING,NSP OFFICE, NARSARAOPET ROAD, CHILAKALURIPET,GUNTUR 522616"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Chirala",
     "Center": "CHIRALA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,NALLA PANENI TOWERS, OPP MARGADHARSI CHIT FUNDS PVT.LTD,MUNTHAVARICENTER,CHIRALA 523165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Dachepalli",
     "Center": "DACHEPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR KRANTHI NURSING HOME,NARAYANAPURAM,DACHEPALLI(MD)GUNTUR(DT)-522414"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "CHAITANYA LAKSHMI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.22-4-47, TITANIC SHOW ROOM UPSTAIRS, NEAR OLD BUS STAND, LALAPET, GUNTUR - 522003."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "ICON CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.5-89-9, 3RD LINE, LAKSHMIPURAM, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "AVANTHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.589-11\/5, 1ST LINE, CHANDRAMOULI NAGAR, GUNTUR - 522007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR NAYAR HOTEL CENTER, OPP. CENTRO, LAKSHMIPURAM MAIN ROAD, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR PRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NAYAR HOTEL CENTER, LAKSHMIPURAM MAIN ROAD, BESIDE WOODLAND, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "GUNTUR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHATMA GANDHI 80FEET INNER RING ROAD, REDDYPALEM, GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "INTERNATIONAL SCHOOL WHITEHOUSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NAVABHARAT NAGAR, 4TH LANE,MAHA LAKSHMI TOWERS OPP. CHALAPATHI GROUNDS GUNTUR 522006"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "NEHRU NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL BUCHAITHOTA 1ST LINE,OPP VIJAYAWADA RAILWAY TRACK, NEHRU NAGAR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "REDDYPALEM DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL INNER RING ROAD REDYYPALEM ,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Guntur",
     "Center": "SYAMALA NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEYAMALA NAGAR, ZERO LINE,NEAR ARMY CANTEEN,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Macherla",
     "Center": "MACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 13TH WARD, R&amp;B BUNGLOW BACK SIDE, NEAR PALAMARA ,MACHERLA GUNTUR (D.T) 522426"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Mangalagiri",
     "Center": "COLLEGE - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,  D.NO.7-426 &amp; 7-426\/A, TIPPARLA BAZAR, MANGALAGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Nagaralu",
     "Center": "NAGARALU",
     "CenterAddress": "SRI CHAITANYA SCHOOL ,TELECOME NAGAR 2ND LINE,AMARAVATHI ROAD, NEAR TAGORE RICE MILL,NAGARALU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARASARAOPET RAMANUJAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.11-23-1, RAMIREDDY PET, NARASARAOPET - 522601."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO:11-14-1\/1,RAMIREDDYPET,BANK COLONY,NARASARAOPET,GUNTUR."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA CENTER ,SATTENAPALLI ROAD, OPP MAHALAKSHMAMMA CHETTU,NARSARAOPET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Narasaraopet",
     "Center": "NARSARAOPET 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 60 FEET ROAD , PRAKASH NAGAR NARASAOPET,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "GAUTAMA BUDDHA BHAVAN PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.416\/B, KOTAIAH SASTRY BAZAR, PIDUGURALLA - 522413."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Piduguralla",
     "Center": "PIDUGURALLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 7-703\/A ABBUBAKAR MUSEED STREET OPP AXIS BANK PIDUGURALLA,GUNTUR - 522413"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Ponnur",
     "Center": "PONNUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GBC ROAD, PONNUR,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Repalle",
     "Center": "PARAMESWARA SADAN REPALLE",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.9-35-210 &amp; 9-35-210\/1, UPPUDI ROAD, REPALLE - 522265."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHINA MAJID CENTER,SBI ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 5-8-8, NAGARJUNA NAGAR,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Sattenapalli",
     "Center": "SATTENAPALLI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL PARK ROAD,SATTENAPALLI,GUNTUR 522403"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "VYAS BHAVAN TENALI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.2-1-74, GANDHI NAGAR, RATNA TALKIES CENTRE, TENALI - 522201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANGANAMMA PET, TENALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR-NO-21-1-60\/1, DEVI CHOWK, RAMALINGESWARAPET,TENALI,GUNTUR-522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR UMESH CHANDRA STATUE,CHENCHUPET,TENALI,GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Tenali",
     "Center": "TENALI-2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP: GOVERNMENT VETERINERY HOSPITAL ,BURRIPALEM ROAD,TENALI 522201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Guntur",
     "City": "Vinukonda",
     "Center": "VINUKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE CURRENT OFFICE, KARAMPUDI ROAD, VINUKONDA GUNTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Badwel",
     "Center": "BADWEL",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDLA STREET,PORUMAMILLA ROAD,BADWEL,KADAPA 516227"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI BALAJI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, DONO:1-399 MARUTHI NAGAR, BESIDE KADAPA CAFÉ, KOTIREDDY CIRCLE KADAPA-516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "SRI SAI SADHAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO:42\/609-28, NGOS COLONY, APASARA CIRCLE , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,KEERTHI PARK VIEW,OPP RAJIV PARK,MARUTHI NAGAR,KADAPA 516001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMBHA BHAVANI TEMPLE,NEAR BUILTUP, KADAPA."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR NEHRU PARK,CO-OPRATIVE COLONY,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL ARP COLONY, PRAKASH NAGAR , KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL 101\/257-2 RIMS BYPASS ROAD KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUGGA VANKA PROJECT ROAD,NEAR SWAMY NAGAR,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL #97\/217-8,NEAR RTO OFFICE,YSR CIRCLE,C.K.DINNE,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:CHINNACHOWK POLICE STATION,NEHRUNAGAR,KADAPA 516002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Kadapa",
     "Center": "KADAPA 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAYACHOTI RING ROAD,VUTKUR CIRCLE,KADAPA 516003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Porumamilla",
     "Center": "PORUMAMILLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL DESAI MAHAL BACK SIDE,NEAR APSRTC BUSSTAND,PORUMAMILLA(V)KADAPA(DT)AP-516193"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ARAVINDA ASHRAMAM, YMR COLONY , PRODDUTUR, Y.S.R KADAPA(DIST) 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL YERRAGUNTLA BY PASS ROAD, NEAR CINE HUB,PRODDATUR,KADAPA 516360"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL BACKSIDE HONDA SHOWROOM,KVR COLONY,MYDUKUR ROAD,PRODDUTUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Proddutur",
     "Center": "PRODDUTUR 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BOLLAVARAM NEAR GOLDEN PARK JAMMALAMADUGU BYPASS ROAD PRODDATUR, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Pulivendula ",
     "Center": "PULIVENDULA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT 70, BESIDE RTO OFFICE, MUDDANURU ROAD ,PULIVENDULA,KADAPA 516390"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHUVANAGIRI PALLI,RAJAMPET,KADAPA 516115"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rajampet",
     "Center": "RAJAMPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL R.S.ROAD, RAJAMPET, KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO COLONY,KOTHAPETA,RAYACHOTI,KADAPA 516269"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 430 BESIDE PREETHAM RESIDENCY,RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 5\/283,NEAR BY ICDS OFFICE, BESIDE VINAYAKA TEMPLE, SUNDEPALLI ROAD, RAJULA COLONY RAYACHOTI 516269 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kadapa",
     "City": "Rayachoti",
     "Center": "RAYACHOTI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL KRISHNA REDDY NAGAR,MADANAPALLI ROAD RAYACHOTI,KADAPA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Avaniggadda",
     "Center": "AVANIGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5TH WARD, NEAR SANTHA MARKET AVANIGADDA,VIJYAWADA KRISHNA (DT)"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Challapalli",
     "Center": "CHALLAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL CLUB ROAD, RAMANAGARAM(VILLAGE),CHALLAPALLI(MANDAL), KRISHNA (DIST),521126."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gannavaram",
     "Center": "GANNAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GNT ROAD ,KOTHAPETA,GANNAVARAM,VIJAYAWADA 521101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "COLLEGE - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 8\/191, SRI RAM PURAM COLONY, OLD CURRENT OFFICE, BESIDE FISH MARKET ROAD, SATYANARAYANA PURAM, GUDIVADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Gudivada",
     "Center": "SCHOOL - GUDIVADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:10\/153, RAJENDRA NAGAR 1ST LINE, GUDIVADA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Ibrahimpatnam",
     "Center": "IBRAHIMPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR STATE BANK OF INDIA,OPP-MANDALAM OFFICE ,V.T.P.S ROAD,IBRAHIMPATNAM,KRISHNA (DT)521456"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Jaggaiahpet",
     "Center": "JAGGAIAHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: YOGIRAMA HOSPITAL, UMA GOPAL COMPLEX,JAGGAIAHPET,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Kankipadu",
     "Center": "KANKIPADU DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE TVS SHOW ROOM,BANDAR ROAD,KANKIPADU,VIJAYAWADA 521151"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "COLLEGE - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMANAIDU PETA, SHAIK IMAM STREET, MACHILIPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Machilipatnam",
     "Center": "SCHOOL - MACHILIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO : 21\/478, SRI CHAITANYA SCHOOL, SAI BABA TEMPLE ROAD, BHASKARAPURAM , MACHILIPATNAM , KRISHNA(DIST), AP 521001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "SCHOOL - MANGALAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D. NO 1-816, NEAR HEAD POST OFFICE, MANGALAGIRI VIJAYAWADA 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO 5-470,WARD NO.5,TENALI ROAD,NEAR MARKANDEYA KALYANA MANDAPAM,ABOVE ICICI BANK,MANGALAGIRI 522 503"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 14-271\/1, CHAIATANYA THOPAVANAM ASHRAMAM, KRISHNA NAGAR, TADEPALLI ,MANGALAGIRI - 522501"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mangalagiri",
     "Center": "MANGALAGIRI-5",
     "CenterAddress": "SRI CHAITANYA SCHOOL SHAROFF BAZAR, VADLAPUDI CENTER,MANGALAGIRI,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Mylavaram",
     "Center": "MYLAVARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:-2-58,BESIDE NARAYANA THEATER , MYLAVARAM MYLAVARAM(M.D)KRISHNA (D.T)-521230 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nandigama",
     "Center": "NANDIGAMA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP VARUN BAJAJ , RAITHUPETA,NANDIGAMA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Nuzvidu",
     "Center": "NUZVIDU",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHERUKURI COMPLEX, BEHIND HERO HONDA SHOW ROOM, H.JUNCTION ROAD, NUZVIDU, KRISHNA (DT) 521201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Penuganchiprolu",
     "Center": "PENUGANCHIPROLU",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-1,MAKKAPET ROAD,PENUGANCHIPROLU,KRISHNA-521191.AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Repalle",
     "Center": "REPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RAJYA LAKSMI THEATRE,OLD STATE BANK COMPOUND,REPALLE 522265"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Tiruvuru",
     "Center": "TIRUVURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP NAGARJUNA COLLEGE, BOSU BOMMA CENTERE, TIRUVURU VIJAYAWADA 521235"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INDRA TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, USHA LAND MARK, OPP. M&amp;M SHOWROOM, MG ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MAHESWARA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAHESWARA BHAVAN, OPP. HDFC BANK, MG ROAD "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ESWARI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KRISHNAVENI CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SHEDS CAMPUS, BESIDE EENADU OFFICE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "RABINDRANATH TAGORE BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO. 32-27-9\/1, SARVODAYA VIDYA PEET ST CHUTTUGUNTA, MARUTHI NAGAR, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "VUYYURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OPP. DEEPAK MAHAL KATURU ROAD, BESIDE CARE HOSPITAL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SRI BHAVANI NILAYAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI SAI SARASWATHI NILAYAM,  SWATHI THEATER CROMBAAY ROAD, BHAVANI PURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ASHOKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:74-14-2, OLD CHECK POST CENTER, YANAMALAKUDURU LAKULA ROAD, KRISHNA NAGAR (ASHOK NAGAR), BESIDE COMMERCIAL TAX OFFICE, VIJAYAWADA-520007."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "BHAVANIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DNO:76-8\/6-5\/1,GUDIVADA RAMA RAO STREET,SWATHI THEATRE ROAD,BHAVANIPURAM,VIJAYAWADA-520012"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "CURRENCY NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2ND LINE, OM NAMASHIVYA STREET, CURRENCY NAGAR,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "GOSALA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PUNADIPADU VILLAGE,KANKIPADU MANDAL,GOSALA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTERNATIONAL SCHOOL",
     "CenterAddress": "SRI CHAITANYA SCHOOL GAYATHRI NAGAR,POLYCLINIC ROAD,NEAR BENZ CIRCLE,VIJAYAWADA 520008"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "INTL BEZAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:57-6-21\/2, ABC BUILDING, OLD POST OFFICE ROAD, BESIDE SONOVISION, PADAMATA, VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KANCHIKACHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.PRATAP TVS SHOW ROOM,KANCHIKACHERLA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "KRISHNA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:-41-1\/8-42,GOWTHAMI NAGAR 3'RD LINE OPPOSITE AMERICAN HOSPITAL,KRISHNA LANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MARUTINAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:32-26-110\/124, SRI BHAVANI MANSION,MARUTINAGAR,ELURU ROAD,VIJAYAWADA 520004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "MOGULRAJAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO36-12\/15\/2A,RAMARAO STREET,MADHU GARDEN,MOGULRAJAPURAM,VIJAYAWADA 520010"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "NUNNA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 6-80, BESIDE BSNL TELEPHONE EXCHANGE, MAIN ROAD, NUNNA,VIJAYAWADA - 521212"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "ONE TOWN",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:4-1-27, BANGARAIAH KOTTU CENTER,ONE TOWN,VIJAYAWADA KRISHNA (DT) 520009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PATAMATA LANKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:40-12-3\/5, OPP:ASWINI ENCLAVE,SEETHARAMA NAGAR, PATAMATALANKA,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "PORANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO-15-113,PRABHU NAGAR,PORANKI,VIJAYAWADA,KRISHNA 521137."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "S.N. PURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DR NO : 24-25-63,NEAR FOOD JUNCTION,OPP.RAILWAY QUARTERS,BRTS ROAD,DURGAPURAM,SATYANARAYANAPURAM,VIJAYAWADA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vijayawada",
     "Center": "SING NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO. 43-78-7 KRISHNA HOTEL CENTER, AJIT SING NAGAR, VIJAYAWADA-520015"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Visannapet",
     "Center": "VISANNAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL, KUKKADAPU PRASAD COMPEX, BESIDE SURVEYNDICATE BANK, MAIN ROAD, VISANNAPETA 521215 "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Krishna",
     "City": "Vuyyur",
     "Center": "VUYYUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO :- 8-269, SRI CHAITANYA SCHOOL, ANU ARCADE BUILDING, BEHIND CARE HOSPITAL, KATURU ROAD, VUYYURU, KRISHNA (D.T) 521165"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, CHEKURI GARDENS, NEAR NEW RTC BUS STAND,ADONI,KURNOOL 518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Adoni",
     "Center": "ADONI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 21\/515\/9\/BCD\/1,AMBEDKAR NAGAR,REVENUE WARD-21,A.P.B.H COLONY,ADONI,518301"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Allagadda",
     "Center": "ALLAGADDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VISWARUPA NAGAR, ALLAGADDA,KURNOOL(DIST) 518543"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Alur",
     "Center": "ALUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL LIC BACK SIDE,ALUR,KURNOOL 521329"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Atmakur",
     "Center": "ATMAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VENKATESWARA SWAMI TEMPLE,GAREEB NAGAR,ATMAKUR,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Banaganapalle",
     "Center": "BANAGANAPALLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL BANAGANAPALLI NEAR RTC BUS STOP ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Bethamcherla",
     "Center": "BETHAMCHERLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12TH WARD,DHONE ROAD, BETHAMCHERLA,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Dhone",
     "Center": "DHONE",
     "CenterAddress": "SRI CHAITANYA SCHOOL,VENKATANAINI PALLI ROAD,OPP ITI COLLEGE,DHONE,KURNOOL 518222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "SRI GURU RAGHAVENDRA BHAVAN BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,NH 40, OPPOSITE SAFA ENGINEERING COLLEGE, NEAR KRANTI GODOWN, B.THANDRAPADU, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE,D.NO 40-304, BESIDE RR HOSPITAL, NEAR MOURYA INN, BHAGYA NAGAR, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 1",
     "CenterAddress": "SRI CHAITANYA SCHOOL , D.NO:451 42\/13B-7 ,KAPPALA NAGAR,ROAD NO 4,VENKATA RAMANA COLONY LANE,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 10",
     "CenterAddress": "SRI CHAITANYA SCHOOL VENKATADRI NAGAR, NERA RAILWAY GATE, KALLURU, KURNOOL 518002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL,D.NO:40-321-1-F ,BESIDE OLD AYYAPPA SWAMY TEMPLE, BHASKAR NAGAR,KURNOOL 518003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BESIDE OLD RAVI THEATER, CENTRAL PLAZA, NEAR VINAYAK GHAT, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE VIJAYA DURGA DEGREE COLLEGE, SRINAGA COLONY,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL KNL652,SRI CHAITANYASCHOOL, SANKHALBAGH,KURNOOL-518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 6",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO:46-156-D-1A,BUDHAWARAPET NEAR PADMA CHANDRA(OMNI) HOSPITAL, KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 7",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR VISWAK GARDEN, SOMISETTY FUNCTION HALL,SANKAL BAGH,KURNOOL 518001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 8",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:6-68\/A,SC-COLONY, THANDRAPADU LAKE,OPP.SIVALAYAM,NANDYAL ROAD,KURNOOL518007"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL 9",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRI RAMA NAGAR ,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Kurnool",
     "Center": "KURNOOL CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL CRR SECONDARY SCHOOL DINNEDEVARAPADU KURNOOL POST BOX NO :-8 ANANTHAPUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandikotkur",
     "Center": "NANDIKOTKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL MADDHUR NAGAR, BESIDE SRI RAMA THEATER, NANDIKOTKUR 518401"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL 25426-E BEHIND MUNCIPAL OFFICE NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SRNIVASA NAGAR,TTD ROAD,OPP: RAITHUBAZAR,NANDYAL,KURNOOL 518502"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL NGO'S COLONY, NANDYAL,KURNOOL"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SOWJANYA MOTORS,R.S ROAD,NANDYAL,KURNOOL(DIST),A.P"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Nandyal",
     "Center": "NANDYAL 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO : 13\/71, RAMAKRISHNA NAGAR,KOILAKUNTLA ROAD, KANALA,NANDYAL. KURNOOL (DT)518493"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Pattikonda",
     "Center": "PATTIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL 17\/177\/12\/1 YASHODA GARDEN SCHOOL YASHODA GARDEN NEAR RTC BUS STAND PATTIKONDA KURNOOL 518380"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Kurnool",
     "City": "Yemmiganur",
     "Center": "YEMMIGANUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL GEETHA NAGAR, YEMMIGANUR, KURNOOL(DI),AP"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Buchireddypalem",
     "Center": "BUCHIREDDYPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP OLD RTC BUS STAND,BUCHIREDDYPALEM,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Gudur",
     "Center": "GUDUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANATH NAGAR,OPP Z.P GIRLS HIGH SCOOL,GUDUR,NELLORE 524101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI",
     "CenterAddress": "SRI CHAITANYA SCHOOL PULLAREDDYNAGAR, BEHIND RSR KALYANA MANDAPAM, KAVALI,SPSR NELLORE DT 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KALIKIVARI STREET , OLD TOWN , KAVALI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kavali",
     "Center": "KAVALI 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANTHINAGAR KAVALI,SPSR NELLORE DT, 524201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kota",
     "Center": "KOTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SRINIVASA NAGAR,KOTA (MANDAL),NELLORE (DT) 524411"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Kovvur",
     "Center": "KOVUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, BESIDE PANCHAYT OFFICE, KOTTUR RAMA MANDIRAM ROAD, MANDABAYALU CENTER, KOVUR,SPSR NELLORE (D.T) 524137"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Naidupet",
     "Center": "NAIDUPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL AGRAHARPETA, NEAR SAI BABA TEMPLE, NAIDUPET, SPSR NELLORE DIST 524126"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GAYATHRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VEDAYAPALEM "
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRI BHARATHI BOYS DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMALINGAPURAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "UJWALA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, TIPPA RAJU VARI STREET"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SRIVANI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PAPPULA VEEDI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "ATMAKUR NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL TENKAYA THOPU,NEAR RAVITEJA KALYANAMANDAPAM ,ATMAKUR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "GUPTA PARK",
     "CenterAddress": "SRI CHAITANYA SCHOOL 12-4-294,BESIDE MODEL HIGH SCHOOL,NEAR GUPTHAPARK,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NAWABPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP:SIVALAYAM, NARUKUR MAIN ROAD, NAWABPETA, NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE",
     "CenterAddress": "SRI CHAITANYA SCHOOL ISKON CITY,KONDAYAPALEM,BACK SIDE BHARATH PERTROL PUMP, VANAMTHOPU, NELLORE 524004"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SETTYGUNTA ROAD,LAKSHMI PURAM,VENGAMAMBA CENTRE,NAWABPETA,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "SANTHAPETA",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR SANTHAPET , NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "AC NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR ADDALA SAI BABA TEMPLE,PULIMI PEDDA BUCHI REDDY NAGAR, AC NAGAR, NELLORE 524002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "BALAJI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL RAMJI NAGAR, 5TH LINE , BALAJI NAGAR NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "MUTHUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPPO POST OFFICE,MUTHUKUR ,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "NELLORE RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP HDFC BANK ATM, DHANALAKSHMIPURAM, NELLORE524003"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Nellore",
     "Center": "PODALAKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL,CHAITANYA NAGAR,RAPUR ROAD,PODALAKUR (MANDAL),NELLORE (DT) 524345"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Sullurpet",
     "Center": "SULLURPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR RR SUPER MARKET ,GNT ROAD , SULLURPET,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vedayapalem",
     "Center": "VEDAYAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL GANDHI NAGAR ,VEDAYAPALEM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL AMMAVARIPETA, MUNICIPAL OFFICE ROAD, VENKATAGIRI,SPSR NELLORE DIST 524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Venkatagiri",
     "Center": "VENKATAGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL DVS COMPLEX, RAJA STREET, VENKATAGIRI, SPSR NELLORE (DT)524132"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Nellore",
     "City": "Vinjamuru",
     "Center": "VINJAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE PRAJA VAIDHYASALA, NEAR RTC BUS STAND , VINJAMURU,NELLORE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ANJANEYA SADAN ADDANKI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO.31-419, 31-420, OIL MILL ROAD, ADDANKI - 523201."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Addanki",
     "Center": "ADDANKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL,BUNGLOW ROAD,ADDANKI,PRAKASAM -523201"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Chimakurthy",
     "Center": "CHIMAKURTHY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GANDHI NAGAR 7TH LINE,CHIMAKURTHY ONGOLE 523226"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Darsi",
     "Center": "DARSI",
     "CenterAddress": "SRI CHAITANYA SCHOOL TEACHERSCOLONY,PODILI(ROAD),DARSI,PRAKASAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kandukur",
     "Center": "KANDUKUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL KOTA REDDY NAGER,KANDUKUR"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.JR COLLEGE,KANDUKUR ROAD,KANIGIRI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Kanigiri",
     "Center": "KANIGIRI 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL SUBHASH ROAD,KOTHA PET,KANIGIRI,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Markapuram",
     "Center": "MARKAPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.8\/A-20 ,BODAPADU ROD ,OPPISITE RTC DEPO,MARKAPURAM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Martur",
     "Center": "MARTUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP. VIJAYALAKSHMI KALAYANA MADAPAM, NH-5 ROAD , MARTUR,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "SARASWATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MANGUMUR ROAD"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "CUMBUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.INDIAN PETROL BUNK,NEAR SBI BANK ,GIDDALUR ROAD,CUMBUM,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL BHAGYA NAGAR 2ND LINE, BESIDE REGISTER OFFICE ,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL,OPP.HP GAS AGENCY,NEAR MARRI CHETTU,MANGAMUR DONKA ROAD,ONGOLE 523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL V.I.P. ROAD,MANGAMUR DONKA,ABOVE HDFC BANK,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Ongole",
     "Center": "ONGOLE DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE MAHALAKSHMI TOWERS, 4TH LINE ,LAWYERPET,ONGOLE-523001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Pamuru",
     "Center": "PAMURU",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP.HP PETROL BUNK ,NELLORE ROAD,PAMURU,ONGOLE"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Prakasam",
     "City": "Singarayakonda",
     "Center": "SINGARAYAKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE I.T.I COLLEGE,MULAGUNTAPADU(V),SINGARAYAKONDA(M) PRAKASAM DISTRICT 523101"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-3,4&amp;5, BEHIND DEEPAMAHAL, SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "KAMAKSHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, OLD NH-5 ROAD, OPP. HONDA SHOWROOM, PADMANABHAPURAM, KASIBUGGA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRIKAKULAM ROAD, NEAR AMRUTHA HOSPITAL, OPP. MAHENDRA SHOWROOM, RAJAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI NAGAR , NEAR DEO OFFICE,WOMENS COLLEGE ROAD,SRIKAKULAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Srikakulam",
     "City": "Srikakulam",
     "Center": "SRIKAKULAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL TANGI SURYANARAYANA COLONY, NEAR AYYAPPA SWAMY TEMPLE, ADIVARAMPETA, CHAPURAM PANCHAYAT, PALAKONDA ROAD, SRIKAKULAM 532 001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "GOWRI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 12-12-73, OLD BUS STAND ROAD, NEAR SHIRDI SAI THEATRE, ANAKAPALLI"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Anakapalli",
     "Center": "ANAKAPALLI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 80 FEET RING ROAD , OPP HEMA SEKHAR DEGREE COLLEGE, STATION ROAD, ANAKAPALLI,VISAKHAPATNAM -531001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Bobbili",
     "Center": "BOBBILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR CBM CHURCH , BALIJIPETA ROAD, BOBBILI,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Narsipatnam",
     "Center": "NARSIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL 2-101\/1, NEAR RTC COMPLEX , ANAKAPALLI ROAD, NARSIPATNAM-531116 VISAKHAPATNAM DIST."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Palasa",
     "Center": "PALASA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO:14-1-279\/A,NEAR AYYAPPA SWAMY TEMPLE,OLD NH-5 ROAD,PADMANABHAPURAM,PALASA-KASIBUGGA,SRIKAKULAM DIST 532222"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Parvathipuram",
     "Center": "PARVATHIPURAM",
     "CenterAddress": "SRI CHAITANAYA SCHOOL , OPP- SRI VENKATESWARA NURSHING HOME ,SUNDERNARAYANAPURAM COLONY , BELAGUM ,PARVATHIPURAM , VIZIANAGARAM ( DIST ) ."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Rajam",
     "Center": "RAJAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP ELECTRICAL SUB STATION, PONDURU ROAD, RAJAM, SRIKAKULAM (DIST) 532127"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN- II",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-48-6-16, SRI VIJAYA SAI TOWERS, OPP. RAMA TALKIES MAIN GATE, SRINAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRIPADA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO-48-8-14, BEHIND KALANIKETHAN, NEAR BUDHIL PARK HOTEL, DWARAKANAGAR, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D NO-58-22-50, NEAR NAD HOSPITAL, SUSARLA COLONY, BUTCHIRAJUPALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "RAMAN BHAVAN2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO 6-62-6\/1, NEAR GAJUWAKA POLICE STATION, SHRAMIK NAGAR, CHINAGANTYADA, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYSHNAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MIG 110, D.NO 24-3-1,BUDA COLONY,PEDAGANTYADA, GAJUWAKA"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "VYDEHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, STEEL PLANT MAIN ROAD, UKKUNAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "SRISAI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D.NO- 34\/2, PILAKAVANIPALEM, CARSHED JUNCTION, P.M PALEM, VIZAG"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO 10-12-8, OPP PYDAH DEGREE COLLEGE REDNAM GARDENS RAM NAGAR,ASILMETTA VISAKHAPATNAM -530002"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "ASILMETTA 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL 11-4-1\/1,UDAY SRI TOWERS, RAMNAGAR,ASILMETTA,VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO:26- 42-10\/2,BESIDE SRI CHAITANYA JUNIOR KALASALA,CHAITANYANAGAR,OLD GAJUWAKA,VISAKHAPATNAM-530026."
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "GAJUWAKA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 27-1-65,SRINAGAR,GAJUWAKA,VISAKHAPATNAM,530026"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KOMMADI",
     "CenterAddress": "SRI CHAITANYA SCHOOL, VIJAYA MOHAN LAYOUTS,NEAR CHAITANYA ENGG COLLEGE, KOMMADI VILLAGE,CHINAGADILI MD MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "KURMANNAPALEM",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR NO: 31\/6-3\/1 OPP. STEEL CITY APSRTC BUS DEPO SATHAVAHANANAGAR ROAD NO.6,MAINROAD KURMANNAPALEM, GAJUWAKA MANDAL VISAKHAPATNAM 530046"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA",
     "CenterAddress": "SRI CHAITANYA SCHOOL OPP: CMR GARDENS, MADHURAWADA , VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MADHURAWADA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, NEAR FLY OVER BAKKANAPALEM ROAD, MADHURAWADA VISAKHAPATNAM 530048"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "MVP COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-10-2\/4, USHA RESIDENCY, SECTOR-1,MVP COLONY, VISAKHAPATNAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D.NO. 58-1-237, TEEGALA TOWERS, MARRIPALEM ROAD, NAD, VIZAG 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "NAD 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL, D-NO-58-15-116\/A, OPP GAJANANA FORT, SANTHI NAGAR, NAD ,VISAKHAPATNAM 530009"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Visakhapatnam",
     "Center": "PENDURTY",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR SBI, PULAGANIPALEM ROAD, PENDURTY"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Visakhapatnam",
     "City": "Yalamanchali",
     "Center": "YALAMANCHILI",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR FIRE STATION,RAMAKRISHNAPURAM, YELAMANCHILI,VISAKHAPATNAM-531055"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL, 100 FEET RING ROAD, DHARMAPUR, NEAR VENKATESWARA SWAMY TEMPLE, VIZIANAGARAM 535001"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagaram",
     "Center": "VIZIANAGARAM 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL KAMAKSHINAGAR NEAR BUS STOP,BOWDARA MAIN ROAD, VIZIANAGARAM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "Vizianagarm",
     "City": "Vizianagarm",
     "Center": "VIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO-102,103,104, NAIDU COLONY, THOTA PALEM, VIZIANAGARM"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Eluru",
     "Center": "COLLEGE - ELURU",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MAIN CAMPUS- ELURU, MARGHADARSHI ROAD, NARASIMHA RAO PETA, ELURU"
    },
    {
     "State": "ANDHRA PRADESH",
     "District": "West Godavari",
     "City": "Palakol",
     "Center": "SARASWATHI SOWDHAM",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SARASWATHI SOUDHAM CAMPUS BRODIPET, BRODIPET BIPASS ROAD, PALAKOLLU, WEST GODAVARI - 534260"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARNAKA (HARI HARA HEIGHTS)",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-13-1210\/1, STREET NO 10, TARNAKA, SECUNDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 6-10-8\/1\/1, NAGENDRA NAGAR, HABSIGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANTHAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-9-29, SHARADA NAGAR, ADRM HOSPITAL LANE, RAMANTHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,1-7-158\/2&amp;1-7-159\/1,KAMALA NAGAR,ECIL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SECENDRABAD",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,OLD LICBUILDING,BEHIND HDFC BANK,NEAR PARADISE CIRCLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ALWAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ALWAL,PNO 27&amp;28,H.NO-1-12-115,MADHAVI NAGAR COLONY,"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "WEST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, R.C NO 23010\/62206\/C23-1\/2002-03,WEST MAREDPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SATYASAI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:18-98,KAMALA NAGAR,CHAITANYAPURI,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI BHAVAN ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO: 5-4-59\/2\/1 SARASWATHI BHAVAN, NEAR GENESIS HIGH SCHOOL, SANGEETH NAGAR, KUKATPALLY, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRIVIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 5-4-58\/9\/1 &amp; 5-5-7\/10\/1, PLOT NO 7 &amp; 8, KUKATPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI VIKRAM TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAI VIKRAM TOWERS, 3RD FLOOR, BESIDE METRO STATION, KUKATPALLY,HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI BHASKAR BHAVAN, ABOVE NEXA CAR SHOWROOM, A S RAJU NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAGDEVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VAGDEVI BHAVAN, PHASE I, BESIDE MRO OFFICE, KPHB COLONY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, APIIC COLONY, OPP IDPL COLONY, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SPRING FIELD COLONY, NEAR GOOD SHEPHERD SCHOOL, SUCHITRA, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHARATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHARATHI BHAVAN, PLOT NO: 5,6 &amp; 7, BEHIND MAX SHOPPING MALL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHARADHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 1-58\/A\/8\/1, RAMA KRISHNA COLONY, BESIDE NAIDU EYE HOSPITAL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASUDA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BACK SIDE KAJANA JEWELERS, MADINAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "JAI HIND COMPLEX",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO 53 TO 63 H NO: 5-88\/2 NEAR ZPH SCHOOL MANIKONDA, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SOUDAMINI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 4-94, CHANDA NAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MAIN CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-5-947 &amp;948, OPP.TAJMAHAL HOTEL, SUDARSHAN BUILDING, NARAYANAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAYS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-4-703,VAYS BHAVAN,NEAR NARAYANAGUDA FLYOVER,HYDERABD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AKSHARA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/279, 256\/M6, BESIDE AXIS BANK, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMRUTHA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/550, 516\/3RT, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ARYABHATTA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 7-1-414\/35(B), AMEERPET,HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "YOUSUFGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8-3-318\/6\/6, BANDARU BHAVAN, 2ND FLOOR, YOUSUFGUDA, HYDERABAD-500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8229382\/J111\/573 G, RAJIV BHAVAN, JUBILEE HILLS, OPP: KBR PARK, GATE NO 6, ROAD NO -1, JUBILEE HILLS, HYDERABAD-500096"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PILLAR NO: 143, H.NO: 3-4-183\/1, ATTAPUR, RAJENDRA NAGAR, RANGA REDDY DISTRICT-500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R K PURAM-2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ROAD NO-1,GREENHILLS COLONY,KOTHAPET"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BALAJI ARCADE ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR CHIKKADPALLY METRO, ABOVE RAMRAJ COTTON, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LBNAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 3-1-33, BAHADURGUDA, LBNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYDEHI BHAVAN AUTONAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 284 (WESTERN PART), NAKKA VENKATA SWAMY YADAV NAGAR, BAGH HAYATHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "UPPAL RES BODUPPAL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-165\/9, PEERZADIGUDA, UPPAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NAGOLE ENCLAVE,BAHADURGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VIVIN TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MADHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VEDAVYAS 1",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO. 319, 320  BESIDE. H.P. PETROL PUMP, NARSINGI,  GANDIPET MD RANGA REDDY DT"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANUJAM BHAVAN BONGULOR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D:NO 5-105, SY.NO:109(PART), OLD JNIT ENGG COLLEGE, BONGULUR X ROADS, MANGALPALLI-PATELGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYASA BHAVAN ADIBATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SURVEY NO 163\/AA, OF BONGULURU VILLAGE, IBRAHIMPATNAM MANDAL, RANGAREDDY DIST"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANDLAGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO 196, ARUNODHAYA COLONY, BANDLAGUDA ROAD NAGOLE, HYD-35"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUSHRUTHA BHAVAN MEDIPALLY CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MEDIPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO-265  AUSHAPUR,ANKUSHAPUR POST  "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PANANIYA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO 103,BLOCK 2B,VVNAGAR,GADDINNARAM"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERNAGAR BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SYNO . 1598169\/2 SRI CHAITANYA JR COLLEGE, HYDERNAGAR BOY CAMPUS, MANJEERA WATER WORK ROAD, NEAR CALAVERY TEMPLE, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MIYAPUR GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE FOR GIRLS,HOUSE NO 1-62 &amp;1-62\/1,SRI VIDYA BHAVAN"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KPHB RES PRATIBHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KPHB RES PRATIBHA BHAVAN,SRI CHAITANYA JUNIOR KALASALA, DHARMA REDDY COLONY,KPHB PHASE -3,NEAR LOTUS HOSPITAL BESIDE STREET ,NEAR TO OPPOSITE PRATIBHA SCHOOL,JNTU, "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PRATHIBHA SAI NAGAR HYD",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, FLOT NO \/ PLOT NO \/ SURVEY NO -16-2-132\/135\/231 STREET NAME -K V R COMPLEX,NIZAMPET CROSS ROAD AREA NAME -SAINAGAR COLONY NEAR BY LAND MARK -LUCID DIAGNASTICS CITY - HYDERABAD PINCIDE -500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI SAI DARBHAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO.1-62\/SD\/5TO 8\/1,PLOT NO.5678,SY NO:198\/2\/A, SRI AUROBINDO COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-217\/A, BALKAMPET, B K GUDA, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DSNR ZONAL DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAIBABA TEMPLE LINE,P &amp; T COLONY,BESIDE SANJAY STEEL,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L B NAGAR ZONAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:3-6-260,L B NAGAR,SBI BANK COLONY,VENTURE -1"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R.K.PURAM SEMI RESI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:11-13-1106&amp;1107,NEAR VICTORIA,MEMORIAL METRO STATION,GREEN HILLS COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHASKAR BHAVAN, OMNI HOSPITAL BACK SIDE, BALAJI NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMAN BHAVAN, BHAGYA NAGAR CO-OPERATIVE SOCIETY , SHIVA PARVATHI THEATER RAOD, OPP KPHB, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 8-3-319\/8\/2 TO 6&amp;319\/2\/7,NEAR SARADHI STUDIOS YOUSUFGUDA,MAIN ROAD AMEERPET HYD 500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO-8-3-222 \/ A\/1,2,3 PLOT NO-C 57-C 59 BESIDE ALLAHABAD BANK ( INDIAN BANK ), MADHURA NAGAR YOUSUFGUDA MAIN ROAD ,AMEERPET HYDERABAD 500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-4-183\/1, SATTI REDDY COMPLEX, ATTAPUR,RAJENDRA NAGAR, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO - 367&amp;368 , KAKATEEYA HILLS (KAVURI HILLS), ROAD NO -8, MADHAPUR , JUBILEE HILLS , GUTALA BEGUMPET , SHERILINGAMPALLY MANDAL, RANGA REDDY DISTRIT - 500081"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:143,145,149,JAYA ABODE,OPP:ANDHRA BANK,SECRETARIAT COLONY,MANIKONDA 500089"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHAMSHABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 578\/A582\/A,ADARSH NAGAR,SHAMSHABAD, RANGAREDDY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SR NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR.NO.7-1-621\/280 &amp; 281,254 &amp; 255-3RT, SR NAGAR MAIN RD, ABOVE SBH BANK, SANJEEVA REDDY NAGAR, HYDERABAD, TELANGANA,500038."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUN CITY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 1-2\/1, SHANTHI NAGAR COLONY, HYDERSHAKOTE, SUNCITY, RR. DT- 500091"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TOLICHOWKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8-1-22\/1\/M, 7 TOMBS ROAD,OPPOSITE GOLDEN PALACE,FUNCTION HALL,TOLICHOWKI, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHAITANYAPURI CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PANANIYA MAHAVIDYALAYA PUBLIC SCHOOL,OPP THANKUR HARI PRASAD INSTITUTE,CHAITANYAPURI,DILSUKNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DILSUKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:3-10\/A,HANUMANNAGAR,BESIDE PAKALA PLAZA,OPP.SAPTAGIRI HOSPITAL,CHAITANYAPURI,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GADDI ANNARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.16-2-752\/123\/1\/123\/A&amp;4A, SHIVA GANGA THEATRES ROAD, BESIDE: SBH BANK, GADDIANNARAM, HYD-500060"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GAYATHRI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 2&amp;131, NEAR GAYATHRINAGAR X ROADS, BESIDE SBI BANK, GAYATHRINAGAR, JILLALAGUDA,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:60,64 &amp; 67,71 KHALSA, HAYATHNAGAR RR(DT) 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT. NO. 5,6,7,8,9 &amp; 10,KHALSA,HAYATHNAGAR,RANGAREDDY 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KESHAVAPURI",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 8-7-92\/K, KESHAVAPURI COLONY, SAGAR ROAD, HASTINAPURAM,HYDERABAD TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHALSA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR HIWAY BAWACHI HOTEL LINE,SUGUNA ENCLAVE,KHALSA,HAYATNAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHARMANGHAT",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:7,SRINIVASA NAGAR COLONY,OPP:UCO BANK,KHARMANGHAT,HYDERABAD 500035"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOTHAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.23-38\/2&amp;3,KRISHNAVENI NAGAR,OPP:FRUITMARKET LANE,NEAR GHMC EAST ZONAL OFFICE,KOTHAPET,DILSUKNAGAR,HYDERABAD,R.R.DIST-60."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-11-282,SHIVA GANGA COLONY,OPP. BIG BAZAR,LBNAGAR,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 3-11-461\/A PART, ROAD NO: 2, SHIVA GANGA COLONY ,MANSOORABAD, L.B NAGAR, HYDERABAD, TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANSOORABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SAI BABA TEMPLE,KAMINENI HOSPITAL BYPASS ROAD,LAXMI NAGAR COLONY,MANSOORABAD,HYDERABAD-500074"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:1234.OPP:Y JR FUNCTION HALL,TMR ENCLAVE ,NEAR MEERPET CROSS ROAD,BADANGPET HYDERABAD 500097"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MOOSARAMBAGH",
     "CenterAddress": "SRI CHAITANYA SCHOOL H NO:16-11-469\/A\/1 TO 12,OPP SBI OFFICERS COLONY PARK, SBI OFFICERS COLONY,MOOSARAMBAGH DILSUKHNAGAR,500036"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO 46&amp;47, ROAD NO.5, SAI NAGAR COLONY, OPP. ALKAPURI SIGNAL, NAGOLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI NAGAR COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SURVEY NO:13,23 &amp; PART OF-25,OPP:RADIO STATION TOWER,VIJAYAWADA HIGHWAY,KALASA,SAI NAGAR COLONY,HAYATH NAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VANASTHALIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.288, DOOR NO.5-5-285, NEAR SRI KANAKADURGA TEMPLE, PRASHANTH NAGAR, VANASTHALIPURAM, HYDERABAD 500070"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HMT COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL FLOT NO :59&amp;60,HT LINE,HMT COLONY,ALWAL,500010"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GUNDLAPOCHAMPALLY,BESIDE GVK EMRI,NEAR PRESTIGE PARK,MEDCHAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MLR COMPLEX,BESIDE BHARATH PETROL BUNK,KOMPALLY,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHANDRAREDDY GARDENS SURVEY NO: 87, MAHALAKSHMI ENCLAVE ROAD,NEAR DHOLA-RI- DHANI, KOMPALLY, HYDERABAD,TELANGANA- 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO.85 BESIDE S.N.R GARDEN, KOMPALLY 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI ENCLAVE, BESIDE NAVATHA TRANSPORT, NEAR DOLA RI DANI, KOMPALLY, MEDCHAL - 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDCHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 36,37,64,OPP SEVEN TEMPLES,UMA NAGAR, MEDCHAL,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BEERAMGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GREEN MEADOWS MAIN ROAD, ESUKA BAVI, BEERAMGUDA, AMEENPUR (MDL), SANGAREDDY (DST) 502032"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHINTAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 145\/P OPP HP GAS AGENCY PATWARI ENCLAVE IDPL CHINTAL 500054"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 6 ,BALAJI NAGAR, NEAR METRO STATION KUKATAPALLY,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5-3-114, PLOT NO 1 &amp; 14, BEHIND RELIANCE SMART, SHANTI NAGAR,NEAR RAMALAYAM, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAGANDLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP APARNA CYBER LIFE,NALLAGANDLA(VILL), RANGAREDDY(DIST) 500019"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SERILINGAMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.20 &amp; 21, HUDA LAY OUT, NEAR AJAY FUNCTION HALL &amp; LINGAMPALLY RYTHU BAZAR, SERILINGAMPALLY RANGA REDDY "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SEVEN HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-2-46\/348,ANJANADRI BLOCK,SEVENHILLS APARTMENTS,NIZAMPET X ROAD,BESID SRI SRI HOLISTIC HOSPITAL,HYD,500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO:3&amp;4,SARDARPATEL NAGAR,NIZAMPET X RAOD,HYDERNAGAR,HYDERBAD 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 175,NEAR JNTU METRO STATION ,SARDAR PATEL NAGAR, KUKATPALLY 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO. 157,158 &amp;159, BESIDE RAMALAYAM, SAPTHAGIRI COLONY, VIVEKANANDANAGAR, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR RES(BOYS)",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO.28,29, SAPTHAGIRI COLONY,VIVEKANANDANAGAR,KUKATPALLY 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANJARAHILLS STARKIDSPREMIUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 8-2-310-B-10, ROAD NO 14, NAVODAYA COLONY, NANDI NAGAR, BANJARA HILLS,HYDERABAD 500034"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BOWENPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO. 1-4, CHINNATHOKATTA, NEW BOWENPALLY, SECUNDERABAD 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "EAST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-3-18\/4,OPP: BANK OF BARODA(FORMERLY DENA BANK),,EAST MAREDPALLY,HYDERBAD-5000026"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL A8, TULASI HOSPITAL LINE,ELECTRONIC COMPLEX, ECIL,KUSHAIGUDA, HYDERABAD - 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:A\/10, ELECTRONIC COMPLEX, PHASE 2,KUSHAIGUDA, ECIL 'X' ROADS MEHDIPATNAM 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GOSHA MAHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO.5-3-825,MALLAKUNTA ROAD, OPP. NEW IOC PETROL PUMP,GOSHAMAHAL,HYDERABAD,500012"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HASMATHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 1, SEETHA RAMAPURAM, MALLAREDDY GARDEN LANE,BESIDE KALYANI THEATRE, OLD BOWENPALLY HASMATHPET 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PILLAR NO -118 ,HANUMAN TEMPLE LANE , SRI LAKSMI NAGAR COLONY, STREET NO -03 ,NEAR INDIAN BANK BACK SIDE &amp; CLOSE TO JANAPRIYA UTOPIYA APARTMENTS, HYDERGUDA ATTAPUR - 500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KARKHANA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 144\/149, TEXT BOOK COLONY ,TRANSPORT ROAD,KARKHANA,SECUNDERABAD. TELANGANA-500009"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LAL DARWAJ",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.18-4-42\/3\/2, ANDHRA BANK LANE,LAL DARWAJ ,HYDERABAD 500065"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "M G ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 2 - 4- 73\/74 , BESIDE KFC, MG ROAD, NALLAGUTTA, SECUNDERABAD -500003"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEHDIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 3 , SANTOSH NAGAR COLONY, ST.ANN'S WOMEN'S COLLEGE ROAD, MEHDIPATNAM, HYDERABAD - 500028"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BARKATPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO: 3-4-760, BESIDE ANDHRA YUVATHI MANDAL, BARKATPURA, HYDERABAD, TELANGANA 500027"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-9-165,OPP IOC PETROL BUNK,NEAR ELECTRICITY SUB STATION,MAIN ROAD, GHATKESAR-501301"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-7-34\/7 &amp; 4\/NR, OPP CHRIST THE KING CHURCH, BESIDE BADRAS GRAND HOTEL, RAMANTHAPUR,HABSIGUDA, UPPAL(M), MEDCHAL (D)"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HIMAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-6-655ROAD9,ASHOKNAGAR.HIMAYATNAGAR,NARAYANGUDA,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDIPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 13-238, OPP.HANUMAN TEMPLE,MAIN ROAD MEDIPALLY VILLEGE,MEDCHAL DIST-500098"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NACHARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 17\/4 , SURVEY NO: 45 &amp; 46 , NACHARAM ,UPPAL MANDAL,MEDCHAL 500076"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAKUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:1-9-1104 TO 1112,OPP LANE TO DURGABAI DESHMUKH HOSPITAL,VIDYANAGAR,ADIKMET,NALLAKUNTA, HYDERABAD-500044"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARANAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-12-5-28\/29\/2,TARNAKA,SECUNDERABAD-500017."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DAMMAIGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL ANJANADRI&nbsp;NAGAR,&nbsp;EXTENSION&nbsp;OPP LAKE VIEW WATER TANK, DAMMAIGUDA MEDCHAL 500083"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Sangareddy",
     "Center": "SANGAREDDY",
     "CenterAddress": "SRI CHAITANYA SCHOOL APHB COLONY OPP NEW COLLECTORATE, SANGAREDDY 502001"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Toopran",
     "Center": "TOOPRAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO-455, ALLAPUR ROAD, TOOPRAN,KOMPALLY 502334"
    },
    {
     "State": "TELANGANA",
     "District": "Karim Nagar",
     "City": "Ramagundam",
     "Center": "RAMAGUNDAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL-FERTILIZER CITY,RFCL TOWNSHIP, RFCL, RAMAGUNDAM-PEDDAPALLY(DIST) 505210"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "STARKIDS KODAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, STAR KIDS CAMPUS, GANESH NAGAR,CURRENT OFFICE BACK,KODAD, SURYAPET (DIST) 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-237\/3, SRINAGAR COLONY,KODAD POST &amp; MDL, SURYAPETA DT 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT RS",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANA ENGINEERING COLLEGE KODAD POST &amp; MDL, KODAD SURYAPETA 508206 "
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-Olympiad",
     "CenterAddress": "Sri Chaitanya International Olympiad School,H.No.5-7-182\/3\/1, Near Mamata Hospital, Khammam - 507 002, Khammam Dist. Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-IOS",
     "CenterAddress": "Sri Chaitanya International School,H.No.5-7-182\/3\/1,  Near Mamata Hospital,Khammam - 507 002, Khammam Dist.Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-1",
     "CenterAddress": "Sri Chaitanya School,H.No.6-3-284, G.L.Towers, Near Ntr Statue,Bypass Road, Khammam - 507 001.Cell: 9666666720 &amp; 9666666718."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-2",
     "CenterAddress": "Sri Chaitanya School,H.No.10-4-31\/A, Beside Sai Baba Temple, Mamillagudem, Khammam - 500 702, Cell: 9666666721 &amp; 7680884537."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-3(Lotus)",
     "CenterAddress": "Near Petrol Bunk ,Musthfanagar Khammam"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-1",
     "CenterAddress": "Sri Chaitanya School,H.No.9-11, Laxmidevi Palli, Kothagudem - 507 101,Bhadradri Kothagudem Dist.Cell: 9666666722, 9666666723."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-2",
     "CenterAddress": "Sri Chaitanya School,G.R. Basthi, Bhajan Mandhir Road, Kothagudem  - 507 101,Bhadradri Kothagudem Dist.Cell: 8367317755 &amp;"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-3",
     "CenterAddress": "Sri Chaitanya School,H.No.3-1-6\/7, Vidhyanagar Colony (Panchayath), Chunchupally (Mndl), Kothagudem,Bhadradri Kothagudem (Dist), Pin: 507 101."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-1",
     "CenterAddress": "Sri Chaitanya School,H.No.20-5-32\/1, Contractor’S Colony,Palvancha - 507 115, Bhadradri Kothagudem (Dist).Cell: 7675837755, 7675847755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-2",
     "CenterAddress": "Sri Chaitanya School,Oddugudem, Near Bramana Kalayana Mandapam, Palvancha - 521 175, Bhadradri Kothagudem (Dist).Cell: 8367247755 &amp; 8367257755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Bhadrachalam",
     "Center": "Bhadrachalam",
     "CenterAddress": "Sri Chaitanya School,Opp: K.K.Function Hall, Charla Road, Bhadrachalam (Post &amp; Mdl).Bhadradri Kothagudem (Dist.) Pin: 507 111.Cell: 8340947755, 8340957755 &amp; 8340967755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Manugur",
     "Center": "Manugur",
     "CenterAddress": "Sri Chaitanya School,Guttamallaram, Manuguru - 507 117,Bhadradri Kothagudem (Dist).Cell: 8340977755, 8340987755 &amp; 8340997755."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Madhira",
     "Center": "Madhira",
     "CenterAddress": "Sri Chaitanya School,Ward No.121, Opp: Club Complex, Madhira (Post &amp; Mndl), Pin: 507 203, Khammam (Dist).Cell: 9666666724, 9666666725."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Mahabubabad",
     "Center": "Mahabubabad",
     "CenterAddress": "Sri Chaitanya School,H.No.6-2-44\/7\/1, Krishna Colony,Near Railwary Gate, Mahabubabad - 506 101 , Mahabubabad Dist.Cell: 9666666714 &amp; 9666666715."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Sathupally",
     "Center": "Sathupally",
     "CenterAddress": "Millennium School,Busstand Opp,Bonthu Aslesha Street, Sathupally.  9949609680"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-4"
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Warangal",
     "Center": "Warangal",
     "CenterAddress": "Sri Chaitanya School,H.No.11-27-16, Near Inner Wheel Club, Vasavi Colony, Kothawada, Warangal - 506 002, Warangal Dist.Cell: 9666666710 &amp; 9666666711."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda",
     "CenterAddress": "Sri Chaitanya School,H.N.5-9-210, Opp: Seven Hills Hospital, Kishanpura, Hanamkonda - 506 001, Warangal (Urban) Dist.Cell: 9666666712 &amp; 9666666708."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda-IPL",
     "CenterAddress": "Sri Chaitanya School,H.No.2-5-278\/280, Iob Lane, Beside G.R Hospital,Hanmakonda -506 001, Warangal (Dist). Cell: 8367407755, 8367417755, 8367427755 &amp; 8367397755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanmakonda",
     "Center": "Hanmakonda-CBSE",
     "CenterAddress": "Sri Chaitanya School,Lead India School, Hunter Road, Dwaraka Nagar, Shyampet,Hanmakonda - 506 001."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Kashibugga",
     "Center": "Kashibugga",
     "CenterAddress": "Sri Chaitanya School,H.No.11-23-662, L.B Nagar, Beside Decent Function Hall, Main Road, Kashibugga - 506 002, Warangal (Urban Dist).Cell: 7995555731 &amp; 7995555733."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Rangasaipet",
     "Center": "Rangasaipet",
     "CenterAddress": "Sri Chaitanya School,H.No.19-9-441, Beside Nagamaiah Temple Arch, Shambhunipet, Khammam Main Road, Warangal - 506 005."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Narsampet",
     "Center": "Narsampet",
     "CenterAddress": "Sri Chaitanya School,Sarojini Devi Road, Near Post Office,Narsampet - 506 132, Warangal (Rural) Dist.Cell: 9951377755 &amp; 9951277755."
    },
    {
     "State": "TELANGANA",
     "District": "Jayashankar Bhupalpally&nbsp;",
     "City": "Bhupalpally",
     "Center": "Bhupalpally",
     "CenterAddress": "Sri Chaitanya School,H.No-9-13\/1, Near Ramalayam Temple, Gandhinagar, Bhupalpally - 506 169,Bhupalpally Jayashankar (Dist).Cell: 9666666740 &amp; 9666666741."
    },
    {
     "State": "TELANGANA",
     "District": "Janagoan",
     "City": "Janagoan",
     "Center": "Janagoan",
     "CenterAddress": "Sri Chaitanya School,D.No.1-10-64\/20, Grain Market Road, A.V.Nagar, Janagoan - 506167, Janagoan (Dist).Cell: 7997837755 &amp; 7997847755"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubabad",
     "City": "Thorrur",
     "Center": "Thorrur",
     "CenterAddress": "Sri Chaitanya School,Bhatupaly, Kazipet -  506 003,Warangal Urban (Dist),Cell: 9705257755 &amp; 9705267755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Kazipet",
     "Center": "Kazipet CBSE",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755"
    },
    {
     "State": "TELANGANA",
     "District": "Medchal",
     "City": "Dammaiguda",
     "Center": "Dammaiguda",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 6-75\/8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755."
    },
    {
     "State": "TELANGANA",
     "District": "Medchal-Malkajgiri",
     "City": "Hyderabad",
     "Center": "Boduppal",
     "CenterAddress": "Sri Chaitanya School,H.No.3-105\/3\/3, Sairam Nagar Colony ,Boduppal, Medipally (M),Medchal Malkajgiri Disit, Pin: 500 039."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Tukkuguda",
     "Center": "Tukkuguda",
     "CenterAddress": "Sri Chaitanya School,Survey No.152\/A\/J, Beside Sri Swami Ayyappa Temple,Tukkuguda, Rangareddy Dist. Pin: 501 359."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Badangpet",
     "CenterAddress": "Sri Chaitanya School,D.No.4-74\/3, Raghavendra Colony,Badangpet Main Road, Opp: Sbi Bank,Badangpet Village, Balapur (Mandal),Ranga Reddy Dist, Pin: 500 058."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Ibrahimpatnam",
     "CenterAddress": "Sri Chaitanya School,Opp : Bharat Garden, Manchal Road,Siripuram Colony, Ibrahimpatnam, Ranga Reddy Dist. Pin: 501 506."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Sangareddy",
     "Center": "Sangareddy",
     "CenterAddress": "Sri Chaitanya School,H.No.9-93, Pothireddy Pally X Roads, Sangareddy, Sangareddy Dist, Pin: 502 295."
    },
    {
     "State": "TELANGANA",
     "District": "Medak",
     "City": "Sadasivpet",
     "Center": "Sadasivpet",
     "CenterAddress": "Sri Chaitanya School, H.No.3-9-12\/2 , Beside Bus Stop,Rahamath Nagar, Sadasivpet, Sangareddy Dist, Pin: 502 291."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Zaheerabad",
     "Center": "Zaheerabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.96\/A\/7, Opp. Sbi Bank, Pastapur X Roads,Zaheerabad - 502 220, Sangaredy Dist."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Vikarabad",
     "Center": "Vikarabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.72, Beside Indian Oil Petrol Pump,Hyderabad Road, Yenapally, Vikarabad,Vikarabad Dist, Pin: 501 101."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Annojiguda",
     "CenterAddress": "Sri Chaitanya School, H.No.6-52\/G\/1, Beside Sbi, Near Sbr Gardens, Annojiguda - 500 088, Ghatkesar (Mdl), Medchal-Malkajgiri (Dist),Cell: 9705737755 &amp; 9705747755."
    },
    {
     "State": "TELANGANA",
     "District": "Yadadri Bhuvanagiri ",
     "City": "Bhongir",
     "Center": "Bhongir",
     "CenterAddress": "Azad Road, 2-2-153 Bongiri"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Kandukur",
     "Center": "Kandukur",
     "CenterAddress": "Beside Mro Office,Kandukur"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Moinabad",
     "Center": "Moinabad",
     "CenterAddress": "Chilkur Village,Moinabad"
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-1",
     "CenterAddress": "Sri Chaitanya School,H.No.18-80, Haripriya Nagar, Vijaya Bank Back Side, Beside Konda Mallaiah Gardens, Hyd Road, Siddipet - 502 103, Siddipet Dist.Cell: 9666666744 &amp; 9666666745."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-2",
     "CenterAddress": "Sri Chaitanya School,H.No.18-19-28\/2 &amp; 2A, Prashanth Nagar, Above Tvs Show Room, Near Hotel Akshaya Grand, Siddipet - 502 103, Siddipet Dist.Cell: 8297827755 &amp; "
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mancheriyal",
     "Center": "Mancheriyal",
     "CenterAddress": "Sri Chaitanya School,Opp. Govt. Degree &amp; P.G College, Godavari Road, Mancherial - 504 208, Mancherial Dist. Cell: 9666666746 &amp; 9666666747."
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mandamarri",
     "Center": "Mandamarri",
     "CenterAddress": "Sri Chaitanya High School,H.No. 42-2\/B, Near Old Bus Stand, Besides Shivani Degree &amp; Pg Collage, Mandamarri - 504 231, Mancheriyal Dist.Cell 7680867755, 7680857755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Godavarikhani",
     "Center": "Godavarikhani",
     "CenterAddress": "Sri Chaitanya School,H.No.17-1-14\/2, F.C.I. Road, Sanjay Gandhi Nagar, Godavarikhani - 505 209, Ramagundam (Mdl), Peddapally (Dist). Cell: 9666666748 &amp; 9666666749."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Boiwada",
     "Center": "Boiwada",
     "CenterAddress": "Sri Chaitanya School,H.No.1-6-79, Near Hanuman Temple,  Boiwada, Karimnagar - 505 001, Karimnagar (Mdl &amp; Dist).Cell: 7995555623,7995555625."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Thimmapur",
     "Center": "Thimmapur",
     "CenterAddress": "Sri Chaitanya School,Opp. Saakshi Office, Hyderabad Road, Rajeev Rahadari, Thimmapur, Karimnagar (Mdl &amp; Dist), Pin: 505 527.Cell: 7995555622 &amp; 7995555624."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Vavilalapally",
     "Center": "Vavilalapally",
     "CenterAddress": "Sri Chaitanya School,H.No.3-7-142, Near Svjc Girls Jr.College, Vavilalpally (Vil),  Karimnagar (Mndl &amp; Dist), Pin:505 001.Cell: 8367637755, 8367647755 &amp; 8367657755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Karimnagar",
     "Center": "Karimnagar-IPL",
     "CenterAddress": "Sri Chaitanya SchoolH.No:4-65\/55-5D2\/4,Road No.2Opp:Apollo Reach Hospital, Vidhyaranyapuri,  Theegalaguttapally (Vill),Karimnagar (Mdl &amp; Dist), Pin: 505 001,Cell: 836743775, 8367457755 &amp; 8367467755."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Yellapur",
     "Center": "Yellapur",
     "CenterAddress": "Sri Chaitanya School,Yellapur (Vil), Hasnparthy (Mdl), Warangal (Urban Dist) Pin: 506 371.Cell: 9666 666 713, 8297427755 &amp; 8297437755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Sircilla",
     "Center": "Sircilla",
     "CenterAddress": "Sri Chaitanya School,H.No.473B\/1, Near Hanuman Temple, Vidyanagar, Siricilla - 505 301, Rajanna Sircilla Dist.Cell: 9912487755 &amp; 9912497755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Sultanabad",
     "Center": "Sultanabad",
     "CenterAddress": "Sri Chaitanya School,H.No.4-76, Opp: Library, Venugopala Swamy Street,  Sulthanabad - 505 185, Peddapalli Dist.Cell: 9505257755 &amp; 9505267755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Huzurabad",
     "Center": "Huzurabad",
     "CenterAddress": "Sri Chaitanya School,H.No.9-116\/1, Banda Ankoos Wada, Huzurabad - 505 468, Karimnagar Dist.Cell: 9603627755 &amp; 9603637755."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet CBSE",
     "CenterAddress": "Sri Chaitanya School,Rangadampally Chowrasta To Husnabad Road, Karimnagar To Hyderabad Highway, Siddipet - 502 103, Siddipet Dist.Cell: 7997807755 &amp; 7997817755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Yellareddypet",
     "Center": "Yellareddypet",
     "CenterAddress": "Siricilla Road, Yellareddy Pet-505301"
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Korutla",
     "Center": "Korutla",
     "CenterAddress": "Sri Chaitanya School,Near Sri Krishna Temple, Sai Ram Pura Colony,Korutla - 505 326, Karimnagar (Dist).Cell: 9666666717, 8374453341."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Jagtial",
     "Center": "Jagtial",
     "CenterAddress": "Sri Chaitanya School,Dr.No.1-3-129,Dr.Md.Shankar Hospital Road,Krishna Nagar, Jagtial, Pin: 505 327."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet ",
     "Center": "Siddipet IPL",
     "CenterAddress": "Near By New Busstand, Muralikrishna (Sushrutha) Hospital Lane, Back Side Of Bajaj Electronics, Siddipet"
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Bellampally",
     "Center": "Bellampally",
     "CenterAddress": "Chemical Area, Caltex, Bellampalli."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Vemulawada",
     "Center": "Vemulawada",
     "CenterAddress": "Chekkapally Road,Bhaghavanthrao Nagar ,Vemulawada."
    },
    {
     "State": "TELANGANA",
     "District": "Komaram Bheem",
     "City": "Sirpur Kagaz Nagar",
     "Center": "Sirpur Kagaz Nagar",
     "CenterAddress": "H.No.1-16-713\/8, Srinagar Colony, Kagaznagar, Komaram Bheem Asifabad Dist. - 504 296."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Husnabad",
     "Center": "Husnabad",
     "CenterAddress": "Siddipet Road,Husnabad"
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Armoor",
     "Center": "Armoor",
     "CenterAddress": "Sri Chaitanya School, H.No.1-18\/6\/E, Housing Board Colony, Perkit, Armoor (Post &amp; Mndl), Nizamabad (Dist), Pin: 503 224.Cell: 8367607755 &amp; 8367627755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-1",
     "CenterAddress": "Sri Chaitanya School,H.No.11-1-272, Gupanpally X Road, Armoor Road, Gangasthan, Nizamabad- 503 003, Nizamabad Dist.Cell: 8367357755 &amp; 8367367755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-2",
     "CenterAddress": "Sri Chaithanya School,H.No.1-12-126\/19,Srinidhi High School, Near Presidency School, Srinagar Colony, Vinayak Nagar,Nizamabad - 503 003."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-1",
     "CenterAddress": "Sri Chaitanya School,H.No.5-11-51\/8\/18, Priya Darshini Nagar,Behind Bus Stand, Nirmal - 504 106. Nirmal (Mdl &amp; Dist).Cell: 8367537755, 8367547755;8367567755."
    },
    {
     "State": "TELANGANA",
     "District": "Adilabad",
     "City": "Adilabad",
     "Center": "Adilabad",
     "CenterAddress": "Sri Chaitanya School,Beside L.V.Prasad Eye Hospital,Mavala Road, Adilabad.Adilabad Dist, Pin: 504 001."
    },
    {
     "State": "TELANGANA",
     "District": "Kamareddy",
     "City": "Kamareddy",
     "Center": "Kamareddy",
     "CenterAddress": "H.No.9-29,Kaliki Nagar,3Rd Street, Lingapur, Kamareddy."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-2",
     "CenterAddress": "Behind Nakshatra Water Plant,Adarsh Nagar, Nirmal"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-1",
     "CenterAddress": "Sri Chaitanya School,Ravindra Nagar, Hyderabad Road, Nalgonda - 508 001, Nalgonda Dist.Cell: 9666666730 &amp; 9666666731."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-2",
     "CenterAddress": "Sri Chaitanya School, H.No:4-10-741, Siddradha Colony,Dvk Road, Nalgonda, Nalgonda Dist, Pin: 508 001."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-1",
     "CenterAddress": "Sri Chaitanya School,Doctor’S Colony, Behind Gromore, Nakirekal - 508 211, Nalgonda Dist. Cell: 9666666732 &amp; 9666666733. "
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-2",
     "CenterAddress": "Sri Chaitanya School,Opp. Raghurama Theatre,Tipparthi Road, Nakirekal - 508 211, Nalgonda Dist.Cell: 9618522088, 9618522077."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Suryapet",
     "Center": "Suryapet",
     "CenterAddress": "Sri Chaitanya School,H.No:1-6-41-10A\/3, Near 60 Feet Road, Nh-65, Beside Gayatri Jr.College, Vidya Nagar, Suryapet - 508213, Suryapet Dist.Cell:9666666734 &amp; 9666666735."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Huzurnagar",
     "Center": "Huzurnagar",
     "CenterAddress": "Sri Chaitanya School,H.No.1-53\/14\/1, C\/O Siddu B.Ed. College, Near Srinivasa Theater, Huzurnagar (Post &amp; Mdl), Suryapet (Dist), Pin: 508 204. Cell:  8367227755 &amp; 8367217755."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-1",
     "CenterAddress": "Sri Chaitanya School,Krishna Manasa Colony, Miryalaguda - 508 207, Nalgonda Dist.  Cell: 9666666736 &amp; 9666666737."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-2",
     "CenterAddress": "Sri Chaitanya School,Reddy Colony, Above Tamilnadu Bank,Near Sbi Complex, Miryalaguda - 508207,  Nalgonda Dist. Cell: 7995555616."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-3",
     "CenterAddress": "Venkatadripalem, Miryalaguda."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Nagarkurnool",
     "Center": "Nagarkurnool",
     "CenterAddress": "Sri Chaitanya School,Eshwar Colony, Road No.1, Nagarkurnool (Post &amp; Dist), Pin: 509 209. Cell: 8340847755 &amp; 8340857755."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Achampet",
     "Center": "Achampet",
     "CenterAddress": "Sri Chaitanya School,Venkateswara Colony, Opp: T.V. Tower, Achampet - 509 375, Nagarkunool (Dist).Cell: 8340917755 &amp; 8340927755."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur",
     "CenterAddress": "Sri Chaitanya School,H.No.2-2-163, Shanthi Nagar,Tandur (Vil &amp; Mdl), Vikarabad Dist, Pin: 501 141.Cell:"
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Kalwakurthy",
     "Center": "Kalwakurthy",
     "CenterAddress": "Ho.No.7-3, Near Dr.Br.Ambedkar Paramedical Vocational College, Subhash Nagar, Nagarkurnool Road, Kalwakurthy."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Shadnagar",
     "Center": "Shadnagar",
     "CenterAddress": "H.No:17-1\/7,Rachappa Estates, Ayyappa Colony, Near Bharat Petrol Bunk, Shadnagar."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur-2",
     "CenterAddress": "Brundavan Colony, Tandur"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Mahabubnagar",
     "Center": "Mahabubnagar",
     "CenterAddress": "Sri Chaitanya School,Telangana Chowrastha, Opp: Dccb Head Office, Mahabubnagar - 509 001,Mahabubnagar (Dist).Cell: 8340817755, 8340827755 &amp;  8340837755."
    },
    {
     "State": "TELANGANA",
     "District": "Jogulamba-Gadwal",
     "City": "Gadwal",
     "Center": "Gadwal",
     "CenterAddress": "Sri Chaitanya School,Navodaya High School, Rajeev Marg, Gadwal, Jogulambha Gadwal Dist, Pin: 509 125."
    },
    {
     "State": "TELANGANA",
     "District": "Wanaparthy",
     "City": "Wanaparthy",
     "Center": "Wanaparthy",
     "CenterAddress": "Sri Chaitanya School,Genius High School,Chityala Road,Wanaparthy, Wanaparthy Dist, Pin: 509 103."
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Jadcherla",
     "Center": "Jadcherla",
     "CenterAddress": "Vikas Nagar, Near Laxminagar Colony, Jedcherla."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARNAKA (HARI HARA HEIGHTS)",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-13-1210\/1, STREET NO 10, TARNAKA, SECUNDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 6-10-8\/1\/1, NAGENDRA NAGAR, HABSIGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANTHAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-9-29, SHARADA NAGAR, ADRM HOSPITAL LANE, RAMANTHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,1-7-158\/2&amp;1-7-159\/1,KAMALA NAGAR,ECIL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SECENDRABAD",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,OLD LICBUILDING,BEHIND HDFC BANK,NEAR PARADISE CIRCLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ALWAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ALWAL,PNO 27&amp;28,H.NO-1-12-115,MADHAVI NAGAR COLONY,"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "WEST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, R.C NO 23010\/62206\/C23-1\/2002-03,WEST MAREDPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SATYASAI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:18-98,KAMALA NAGAR,CHAITANYAPURI,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI BHAVAN ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO: 5-4-59\/2\/1 SARASWATHI BHAVAN, NEAR GENESIS HIGH SCHOOL, SANGEETH NAGAR, KUKATPALLY, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRIVIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 5-4-58\/9\/1 &amp; 5-5-7\/10\/1, PLOT NO 7 &amp; 8, KUKATPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI VIKRAM TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAI VIKRAM TOWERS, 3RD FLOOR, BESIDE METRO STATION, KUKATPALLY,HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI BHASKAR BHAVAN, ABOVE NEXA CAR SHOWROOM, A S RAJU NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAGDEVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VAGDEVI BHAVAN, PHASE I, BESIDE MRO OFFICE, KPHB COLONY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, APIIC COLONY, OPP IDPL COLONY, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SPRING FIELD COLONY, NEAR GOOD SHEPHERD SCHOOL, SUCHITRA, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHARATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHARATHI BHAVAN, PLOT NO: 5,6 &amp; 7, BEHIND MAX SHOPPING MALL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHARADHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 1-58\/A\/8\/1, RAMA KRISHNA COLONY, BESIDE NAIDU EYE HOSPITAL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASUDA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BACK SIDE KAJANA JEWELERS, MADINAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "JAI HIND COMPLEX",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO 53 TO 63 H NO: 5-88\/2 NEAR ZPH SCHOOL MANIKONDA, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SOUDAMINI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 4-94, CHANDA NAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MAIN CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-5-947 &amp;948, OPP.TAJMAHAL HOTEL, SUDARSHAN BUILDING, NARAYANAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAYS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-4-703,VAYS BHAVAN,NEAR NARAYANAGUDA FLYOVER,HYDERABD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AKSHARA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/279, 256\/M6, BESIDE AXIS BANK, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMRUTHA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/550, 516\/3RT, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ARYABHATTA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 7-1-414\/35(B), AMEERPET,HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "YOUSUFGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8-3-318\/6\/6, BANDARU BHAVAN, 2ND FLOOR, YOUSUFGUDA, HYDERABAD-500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8229382\/J111\/573 G, RAJIV BHAVAN, JUBILEE HILLS, OPP: KBR PARK, GATE NO 6, ROAD NO -1, JUBILEE HILLS, HYDERABAD-500096"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PILLAR NO: 143, H.NO: 3-4-183\/1, ATTAPUR, RAJENDRA NAGAR, RANGA REDDY DISTRICT-500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R K PURAM-2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ROAD NO-1,GREENHILLS COLONY,KOTHAPET"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BALAJI ARCADE ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR CHIKKADPALLY METRO, ABOVE RAMRAJ COTTON, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LBNAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 3-1-33, BAHADURGUDA, LBNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYDEHI BHAVAN AUTONAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 284 (WESTERN PART), NAKKA VENKATA SWAMY YADAV NAGAR, BAGH HAYATHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "UPPAL RES BODUPPAL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-165\/9, PEERZADIGUDA, UPPAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NAGOLE ENCLAVE,BAHADURGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VIVIN TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MADHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VEDAVYAS 1",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO. 319, 320  BESIDE. H.P. PETROL PUMP, NARSINGI,  GANDIPET MD RANGA REDDY DT"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANUJAM BHAVAN BONGULOR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D:NO 5-105, SY.NO:109(PART), OLD JNIT ENGG COLLEGE, BONGULUR X ROADS, MANGALPALLI-PATELGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYASA BHAVAN ADIBATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SURVEY NO 163\/AA, OF BONGULURU VILLAGE, IBRAHIMPATNAM MANDAL, RANGAREDDY DIST"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANDLAGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO 196, ARUNODHAYA COLONY, BANDLAGUDA ROAD NAGOLE, HYD-35"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUSHRUTHA BHAVAN MEDIPALLY CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MEDIPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO-265  AUSHAPUR,ANKUSHAPUR POST  "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PANANIYA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO 103,BLOCK 2B,VVNAGAR,GADDINNARAM"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERNAGAR BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SYNO . 1598169\/2 SRI CHAITANYA JR COLLEGE, HYDERNAGAR BOY CAMPUS, MANJEERA WATER WORK ROAD, NEAR CALAVERY TEMPLE, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MIYAPUR GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE FOR GIRLS,HOUSE NO 1-62 &amp;1-62\/1,SRI VIDYA BHAVAN"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KPHB RES PRATIBHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KPHB RES PRATIBHA BHAVAN,SRI CHAITANYA JUNIOR KALASALA, DHARMA REDDY COLONY,KPHB PHASE -3,NEAR LOTUS HOSPITAL BESIDE STREET ,NEAR TO OPPOSITE PRATIBHA SCHOOL,JNTU, "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PRATHIBHA SAI NAGAR HYD",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, FLOT NO \/ PLOT NO \/ SURVEY NO -16-2-132\/135\/231 STREET NAME -K V R COMPLEX,NIZAMPET CROSS ROAD AREA NAME -SAINAGAR COLONY NEAR BY LAND MARK -LUCID DIAGNASTICS CITY - HYDERABAD PINCIDE -500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI SAI DARBHAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO.1-62\/SD\/5TO 8\/1,PLOT NO.5678,SY NO:198\/2\/A, SRI AUROBINDO COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-217\/A, BALKAMPET, B K GUDA, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DSNR ZONAL DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAIBABA TEMPLE LINE,P &amp; T COLONY,BESIDE SANJAY STEEL,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L B NAGAR ZONAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:3-6-260,L B NAGAR,SBI BANK COLONY,VENTURE -1"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R.K.PURAM SEMI RESI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:11-13-1106&amp;1107,NEAR VICTORIA,MEMORIAL METRO STATION,GREEN HILLS COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHASKAR BHAVAN, OMNI HOSPITAL BACK SIDE, BALAJI NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMAN BHAVAN, BHAGYA NAGAR CO-OPERATIVE SOCIETY , SHIVA PARVATHI THEATER RAOD, OPP KPHB, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 8-3-319\/8\/2 TO 6&amp;319\/2\/7,NEAR SARADHI STUDIOS YOUSUFGUDA,MAIN ROAD AMEERPET HYD 500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO-8-3-222 \/ A\/1,2,3 PLOT NO-C 57-C 59 BESIDE ALLAHABAD BANK ( INDIAN BANK ), MADHURA NAGAR YOUSUFGUDA MAIN ROAD ,AMEERPET HYDERABAD 500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-4-183\/1, SATTI REDDY COMPLEX, ATTAPUR,RAJENDRA NAGAR, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO - 367&amp;368 , KAKATEEYA HILLS (KAVURI HILLS), ROAD NO -8, MADHAPUR , JUBILEE HILLS , GUTALA BEGUMPET , SHERILINGAMPALLY MANDAL, RANGA REDDY DISTRIT - 500081"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:143,145,149,JAYA ABODE,OPP:ANDHRA BANK,SECRETARIAT COLONY,MANIKONDA 500089"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHAMSHABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 578\/A582\/A,ADARSH NAGAR,SHAMSHABAD, RANGAREDDY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SR NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR.NO.7-1-621\/280 &amp; 281,254 &amp; 255-3RT, SR NAGAR MAIN RD, ABOVE SBH BANK, SANJEEVA REDDY NAGAR, HYDERABAD, TELANGANA,500038."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUN CITY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 1-2\/1, SHANTHI NAGAR COLONY, HYDERSHAKOTE, SUNCITY, RR. DT- 500091"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TOLICHOWKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8-1-22\/1\/M, 7 TOMBS ROAD,OPPOSITE GOLDEN PALACE,FUNCTION HALL,TOLICHOWKI, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHAITANYAPURI CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PANANIYA MAHAVIDYALAYA PUBLIC SCHOOL,OPP THANKUR HARI PRASAD INSTITUTE,CHAITANYAPURI,DILSUKNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DILSUKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:3-10\/A,HANUMANNAGAR,BESIDE PAKALA PLAZA,OPP.SAPTAGIRI HOSPITAL,CHAITANYAPURI,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GADDI ANNARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.16-2-752\/123\/1\/123\/A&amp;4A, SHIVA GANGA THEATRES ROAD, BESIDE: SBH BANK, GADDIANNARAM, HYD-500060"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GAYATHRI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 2&amp;131, NEAR GAYATHRINAGAR X ROADS, BESIDE SBI BANK, GAYATHRINAGAR, JILLALAGUDA,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:60,64 &amp; 67,71 KHALSA, HAYATHNAGAR RR(DT) 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT. NO. 5,6,7,8,9 &amp; 10,KHALSA,HAYATHNAGAR,RANGAREDDY 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KESHAVAPURI",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 8-7-92\/K, KESHAVAPURI COLONY, SAGAR ROAD, HASTINAPURAM,HYDERABAD TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHALSA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR HIWAY BAWACHI HOTEL LINE,SUGUNA ENCLAVE,KHALSA,HAYATNAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHARMANGHAT",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:7,SRINIVASA NAGAR COLONY,OPP:UCO BANK,KHARMANGHAT,HYDERABAD 500035"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOTHAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.23-38\/2&amp;3,KRISHNAVENI NAGAR,OPP:FRUITMARKET LANE,NEAR GHMC EAST ZONAL OFFICE,KOTHAPET,DILSUKNAGAR,HYDERABAD,R.R.DIST-60."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-11-282,SHIVA GANGA COLONY,OPP. BIG BAZAR,LBNAGAR,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 3-11-461\/A PART, ROAD NO: 2, SHIVA GANGA COLONY ,MANSOORABAD, L.B NAGAR, HYDERABAD, TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANSOORABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SAI BABA TEMPLE,KAMINENI HOSPITAL BYPASS ROAD,LAXMI NAGAR COLONY,MANSOORABAD,HYDERABAD-500074"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:1234.OPP:Y JR FUNCTION HALL,TMR ENCLAVE ,NEAR MEERPET CROSS ROAD,BADANGPET HYDERABAD 500097"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MOOSARAMBAGH",
     "CenterAddress": "SRI CHAITANYA SCHOOL H NO:16-11-469\/A\/1 TO 12,OPP SBI OFFICERS COLONY PARK, SBI OFFICERS COLONY,MOOSARAMBAGH DILSUKHNAGAR,500036"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO 46&amp;47, ROAD NO.5, SAI NAGAR COLONY, OPP. ALKAPURI SIGNAL, NAGOLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI NAGAR COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SURVEY NO:13,23 &amp; PART OF-25,OPP:RADIO STATION TOWER,VIJAYAWADA HIGHWAY,KALASA,SAI NAGAR COLONY,HAYATH NAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VANASTHALIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.288, DOOR NO.5-5-285, NEAR SRI KANAKADURGA TEMPLE, PRASHANTH NAGAR, VANASTHALIPURAM, HYDERABAD 500070"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HMT COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL FLOT NO :59&amp;60,HT LINE,HMT COLONY,ALWAL,500010"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GUNDLAPOCHAMPALLY,BESIDE GVK EMRI,NEAR PRESTIGE PARK,MEDCHAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MLR COMPLEX,BESIDE BHARATH PETROL BUNK,KOMPALLY,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHANDRAREDDY GARDENS SURVEY NO: 87, MAHALAKSHMI ENCLAVE ROAD,NEAR DHOLA-RI- DHANI, KOMPALLY, HYDERABAD,TELANGANA- 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO.85 BESIDE S.N.R GARDEN, KOMPALLY 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI ENCLAVE, BESIDE NAVATHA TRANSPORT, NEAR DOLA RI DANI, KOMPALLY, MEDCHAL - 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDCHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 36,37,64,OPP SEVEN TEMPLES,UMA NAGAR, MEDCHAL,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BEERAMGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GREEN MEADOWS MAIN ROAD, ESUKA BAVI, BEERAMGUDA, AMEENPUR (MDL), SANGAREDDY (DST) 502032"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHINTAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 145\/P OPP HP GAS AGENCY PATWARI ENCLAVE IDPL CHINTAL 500054"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 6 ,BALAJI NAGAR, NEAR METRO STATION KUKATAPALLY,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5-3-114, PLOT NO 1 &amp; 14, BEHIND RELIANCE SMART, SHANTI NAGAR,NEAR RAMALAYAM, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAGANDLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP APARNA CYBER LIFE,NALLAGANDLA(VILL), RANGAREDDY(DIST) 500019"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SERILINGAMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.20 &amp; 21, HUDA LAY OUT, NEAR AJAY FUNCTION HALL &amp; LINGAMPALLY RYTHU BAZAR, SERILINGAMPALLY RANGA REDDY "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SEVEN HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-2-46\/348,ANJANADRI BLOCK,SEVENHILLS APARTMENTS,NIZAMPET X ROAD,BESID SRI SRI HOLISTIC HOSPITAL,HYD,500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO:3&amp;4,SARDARPATEL NAGAR,NIZAMPET X RAOD,HYDERNAGAR,HYDERBAD 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 175,NEAR JNTU METRO STATION ,SARDAR PATEL NAGAR, KUKATPALLY 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO. 157,158 &amp;159, BESIDE RAMALAYAM, SAPTHAGIRI COLONY, VIVEKANANDANAGAR, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR RES(BOYS)",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO.28,29, SAPTHAGIRI COLONY,VIVEKANANDANAGAR,KUKATPALLY 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANJARAHILLS STARKIDSPREMIUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 8-2-310-B-10, ROAD NO 14, NAVODAYA COLONY, NANDI NAGAR, BANJARA HILLS,HYDERABAD 500034"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BOWENPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO. 1-4, CHINNATHOKATTA, NEW BOWENPALLY, SECUNDERABAD 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "EAST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-3-18\/4,OPP: BANK OF BARODA(FORMERLY DENA BANK),,EAST MAREDPALLY,HYDERBAD-5000026"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL A8, TULASI HOSPITAL LINE,ELECTRONIC COMPLEX, ECIL,KUSHAIGUDA, HYDERABAD - 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:A\/10, ELECTRONIC COMPLEX, PHASE 2,KUSHAIGUDA, ECIL 'X' ROADS MEHDIPATNAM 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GOSHA MAHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO.5-3-825,MALLAKUNTA ROAD, OPP. NEW IOC PETROL PUMP,GOSHAMAHAL,HYDERABAD,500012"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HASMATHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 1, SEETHA RAMAPURAM, MALLAREDDY GARDEN LANE,BESIDE KALYANI THEATRE, OLD BOWENPALLY HASMATHPET 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PILLAR NO -118 ,HANUMAN TEMPLE LANE , SRI LAKSMI NAGAR COLONY, STREET NO -03 ,NEAR INDIAN BANK BACK SIDE &amp; CLOSE TO JANAPRIYA UTOPIYA APARTMENTS, HYDERGUDA ATTAPUR - 500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KARKHANA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 144\/149, TEXT BOOK COLONY ,TRANSPORT ROAD,KARKHANA,SECUNDERABAD. TELANGANA-500009"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LAL DARWAJ",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.18-4-42\/3\/2, ANDHRA BANK LANE,LAL DARWAJ ,HYDERABAD 500065"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "M G ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 2 - 4- 73\/74 , BESIDE KFC, MG ROAD, NALLAGUTTA, SECUNDERABAD -500003"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEHDIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 3 , SANTOSH NAGAR COLONY, ST.ANN'S WOMEN'S COLLEGE ROAD, MEHDIPATNAM, HYDERABAD - 500028"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BARKATPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO: 3-4-760, BESIDE ANDHRA YUVATHI MANDAL, BARKATPURA, HYDERABAD, TELANGANA 500027"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-9-165,OPP IOC PETROL BUNK,NEAR ELECTRICITY SUB STATION,MAIN ROAD, GHATKESAR-501301"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-7-34\/7 &amp; 4\/NR, OPP CHRIST THE KING CHURCH, BESIDE BADRAS GRAND HOTEL, RAMANTHAPUR,HABSIGUDA, UPPAL(M), MEDCHAL (D)"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HIMAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-6-655ROAD9,ASHOKNAGAR.HIMAYATNAGAR,NARAYANGUDA,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDIPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 13-238, OPP.HANUMAN TEMPLE,MAIN ROAD MEDIPALLY VILLEGE,MEDCHAL DIST-500098"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NACHARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 17\/4 , SURVEY NO: 45 &amp; 46 , NACHARAM ,UPPAL MANDAL,MEDCHAL 500076"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAKUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:1-9-1104 TO 1112,OPP LANE TO DURGABAI DESHMUKH HOSPITAL,VIDYANAGAR,ADIKMET,NALLAKUNTA, HYDERABAD-500044"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARANAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-12-5-28\/29\/2,TARNAKA,SECUNDERABAD-500017."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DAMMAIGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL ANJANADRI&nbsp;NAGAR,&nbsp;EXTENSION&nbsp;OPP LAKE VIEW WATER TANK, DAMMAIGUDA MEDCHAL 500083"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Sangareddy",
     "Center": "SANGAREDDY",
     "CenterAddress": "SRI CHAITANYA SCHOOL APHB COLONY OPP NEW COLLECTORATE, SANGAREDDY 502001"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Toopran",
     "Center": "TOOPRAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO-455, ALLAPUR ROAD, TOOPRAN,KOMPALLY 502334"
    },
    {
     "State": "TELANGANA",
     "District": "Karim Nagar",
     "City": "Ramagundam",
     "Center": "RAMAGUNDAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL-FERTILIZER CITY,RFCL TOWNSHIP, RFCL, RAMAGUNDAM-PEDDAPALLY(DIST) 505210"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "STARKIDS KODAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, STAR KIDS CAMPUS, GANESH NAGAR,CURRENT OFFICE BACK,KODAD, SURYAPET (DIST) 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-237\/3, SRINAGAR COLONY,KODAD POST &amp; MDL, SURYAPETA DT 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT RS",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANA ENGINEERING COLLEGE KODAD POST &amp; MDL, KODAD SURYAPETA 508206 "
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-Olympiad",
     "CenterAddress": "Sri Chaitanya International Olympiad School,H.No.5-7-182\/3\/1, Near Mamata Hospital, Khammam - 507 002, Khammam Dist. Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-IOS",
     "CenterAddress": "Sri Chaitanya International School,H.No.5-7-182\/3\/1,  Near Mamata Hospital,Khammam - 507 002, Khammam Dist.Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-1",
     "CenterAddress": "Sri Chaitanya School,H.No.6-3-284, G.L.Towers, Near Ntr Statue,Bypass Road, Khammam - 507 001.Cell: 9666666720 &amp; 9666666718."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-2",
     "CenterAddress": "Sri Chaitanya School,H.No.10-4-31\/A, Beside Sai Baba Temple, Mamillagudem, Khammam - 500 702, Cell: 9666666721 &amp; 7680884537."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-3(Lotus)",
     "CenterAddress": "Near Petrol Bunk ,Musthfanagar Khammam"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-1",
     "CenterAddress": "Sri Chaitanya School,H.No.9-11, Laxmidevi Palli, Kothagudem - 507 101,Bhadradri Kothagudem Dist.Cell: 9666666722, 9666666723."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-2",
     "CenterAddress": "Sri Chaitanya School,G.R. Basthi, Bhajan Mandhir Road, Kothagudem  - 507 101,Bhadradri Kothagudem Dist.Cell: 8367317755 &amp;"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-3",
     "CenterAddress": "Sri Chaitanya School,H.No.3-1-6\/7, Vidhyanagar Colony (Panchayath), Chunchupally (Mndl), Kothagudem,Bhadradri Kothagudem (Dist), Pin: 507 101."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-1",
     "CenterAddress": "Sri Chaitanya School,H.No.20-5-32\/1, Contractor’S Colony,Palvancha - 507 115, Bhadradri Kothagudem (Dist).Cell: 7675837755, 7675847755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-2",
     "CenterAddress": "Sri Chaitanya School,Oddugudem, Near Bramana Kalayana Mandapam, Palvancha - 521 175, Bhadradri Kothagudem (Dist).Cell: 8367247755 &amp; 8367257755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Bhadrachalam",
     "Center": "Bhadrachalam",
     "CenterAddress": "Sri Chaitanya School,Opp: K.K.Function Hall, Charla Road, Bhadrachalam (Post &amp; Mdl).Bhadradri Kothagudem (Dist.) Pin: 507 111.Cell: 8340947755, 8340957755 &amp; 8340967755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Manugur",
     "Center": "Manugur",
     "CenterAddress": "Sri Chaitanya School,Guttamallaram, Manuguru - 507 117,Bhadradri Kothagudem (Dist).Cell: 8340977755, 8340987755 &amp; 8340997755."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Madhira",
     "Center": "Madhira",
     "CenterAddress": "Sri Chaitanya School,Ward No.121, Opp: Club Complex, Madhira (Post &amp; Mndl), Pin: 507 203, Khammam (Dist).Cell: 9666666724, 9666666725."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Mahabubabad",
     "Center": "Mahabubabad",
     "CenterAddress": "Sri Chaitanya School,H.No.6-2-44\/7\/1, Krishna Colony,Near Railwary Gate, Mahabubabad - 506 101 , Mahabubabad Dist.Cell: 9666666714 &amp; 9666666715."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Sathupally",
     "Center": "Sathupally",
     "CenterAddress": "Millennium School,Busstand Opp,Bonthu Aslesha Street, Sathupally.  9949609680"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-4"
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Warangal",
     "Center": "Warangal",
     "CenterAddress": "Sri Chaitanya School,H.No.11-27-16, Near Inner Wheel Club, Vasavi Colony, Kothawada, Warangal - 506 002, Warangal Dist.Cell: 9666666710 &amp; 9666666711."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda",
     "CenterAddress": "Sri Chaitanya School,H.N.5-9-210, Opp: Seven Hills Hospital, Kishanpura, Hanamkonda - 506 001, Warangal (Urban) Dist.Cell: 9666666712 &amp; 9666666708."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda-IPL",
     "CenterAddress": "Sri Chaitanya School,H.No.2-5-278\/280, Iob Lane, Beside G.R Hospital,Hanmakonda -506 001, Warangal (Dist). Cell: 8367407755, 8367417755, 8367427755 &amp; 8367397755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanmakonda",
     "Center": "Hanmakonda-CBSE",
     "CenterAddress": "Sri Chaitanya School,Lead India School, Hunter Road, Dwaraka Nagar, Shyampet,Hanmakonda - 506 001."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Kashibugga",
     "Center": "Kashibugga",
     "CenterAddress": "Sri Chaitanya School,H.No.11-23-662, L.B Nagar, Beside Decent Function Hall, Main Road, Kashibugga - 506 002, Warangal (Urban Dist).Cell: 7995555731 &amp; 7995555733."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Rangasaipet",
     "Center": "Rangasaipet",
     "CenterAddress": "Sri Chaitanya School,H.No.19-9-441, Beside Nagamaiah Temple Arch, Shambhunipet, Khammam Main Road, Warangal - 506 005."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Narsampet",
     "Center": "Narsampet",
     "CenterAddress": "Sri Chaitanya School,Sarojini Devi Road, Near Post Office,Narsampet - 506 132, Warangal (Rural) Dist.Cell: 9951377755 &amp; 9951277755."
    },
    {
     "State": "TELANGANA",
     "District": "Jayashankar Bhupalpally&nbsp;",
     "City": "Bhupalpally",
     "Center": "Bhupalpally",
     "CenterAddress": "Sri Chaitanya School,H.No-9-13\/1, Near Ramalayam Temple, Gandhinagar, Bhupalpally - 506 169,Bhupalpally Jayashankar (Dist).Cell: 9666666740 &amp; 9666666741."
    },
    {
     "State": "TELANGANA",
     "District": "Janagoan",
     "City": "Janagoan",
     "Center": "Janagoan",
     "CenterAddress": "Sri Chaitanya School,D.No.1-10-64\/20, Grain Market Road, A.V.Nagar, Janagoan - 506167, Janagoan (Dist).Cell: 7997837755 &amp; 7997847755"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubabad",
     "City": "Thorrur",
     "Center": "Thorrur",
     "CenterAddress": "Sri Chaitanya School,Bhatupaly, Kazipet -  506 003,Warangal Urban (Dist),Cell: 9705257755 &amp; 9705267755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Kazipet",
     "Center": "Kazipet CBSE",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755"
    },
    {
     "State": "TELANGANA",
     "District": "Medchal",
     "City": "Dammaiguda",
     "Center": "Dammaiguda",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 6-75\/8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755."
    },
    {
     "State": "TELANGANA",
     "District": "Medchal-Malkajgiri",
     "City": "Hyderabad",
     "Center": "Boduppal",
     "CenterAddress": "Sri Chaitanya School,H.No.3-105\/3\/3, Sairam Nagar Colony ,Boduppal, Medipally (M),Medchal Malkajgiri Disit, Pin: 500 039."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Tukkuguda",
     "Center": "Tukkuguda",
     "CenterAddress": "Sri Chaitanya School,Survey No.152\/A\/J, Beside Sri Swami Ayyappa Temple,Tukkuguda, Rangareddy Dist. Pin: 501 359."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Badangpet",
     "CenterAddress": "Sri Chaitanya School,D.No.4-74\/3, Raghavendra Colony,Badangpet Main Road, Opp: Sbi Bank,Badangpet Village, Balapur (Mandal),Ranga Reddy Dist, Pin: 500 058."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Ibrahimpatnam",
     "CenterAddress": "Sri Chaitanya School,Opp : Bharat Garden, Manchal Road,Siripuram Colony, Ibrahimpatnam, Ranga Reddy Dist. Pin: 501 506."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Sangareddy",
     "Center": "Sangareddy",
     "CenterAddress": "Sri Chaitanya School,H.No.9-93, Pothireddy Pally X Roads, Sangareddy, Sangareddy Dist, Pin: 502 295."
    },
    {
     "State": "TELANGANA",
     "District": "Medak",
     "City": "Sadasivpet",
     "Center": "Sadasivpet",
     "CenterAddress": "Sri Chaitanya School, H.No.3-9-12\/2 , Beside Bus Stop,Rahamath Nagar, Sadasivpet, Sangareddy Dist, Pin: 502 291."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Zaheerabad",
     "Center": "Zaheerabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.96\/A\/7, Opp. Sbi Bank, Pastapur X Roads,Zaheerabad - 502 220, Sangaredy Dist."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Vikarabad",
     "Center": "Vikarabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.72, Beside Indian Oil Petrol Pump,Hyderabad Road, Yenapally, Vikarabad,Vikarabad Dist, Pin: 501 101."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Annojiguda",
     "CenterAddress": "Sri Chaitanya School, H.No.6-52\/G\/1, Beside Sbi, Near Sbr Gardens, Annojiguda - 500 088, Ghatkesar (Mdl), Medchal-Malkajgiri (Dist),Cell: 9705737755 &amp; 9705747755."
    },
    {
     "State": "TELANGANA",
     "District": "Yadadri Bhuvanagiri ",
     "City": "Bhongir",
     "Center": "Bhongir",
     "CenterAddress": "Azad Road, 2-2-153 Bongiri"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Kandukur",
     "Center": "Kandukur",
     "CenterAddress": "Beside Mro Office,Kandukur"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Moinabad",
     "Center": "Moinabad",
     "CenterAddress": "Chilkur Village,Moinabad"
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-1",
     "CenterAddress": "Sri Chaitanya School,H.No.18-80, Haripriya Nagar, Vijaya Bank Back Side, Beside Konda Mallaiah Gardens, Hyd Road, Siddipet - 502 103, Siddipet Dist.Cell: 9666666744 &amp; 9666666745."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-2",
     "CenterAddress": "Sri Chaitanya School,H.No.18-19-28\/2 &amp; 2A, Prashanth Nagar, Above Tvs Show Room, Near Hotel Akshaya Grand, Siddipet - 502 103, Siddipet Dist.Cell: 8297827755 &amp; "
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mancheriyal",
     "Center": "Mancheriyal",
     "CenterAddress": "Sri Chaitanya School,Opp. Govt. Degree &amp; P.G College, Godavari Road, Mancherial - 504 208, Mancherial Dist. Cell: 9666666746 &amp; 9666666747."
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mandamarri",
     "Center": "Mandamarri",
     "CenterAddress": "Sri Chaitanya High School,H.No. 42-2\/B, Near Old Bus Stand, Besides Shivani Degree &amp; Pg Collage, Mandamarri - 504 231, Mancheriyal Dist.Cell 7680867755, 7680857755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Godavarikhani",
     "Center": "Godavarikhani",
     "CenterAddress": "Sri Chaitanya School,H.No.17-1-14\/2, F.C.I. Road, Sanjay Gandhi Nagar, Godavarikhani - 505 209, Ramagundam (Mdl), Peddapally (Dist). Cell: 9666666748 &amp; 9666666749."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Boiwada",
     "Center": "Boiwada",
     "CenterAddress": "Sri Chaitanya School,H.No.1-6-79, Near Hanuman Temple,  Boiwada, Karimnagar - 505 001, Karimnagar (Mdl &amp; Dist).Cell: 7995555623,7995555625."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Thimmapur",
     "Center": "Thimmapur",
     "CenterAddress": "Sri Chaitanya School,Opp. Saakshi Office, Hyderabad Road, Rajeev Rahadari, Thimmapur, Karimnagar (Mdl &amp; Dist), Pin: 505 527.Cell: 7995555622 &amp; 7995555624."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Vavilalapally",
     "Center": "Vavilalapally",
     "CenterAddress": "Sri Chaitanya School,H.No.3-7-142, Near Svjc Girls Jr.College, Vavilalpally (Vil),  Karimnagar (Mndl &amp; Dist), Pin:505 001.Cell: 8367637755, 8367647755 &amp; 8367657755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Karimnagar",
     "Center": "Karimnagar-IPL",
     "CenterAddress": "Sri Chaitanya SchoolH.No:4-65\/55-5D2\/4,Road No.2Opp:Apollo Reach Hospital, Vidhyaranyapuri,  Theegalaguttapally (Vill),Karimnagar (Mdl &amp; Dist), Pin: 505 001,Cell: 836743775, 8367457755 &amp; 8367467755."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Yellapur",
     "Center": "Yellapur",
     "CenterAddress": "Sri Chaitanya School,Yellapur (Vil), Hasnparthy (Mdl), Warangal (Urban Dist) Pin: 506 371.Cell: 9666 666 713, 8297427755 &amp; 8297437755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Sircilla",
     "Center": "Sircilla",
     "CenterAddress": "Sri Chaitanya School,H.No.473B\/1, Near Hanuman Temple, Vidyanagar, Siricilla - 505 301, Rajanna Sircilla Dist.Cell: 9912487755 &amp; 9912497755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Sultanabad",
     "Center": "Sultanabad",
     "CenterAddress": "Sri Chaitanya School,H.No.4-76, Opp: Library, Venugopala Swamy Street,  Sulthanabad - 505 185, Peddapalli Dist.Cell: 9505257755 &amp; 9505267755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Huzurabad",
     "Center": "Huzurabad",
     "CenterAddress": "Sri Chaitanya School,H.No.9-116\/1, Banda Ankoos Wada, Huzurabad - 505 468, Karimnagar Dist.Cell: 9603627755 &amp; 9603637755."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet CBSE",
     "CenterAddress": "Sri Chaitanya School,Rangadampally Chowrasta To Husnabad Road, Karimnagar To Hyderabad Highway, Siddipet - 502 103, Siddipet Dist.Cell: 7997807755 &amp; 7997817755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Yellareddypet",
     "Center": "Yellareddypet",
     "CenterAddress": "Siricilla Road, Yellareddy Pet-505301"
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Korutla",
     "Center": "Korutla",
     "CenterAddress": "Sri Chaitanya School,Near Sri Krishna Temple, Sai Ram Pura Colony,Korutla - 505 326, Karimnagar (Dist).Cell: 9666666717, 8374453341."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Jagtial",
     "Center": "Jagtial",
     "CenterAddress": "Sri Chaitanya School,Dr.No.1-3-129,Dr.Md.Shankar Hospital Road,Krishna Nagar, Jagtial, Pin: 505 327."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet ",
     "Center": "Siddipet IPL",
     "CenterAddress": "Near By New Busstand, Muralikrishna (Sushrutha) Hospital Lane, Back Side Of Bajaj Electronics, Siddipet"
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Bellampally",
     "Center": "Bellampally",
     "CenterAddress": "Chemical Area, Caltex, Bellampalli."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Vemulawada",
     "Center": "Vemulawada",
     "CenterAddress": "Chekkapally Road,Bhaghavanthrao Nagar ,Vemulawada."
    },
    {
     "State": "TELANGANA",
     "District": "Komaram Bheem",
     "City": "Sirpur Kagaz Nagar",
     "Center": "Sirpur Kagaz Nagar",
     "CenterAddress": "H.No.1-16-713\/8, Srinagar Colony, Kagaznagar, Komaram Bheem Asifabad Dist. - 504 296."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Husnabad",
     "Center": "Husnabad",
     "CenterAddress": "Siddipet Road,Husnabad"
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Armoor",
     "Center": "Armoor",
     "CenterAddress": "Sri Chaitanya School, H.No.1-18\/6\/E, Housing Board Colony, Perkit, Armoor (Post &amp; Mndl), Nizamabad (Dist), Pin: 503 224.Cell: 8367607755 &amp; 8367627755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-1",
     "CenterAddress": "Sri Chaitanya School,H.No.11-1-272, Gupanpally X Road, Armoor Road, Gangasthan, Nizamabad- 503 003, Nizamabad Dist.Cell: 8367357755 &amp; 8367367755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-2",
     "CenterAddress": "Sri Chaithanya School,H.No.1-12-126\/19,Srinidhi High School, Near Presidency School, Srinagar Colony, Vinayak Nagar,Nizamabad - 503 003."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-1",
     "CenterAddress": "Sri Chaitanya School,H.No.5-11-51\/8\/18, Priya Darshini Nagar,Behind Bus Stand, Nirmal - 504 106. Nirmal (Mdl &amp; Dist).Cell: 8367537755, 8367547755;8367567755."
    },
    {
     "State": "TELANGANA",
     "District": "Adilabad",
     "City": "Adilabad",
     "Center": "Adilabad",
     "CenterAddress": "Sri Chaitanya School,Beside L.V.Prasad Eye Hospital,Mavala Road, Adilabad.Adilabad Dist, Pin: 504 001."
    },
    {
     "State": "TELANGANA",
     "District": "Kamareddy",
     "City": "Kamareddy",
     "Center": "Kamareddy",
     "CenterAddress": "H.No.9-29,Kaliki Nagar,3Rd Street, Lingapur, Kamareddy."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-2",
     "CenterAddress": "Behind Nakshatra Water Plant,Adarsh Nagar, Nirmal"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-1",
     "CenterAddress": "Sri Chaitanya School,Ravindra Nagar, Hyderabad Road, Nalgonda - 508 001, Nalgonda Dist.Cell: 9666666730 &amp; 9666666731."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-2",
     "CenterAddress": "Sri Chaitanya School, H.No:4-10-741, Siddradha Colony,Dvk Road, Nalgonda, Nalgonda Dist, Pin: 508 001."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-1",
     "CenterAddress": "Sri Chaitanya School,Doctor’S Colony, Behind Gromore, Nakirekal - 508 211, Nalgonda Dist. Cell: 9666666732 &amp; 9666666733. "
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-2",
     "CenterAddress": "Sri Chaitanya School,Opp. Raghurama Theatre,Tipparthi Road, Nakirekal - 508 211, Nalgonda Dist.Cell: 9618522088, 9618522077."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Suryapet",
     "Center": "Suryapet",
     "CenterAddress": "Sri Chaitanya School,H.No:1-6-41-10A\/3, Near 60 Feet Road, Nh-65, Beside Gayatri Jr.College, Vidya Nagar, Suryapet - 508213, Suryapet Dist.Cell:9666666734 &amp; 9666666735."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Huzurnagar",
     "Center": "Huzurnagar",
     "CenterAddress": "Sri Chaitanya School,H.No.1-53\/14\/1, C\/O Siddu B.Ed. College, Near Srinivasa Theater, Huzurnagar (Post &amp; Mdl), Suryapet (Dist), Pin: 508 204. Cell:  8367227755 &amp; 8367217755."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-1",
     "CenterAddress": "Sri Chaitanya School,Krishna Manasa Colony, Miryalaguda - 508 207, Nalgonda Dist.  Cell: 9666666736 &amp; 9666666737."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-2",
     "CenterAddress": "Sri Chaitanya School,Reddy Colony, Above Tamilnadu Bank,Near Sbi Complex, Miryalaguda - 508207,  Nalgonda Dist. Cell: 7995555616."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-3",
     "CenterAddress": "Venkatadripalem, Miryalaguda."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Nagarkurnool",
     "Center": "Nagarkurnool",
     "CenterAddress": "Sri Chaitanya School,Eshwar Colony, Road No.1, Nagarkurnool (Post &amp; Dist), Pin: 509 209. Cell: 8340847755 &amp; 8340857755."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Achampet",
     "Center": "Achampet",
     "CenterAddress": "Sri Chaitanya School,Venkateswara Colony, Opp: T.V. Tower, Achampet - 509 375, Nagarkunool (Dist).Cell: 8340917755 &amp; 8340927755."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur",
     "CenterAddress": "Sri Chaitanya School,H.No.2-2-163, Shanthi Nagar,Tandur (Vil &amp; Mdl), Vikarabad Dist, Pin: 501 141.Cell:"
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Kalwakurthy",
     "Center": "Kalwakurthy",
     "CenterAddress": "Ho.No.7-3, Near Dr.Br.Ambedkar Paramedical Vocational College, Subhash Nagar, Nagarkurnool Road, Kalwakurthy."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Shadnagar",
     "Center": "Shadnagar",
     "CenterAddress": "H.No:17-1\/7,Rachappa Estates, Ayyappa Colony, Near Bharat Petrol Bunk, Shadnagar."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur-2",
     "CenterAddress": "Brundavan Colony, Tandur"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Mahabubnagar",
     "Center": "Mahabubnagar",
     "CenterAddress": "Sri Chaitanya School,Telangana Chowrastha, Opp: Dccb Head Office, Mahabubnagar - 509 001,Mahabubnagar (Dist).Cell: 8340817755, 8340827755 &amp;  8340837755."
    },
    {
     "State": "TELANGANA",
     "District": "Jogulamba-Gadwal",
     "City": "Gadwal",
     "Center": "Gadwal",
     "CenterAddress": "Sri Chaitanya School,Navodaya High School, Rajeev Marg, Gadwal, Jogulambha Gadwal Dist, Pin: 509 125."
    },
    {
     "State": "TELANGANA",
     "District": "Wanaparthy",
     "City": "Wanaparthy",
     "Center": "Wanaparthy",
     "CenterAddress": "Sri Chaitanya School,Genius High School,Chityala Road,Wanaparthy, Wanaparthy Dist, Pin: 509 103."
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Jadcherla",
     "Center": "Jadcherla",
     "CenterAddress": "Vikas Nagar, Near Laxminagar Colony, Jedcherla."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARNAKA (HARI HARA HEIGHTS)",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-13-1210\/1, STREET NO 10, TARNAKA, SECUNDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 6-10-8\/1\/1, NAGENDRA NAGAR, HABSIGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANTHAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-9-29, SHARADA NAGAR, ADRM HOSPITAL LANE, RAMANTHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,1-7-158\/2&amp;1-7-159\/1,KAMALA NAGAR,ECIL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SECENDRABAD",
     "CenterAddress": "SRI CHAITANYA JR KALASALA,OLD LICBUILDING,BEHIND HDFC BANK,NEAR PARADISE CIRCLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ALWAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ALWAL,PNO 27&amp;28,H.NO-1-12-115,MADHAVI NAGAR COLONY,"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "WEST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, R.C NO 23010\/62206\/C23-1\/2002-03,WEST MAREDPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SATYASAI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:18-98,KAMALA NAGAR,CHAITANYAPURI,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI BHAVAN ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO: 5-4-59\/2\/1 SARASWATHI BHAVAN, NEAR GENESIS HIGH SCHOOL, SANGEETH NAGAR, KUKATPALLY, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRIVIDYA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 5-4-58\/9\/1 &amp; 5-5-7\/10\/1, PLOT NO 7 &amp; 8, KUKATPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI VIKRAM TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAI VIKRAM TOWERS, 3RD FLOOR, BESIDE METRO STATION, KUKATPALLY,HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SRI BHASKAR BHAVAN, ABOVE NEXA CAR SHOWROOM, A S RAJU NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAGDEVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, VAGDEVI BHAVAN, PHASE I, BESIDE MRO OFFICE, KPHB COLONY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASAVI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, APIIC COLONY, OPP IDPL COLONY, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYAS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SPRING FIELD COLONY, NEAR GOOD SHEPHERD SCHOOL, SUCHITRA, QUTHBULLAPUR, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHARATHI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHARATHI BHAVAN, PLOT NO: 5,6 &amp; 7, BEHIND MAX SHOPPING MALL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHARADHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 1-58\/A\/8\/1, RAMA KRISHNA COLONY, BESIDE NAIDU EYE HOSPITAL, MADINAGUDA, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VASUDA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BACK SIDE KAJANA JEWELERS, MADINAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "JAI HIND COMPLEX",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO 53 TO 63 H NO: 5-88\/2 NEAR ZPH SCHOOL MANIKONDA, HYD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SOUDAMINI BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 4-94, CHANDA NAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MAIN CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-5-947 &amp;948, OPP.TAJMAHAL HOTEL, SUDARSHAN BUILDING, NARAYANAGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VAYS BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 3-4-703,VAYS BHAVAN,NEAR NARAYANAGUDA FLYOVER,HYDERABD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AKSHARA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/279, 256\/M6, BESIDE AXIS BANK, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMRUTHA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-621\/550, 516\/3RT, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ARYABHATTA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 7-1-414\/35(B), AMEERPET,HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "YOUSUFGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8-3-318\/6\/6, BANDARU BHAVAN, 2ND FLOOR, YOUSUFGUDA, HYDERABAD-500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 8229382\/J111\/573 G, RAJIV BHAVAN, JUBILEE HILLS, OPP: KBR PARK, GATE NO 6, ROAD NO -1, JUBILEE HILLS, HYDERABAD-500096"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PILLAR NO: 143, H.NO: 3-4-183\/1, ATTAPUR, RAJENDRA NAGAR, RANGA REDDY DISTRICT-500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R K PURAM-2",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, ROAD NO-1,GREENHILLS COLONY,KOTHAPET"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BALAJI ARCADE ",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NEAR CHIKKADPALLY METRO, ABOVE RAMRAJ COTTON, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LBNAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 3-1-33, BAHADURGUDA, LBNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYDEHI BHAVAN AUTONAGAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, 284 (WESTERN PART), NAKKA VENKATA SWAMY YADAV NAGAR, BAGH HAYATHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "UPPAL RES BODUPPAL CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H NO 12-165\/9, PEERZADIGUDA, UPPAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, NAGOLE ENCLAVE,BAHADURGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VIVIN TOWERS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MADHAPUR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VEDAVYAS 1",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, PLOT NO. 319, 320  BESIDE. H.P. PETROL PUMP, NARSINGI,  GANDIPET MD RANGA REDDY DT"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMANUJAM BHAVAN BONGULOR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, D:NO 5-105, SY.NO:109(PART), OLD JNIT ENGG COLLEGE, BONGULUR X ROADS, MANGALPALLI-PATELGUDA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VYASA BHAVAN ADIBATLA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SURVEY NO 163\/AA, OF BONGULURU VILLAGE, IBRAHIMPATNAM MANDAL, RANGAREDDY DIST"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANDLAGUDA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO 196, ARUNODHAYA COLONY, BANDLAGUDA ROAD NAGOLE, HYD-35"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUSHRUTHA BHAVAN MEDIPALLY CAMPUS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, MEDIPALLY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "COLLEGE - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO-265  AUSHAPUR,ANKUSHAPUR POST  "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PANANIYA",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SY NO 103,BLOCK 2B,VVNAGAR,GADDINNARAM"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERNAGAR BOYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SYNO . 1598169\/2 SRI CHAITANYA JR COLLEGE, HYDERNAGAR BOY CAMPUS, MANJEERA WATER WORK ROAD, NEAR CALAVERY TEMPLE, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MIYAPUR GIRLS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE FOR GIRLS,HOUSE NO 1-62 &amp;1-62\/1,SRI VIDYA BHAVAN"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KPHB RES PRATIBHA BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, KPHB RES PRATIBHA BHAVAN,SRI CHAITANYA JUNIOR KALASALA, DHARMA REDDY COLONY,KPHB PHASE -3,NEAR LOTUS HOSPITAL BESIDE STREET ,NEAR TO OPPOSITE PRATIBHA SCHOOL,JNTU, "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "PRATHIBHA SAI NAGAR HYD",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, FLOT NO \/ PLOT NO \/ SURVEY NO -16-2-132\/135\/231 STREET NAME -K V R COMPLEX,NIZAMPET CROSS ROAD AREA NAME -SAINAGAR COLONY NEAR BY LAND MARK -LUCID DIAGNASTICS CITY - HYDERABAD PINCIDE -500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SRI SAI DARBHAR",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO.1-62\/SD\/5TO 8\/1,PLOT NO.5678,SY NO:198\/2\/A, SRI AUROBINDO COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SARASWATHI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO: 7-1-217\/A, BALKAMPET, B K GUDA, SR NAGAR, HYDERABAD-500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DSNR ZONAL DAYS",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, SAIBABA TEMPLE LINE,P &amp; T COLONY,BESIDE SANJAY STEEL,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L B NAGAR ZONAL",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:3-6-260,L B NAGAR,SBI BANK COLONY,VENTURE -1"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "R.K.PURAM SEMI RESI",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, H.NO:11-13-1106&amp;1107,NEAR VICTORIA,MEMORIAL METRO STATION,GREEN HILLS COLONY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BHASKAR BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, BHASKAR BHAVAN, OMNI HOSPITAL BACK SIDE, BALAJI NAGAR, KUKATPALLY, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "RAMAN BHAVAN",
     "CenterAddress": "SRI CHAITANYA JR COLLEGE, RAMAN BHAVAN, BHAGYA NAGAR CO-OPERATIVE SOCIETY , SHIVA PARVATHI THEATER RAOD, OPP KPHB, HYD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO 8-3-319\/8\/2 TO 6&amp;319\/2\/7,NEAR SARADHI STUDIOS YOUSUFGUDA,MAIN ROAD AMEERPET HYD 500073"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "AMEERPET 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL NO-8-3-222 \/ A\/1,2,3 PLOT NO-C 57-C 59 BESIDE ALLAHABAD BANK ( INDIAN BANK ), MADHURA NAGAR YOUSUFGUDA MAIN ROAD ,AMEERPET HYDERABAD 500038"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - ATTAPUR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-4-183\/1, SATTI REDDY COMPLEX, ATTAPUR,RAJENDRA NAGAR, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - JUBILEE HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO - 367&amp;368 , KAKATEEYA HILLS (KAVURI HILLS), ROAD NO -8, MADHAPUR , JUBILEE HILLS , GUTALA BEGUMPET , SHERILINGAMPALLY MANDAL, RANGA REDDY DISTRIT - 500081"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANIKONDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO:143,145,149,JAYA ABODE,OPP:ANDHRA BANK,SECRETARIAT COLONY,MANIKONDA 500089"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SHAMSHABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 578\/A582\/A,ADARSH NAGAR,SHAMSHABAD, RANGAREDDY"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SR NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL DOOR.NO.7-1-621\/280 &amp; 281,254 &amp; 255-3RT, SR NAGAR MAIN RD, ABOVE SBH BANK, SANJEEVA REDDY NAGAR, HYDERABAD, TELANGANA,500038."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SUN CITY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 1-2\/1, SHANTHI NAGAR COLONY, HYDERSHAKOTE, SUNCITY, RR. DT- 500091"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TOLICHOWKI",
     "CenterAddress": "SRI CHAITANYA SCHOOL 8-1-22\/1\/M, 7 TOMBS ROAD,OPPOSITE GOLDEN PALACE,FUNCTION HALL,TOLICHOWKI, HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHAITANYAPURI CBSE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PANANIYA MAHAVIDYALAYA PUBLIC SCHOOL,OPP THANKUR HARI PRASAD INSTITUTE,CHAITANYAPURI,DILSUKNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DILSUKNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:3-10\/A,HANUMANNAGAR,BESIDE PAKALA PLAZA,OPP.SAPTAGIRI HOSPITAL,CHAITANYAPURI,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GADDI ANNARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.16-2-752\/123\/1\/123\/A&amp;4A, SHIVA GANGA THEATRES ROAD, BESIDE: SBH BANK, GADDIANNARAM, HYD-500060"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GAYATHRI NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 2&amp;131, NEAR GAYATHRINAGAR X ROADS, BESIDE SBI BANK, GAYATHRINAGAR, JILLALAGUDA,DILSUKHNAGAR"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:60,64 &amp; 67,71 KHALSA, HAYATHNAGAR RR(DT) 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HAYATNAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT. NO. 5,6,7,8,9 &amp; 10,KHALSA,HAYATHNAGAR,RANGAREDDY 501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KESHAVAPURI",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 8-7-92\/K, KESHAVAPURI COLONY, SAGAR ROAD, HASTINAPURAM,HYDERABAD TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHALSA",
     "CenterAddress": "SRI CHAITANYA SCHOOL NEAR HIWAY BAWACHI HOTEL LINE,SUGUNA ENCLAVE,KHALSA,HAYATNAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KHARMANGHAT",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO:7,SRINIVASA NAGAR COLONY,OPP:UCO BANK,KHARMANGHAT,HYDERABAD 500035"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOTHAPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL D.NO.23-38\/2&amp;3,KRISHNAVENI NAGAR,OPP:FRUITMARKET LANE,NEAR GHMC EAST ZONAL OFFICE,KOTHAPET,DILSUKNAGAR,HYDERABAD,R.R.DIST-60."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-11-282,SHIVA GANGA COLONY,OPP. BIG BAZAR,LBNAGAR,HYDERABAD."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "L.B.NAGAR 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 3-11-461\/A PART, ROAD NO: 2, SHIVA GANGA COLONY ,MANSOORABAD, L.B NAGAR, HYDERABAD, TELANGANA"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MANSOORABAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL BESIDE SAI BABA TEMPLE,KAMINENI HOSPITAL BYPASS ROAD,LAXMI NAGAR COLONY,MANSOORABAD,HYDERABAD-500074"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEERPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:1234.OPP:Y JR FUNCTION HALL,TMR ENCLAVE ,NEAR MEERPET CROSS ROAD,BADANGPET HYDERABAD 500097"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MOOSARAMBAGH",
     "CenterAddress": "SRI CHAITANYA SCHOOL H NO:16-11-469\/A\/1 TO 12,OPP SBI OFFICERS COLONY PARK, SBI OFFICERS COLONY,MOOSARAMBAGH DILSUKHNAGAR,500036"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NAGOLE",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO 46&amp;47, ROAD NO.5, SAI NAGAR COLONY, OPP. ALKAPURI SIGNAL, NAGOLE"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SAI NAGAR COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,SURVEY NO:13,23 &amp; PART OF-25,OPP:RADIO STATION TOWER,VIJAYAWADA HIGHWAY,KALASA,SAI NAGAR COLONY,HAYATH NAGAR-501505"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VANASTHALIPURAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.288, DOOR NO.5-5-285, NEAR SRI KANAKADURGA TEMPLE, PRASHANTH NAGAR, VANASTHALIPURAM, HYDERABAD 500070"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HMT COLONY",
     "CenterAddress": "SRI CHAITANYA SCHOOL FLOT NO :59&amp;60,HT LINE,HMT COLONY,ALWAL,500010"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL,GUNDLAPOCHAMPALLY,BESIDE GVK EMRI,NEAR PRESTIGE PARK,MEDCHAL"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL MLR COMPLEX,BESIDE BHARATH PETROL BUNK,KOMPALLY,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL CHANDRAREDDY GARDENS SURVEY NO: 87, MAHALAKSHMI ENCLAVE ROAD,NEAR DHOLA-RI- DHANI, KOMPALLY, HYDERABAD,TELANGANA- 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY.NO.85 BESIDE S.N.R GARDEN, KOMPALLY 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KOMPALLY 5",
     "CenterAddress": "SRI CHAITANYA SCHOOL MAHALAKSHMI ENCLAVE, BESIDE NAVATHA TRANSPORT, NEAR DOLA RI DANI, KOMPALLY, MEDCHAL - 500014"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDCHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 36,37,64,OPP SEVEN TEMPLES,UMA NAGAR, MEDCHAL,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BEERAMGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, GREEN MEADOWS MAIN ROAD, ESUKA BAVI, BEERAMGUDA, AMEENPUR (MDL), SANGAREDDY (DST) 502032"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "CHINTAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 145\/P OPP HP GAS AGENCY PATWARI ENCLAVE IDPL CHINTAL 500054"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 6 ,BALAJI NAGAR, NEAR METRO STATION KUKATAPALLY,HYDERABAD "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KUKATPALLY 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 5-3-114, PLOT NO 1 &amp; 14, BEHIND RELIANCE SMART, SHANTI NAGAR,NEAR RAMALAYAM, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAGANDLA",
     "CenterAddress": "SRI CHAITANYA SCHOOL, OPP APARNA CYBER LIFE,NALLAGANDLA(VILL), RANGAREDDY(DIST) 500019"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SERILINGAMPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.20 &amp; 21, HUDA LAY OUT, NEAR AJAY FUNCTION HALL &amp; LINGAMPALLY RYTHU BAZAR, SERILINGAMPALLY RANGA REDDY "
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SEVEN HILLS",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-2-46\/348,ANJANADRI BLOCK,SEVENHILLS APARTMENTS,NIZAMPET X ROAD,BESID SRI SRI HOLISTIC HOSPITAL,HYD,500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO:3&amp;4,SARDARPATEL NAGAR,NIZAMPET X RAOD,HYDERNAGAR,HYDERBAD 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SP NAGAR RES",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 175,NEAR JNTU METRO STATION ,SARDAR PATEL NAGAR, KUKATPALLY 500085"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT.NO. 157,158 &amp;159, BESIDE RAMALAYAM, SAPTHAGIRI COLONY, VIVEKANANDANAGAR, KUKATPALLY, HYDERABAD 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "VV NAGAR RES(BOYS)",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOTNO.28,29, SAPTHAGIRI COLONY,VIVEKANANDANAGAR,KUKATPALLY 500072"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BANJARAHILLS STARKIDSPREMIUM",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO 8-2-310-B-10, ROAD NO 14, NAVODAYA COLONY, NANDI NAGAR, BANJARA HILLS,HYDERABAD 500034"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BOWENPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO. 1-4, CHINNATHOKATTA, NEW BOWENPALLY, SECUNDERABAD 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "EAST MAREDPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL 10-3-18\/4,OPP: BANK OF BARODA(FORMERLY DENA BANK),,EAST MAREDPALLY,HYDERBAD-5000026"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 3",
     "CenterAddress": "SRI CHAITANYA SCHOOL A8, TULASI HOSPITAL LINE,ELECTRONIC COMPLEX, ECIL,KUSHAIGUDA, HYDERABAD - 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "ECIL 4",
     "CenterAddress": "SRI CHAITANYA SCHOOL P.NO:A\/10, ELECTRONIC COMPLEX, PHASE 2,KUSHAIGUDA, ECIL 'X' ROADS MEHDIPATNAM 500062"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "GOSHA MAHAL",
     "CenterAddress": "SRI CHAITANYA SCHOOL D NO.5-3-825,MALLAKUNTA ROAD, OPP. NEW IOC PETROL PUMP,GOSHAMAHAL,HYDERABAD,500012"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HASMATHPET",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO 1, SEETHA RAMAPURAM, MALLAREDDY GARDEN LANE,BESIDE KALYANI THEATRE, OLD BOWENPALLY HASMATHPET 500011"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HYDERGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PILLAR NO -118 ,HANUMAN TEMPLE LANE , SRI LAKSMI NAGAR COLONY, STREET NO -03 ,NEAR INDIAN BANK BACK SIDE &amp; CLOSE TO JANAPRIYA UTOPIYA APARTMENTS, HYDERGUDA ATTAPUR - 500048"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "KARKHANA",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 144\/149, TEXT BOOK COLONY ,TRANSPORT ROAD,KARKHANA,SECUNDERABAD. TELANGANA-500009"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "LAL DARWAJ",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO.18-4-42\/3\/2, ANDHRA BANK LANE,LAL DARWAJ ,HYDERABAD 500065"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "M G ROAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL # 2 - 4- 73\/74 , BESIDE KFC, MG ROAD, NALLAGUTTA, SECUNDERABAD -500003"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEHDIPATNAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO: 3 , SANTOSH NAGAR COLONY, ST.ANN'S WOMEN'S COLLEGE ROAD, MEHDIPATNAM, HYDERABAD - 500028"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "BARKATPURA",
     "CenterAddress": "SRI CHAITANYA SCHOOL HNO: 3-4-760, BESIDE ANDHRA YUVATHI MANDAL, BARKATPURA, HYDERABAD, TELANGANA 500027"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "SCHOOL - GHATKESAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-9-165,OPP IOC PETROL BUNK,NEAR ELECTRICITY SUB STATION,MAIN ROAD, GHATKESAR-501301"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HABSIGUDA 2",
     "CenterAddress": "SRI CHAITANYA SCHOOL 1-7-34\/7 &amp; 4\/NR, OPP CHRIST THE KING CHURCH, BESIDE BADRAS GRAND HOTEL, RAMANTHAPUR,HABSIGUDA, UPPAL(M), MEDCHAL (D)"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "HIMAYATNAGAR",
     "CenterAddress": "SRI CHAITANYA SCHOOL 3-6-655ROAD9,ASHOKNAGAR.HIMAYATNAGAR,NARAYANGUDA,HYDERABAD"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "MEDIPALLY",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO: 13-238, OPP.HANUMAN TEMPLE,MAIN ROAD MEDIPALLY VILLEGE,MEDCHAL DIST-500098"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NACHARAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL PLOT NO 17\/4 , SURVEY NO: 45 &amp; 46 , NACHARAM ,UPPAL MANDAL,MEDCHAL 500076"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "NALLAKUNTA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO:1-9-1104 TO 1112,OPP LANE TO DURGABAI DESHMUKH HOSPITAL,VIDYANAGAR,ADIKMET,NALLAKUNTA, HYDERABAD-500044"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "TARANAKA",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO-12-5-28\/29\/2,TARNAKA,SECUNDERABAD-500017."
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Hyderabad",
     "Center": "DAMMAIGUDA",
     "CenterAddress": "SRI CHAITANYA SCHOOL ANJANADRI&nbsp;NAGAR,&nbsp;EXTENSION&nbsp;OPP LAKE VIEW WATER TANK, DAMMAIGUDA MEDCHAL 500083"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Sangareddy",
     "Center": "SANGAREDDY",
     "CenterAddress": "SRI CHAITANYA SCHOOL APHB COLONY OPP NEW COLLECTORATE, SANGAREDDY 502001"
    },
    {
     "State": "TELANGANA",
     "District": "Hyderabad",
     "City": "Toopran",
     "Center": "TOOPRAN",
     "CenterAddress": "SRI CHAITANYA SCHOOL SURVEY NO-455, ALLAPUR ROAD, TOOPRAN,KOMPALLY 502334"
    },
    {
     "State": "TELANGANA",
     "District": "Karim Nagar",
     "City": "Ramagundam",
     "Center": "RAMAGUNDAM",
     "CenterAddress": "SRI CHAITANYA SCHOOL-FERTILIZER CITY,RFCL TOWNSHIP, RFCL, RAMAGUNDAM-PEDDAPALLY(DIST) 505210"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "STARKIDS KODAD",
     "CenterAddress": "SRI CHAITANYA SCHOOL, STAR KIDS CAMPUS, GANESH NAGAR,CURRENT OFFICE BACK,KODAD, SURYAPET (DIST) 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT DS",
     "CenterAddress": "SRI CHAITANYA SCHOOL H.NO.3-237\/3, SRINAGAR COLONY,KODAD POST &amp; MDL, SURYAPETA DT 508206"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Kodad",
     "Center": "TALENT RS",
     "CenterAddress": "SRI CHAITANYA SCHOOL SANA ENGINEERING COLLEGE KODAD POST &amp; MDL, KODAD SURYAPETA 508206 "
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-Olympiad",
     "CenterAddress": "Sri Chaitanya International Olympiad School,H.No.5-7-182\/3\/1, Near Mamata Hospital, Khammam - 507 002, Khammam Dist. Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "KMM-IOS",
     "CenterAddress": "Sri Chaitanya International School,H.No.5-7-182\/3\/1,  Near Mamata Hospital,Khammam - 507 002, Khammam Dist.Cell No: 9666666728 &amp; 9666666729."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-1",
     "CenterAddress": "Sri Chaitanya School,H.No.6-3-284, G.L.Towers, Near Ntr Statue,Bypass Road, Khammam - 507 001.Cell: 9666666720 &amp; 9666666718."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-2",
     "CenterAddress": "Sri Chaitanya School,H.No.10-4-31\/A, Beside Sai Baba Temple, Mamillagudem, Khammam - 500 702, Cell: 9666666721 &amp; 7680884537."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Khammam",
     "Center": "Khammam-3(Lotus)",
     "CenterAddress": "Near Petrol Bunk ,Musthfanagar Khammam"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-1",
     "CenterAddress": "Sri Chaitanya School,H.No.9-11, Laxmidevi Palli, Kothagudem - 507 101,Bhadradri Kothagudem Dist.Cell: 9666666722, 9666666723."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-2",
     "CenterAddress": "Sri Chaitanya School,G.R. Basthi, Bhajan Mandhir Road, Kothagudem  - 507 101,Bhadradri Kothagudem Dist.Cell: 8367317755 &amp;"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-3",
     "CenterAddress": "Sri Chaitanya School,H.No.3-1-6\/7, Vidhyanagar Colony (Panchayath), Chunchupally (Mndl), Kothagudem,Bhadradri Kothagudem (Dist), Pin: 507 101."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-1",
     "CenterAddress": "Sri Chaitanya School,H.No.20-5-32\/1, Contractor’S Colony,Palvancha - 507 115, Bhadradri Kothagudem (Dist).Cell: 7675837755, 7675847755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Palvancha",
     "Center": "Palvancha-2",
     "CenterAddress": "Sri Chaitanya School,Oddugudem, Near Bramana Kalayana Mandapam, Palvancha - 521 175, Bhadradri Kothagudem (Dist).Cell: 8367247755 &amp; 8367257755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Bhadrachalam",
     "Center": "Bhadrachalam",
     "CenterAddress": "Sri Chaitanya School,Opp: K.K.Function Hall, Charla Road, Bhadrachalam (Post &amp; Mdl).Bhadradri Kothagudem (Dist.) Pin: 507 111.Cell: 8340947755, 8340957755 &amp; 8340967755."
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Manugur",
     "Center": "Manugur",
     "CenterAddress": "Sri Chaitanya School,Guttamallaram, Manuguru - 507 117,Bhadradri Kothagudem (Dist).Cell: 8340977755, 8340987755 &amp; 8340997755."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Madhira",
     "Center": "Madhira",
     "CenterAddress": "Sri Chaitanya School,Ward No.121, Opp: Club Complex, Madhira (Post &amp; Mndl), Pin: 507 203, Khammam (Dist).Cell: 9666666724, 9666666725."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Mahabubabad",
     "Center": "Mahabubabad",
     "CenterAddress": "Sri Chaitanya School,H.No.6-2-44\/7\/1, Krishna Colony,Near Railwary Gate, Mahabubabad - 506 101 , Mahabubabad Dist.Cell: 9666666714 &amp; 9666666715."
    },
    {
     "State": "TELANGANA",
     "District": "Khammam",
     "City": "Sathupally",
     "Center": "Sathupally",
     "CenterAddress": "Millennium School,Busstand Opp,Bonthu Aslesha Street, Sathupally.  9949609680"
    },
    {
     "State": "TELANGANA",
     "District": "Bhadradri Kothagudem",
     "City": "Kothagudem",
     "Center": "Kothagudem-4"
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Warangal",
     "Center": "Warangal",
     "CenterAddress": "Sri Chaitanya School,H.No.11-27-16, Near Inner Wheel Club, Vasavi Colony, Kothawada, Warangal - 506 002, Warangal Dist.Cell: 9666666710 &amp; 9666666711."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda",
     "CenterAddress": "Sri Chaitanya School,H.N.5-9-210, Opp: Seven Hills Hospital, Kishanpura, Hanamkonda - 506 001, Warangal (Urban) Dist.Cell: 9666666712 &amp; 9666666708."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanamkonda",
     "Center": "Hanamkonda-IPL",
     "CenterAddress": "Sri Chaitanya School,H.No.2-5-278\/280, Iob Lane, Beside G.R Hospital,Hanmakonda -506 001, Warangal (Dist). Cell: 8367407755, 8367417755, 8367427755 &amp; 8367397755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Hanmakonda",
     "Center": "Hanmakonda-CBSE",
     "CenterAddress": "Sri Chaitanya School,Lead India School, Hunter Road, Dwaraka Nagar, Shyampet,Hanmakonda - 506 001."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Kashibugga",
     "Center": "Kashibugga",
     "CenterAddress": "Sri Chaitanya School,H.No.11-23-662, L.B Nagar, Beside Decent Function Hall, Main Road, Kashibugga - 506 002, Warangal (Urban Dist).Cell: 7995555731 &amp; 7995555733."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Rangasaipet",
     "Center": "Rangasaipet",
     "CenterAddress": "Sri Chaitanya School,H.No.19-9-441, Beside Nagamaiah Temple Arch, Shambhunipet, Khammam Main Road, Warangal - 506 005."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Narsampet",
     "Center": "Narsampet",
     "CenterAddress": "Sri Chaitanya School,Sarojini Devi Road, Near Post Office,Narsampet - 506 132, Warangal (Rural) Dist.Cell: 9951377755 &amp; 9951277755."
    },
    {
     "State": "TELANGANA",
     "District": "Jayashankar Bhupalpally&nbsp;",
     "City": "Bhupalpally",
     "Center": "Bhupalpally",
     "CenterAddress": "Sri Chaitanya School,H.No-9-13\/1, Near Ramalayam Temple, Gandhinagar, Bhupalpally - 506 169,Bhupalpally Jayashankar (Dist).Cell: 9666666740 &amp; 9666666741."
    },
    {
     "State": "TELANGANA",
     "District": "Janagoan",
     "City": "Janagoan",
     "Center": "Janagoan",
     "CenterAddress": "Sri Chaitanya School,D.No.1-10-64\/20, Grain Market Road, A.V.Nagar, Janagoan - 506167, Janagoan (Dist).Cell: 7997837755 &amp; 7997847755"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubabad",
     "City": "Thorrur",
     "Center": "Thorrur",
     "CenterAddress": "Sri Chaitanya School,Bhatupaly, Kazipet -  506 003,Warangal Urban (Dist),Cell: 9705257755 &amp; 9705267755."
    },
    {
     "State": "TELANGANA",
     "District": "Hanamkonda",
     "City": "Kazipet",
     "Center": "Kazipet CBSE",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755"
    },
    {
     "State": "TELANGANA",
     "District": "Medchal",
     "City": "Dammaiguda",
     "Center": "Dammaiguda",
     "CenterAddress": "Sri Chaitanya School,H.No.6-75\/7 &amp; 6-75\/8, Ganesh Nagar Colony, Nagaram (Vil) Keeasara (Mdl), Dammaiguda Road, Medchal-Malkajgiri (Dist), Pin: 500 083. Cell: 8367527755, 8367507755 &amp; 8367497755."
    },
    {
     "State": "TELANGANA",
     "District": "Medchal-Malkajgiri",
     "City": "Hyderabad",
     "Center": "Boduppal",
     "CenterAddress": "Sri Chaitanya School,H.No.3-105\/3\/3, Sairam Nagar Colony ,Boduppal, Medipally (M),Medchal Malkajgiri Disit, Pin: 500 039."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Tukkuguda",
     "Center": "Tukkuguda",
     "CenterAddress": "Sri Chaitanya School,Survey No.152\/A\/J, Beside Sri Swami Ayyappa Temple,Tukkuguda, Rangareddy Dist. Pin: 501 359."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Badangpet",
     "CenterAddress": "Sri Chaitanya School,D.No.4-74\/3, Raghavendra Colony,Badangpet Main Road, Opp: Sbi Bank,Badangpet Village, Balapur (Mandal),Ranga Reddy Dist, Pin: 500 058."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Ibrahimpatnam",
     "CenterAddress": "Sri Chaitanya School,Opp : Bharat Garden, Manchal Road,Siripuram Colony, Ibrahimpatnam, Ranga Reddy Dist. Pin: 501 506."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Sangareddy",
     "Center": "Sangareddy",
     "CenterAddress": "Sri Chaitanya School,H.No.9-93, Pothireddy Pally X Roads, Sangareddy, Sangareddy Dist, Pin: 502 295."
    },
    {
     "State": "TELANGANA",
     "District": "Medak",
     "City": "Sadasivpet",
     "Center": "Sadasivpet",
     "CenterAddress": "Sri Chaitanya School, H.No.3-9-12\/2 , Beside Bus Stop,Rahamath Nagar, Sadasivpet, Sangareddy Dist, Pin: 502 291."
    },
    {
     "State": "TELANGANA",
     "District": "Sangareddy",
     "City": "Zaheerabad",
     "Center": "Zaheerabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.96\/A\/7, Opp. Sbi Bank, Pastapur X Roads,Zaheerabad - 502 220, Sangaredy Dist."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Vikarabad",
     "Center": "Vikarabad",
     "CenterAddress": "Sri Chaitanya School,Survey No.72, Beside Indian Oil Petrol Pump,Hyderabad Road, Yenapally, Vikarabad,Vikarabad Dist, Pin: 501 101."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Hyderabad",
     "Center": "Annojiguda",
     "CenterAddress": "Sri Chaitanya School, H.No.6-52\/G\/1, Beside Sbi, Near Sbr Gardens, Annojiguda - 500 088, Ghatkesar (Mdl), Medchal-Malkajgiri (Dist),Cell: 9705737755 &amp; 9705747755."
    },
    {
     "State": "TELANGANA",
     "District": "Yadadri Bhuvanagiri ",
     "City": "Bhongir",
     "Center": "Bhongir",
     "CenterAddress": "Azad Road, 2-2-153 Bongiri"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Kandukur",
     "Center": "Kandukur",
     "CenterAddress": "Beside Mro Office,Kandukur"
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Moinabad",
     "Center": "Moinabad",
     "CenterAddress": "Chilkur Village,Moinabad"
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-1",
     "CenterAddress": "Sri Chaitanya School,H.No.18-80, Haripriya Nagar, Vijaya Bank Back Side, Beside Konda Mallaiah Gardens, Hyd Road, Siddipet - 502 103, Siddipet Dist.Cell: 9666666744 &amp; 9666666745."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet-2",
     "CenterAddress": "Sri Chaitanya School,H.No.18-19-28\/2 &amp; 2A, Prashanth Nagar, Above Tvs Show Room, Near Hotel Akshaya Grand, Siddipet - 502 103, Siddipet Dist.Cell: 8297827755 &amp; "
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mancheriyal",
     "Center": "Mancheriyal",
     "CenterAddress": "Sri Chaitanya School,Opp. Govt. Degree &amp; P.G College, Godavari Road, Mancherial - 504 208, Mancherial Dist. Cell: 9666666746 &amp; 9666666747."
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Mandamarri",
     "Center": "Mandamarri",
     "CenterAddress": "Sri Chaitanya High School,H.No. 42-2\/B, Near Old Bus Stand, Besides Shivani Degree &amp; Pg Collage, Mandamarri - 504 231, Mancheriyal Dist.Cell 7680867755, 7680857755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Godavarikhani",
     "Center": "Godavarikhani",
     "CenterAddress": "Sri Chaitanya School,H.No.17-1-14\/2, F.C.I. Road, Sanjay Gandhi Nagar, Godavarikhani - 505 209, Ramagundam (Mdl), Peddapally (Dist). Cell: 9666666748 &amp; 9666666749."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Boiwada",
     "Center": "Boiwada",
     "CenterAddress": "Sri Chaitanya School,H.No.1-6-79, Near Hanuman Temple,  Boiwada, Karimnagar - 505 001, Karimnagar (Mdl &amp; Dist).Cell: 7995555623,7995555625."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Thimmapur",
     "Center": "Thimmapur",
     "CenterAddress": "Sri Chaitanya School,Opp. Saakshi Office, Hyderabad Road, Rajeev Rahadari, Thimmapur, Karimnagar (Mdl &amp; Dist), Pin: 505 527.Cell: 7995555622 &amp; 7995555624."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Vavilalapally",
     "Center": "Vavilalapally",
     "CenterAddress": "Sri Chaitanya School,H.No.3-7-142, Near Svjc Girls Jr.College, Vavilalpally (Vil),  Karimnagar (Mndl &amp; Dist), Pin:505 001.Cell: 8367637755, 8367647755 &amp; 8367657755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Karimnagar",
     "Center": "Karimnagar-IPL",
     "CenterAddress": "Sri Chaitanya SchoolH.No:4-65\/55-5D2\/4,Road No.2Opp:Apollo Reach Hospital, Vidhyaranyapuri,  Theegalaguttapally (Vill),Karimnagar (Mdl &amp; Dist), Pin: 505 001,Cell: 836743775, 8367457755 &amp; 8367467755."
    },
    {
     "State": "TELANGANA",
     "District": "Warangal",
     "City": "Yellapur",
     "Center": "Yellapur",
     "CenterAddress": "Sri Chaitanya School,Yellapur (Vil), Hasnparthy (Mdl), Warangal (Urban Dist) Pin: 506 371.Cell: 9666 666 713, 8297427755 &amp; 8297437755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Sircilla",
     "Center": "Sircilla",
     "CenterAddress": "Sri Chaitanya School,H.No.473B\/1, Near Hanuman Temple, Vidyanagar, Siricilla - 505 301, Rajanna Sircilla Dist.Cell: 9912487755 &amp; 9912497755."
    },
    {
     "State": "TELANGANA",
     "District": "Peddapalli",
     "City": "Sultanabad",
     "Center": "Sultanabad",
     "CenterAddress": "Sri Chaitanya School,H.No.4-76, Opp: Library, Venugopala Swamy Street,  Sulthanabad - 505 185, Peddapalli Dist.Cell: 9505257755 &amp; 9505267755."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Huzurabad",
     "Center": "Huzurabad",
     "CenterAddress": "Sri Chaitanya School,H.No.9-116\/1, Banda Ankoos Wada, Huzurabad - 505 468, Karimnagar Dist.Cell: 9603627755 &amp; 9603637755."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet",
     "Center": "Siddipet CBSE",
     "CenterAddress": "Sri Chaitanya School,Rangadampally Chowrasta To Husnabad Road, Karimnagar To Hyderabad Highway, Siddipet - 502 103, Siddipet Dist.Cell: 7997807755 &amp; 7997817755."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Yellareddypet",
     "Center": "Yellareddypet",
     "CenterAddress": "Siricilla Road, Yellareddy Pet-505301"
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Korutla",
     "Center": "Korutla",
     "CenterAddress": "Sri Chaitanya School,Near Sri Krishna Temple, Sai Ram Pura Colony,Korutla - 505 326, Karimnagar (Dist).Cell: 9666666717, 8374453341."
    },
    {
     "State": "TELANGANA",
     "District": "Karimnagar ",
     "City": "Jagtial",
     "Center": "Jagtial",
     "CenterAddress": "Sri Chaitanya School,Dr.No.1-3-129,Dr.Md.Shankar Hospital Road,Krishna Nagar, Jagtial, Pin: 505 327."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Siddipet ",
     "Center": "Siddipet IPL",
     "CenterAddress": "Near By New Busstand, Muralikrishna (Sushrutha) Hospital Lane, Back Side Of Bajaj Electronics, Siddipet"
    },
    {
     "State": "TELANGANA",
     "District": "Mancheriyal",
     "City": "Bellampally",
     "Center": "Bellampally",
     "CenterAddress": "Chemical Area, Caltex, Bellampalli."
    },
    {
     "State": "TELANGANA",
     "District": "Rajanna Sircilla ",
     "City": "Vemulawada",
     "Center": "Vemulawada",
     "CenterAddress": "Chekkapally Road,Bhaghavanthrao Nagar ,Vemulawada."
    },
    {
     "State": "TELANGANA",
     "District": "Komaram Bheem",
     "City": "Sirpur Kagaz Nagar",
     "Center": "Sirpur Kagaz Nagar",
     "CenterAddress": "H.No.1-16-713\/8, Srinagar Colony, Kagaznagar, Komaram Bheem Asifabad Dist. - 504 296."
    },
    {
     "State": "TELANGANA",
     "District": "Siddipet",
     "City": "Husnabad",
     "Center": "Husnabad",
     "CenterAddress": "Siddipet Road,Husnabad"
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Armoor",
     "Center": "Armoor",
     "CenterAddress": "Sri Chaitanya School, H.No.1-18\/6\/E, Housing Board Colony, Perkit, Armoor (Post &amp; Mndl), Nizamabad (Dist), Pin: 503 224.Cell: 8367607755 &amp; 8367627755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-1",
     "CenterAddress": "Sri Chaitanya School,H.No.11-1-272, Gupanpally X Road, Armoor Road, Gangasthan, Nizamabad- 503 003, Nizamabad Dist.Cell: 8367357755 &amp; 8367367755."
    },
    {
     "State": "TELANGANA",
     "District": "Nizamabad",
     "City": "Nizamabad",
     "Center": "Nizamabad-2",
     "CenterAddress": "Sri Chaithanya School,H.No.1-12-126\/19,Srinidhi High School, Near Presidency School, Srinagar Colony, Vinayak Nagar,Nizamabad - 503 003."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-1",
     "CenterAddress": "Sri Chaitanya School,H.No.5-11-51\/8\/18, Priya Darshini Nagar,Behind Bus Stand, Nirmal - 504 106. Nirmal (Mdl &amp; Dist).Cell: 8367537755, 8367547755;8367567755."
    },
    {
     "State": "TELANGANA",
     "District": "Adilabad",
     "City": "Adilabad",
     "Center": "Adilabad",
     "CenterAddress": "Sri Chaitanya School,Beside L.V.Prasad Eye Hospital,Mavala Road, Adilabad.Adilabad Dist, Pin: 504 001."
    },
    {
     "State": "TELANGANA",
     "District": "Kamareddy",
     "City": "Kamareddy",
     "Center": "Kamareddy",
     "CenterAddress": "H.No.9-29,Kaliki Nagar,3Rd Street, Lingapur, Kamareddy."
    },
    {
     "State": "TELANGANA",
     "District": "Nirmal",
     "City": "Nirmal",
     "Center": "Nirmal-2",
     "CenterAddress": "Behind Nakshatra Water Plant,Adarsh Nagar, Nirmal"
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-1",
     "CenterAddress": "Sri Chaitanya School,Ravindra Nagar, Hyderabad Road, Nalgonda - 508 001, Nalgonda Dist.Cell: 9666666730 &amp; 9666666731."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nalgonda",
     "Center": "Nalgonda-2",
     "CenterAddress": "Sri Chaitanya School, H.No:4-10-741, Siddradha Colony,Dvk Road, Nalgonda, Nalgonda Dist, Pin: 508 001."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-1",
     "CenterAddress": "Sri Chaitanya School,Doctor’S Colony, Behind Gromore, Nakirekal - 508 211, Nalgonda Dist. Cell: 9666666732 &amp; 9666666733. "
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Nakirekal",
     "Center": "Nakirekal-2",
     "CenterAddress": "Sri Chaitanya School,Opp. Raghurama Theatre,Tipparthi Road, Nakirekal - 508 211, Nalgonda Dist.Cell: 9618522088, 9618522077."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Suryapet",
     "Center": "Suryapet",
     "CenterAddress": "Sri Chaitanya School,H.No:1-6-41-10A\/3, Near 60 Feet Road, Nh-65, Beside Gayatri Jr.College, Vidya Nagar, Suryapet - 508213, Suryapet Dist.Cell:9666666734 &amp; 9666666735."
    },
    {
     "State": "TELANGANA",
     "District": "Suryapet",
     "City": "Huzurnagar",
     "Center": "Huzurnagar",
     "CenterAddress": "Sri Chaitanya School,H.No.1-53\/14\/1, C\/O Siddu B.Ed. College, Near Srinivasa Theater, Huzurnagar (Post &amp; Mdl), Suryapet (Dist), Pin: 508 204. Cell:  8367227755 &amp; 8367217755."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-1",
     "CenterAddress": "Sri Chaitanya School,Krishna Manasa Colony, Miryalaguda - 508 207, Nalgonda Dist.  Cell: 9666666736 &amp; 9666666737."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-2",
     "CenterAddress": "Sri Chaitanya School,Reddy Colony, Above Tamilnadu Bank,Near Sbi Complex, Miryalaguda - 508207,  Nalgonda Dist. Cell: 7995555616."
    },
    {
     "State": "TELANGANA",
     "District": "Nalgonda",
     "City": "Miryalaguda",
     "Center": "Miryalaguda-3",
     "CenterAddress": "Venkatadripalem, Miryalaguda."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Nagarkurnool",
     "Center": "Nagarkurnool",
     "CenterAddress": "Sri Chaitanya School,Eshwar Colony, Road No.1, Nagarkurnool (Post &amp; Dist), Pin: 509 209. Cell: 8340847755 &amp; 8340857755."
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Achampet",
     "Center": "Achampet",
     "CenterAddress": "Sri Chaitanya School,Venkateswara Colony, Opp: T.V. Tower, Achampet - 509 375, Nagarkunool (Dist).Cell: 8340917755 &amp; 8340927755."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur",
     "CenterAddress": "Sri Chaitanya School,H.No.2-2-163, Shanthi Nagar,Tandur (Vil &amp; Mdl), Vikarabad Dist, Pin: 501 141.Cell:"
    },
    {
     "State": "TELANGANA",
     "District": "Nagarkurnool",
     "City": "Kalwakurthy",
     "Center": "Kalwakurthy",
     "CenterAddress": "Ho.No.7-3, Near Dr.Br.Ambedkar Paramedical Vocational College, Subhash Nagar, Nagarkurnool Road, Kalwakurthy."
    },
    {
     "State": "TELANGANA",
     "District": "Rangareddy",
     "City": "Shadnagar",
     "Center": "Shadnagar",
     "CenterAddress": "H.No:17-1\/7,Rachappa Estates, Ayyappa Colony, Near Bharat Petrol Bunk, Shadnagar."
    },
    {
     "State": "TELANGANA",
     "District": "Vikarabad",
     "City": "Tandur",
     "Center": "Tandur-2",
     "CenterAddress": "Brundavan Colony, Tandur"
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Mahabubnagar",
     "Center": "Mahabubnagar",
     "CenterAddress": "Sri Chaitanya School,Telangana Chowrastha, Opp: Dccb Head Office, Mahabubnagar - 509 001,Mahabubnagar (Dist).Cell: 8340817755, 8340827755 &amp;  8340837755."
    },
    {
     "State": "TELANGANA",
     "District": "Jogulamba-Gadwal",
     "City": "Gadwal",
     "Center": "Gadwal",
     "CenterAddress": "Sri Chaitanya School,Navodaya High School, Rajeev Marg, Gadwal, Jogulambha Gadwal Dist, Pin: 509 125."
    },
    {
     "State": "TELANGANA",
     "District": "Wanaparthy",
     "City": "Wanaparthy",
     "Center": "Wanaparthy",
     "CenterAddress": "Sri Chaitanya School,Genius High School,Chityala Road,Wanaparthy, Wanaparthy Dist, Pin: 509 103."
    },
    {
     "State": "TELANGANA",
     "District": "Mahabubnagar",
     "City": "Jadcherla",
     "Center": "Jadcherla",
     "CenterAddress": "Vikas Nagar, Near Laxminagar Colony, Jedcherla."
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Navi Mumbai",
     "Center": "Sanpada",
     "CenterAddress": "Jaipuriar School, Plot No 12 , Sector : 18, off Palm Beach Road, Sanpada, Navi Mumbai, 400705"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Thane",
     "Center": "Vasai",
     "CenterAddress": "Seth Vidya MandirEnglish High school Sector 4, Vasant Nagari, Vasai East, Vasai-Virar, Maharashtra 401208"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Navi Mumbai",
     "Center": "Sanpada",
     "CenterAddress": "Jaipuriar School, Plot No 12 , Sector : 18, off Palm Beach Road, Sanpada, Navi Mumbai, 400705"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Thane",
     "Center": "Vasai",
     "CenterAddress": "Seth Vidya MandirEnglish High school Sector 4, Vasant Nagari, Vasai East, Vasai-Virar, Maharashtra 401208"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Navi Mumbai",
     "Center": "Sanpada",
     "CenterAddress": "Jaipuriar School, Plot No 12 , Sector : 18, off Palm Beach Road, Sanpada, Navi Mumbai, 400705"
    },
    {
     "State": "Maharashtra",
     "District": "Mumbai",
     "City": "Thane",
     "Center": "Vasai",
     "CenterAddress": "Seth Vidya MandirEnglish High school Sector 4, Vasant Nagari, Vasai East, Vasai-Virar, Maharashtra 401208"
    },
    {
        "State": "Karnataka",
        "District": "Bengaluru",
        "City": "Bengaluru",
        "Center": "Sri Chaitanya Knowledge Hub, Kalyan Nagar",
        "CenterAddress": "# 17th , 7th Main, 80ft Road, HRBR Layout, Kalyan Nagar, Bengalore - 560043 PH : 9901799767, 9900050788"
    },
    {
        "State": "Karnataka",
        "District": "Bengaluru",
        "City": "Belagavi",
        "Center": "Sri Chaitanya Knowledge Hub, Belagavi",
        "CenterAddress": "Krishna Arcade Tanishq, opp TATA Croma, Khanapur Road, Tilakwadi, Belagavi - 590006 Ph :7207914070"
    },
   ]